// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"bNIxh":[function(require,module,exports,__globalThis) {
var _runtime = require("storybook/internal/preview/runtime");
var _channels = require("storybook/internal/channels");
var _previewApi = require("storybook/internal/preview-api");
var _csf = require("storybook/internal/csf");
(0, _runtime.setup)();
const channel = (0, _channels.createBrowserChannel)({
    page: 'preview'
});
(0, _previewApi.addons).setChannel(channel);
window.__STORYBOOK_ADDONS_CHANNEL__ = channel;
if (window.CONFIG_TYPE === 'DEVELOPMENT') window.__STORYBOOK_SERVER_CHANNEL__ = channel;
const importers = {
    ...require("6ca2c6fd008aab27"),
    ...require("de75f972db07da47")
};
async function importFn(path) {
    return importers[path]();
}
const getProjectAnnotations = async ()=>{
    const configs = await Promise.all([
        require("269de69b225de7d7"),
        require("83b35d0e25d88b86"),
        require("62dba11d556e1a55"),
        require("5b9c4e984443562f"),
        require("e8f24e7464c5bfed"),
        require("1ad4776adf3979d3"),
        require("6f45ef0b406d7b72"),
        require("d3214249879d698a"),
        require("a00a096c373eaca9"),
        require("269b5b224a4b10a0"),
        require("5f703aa230fb8744"),
        require("abc58c6410fd4f6e"),
        require("14286a566ea84df2"),
        require("96aacaa4a64516ec")
    ]);
    return (0, _previewApi.composeConfigs)(configs);
};
window.__STORYBOOK_PREVIEW__ = window.__STORYBOOK_PREVIEW__ || new (0, _previewApi.PreviewWeb)(importFn, getProjectAnnotations);
window.__STORYBOOK_STORY_STORE__ = window.__STORYBOOK_STORY_STORE__ || window.__STORYBOOK_PREVIEW__.storyStore;
module.hot.accept(()=>{
    // importFn has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onStoriesChanged({
        importFn
    });
    // getProjectAnnotations has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onGetProjectAnnotationsChanged({
        getProjectAnnotations
    });
});

},{"storybook/internal/preview/runtime":"hRwnV","storybook/internal/channels":"fugct","storybook/internal/preview-api":"iduAM","storybook/internal/csf":"5mm0x","6ca2c6fd008aab27":"gLGvH","de75f972db07da47":"cW8jp","269de69b225de7d7":"huTYo","83b35d0e25d88b86":"KUiYy","62dba11d556e1a55":"61OqM","5b9c4e984443562f":"9aIyJ","e8f24e7464c5bfed":"ck8Ne","1ad4776adf3979d3":"dIBwg","6f45ef0b406d7b72":"5lIdo","d3214249879d698a":"3HXbo","a00a096c373eaca9":"c5EQp","269b5b224a4b10a0":"8dzD6","5f703aa230fb8744":"c33w7","abc58c6410fd4f6e":"64zdn","14286a566ea84df2":"lC5bg","96aacaa4a64516ec":"ddhQC"}],"hRwnV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("@storybook/core/preview/runtime");
parcelHelpers.exportAll(_runtime, exports);

},{"@storybook/core/preview/runtime":"6TjQJ","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"6TjQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setup", ()=>Ff);
var global = arguments[3];
var Buffer = require("8fb47097d7775935").Buffer;
var tl = Object.create;
var et = Object.defineProperty;
var ol = Object.getOwnPropertyDescriptor;
var nl = Object.getOwnPropertyNames;
var sl = Object.getPrototypeOf, il = Object.prototype.hasOwnProperty;
var n = (r, e)=>et(r, "name", {
        value: e,
        configurable: !0
    }), cr = /* @__PURE__ */ ((r)=>undefined)(function(r) {
    return undefined(this, arguments);
});
var q = (r, e)=>()=>(e || r((e = {
            exports: {}
        }).exports, e), e.exports), _e = (r, e)=>{
    for(var t in e)et(r, t, {
        get: e[t],
        enumerable: !0
    });
}, al = (r, e, t, o)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let s of nl(e))!il.call(r, s) && s !== t && et(r, s, {
        get: ()=>e[s],
        enumerable: !(o = ol(e, s)) || o.enumerable
    });
    return r;
};
var ue = (r, e, t)=>(t = r != null ? tl(sl(r)) : {}, al(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    e || !r || !r.__esModule ? et(t, "default", {
        value: r,
        enumerable: !0
    }) : t, r));
// ../node_modules/memoizerific/memoizerific.js
var it = q((ys, So)=>{
    (function(r) {
        if (typeof ys == "object" && typeof So < "u") So.exports = r();
        else if (typeof define == "function" && define.amd) define([], r);
        else {
            var e;
            typeof window < "u" ? e = window : typeof global < "u" ? e = global : typeof self < "u" ? e = self : e = this, e.memoizerific = r();
        }
    })(function() {
        var r, e, t;
        return /* @__PURE__ */ n(function o(s, i, a) {
            function c(u, d) {
                if (!i[u]) {
                    if (!s[u]) {
                        var h = typeof cr == "function" && cr;
                        if (!d && h) return h(u, !0);
                        if (l) return l(u, !0);
                        var S = new Error("Cannot find module '" + u + "'");
                        throw S.code = "MODULE_NOT_FOUND", S;
                    }
                    var m = i[u] = {
                        exports: {}
                    };
                    s[u][0].call(m.exports, function(T) {
                        var y = s[u][1][T];
                        return c(y || T);
                    }, m, m.exports, o, s, i, a);
                }
                return i[u].exports;
            }
            n(c, "s");
            for(var l = typeof cr == "function" && cr, p = 0; p < a.length; p++)c(a[p]);
            return c;
        }, "e")({
            1: [
                function(o, s, i) {
                    s.exports = function(a) {
                        if (typeof Map != "function" || a) {
                            var c = o("./similar");
                            return new c();
                        } else return /* @__PURE__ */ new Map();
                    };
                },
                {
                    "./similar": 2
                }
            ],
            2: [
                function(o, s, i) {
                    function a() {
                        return this.list = [], this.lastItem = void 0, this.size = 0, this;
                    }
                    n(a, "Similar"), a.prototype.get = function(c) {
                        var l;
                        if (this.lastItem && this.isEqual(this.lastItem.key, c)) return this.lastItem.val;
                        if (l = this.indexOf(c), l >= 0) return this.lastItem = this.list[l], this.list[l].val;
                    }, a.prototype.set = function(c, l) {
                        var p;
                        return this.lastItem && this.isEqual(this.lastItem.key, c) ? (this.lastItem.val = l, this) : (p = this.indexOf(c), p >= 0 ? (this.lastItem = this.list[p], this.list[p].val = l, this) : (this.lastItem = {
                            key: c,
                            val: l
                        }, this.list.push(this.lastItem), this.size++, this));
                    }, a.prototype.delete = function(c) {
                        var l;
                        if (this.lastItem && this.isEqual(this.lastItem.key, c) && (this.lastItem = void 0), l = this.indexOf(c), l >= 0) return this.size--, this.list.splice(l, 1)[0];
                    }, a.prototype.has = function(c) {
                        var l;
                        return this.lastItem && this.isEqual(this.lastItem.key, c) ? !0 : (l = this.indexOf(c), l >= 0 ? (this.lastItem = this.list[l], !0) : !1);
                    }, a.prototype.forEach = function(c, l) {
                        var p;
                        for(p = 0; p < this.size; p++)c.call(l || this, this.list[p].val, this.list[p].key, this);
                    }, a.prototype.indexOf = function(c) {
                        var l;
                        for(l = 0; l < this.size; l++)if (this.isEqual(this.list[l].key, c)) return l;
                        return -1;
                    }, a.prototype.isEqual = function(c, l) {
                        return c === l || c !== c && l !== l;
                    }, s.exports = a;
                },
                {}
            ],
            3: [
                function(o, s, i) {
                    var a = o("map-or-similar");
                    s.exports = function(u) {
                        var d = new a(!1), h = [];
                        return function(S) {
                            var m = /* @__PURE__ */ n(function() {
                                var T = d, y, R, x = arguments.length - 1, g = Array(x + 1), b = !0, v;
                                if ((m.numArgs || m.numArgs === 0) && m.numArgs !== x + 1) throw new Error("Memoizerific functions should always be called with the same number of arguments");
                                for(v = 0; v < x; v++){
                                    if (g[v] = {
                                        cacheItem: T,
                                        arg: arguments[v]
                                    }, T.has(arguments[v])) {
                                        T = T.get(arguments[v]);
                                        continue;
                                    }
                                    b = !1, y = new a(!1), T.set(arguments[v], y), T = y;
                                }
                                return b && (T.has(arguments[x]) ? R = T.get(arguments[x]) : b = !1), b || (R = S.apply(null, arguments), T.set(arguments[x], R)), u > 0 && (g[x] = {
                                    cacheItem: T,
                                    arg: arguments[x]
                                }, b ? c(h, g) : h.push(g), h.length > u && l(h.shift())), m.wasMemoized = b, m.numArgs = x + 1, R;
                            }, "memoizerific");
                            return m.limit = u, m.wasMemoized = !1, m.cache = d, m.lru = h, m;
                        };
                    };
                    function c(u, d) {
                        var h = u.length, S = d.length, m, T, y;
                        for(T = 0; T < h; T++){
                            for(m = !0, y = 0; y < S; y++)if (!p(u[T][y].arg, d[y].arg)) {
                                m = !1;
                                break;
                            }
                            if (m) break;
                        }
                        u.push(u.splice(T, 1)[0]);
                    }
                    n(c, "moveToMostRecentLru");
                    function l(u) {
                        var d = u.length, h = u[d - 1], S, m;
                        for(h.cacheItem.delete(h.arg), m = d - 2; m >= 0 && (h = u[m], S = h.cacheItem.get(h.arg), !S || !S.size); m--)h.cacheItem.delete(h.arg);
                    }
                    n(l, "removeCachedResult");
                    function p(u, d) {
                        return u === d || u !== u && d !== d;
                    }
                    n(p, "isEqual");
                },
                {
                    "map-or-similar": 1
                }
            ]
        }, {}, [
            3
        ])(3);
    });
});
// ../node_modules/@ngard/tiny-isequal/index.js
var wi = q((Tn)=>{
    Object.defineProperty(Tn, "__esModule", {
        value: !0
    }), Tn.isEqual = /* @__PURE__ */ function() {
        var r = Object.prototype.toString, e = Object.getPrototypeOf, t = Object.getOwnPropertySymbols ? function(o) {
            return Object.keys(o).concat(Object.getOwnPropertySymbols(o));
        } : Object.keys;
        return function(o, s) {
            return /* @__PURE__ */ n(function i(a, c, l) {
                var p, u, d, h = r.call(a), S = r.call(c);
                if (a === c) return !0;
                if (a == null || c == null) return !1;
                if (l.indexOf(a) > -1 && l.indexOf(c) > -1) return !0;
                if (l.push(a, c), h != S || (p = t(a), u = t(c), p.length != u.length || p.some(function(m) {
                    return !i(a[m], c[m], l);
                }))) return !1;
                switch(h.slice(8, -1)){
                    case "Symbol":
                        return a.valueOf() == c.valueOf();
                    case "Date":
                    case "Number":
                        return +a == +c || +a != +a && +c != +c;
                    case "RegExp":
                    case "Function":
                    case "String":
                    case "Boolean":
                        return "" + a == "" + c;
                    case "Set":
                    case "Map":
                        p = a.entries(), u = c.entries();
                        do if (!i((d = p.next()).value, u.next().value, l)) return !1;
                        while (!d.done);
                        return !0;
                    case "ArrayBuffer":
                        a = new Uint8Array(a), c = new Uint8Array(c);
                    case "DataView":
                        a = new Uint8Array(a.buffer), c = new Uint8Array(c.buffer);
                    case "Float32Array":
                    case "Float64Array":
                    case "Int8Array":
                    case "Int16Array":
                    case "Int32Array":
                    case "Uint8Array":
                    case "Uint16Array":
                    case "Uint32Array":
                    case "Uint8ClampedArray":
                    case "Arguments":
                    case "Array":
                        if (a.length != c.length) return !1;
                        for(d = 0; d < a.length; d++)if ((d in a || d in c) && (d in a != d in c || !i(a[d], c[d], l))) return !1;
                        return !0;
                    case "Object":
                        return i(e(a), e(c), l);
                    default:
                        return !1;
                }
            }, "n")(o, s, []);
        };
    }();
});
// ../node_modules/picoquery/lib/string-util.js
var qn = q((Gn)=>{
    "use strict";
    Object.defineProperty(Gn, "__esModule", {
        value: !0
    });
    Gn.encodeString = mu;
    var le = Array.from({
        length: 256
    }, (r, e)=>"%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase()), yu = new Int8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0
    ]);
    function mu(r) {
        let e = r.length;
        if (e === 0) return "";
        let t = "", o = 0, s = 0;
        e: for(; s < e; s++){
            let i = r.charCodeAt(s);
            for(; i < 128;){
                if (yu[i] !== 1 && (o < s && (t += r.slice(o, s)), o = s + 1, t += le[i]), ++s === e) break e;
                i = r.charCodeAt(s);
            }
            if (o < s && (t += r.slice(o, s)), i < 2048) {
                o = s + 1, t += le[192 | i >> 6] + le[128 | i & 63];
                continue;
            }
            if (i < 55296 || i >= 57344) {
                o = s + 1, t += le[224 | i >> 12] + le[128 | i >> 6 & 63] + le[128 | i & 63];
                continue;
            }
            if (++s, s >= e) throw new Error("URI malformed");
            let a = r.charCodeAt(s) & 1023;
            o = s + 1, i = 65536 + ((i & 1023) << 10 | a), t += le[240 | i >> 18] + le[128 | i >> 12 & 63] + le[128 | i >> 6 & 63] + le[128 | i & 63];
        }
        return o === 0 ? r : o < e ? t + r.slice(o) : t;
    }
    n(mu, "encodeString");
});
// ../node_modules/picoquery/lib/shared.js
var It = q((ce)=>{
    "use strict";
    Object.defineProperty(ce, "__esModule", {
        value: !0
    });
    ce.defaultOptions = ce.defaultShouldSerializeObject = ce.defaultValueSerializer = void 0;
    var Bn = qn(), hu = /* @__PURE__ */ n((r)=>{
        switch(typeof r){
            case "string":
                return (0, Bn.encodeString)(r);
            case "bigint":
            case "boolean":
                return "" + r;
            case "number":
                if (Number.isFinite(r)) return r < 1e21 ? "" + r : (0, Bn.encodeString)("" + r);
                break;
        }
        return r instanceof Date ? (0, Bn.encodeString)(r.toISOString()) : "";
    }, "defaultValueSerializer");
    ce.defaultValueSerializer = hu;
    var gu = /* @__PURE__ */ n((r)=>r instanceof Date, "defaultShouldSerializeObject");
    ce.defaultShouldSerializeObject = gu;
    var Zi = /* @__PURE__ */ n((r)=>r, "identityFunc");
    ce.defaultOptions = {
        nesting: !0,
        nestingSyntax: "dot",
        arrayRepeat: !1,
        arrayRepeatSyntax: "repeat",
        delimiter: 38,
        valueDeserializer: Zi,
        valueSerializer: ce.defaultValueSerializer,
        keyDeserializer: Zi,
        shouldSerializeObject: ce.defaultShouldSerializeObject
    };
});
// ../node_modules/picoquery/lib/object-util.js
var Vn = q((Ft)=>{
    "use strict";
    Object.defineProperty(Ft, "__esModule", {
        value: !0
    });
    Ft.getDeepObject = Tu;
    Ft.stringifyObject = ea;
    var Ge = It(), Su = qn();
    function bu(r) {
        return r === "__proto__" || r === "constructor" || r === "prototype";
    }
    n(bu, "isPrototypeKey");
    function Tu(r, e, t, o, s) {
        if (bu(e)) return r;
        let i = r[e];
        return typeof i == "object" && i !== null ? i : !o && (s || typeof t == "number" || typeof t == "string" && t * 0 === 0 && t.indexOf(".") === -1) ? r[e] = [] : r[e] = {};
    }
    n(Tu, "getDeepObject");
    var Eu = 20, Ru = "[]", Au = "[", xu = "]", vu = ".";
    function ea(r, e, t = 0, o, s) {
        let { nestingSyntax: i = Ge.defaultOptions.nestingSyntax, arrayRepeat: a = Ge.defaultOptions.arrayRepeat, arrayRepeatSyntax: c = Ge.defaultOptions.arrayRepeatSyntax, nesting: l = Ge.defaultOptions.nesting, delimiter: p = Ge.defaultOptions.delimiter, valueSerializer: u = Ge.defaultOptions.valueSerializer, shouldSerializeObject: d = Ge.defaultOptions.shouldSerializeObject } = e, h = typeof p == "number" ? String.fromCharCode(p) : p, S = s === !0 && a, m = i === "dot" || i === "js" && !s;
        if (t > Eu) return "";
        let T = "", y = !0, R = !1;
        for(let x in r){
            let g = r[x], b;
            o ? (b = o, S ? c === "bracket" && (b += Ru) : m ? (b += vu, b += x) : (b += Au, b += x, b += xu)) : b = x, y || (T += h), typeof g == "object" && g !== null && !d(g) ? (R = g.pop !== void 0, (l || a && R) && (T += ea(g, e, t + 1, b, R))) : (T += (0, Su.encodeString)(b), T += "=", T += u(g, x)), y && (y = !1);
        }
        return T;
    }
    n(ea, "stringifyObject");
});
// ../node_modules/fast-decode-uri-component/index.js
var na = q((zb, oa)=>{
    "use strict";
    var ra = 12, wu = 0, Hn = [
        // The first part of the table maps bytes to character to a transition.
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        4,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        6,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        8,
        7,
        7,
        10,
        9,
        9,
        9,
        11,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        // The second part of the table maps a state to a new state when adding a
        // transition.
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        24,
        36,
        48,
        60,
        72,
        84,
        96,
        0,
        12,
        12,
        12,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        24,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        48,
        48,
        48,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        48,
        48,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        48,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // The third part maps the current transition to a mask that needs to apply
        // to the byte.
        127,
        63,
        63,
        63,
        0,
        31,
        15,
        15,
        15,
        7,
        7,
        7
    ];
    function _u(r) {
        var e = r.indexOf("%");
        if (e === -1) return r;
        for(var t = r.length, o = "", s = 0, i = 0, a = e, c = ra; e > -1 && e < t;){
            var l = ta(r[e + 1], 4), p = ta(r[e + 2], 0), u = l | p, d = Hn[u];
            if (c = Hn[256 + c + d], i = i << 6 | u & Hn[364 + d], c === ra) o += r.slice(s, a), o += i <= 65535 ? String.fromCharCode(i) : String.fromCharCode(55232 + (i >> 10), 56320 + (i & 1023)), i = 0, s = e + 3, e = a = r.indexOf("%", s);
            else {
                if (c === wu) return null;
                if (e += 3, e < t && r.charCodeAt(e) === 37) continue;
                return null;
            }
        }
        return o + r.slice(s);
    }
    n(_u, "decodeURIComponent");
    var Cu = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        a: 10,
        A: 10,
        b: 11,
        B: 11,
        c: 12,
        C: 12,
        d: 13,
        D: 13,
        e: 14,
        E: 14,
        f: 15,
        F: 15
    };
    function ta(r, e) {
        var t = Cu[r];
        return t === void 0 ? 255 : t << e;
    }
    n(ta, "hexCodeToInt");
    oa.exports = _u;
});
// ../node_modules/picoquery/lib/parse.js
var la = q((he)=>{
    "use strict";
    var Pu = he && he.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty(he, "__esModule", {
        value: !0
    });
    he.numberValueDeserializer = he.numberKeyDeserializer = void 0;
    he.parse = Fu;
    var Dt = Vn(), qe = It(), sa = Pu(na()), Ou = /* @__PURE__ */ n((r)=>{
        let e = Number(r);
        return Number.isNaN(e) ? r : e;
    }, "numberKeyDeserializer");
    he.numberKeyDeserializer = Ou;
    var Iu = /* @__PURE__ */ n((r)=>{
        let e = Number(r);
        return Number.isNaN(e) ? r : e;
    }, "numberValueDeserializer");
    he.numberValueDeserializer = Iu;
    var ia = /\+/g, aa = /* @__PURE__ */ n(function() {}, "Empty");
    aa.prototype = /* @__PURE__ */ Object.create(null);
    function Nt(r, e, t, o, s) {
        let i = r.substring(e, t);
        return o && (i = i.replace(ia, " ")), s && (i = (0, sa.default)(i) || i), i;
    }
    n(Nt, "computeKeySlice");
    function Fu(r, e) {
        let { valueDeserializer: t = qe.defaultOptions.valueDeserializer, keyDeserializer: o = qe.defaultOptions.keyDeserializer, arrayRepeatSyntax: s = qe.defaultOptions.arrayRepeatSyntax, nesting: i = qe.defaultOptions.nesting, arrayRepeat: a = qe.defaultOptions.arrayRepeat, nestingSyntax: c = qe.defaultOptions.nestingSyntax, delimiter: l = qe.defaultOptions.delimiter } = e ?? {}, p = typeof l == "string" ? l.charCodeAt(0) : l, u = c === "js", d = new aa();
        if (typeof r != "string") return d;
        let h = r.length, S = "", m = -1, T = -1, y = -1, R = d, x, g = "", b = "", v = !1, C = !1, F = !1, U = !1, B = !1, W = !1, se = !1, P = 0, D = -1, M = -1, L = -1;
        for(let N = 0; N < h + 1; N++){
            if (P = N !== h ? r.charCodeAt(N) : p, P === p) {
                if (se = T > m, se || (T = N), y !== T - 1 && (b = Nt(r, y + 1, D > -1 ? D : T, F, v), g = o(b), x !== void 0 && (R = (0, Dt.getDeepObject)(R, x, g, u && B, u && W))), se || g !== "") {
                    se && (S = r.slice(T + 1, N), U && (S = S.replace(ia, " ")), C && (S = (0, sa.default)(S) || S));
                    let H = t(S, g);
                    if (a) {
                        let re = R[g];
                        re === void 0 ? D > -1 ? R[g] = [
                            H
                        ] : R[g] = H : re.pop ? re.push(H) : R[g] = [
                            re,
                            H
                        ];
                    } else R[g] = H;
                }
                S = "", m = N, T = N, v = !1, C = !1, F = !1, U = !1, B = !1, W = !1, D = -1, y = N, R = d, x = void 0, g = "";
            } else P === 93 ? (a && s === "bracket" && L === 91 && (D = M), i && (c === "index" || u) && T <= m && (y !== M && (b = Nt(r, y + 1, N, F, v), g = o(b), x !== void 0 && (R = (0, Dt.getDeepObject)(R, x, g, void 0, u)), x = g, F = !1, v = !1), y = N, W = !0, B = !1)) : P === 46 ? i && (c === "dot" || u) && T <= m && (y !== M && (b = Nt(r, y + 1, N, F, v), g = o(b), x !== void 0 && (R = (0, Dt.getDeepObject)(R, x, g, u)), x = g, F = !1, v = !1), B = !0, W = !1, y = N) : P === 91 ? i && (c === "index" || u) && T <= m && (y !== M && (b = Nt(r, y + 1, N, F, v), g = o(b), u && x !== void 0 && (R = (0, Dt.getDeepObject)(R, x, g, u)), x = g, F = !1, v = !1, B = !1, W = !0), y = N) : P === 61 ? T <= m ? T = N : C = !0 : P === 43 ? T > m ? U = !0 : F = !0 : P === 37 && (T > m ? C = !0 : v = !0);
            M = N, L = P;
        }
        return d;
    }
    n(Fu, "parse");
});
// ../node_modules/picoquery/lib/stringify.js
var ca = q((zn)=>{
    "use strict";
    Object.defineProperty(zn, "__esModule", {
        value: !0
    });
    zn.stringify = Nu;
    var Du = Vn();
    function Nu(r, e) {
        if (r === null || typeof r != "object") return "";
        let t = e ?? {};
        return (0, Du.stringifyObject)(r, t);
    }
    n(Nu, "stringify");
});
// ../node_modules/picoquery/lib/main.js
var kt = q((ne)=>{
    "use strict";
    var ku = ne && ne.__createBinding || (Object.create ? function(r, e, t, o) {
        o === void 0 && (o = t);
        var s = Object.getOwnPropertyDescriptor(e, t);
        (!s || ("get" in s ? !e.__esModule : s.writable || s.configurable)) && (s = {
            enumerable: !0,
            get: /* @__PURE__ */ n(function() {
                return e[t];
            }, "get")
        }), Object.defineProperty(r, o, s);
    } : function(r, e, t, o) {
        o === void 0 && (o = t), r[o] = e[t];
    }), Lu = ne && ne.__exportStar || function(r, e) {
        for(var t in r)t !== "default" && !Object.prototype.hasOwnProperty.call(e, t) && ku(e, r, t);
    };
    Object.defineProperty(ne, "__esModule", {
        value: !0
    });
    ne.stringify = ne.parse = void 0;
    var ju = la();
    Object.defineProperty(ne, "parse", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ju.parse;
        }, "get")
    });
    var Mu = ca();
    Object.defineProperty(ne, "stringify", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Mu.stringify;
        }, "get")
    });
    Lu(It(), ne);
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/entities.json
var Kn = q((lT, zu)=>{
    zu.exports = {
        Aacute: "\xC1",
        aacute: "\xE1",
        Abreve: "\u0102",
        abreve: "\u0103",
        ac: "\u223E",
        acd: "\u223F",
        acE: "\u223E\u0333",
        Acirc: "\
\xC2",
        acirc: "\xE2",
        acute: "\xB4",
        Acy: "\u0410",
        acy: "\u0430",
        AElig: "\xC6",
        aelig: "\xE6",
        af: "\u2061",
        Afr: "\uD835\uDD04",
        afr: "\uD835\uDD1E",
        Agrave: "\xC0",
        agrave: "\xE0",
        alefsym: "\u2135",
        aleph: "\u2135",
        Alpha: "\u0391",
        alpha: "\u03B1",
        Amacr: "\u0100",
        amacr: "\u0101",
        amalg: "\
\u2A3F",
        amp: "&",
        AMP: "&",
        andand: "\u2A55",
        And: "\u2A53",
        and: "\u2227",
        andd: "\u2A5C",
        andslope: "\u2A58",
        andv: "\u2A5A",
        ang: "\u2220",
        ange: "\u29A4",
        angle: "\u2220",
        angmsdaa: "\u29A8",
        angmsdab: "\u29A9",
        angmsdac: "\u29AA",
        angmsdad: "\u29AB",
        angmsdae: "\u29AC",
        angmsdaf: "\
\u29AD",
        angmsdag: "\u29AE",
        angmsdah: "\u29AF",
        angmsd: "\u2221",
        angrt: "\u221F",
        angrtvb: "\u22BE",
        angrtvbd: "\u299D",
        angsph: "\u2222",
        angst: "\xC5",
        angzarr: "\u237C",
        Aogon: "\u0104",
        aogon: "\u0105",
        Aopf: "\uD835\uDD38",
        aopf: "\uD835\uDD52",
        apacir: "\u2A6F",
        ap: "\u2248",
        apE: "\
\u2A70",
        ape: "\u224A",
        apid: "\u224B",
        apos: "'",
        ApplyFunction: "\u2061",
        approx: "\u2248",
        approxeq: "\u224A",
        Aring: "\xC5",
        aring: "\xE5",
        Ascr: "\uD835\uDC9C",
        ascr: "\uD835\uDCB6",
        Assign: "\u2254",
        ast: "*",
        asymp: "\u2248",
        asympeq: "\u224D",
        Atilde: "\xC3",
        atilde: "\xE3",
        Auml: "\
\xC4",
        auml: "\xE4",
        awconint: "\u2233",
        awint: "\u2A11",
        backcong: "\u224C",
        backepsilon: "\u03F6",
        backprime: "\u2035",
        backsim: "\u223D",
        backsimeq: "\u22CD",
        Backslash: "\u2216",
        Barv: "\u2AE7",
        barvee: "\u22BD",
        barwed: "\u2305",
        Barwed: "\u2306",
        barwedge: "\u2305",
        bbrk: "\
\u23B5",
        bbrktbrk: "\u23B6",
        bcong: "\u224C",
        Bcy: "\u0411",
        bcy: "\u0431",
        bdquo: "\u201E",
        becaus: "\u2235",
        because: "\u2235",
        Because: "\
\u2235",
        bemptyv: "\u29B0",
        bepsi: "\u03F6",
        bernou: "\u212C",
        Bernoullis: "\u212C",
        Beta: "\u0392",
        beta: "\u03B2",
        beth: "\u2136",
        between: "\
\u226C",
        Bfr: "\uD835\uDD05",
        bfr: "\uD835\uDD1F",
        bigcap: "\u22C2",
        bigcirc: "\u25EF",
        bigcup: "\u22C3",
        bigodot: "\u2A00",
        bigoplus: "\u2A01",
        bigotimes: "\
\u2A02",
        bigsqcup: "\u2A06",
        bigstar: "\u2605",
        bigtriangledown: "\u25BD",
        bigtriangleup: "\u25B3",
        biguplus: "\u2A04",
        bigvee: "\u22C1",
        bigwedge: "\
\u22C0",
        bkarow: "\u290D",
        blacklozenge: "\u29EB",
        blacksquare: "\u25AA",
        blacktriangle: "\u25B4",
        blacktriangledown: "\u25BE",
        blacktriangleleft: "\
\u25C2",
        blacktriangleright: "\u25B8",
        blank: "\u2423",
        blk12: "\u2592",
        blk14: "\u2591",
        blk34: "\u2593",
        block: "\u2588",
        bne: "=\u20E5",
        bnequiv: "\
\u2261\u20E5",
        bNot: "\u2AED",
        bnot: "\u2310",
        Bopf: "\uD835\uDD39",
        bopf: "\uD835\uDD53",
        bot: "\u22A5",
        bottom: "\u22A5",
        bowtie: "\u22C8",
        boxbox: "\
\u29C9",
        boxdl: "\u2510",
        boxdL: "\u2555",
        boxDl: "\u2556",
        boxDL: "\u2557",
        boxdr: "\u250C",
        boxdR: "\u2552",
        boxDr: "\u2553",
        boxDR: "\u2554",
        boxh: "\u2500",
        boxH: "\u2550",
        boxhd: "\u252C",
        boxHd: "\u2564",
        boxhD: "\u2565",
        boxHD: "\u2566",
        boxhu: "\u2534",
        boxHu: "\u2567",
        boxhU: "\
\u2568",
        boxHU: "\u2569",
        boxminus: "\u229F",
        boxplus: "\u229E",
        boxtimes: "\u22A0",
        boxul: "\u2518",
        boxuL: "\u255B",
        boxUl: "\u255C",
        boxUL: "\
\u255D",
        boxur: "\u2514",
        boxuR: "\u2558",
        boxUr: "\u2559",
        boxUR: "\u255A",
        boxv: "\u2502",
        boxV: "\u2551",
        boxvh: "\u253C",
        boxvH: "\u256A",
        boxVh: "\u256B",
        boxVH: "\u256C",
        boxvl: "\u2524",
        boxvL: "\u2561",
        boxVl: "\u2562",
        boxVL: "\u2563",
        boxvr: "\u251C",
        boxvR: "\u255E",
        boxVr: "\
\u255F",
        boxVR: "\u2560",
        bprime: "\u2035",
        breve: "\u02D8",
        Breve: "\u02D8",
        brvbar: "\xA6",
        bscr: "\uD835\uDCB7",
        Bscr: "\u212C",
        bsemi: "\u204F",
        bsim: "\u223D",
        bsime: "\u22CD",
        bsolb: "\u29C5",
        bsol: "\\",
        bsolhsub: "\u27C8",
        bull: "\u2022",
        bullet: "\u2022",
        bump: "\u224E",
        bumpE: "\
\u2AAE",
        bumpe: "\u224F",
        Bumpeq: "\u224E",
        bumpeq: "\u224F",
        Cacute: "\u0106",
        cacute: "\u0107",
        capand: "\u2A44",
        capbrcup: "\u2A49",
        capcap: "\
\u2A4B",
        cap: "\u2229",
        Cap: "\u22D2",
        capcup: "\u2A47",
        capdot: "\u2A40",
        CapitalDifferentialD: "\u2145",
        caps: "\u2229\uFE00",
        caret: "\u2041",
        caron: "\u02C7",
        Cayleys: "\u212D",
        ccaps: "\u2A4D",
        Ccaron: "\u010C",
        ccaron: "\u010D",
        Ccedil: "\xC7",
        ccedil: "\xE7",
        Ccirc: "\u0108",
        ccirc: "\
\u0109",
        Cconint: "\u2230",
        ccups: "\u2A4C",
        ccupssm: "\u2A50",
        Cdot: "\u010A",
        cdot: "\u010B",
        cedil: "\xB8",
        Cedilla: "\xB8",
        cemptyv: "\u29B2",
        cent: "\xA2",
        centerdot: "\xB7",
        CenterDot: "\xB7",
        cfr: "\uD835\uDD20",
        Cfr: "\u212D",
        CHcy: "\u0427",
        chcy: "\u0447",
        check: "\u2713",
        checkmark: "\
\u2713",
        Chi: "\u03A7",
        chi: "\u03C7",
        circ: "\u02C6",
        circeq: "\u2257",
        circlearrowleft: "\u21BA",
        circlearrowright: "\u21BB",
        circledast: "\
\u229B",
        circledcirc: "\u229A",
        circleddash: "\u229D",
        CircleDot: "\u2299",
        circledR: "\xAE",
        circledS: "\u24C8",
        CircleMinus: "\u2296",
        CirclePlus: "\
\u2295",
        CircleTimes: "\u2297",
        cir: "\u25CB",
        cirE: "\u29C3",
        cire: "\u2257",
        cirfnint: "\u2A10",
        cirmid: "\u2AEF",
        cirscir: "\u29C2",
        ClockwiseContourIntegral: "\
\u2232",
        CloseCurlyDoubleQuote: "\u201D",
        CloseCurlyQuote: "\u2019",
        clubs: "\u2663",
        clubsuit: "\u2663",
        colon: ":",
        Colon: "\u2237",
        Colone: "\
\u2A74",
        colone: "\u2254",
        coloneq: "\u2254",
        comma: ",",
        commat: "@",
        comp: "\u2201",
        compfn: "\u2218",
        complement: "\u2201",
        complexes: "\u2102",
        cong: "\u2245",
        congdot: "\u2A6D",
        Congruent: "\u2261",
        conint: "\u222E",
        Conint: "\u222F",
        ContourIntegral: "\u222E",
        copf: "\uD835\uDD54",
        Copf: "\
\u2102",
        coprod: "\u2210",
        Coproduct: "\u2210",
        copy: "\xA9",
        COPY: "\xA9",
        copysr: "\u2117",
        CounterClockwiseContourIntegral: "\u2233",
        crarr: "\
\u21B5",
        cross: "\u2717",
        Cross: "\u2A2F",
        Cscr: "\uD835\uDC9E",
        cscr: "\uD835\uDCB8",
        csub: "\u2ACF",
        csube: "\u2AD1",
        csup: "\u2AD0",
        csupe: "\u2AD2",
        ctdot: "\u22EF",
        cudarrl: "\u2938",
        cudarrr: "\u2935",
        cuepr: "\u22DE",
        cuesc: "\u22DF",
        cularr: "\u21B6",
        cularrp: "\u293D",
        cupbrcap: "\u2A48",
        cupcap: "\u2A46",
        CupCap: "\u224D",
        cup: "\u222A",
        Cup: "\u22D3",
        cupcup: "\u2A4A",
        cupdot: "\u228D",
        cupor: "\u2A45",
        cups: "\u222A\uFE00",
        curarr: "\u21B7",
        curarrm: "\u293C",
        curlyeqprec: "\u22DE",
        curlyeqsucc: "\u22DF",
        curlyvee: "\u22CE",
        curlywedge: "\u22CF",
        curren: "\xA4",
        curvearrowleft: "\u21B6",
        curvearrowright: "\u21B7",
        cuvee: "\u22CE",
        cuwed: "\u22CF",
        cwconint: "\u2232",
        cwint: "\u2231",
        cylcty: "\u232D",
        dagger: "\u2020",
        Dagger: "\u2021",
        daleth: "\u2138",
        darr: "\u2193",
        Darr: "\u21A1",
        dArr: "\u21D3",
        dash: "\u2010",
        Dashv: "\u2AE4",
        dashv: "\
\u22A3",
        dbkarow: "\u290F",
        dblac: "\u02DD",
        Dcaron: "\u010E",
        dcaron: "\u010F",
        Dcy: "\u0414",
        dcy: "\u0434",
        ddagger: "\u2021",
        ddarr: "\u21CA",
        DD: "\u2145",
        dd: "\u2146",
        DDotrahd: "\u2911",
        ddotseq: "\u2A77",
        deg: "\xB0",
        Del: "\u2207",
        Delta: "\u0394",
        delta: "\u03B4",
        demptyv: "\
\u29B1",
        dfisht: "\u297F",
        Dfr: "\uD835\uDD07",
        dfr: "\uD835\uDD21",
        dHar: "\u2965",
        dharl: "\u21C3",
        dharr: "\u21C2",
        DiacriticalAcute: "\xB4",
        DiacriticalDot: "\
\u02D9",
        DiacriticalDoubleAcute: "\u02DD",
        DiacriticalGrave: "`",
        DiacriticalTilde: "\u02DC",
        diam: "\u22C4",
        diamond: "\u22C4",
        Diamond: "\u22C4",
        diamondsuit: "\u2666",
        diams: "\u2666",
        die: "\xA8",
        DifferentialD: "\u2146",
        digamma: "\u03DD",
        disin: "\u22F2",
        div: "\xF7",
        divide: "\xF7",
        divideontimes: "\u22C7",
        divonx: "\u22C7",
        DJcy: "\u0402",
        djcy: "\u0452",
        dlcorn: "\u231E",
        dlcrop: "\u230D",
        dollar: "$",
        Dopf: "\uD835\uDD3B",
        dopf: "\uD835\uDD55",
        Dot: "\xA8",
        dot: "\u02D9",
        DotDot: "\u20DC",
        doteq: "\u2250",
        doteqdot: "\u2251",
        DotEqual: "\u2250",
        dotminus: "\u2238",
        dotplus: "\u2214",
        dotsquare: "\u22A1",
        doublebarwedge: "\u2306",
        DoubleContourIntegral: "\u222F",
        DoubleDot: "\xA8",
        DoubleDownArrow: "\u21D3",
        DoubleLeftArrow: "\u21D0",
        DoubleLeftRightArrow: "\u21D4",
        DoubleLeftTee: "\u2AE4",
        DoubleLongLeftArrow: "\u27F8",
        DoubleLongLeftRightArrow: "\
\u27FA",
        DoubleLongRightArrow: "\u27F9",
        DoubleRightArrow: "\u21D2",
        DoubleRightTee: "\u22A8",
        DoubleUpArrow: "\u21D1",
        DoubleUpDownArrow: "\
\u21D5",
        DoubleVerticalBar: "\u2225",
        DownArrowBar: "\u2913",
        downarrow: "\u2193",
        DownArrow: "\u2193",
        Downarrow: "\u21D3",
        DownArrowUpArrow: "\
\u21F5",
        DownBreve: "\u0311",
        downdownarrows: "\u21CA",
        downharpoonleft: "\u21C3",
        downharpoonright: "\u21C2",
        DownLeftRightVector: "\u2950",
        DownLeftTeeVector: "\u295E",
        DownLeftVectorBar: "\u2956",
        DownLeftVector: "\u21BD",
        DownRightTeeVector: "\u295F",
        DownRightVectorBar: "\u2957",
        DownRightVector: "\u21C1",
        DownTeeArrow: "\u21A7",
        DownTee: "\u22A4",
        drbkarow: "\u2910",
        drcorn: "\u231F",
        drcrop: "\u230C",
        Dscr: "\uD835\uDC9F",
        dscr: "\uD835\uDCB9",
        DScy: "\u0405",
        dscy: "\u0455",
        dsol: "\u29F6",
        Dstrok: "\u0110",
        dstrok: "\u0111",
        dtdot: "\u22F1",
        dtri: "\u25BF",
        dtrif: "\
\u25BE",
        duarr: "\u21F5",
        duhar: "\u296F",
        dwangle: "\u29A6",
        DZcy: "\u040F",
        dzcy: "\u045F",
        dzigrarr: "\u27FF",
        Eacute: "\xC9",
        eacute: "\xE9",
        easter: "\u2A6E",
        Ecaron: "\u011A",
        ecaron: "\u011B",
        Ecirc: "\xCA",
        ecirc: "\xEA",
        ecir: "\u2256",
        ecolon: "\u2255",
        Ecy: "\u042D",
        ecy: "\
\u044D",
        eDDot: "\u2A77",
        Edot: "\u0116",
        edot: "\u0117",
        eDot: "\u2251",
        ee: "\u2147",
        efDot: "\u2252",
        Efr: "\uD835\uDD08",
        efr: "\uD835\uDD22",
        eg: "\u2A9A",
        Egrave: "\xC8",
        egrave: "\xE8",
        egs: "\u2A96",
        egsdot: "\u2A98",
        el: "\u2A99",
        Element: "\u2208",
        elinters: "\u23E7",
        ell: "\
\u2113",
        els: "\u2A95",
        elsdot: "\u2A97",
        Emacr: "\u0112",
        emacr: "\u0113",
        empty: "\u2205",
        emptyset: "\u2205",
        EmptySmallSquare: "\u25FB",
        emptyv: "\u2205",
        EmptyVerySmallSquare: "\u25AB",
        emsp13: "\u2004",
        emsp14: "\u2005",
        emsp: "\u2003",
        ENG: "\u014A",
        eng: "\u014B",
        ensp: "\
\u2002",
        Eogon: "\u0118",
        eogon: "\u0119",
        Eopf: "\uD835\uDD3C",
        eopf: "\uD835\uDD56",
        epar: "\u22D5",
        eparsl: "\u29E3",
        eplus: "\u2A71",
        epsi: "\u03B5",
        Epsilon: "\u0395",
        epsilon: "\u03B5",
        epsiv: "\u03F5",
        eqcirc: "\u2256",
        eqcolon: "\u2255",
        eqsim: "\u2242",
        eqslantgtr: "\u2A96",
        eqslantless: "\
\u2A95",
        Equal: "\u2A75",
        equals: "=",
        EqualTilde: "\u2242",
        equest: "\u225F",
        Equilibrium: "\u21CC",
        equiv: "\u2261",
        equivDD: "\u2A78",
        eqvparsl: "\
\u29E5",
        erarr: "\u2971",
        erDot: "\u2253",
        escr: "\u212F",
        Escr: "\u2130",
        esdot: "\u2250",
        Esim: "\u2A73",
        esim: "\u2242",
        Eta: "\u0397",
        eta: "\
\u03B7",
        ETH: "\xD0",
        eth: "\xF0",
        Euml: "\xCB",
        euml: "\xEB",
        euro: "\u20AC",
        excl: "!",
        exist: "\u2203",
        Exists: "\u2203",
        expectation: "\u2130",
        exponentiale: "\u2147",
        ExponentialE: "\u2147",
        fallingdotseq: "\u2252",
        Fcy: "\u0424",
        fcy: "\u0444",
        female: "\u2640",
        ffilig: "\uFB03",
        fflig: "\uFB00",
        ffllig: "\uFB04",
        Ffr: "\uD835\uDD09",
        ffr: "\uD835\uDD23",
        filig: "\uFB01",
        FilledSmallSquare: "\u25FC",
        FilledVerySmallSquare: "\
\u25AA",
        fjlig: "fj",
        flat: "\u266D",
        fllig: "\uFB02",
        fltns: "\u25B1",
        fnof: "\u0192",
        Fopf: "\uD835\uDD3D",
        fopf: "\uD835\uDD57",
        forall: "\u2200",
        ForAll: "\u2200",
        fork: "\u22D4",
        forkv: "\u2AD9",
        Fouriertrf: "\u2131",
        fpartint: "\u2A0D",
        frac12: "\xBD",
        frac13: "\u2153",
        frac14: "\xBC",
        frac15: "\u2155",
        frac16: "\u2159",
        frac18: "\u215B",
        frac23: "\u2154",
        frac25: "\u2156",
        frac34: "\xBE",
        frac35: "\u2157",
        frac38: "\u215C",
        frac45: "\u2158",
        frac56: "\u215A",
        frac58: "\u215D",
        frac78: "\u215E",
        frasl: "\u2044",
        frown: "\u2322",
        fscr: "\uD835\uDCBB",
        Fscr: "\u2131",
        gacute: "\u01F5",
        Gamma: "\u0393",
        gamma: "\u03B3",
        Gammad: "\u03DC",
        gammad: "\u03DD",
        gap: "\u2A86",
        Gbreve: "\u011E",
        gbreve: "\u011F",
        Gcedil: "\u0122",
        Gcirc: "\u011C",
        gcirc: "\u011D",
        Gcy: "\u0413",
        gcy: "\u0433",
        Gdot: "\u0120",
        gdot: "\u0121",
        ge: "\u2265",
        gE: "\u2267",
        gEl: "\u2A8C",
        gel: "\u22DB",
        geq: "\u2265",
        geqq: "\u2267",
        geqslant: "\u2A7E",
        gescc: "\u2AA9",
        ges: "\u2A7E",
        gesdot: "\u2A80",
        gesdoto: "\
\u2A82",
        gesdotol: "\u2A84",
        gesl: "\u22DB\uFE00",
        gesles: "\u2A94",
        Gfr: "\uD835\uDD0A",
        gfr: "\uD835\uDD24",
        gg: "\u226B",
        Gg: "\u22D9",
        ggg: "\u22D9",
        gimel: "\u2137",
        GJcy: "\u0403",
        gjcy: "\u0453",
        gla: "\u2AA5",
        gl: "\u2277",
        glE: "\u2A92",
        glj: "\u2AA4",
        gnap: "\u2A8A",
        gnapprox: "\u2A8A",
        gne: "\u2A88",
        gnE: "\u2269",
        gneq: "\u2A88",
        gneqq: "\u2269",
        gnsim: "\u22E7",
        Gopf: "\uD835\uDD3E",
        gopf: "\uD835\uDD58",
        grave: "`",
        GreaterEqual: "\
\u2265",
        GreaterEqualLess: "\u22DB",
        GreaterFullEqual: "\u2267",
        GreaterGreater: "\u2AA2",
        GreaterLess: "\u2277",
        GreaterSlantEqual: "\u2A7E",
        GreaterTilde: "\u2273",
        Gscr: "\uD835\uDCA2",
        gscr: "\u210A",
        gsim: "\u2273",
        gsime: "\u2A8E",
        gsiml: "\u2A90",
        gtcc: "\u2AA7",
        gtcir: "\u2A7A",
        gt: ">",
        GT: ">",
        Gt: "\u226B",
        gtdot: "\u22D7",
        gtlPar: "\u2995",
        gtquest: "\u2A7C",
        gtrapprox: "\u2A86",
        gtrarr: "\u2978",
        gtrdot: "\u22D7",
        gtreqless: "\u22DB",
        gtreqqless: "\u2A8C",
        gtrless: "\u2277",
        gtrsim: "\u2273",
        gvertneqq: "\u2269\uFE00",
        gvnE: "\u2269\uFE00",
        Hacek: "\u02C7",
        hairsp: "\u200A",
        half: "\xBD",
        hamilt: "\u210B",
        HARDcy: "\u042A",
        hardcy: "\u044A",
        harrcir: "\u2948",
        harr: "\u2194",
        hArr: "\u21D4",
        harrw: "\
\u21AD",
        Hat: "^",
        hbar: "\u210F",
        Hcirc: "\u0124",
        hcirc: "\u0125",
        hearts: "\u2665",
        heartsuit: "\u2665",
        hellip: "\u2026",
        hercon: "\u22B9",
        hfr: "\uD835\uDD25",
        Hfr: "\u210C",
        HilbertSpace: "\u210B",
        hksearow: "\u2925",
        hkswarow: "\u2926",
        hoarr: "\u21FF",
        homtht: "\u223B",
        hookleftarrow: "\
\u21A9",
        hookrightarrow: "\u21AA",
        hopf: "\uD835\uDD59",
        Hopf: "\u210D",
        horbar: "\u2015",
        HorizontalLine: "\u2500",
        hscr: "\uD835\uDCBD",
        Hscr: "\
\u210B",
        hslash: "\u210F",
        Hstrok: "\u0126",
        hstrok: "\u0127",
        HumpDownHump: "\u224E",
        HumpEqual: "\u224F",
        hybull: "\u2043",
        hyphen: "\u2010",
        Iacute: "\xCD",
        iacute: "\xED",
        ic: "\u2063",
        Icirc: "\xCE",
        icirc: "\xEE",
        Icy: "\u0418",
        icy: "\u0438",
        Idot: "\u0130",
        IEcy: "\u0415",
        iecy: "\
\u0435",
        iexcl: "\xA1",
        iff: "\u21D4",
        ifr: "\uD835\uDD26",
        Ifr: "\u2111",
        Igrave: "\xCC",
        igrave: "\xEC",
        ii: "\u2148",
        iiiint: "\u2A0C",
        iiint: "\
\u222D",
        iinfin: "\u29DC",
        iiota: "\u2129",
        IJlig: "\u0132",
        ijlig: "\u0133",
        Imacr: "\u012A",
        imacr: "\u012B",
        image: "\u2111",
        ImaginaryI: "\
\u2148",
        imagline: "\u2110",
        imagpart: "\u2111",
        imath: "\u0131",
        Im: "\u2111",
        imof: "\u22B7",
        imped: "\u01B5",
        Implies: "\u21D2",
        incare: "\
\u2105",
        in: "\u2208",
        infin: "\u221E",
        infintie: "\u29DD",
        inodot: "\u0131",
        intcal: "\u22BA",
        int: "\u222B",
        Int: "\u222C",
        integers: "\u2124",
        Integral: "\u222B",
        intercal: "\u22BA",
        Intersection: "\u22C2",
        intlarhk: "\u2A17",
        intprod: "\u2A3C",
        InvisibleComma: "\u2063",
        InvisibleTimes: "\
\u2062",
        IOcy: "\u0401",
        iocy: "\u0451",
        Iogon: "\u012E",
        iogon: "\u012F",
        Iopf: "\uD835\uDD40",
        iopf: "\uD835\uDD5A",
        Iota: "\u0399",
        iota: "\u03B9",
        iprod: "\u2A3C",
        iquest: "\xBF",
        iscr: "\uD835\uDCBE",
        Iscr: "\u2110",
        isin: "\u2208",
        isindot: "\u22F5",
        isinE: "\u22F9",
        isins: "\u22F4",
        isinsv: "\
\u22F3",
        isinv: "\u2208",
        it: "\u2062",
        Itilde: "\u0128",
        itilde: "\u0129",
        Iukcy: "\u0406",
        iukcy: "\u0456",
        Iuml: "\xCF",
        iuml: "\xEF",
        Jcirc: "\
\u0134",
        jcirc: "\u0135",
        Jcy: "\u0419",
        jcy: "\u0439",
        Jfr: "\uD835\uDD0D",
        jfr: "\uD835\uDD27",
        jmath: "\u0237",
        Jopf: "\uD835\uDD41",
        jopf: "\uD835\uDD5B",
        Jscr: "\uD835\uDCA5",
        jscr: "\uD835\uDCBF",
        Jsercy: "\u0408",
        jsercy: "\u0458",
        Jukcy: "\u0404",
        jukcy: "\u0454",
        Kappa: "\u039A",
        kappa: "\u03BA",
        kappav: "\u03F0",
        Kcedil: "\u0136",
        kcedil: "\u0137",
        Kcy: "\u041A",
        kcy: "\u043A",
        Kfr: "\uD835\uDD0E",
        kfr: "\uD835\uDD28",
        kgreen: "\u0138",
        KHcy: "\
\u0425",
        khcy: "\u0445",
        KJcy: "\u040C",
        kjcy: "\u045C",
        Kopf: "\uD835\uDD42",
        kopf: "\uD835\uDD5C",
        Kscr: "\uD835\uDCA6",
        kscr: "\uD835\uDCC0",
        lAarr: "\
\u21DA",
        Lacute: "\u0139",
        lacute: "\u013A",
        laemptyv: "\u29B4",
        lagran: "\u2112",
        Lambda: "\u039B",
        lambda: "\u03BB",
        lang: "\u27E8",
        Lang: "\
\u27EA",
        langd: "\u2991",
        langle: "\u27E8",
        lap: "\u2A85",
        Laplacetrf: "\u2112",
        laquo: "\xAB",
        larrb: "\u21E4",
        larrbfs: "\u291F",
        larr: "\u2190",
        Larr: "\u219E",
        lArr: "\u21D0",
        larrfs: "\u291D",
        larrhk: "\u21A9",
        larrlp: "\u21AB",
        larrpl: "\u2939",
        larrsim: "\u2973",
        larrtl: "\u21A2",
        latail: "\u2919",
        lAtail: "\u291B",
        lat: "\u2AAB",
        late: "\u2AAD",
        lates: "\u2AAD\uFE00",
        lbarr: "\u290C",
        lBarr: "\u290E",
        lbbrk: "\u2772",
        lbrace: "{",
        lbrack: "[",
        lbrke: "\u298B",
        lbrksld: "\u298F",
        lbrkslu: "\u298D",
        Lcaron: "\u013D",
        lcaron: "\u013E",
        Lcedil: "\u013B",
        lcedil: "\
\u013C",
        lceil: "\u2308",
        lcub: "{",
        Lcy: "\u041B",
        lcy: "\u043B",
        ldca: "\u2936",
        ldquo: "\u201C",
        ldquor: "\u201E",
        ldrdhar: "\u2967",
        ldrushar: "\
\u294B",
        ldsh: "\u21B2",
        le: "\u2264",
        lE: "\u2266",
        LeftAngleBracket: "\u27E8",
        LeftArrowBar: "\u21E4",
        leftarrow: "\u2190",
        LeftArrow: "\u2190",
        Leftarrow: "\u21D0",
        LeftArrowRightArrow: "\u21C6",
        leftarrowtail: "\u21A2",
        LeftCeiling: "\u2308",
        LeftDoubleBracket: "\u27E6",
        LeftDownTeeVector: "\
\u2961",
        LeftDownVectorBar: "\u2959",
        LeftDownVector: "\u21C3",
        LeftFloor: "\u230A",
        leftharpoondown: "\u21BD",
        leftharpoonup: "\u21BC",
        leftleftarrows: "\
\u21C7",
        leftrightarrow: "\u2194",
        LeftRightArrow: "\u2194",
        Leftrightarrow: "\u21D4",
        leftrightarrows: "\u21C6",
        leftrightharpoons: "\u21CB",
        leftrightsquigarrow: "\u21AD",
        LeftRightVector: "\u294E",
        LeftTeeArrow: "\u21A4",
        LeftTee: "\u22A3",
        LeftTeeVector: "\u295A",
        leftthreetimes: "\
\u22CB",
        LeftTriangleBar: "\u29CF",
        LeftTriangle: "\u22B2",
        LeftTriangleEqual: "\u22B4",
        LeftUpDownVector: "\u2951",
        LeftUpTeeVector: "\u2960",
        LeftUpVectorBar: "\u2958",
        LeftUpVector: "\u21BF",
        LeftVectorBar: "\u2952",
        LeftVector: "\u21BC",
        lEg: "\u2A8B",
        leg: "\u22DA",
        leq: "\u2264",
        leqq: "\u2266",
        leqslant: "\u2A7D",
        lescc: "\u2AA8",
        les: "\u2A7D",
        lesdot: "\u2A7F",
        lesdoto: "\u2A81",
        lesdotor: "\u2A83",
        lesg: "\u22DA\uFE00",
        lesges: "\u2A93",
        lessapprox: "\u2A85",
        lessdot: "\u22D6",
        lesseqgtr: "\u22DA",
        lesseqqgtr: "\u2A8B",
        LessEqualGreater: "\u22DA",
        LessFullEqual: "\
\u2266",
        LessGreater: "\u2276",
        lessgtr: "\u2276",
        LessLess: "\u2AA1",
        lesssim: "\u2272",
        LessSlantEqual: "\u2A7D",
        LessTilde: "\u2272",
        lfisht: "\
\u297C",
        lfloor: "\u230A",
        Lfr: "\uD835\uDD0F",
        lfr: "\uD835\uDD29",
        lg: "\u2276",
        lgE: "\u2A91",
        lHar: "\u2962",
        lhard: "\u21BD",
        lharu: "\u21BC",
        lharul: "\u296A",
        lhblk: "\u2584",
        LJcy: "\u0409",
        ljcy: "\u0459",
        llarr: "\u21C7",
        ll: "\u226A",
        Ll: "\u22D8",
        llcorner: "\u231E",
        Lleftarrow: "\
\u21DA",
        llhard: "\u296B",
        lltri: "\u25FA",
        Lmidot: "\u013F",
        lmidot: "\u0140",
        lmoustache: "\u23B0",
        lmoust: "\u23B0",
        lnap: "\u2A89",
        lnapprox: "\
\u2A89",
        lne: "\u2A87",
        lnE: "\u2268",
        lneq: "\u2A87",
        lneqq: "\u2268",
        lnsim: "\u22E6",
        loang: "\u27EC",
        loarr: "\u21FD",
        lobrk: "\u27E6",
        longleftarrow: "\
\u27F5",
        LongLeftArrow: "\u27F5",
        Longleftarrow: "\u27F8",
        longleftrightarrow: "\u27F7",
        LongLeftRightArrow: "\u27F7",
        Longleftrightarrow: "\
\u27FA",
        longmapsto: "\u27FC",
        longrightarrow: "\u27F6",
        LongRightArrow: "\u27F6",
        Longrightarrow: "\u27F9",
        looparrowleft: "\u21AB",
        looparrowright: "\
\u21AC",
        lopar: "\u2985",
        Lopf: "\uD835\uDD43",
        lopf: "\uD835\uDD5D",
        loplus: "\u2A2D",
        lotimes: "\u2A34",
        lowast: "\u2217",
        lowbar: "_",
        LowerLeftArrow: "\
\u2199",
        LowerRightArrow: "\u2198",
        loz: "\u25CA",
        lozenge: "\u25CA",
        lozf: "\u29EB",
        lpar: "(",
        lparlt: "\u2993",
        lrarr: "\u21C6",
        lrcorner: "\
\u231F",
        lrhar: "\u21CB",
        lrhard: "\u296D",
        lrm: "\u200E",
        lrtri: "\u22BF",
        lsaquo: "\u2039",
        lscr: "\uD835\uDCC1",
        Lscr: "\u2112",
        lsh: "\u21B0",
        Lsh: "\u21B0",
        lsim: "\u2272",
        lsime: "\u2A8D",
        lsimg: "\u2A8F",
        lsqb: "[",
        lsquo: "\u2018",
        lsquor: "\u201A",
        Lstrok: "\u0141",
        lstrok: "\
\u0142",
        ltcc: "\u2AA6",
        ltcir: "\u2A79",
        lt: "<",
        LT: "<",
        Lt: "\u226A",
        ltdot: "\u22D6",
        lthree: "\u22CB",
        ltimes: "\u22C9",
        ltlarr: "\u2976",
        ltquest: "\u2A7B",
        ltri: "\u25C3",
        ltrie: "\u22B4",
        ltrif: "\u25C2",
        ltrPar: "\u2996",
        lurdshar: "\u294A",
        luruhar: "\u2966",
        lvertneqq: "\
\u2268\uFE00",
        lvnE: "\u2268\uFE00",
        macr: "\xAF",
        male: "\u2642",
        malt: "\u2720",
        maltese: "\u2720",
        Map: "\u2905",
        map: "\u21A6",
        mapsto: "\
\u21A6",
        mapstodown: "\u21A7",
        mapstoleft: "\u21A4",
        mapstoup: "\u21A5",
        marker: "\u25AE",
        mcomma: "\u2A29",
        Mcy: "\u041C",
        mcy: "\u043C",
        mdash: "\
\u2014",
        mDDot: "\u223A",
        measuredangle: "\u2221",
        MediumSpace: "\u205F",
        Mellintrf: "\u2133",
        Mfr: "\uD835\uDD10",
        mfr: "\uD835\uDD2A",
        mho: "\u2127",
        micro: "\xB5",
        midast: "*",
        midcir: "\u2AF0",
        mid: "\u2223",
        middot: "\xB7",
        minusb: "\u229F",
        minus: "\u2212",
        minusd: "\u2238",
        minusdu: "\
\u2A2A",
        MinusPlus: "\u2213",
        mlcp: "\u2ADB",
        mldr: "\u2026",
        mnplus: "\u2213",
        models: "\u22A7",
        Mopf: "\uD835\uDD44",
        mopf: "\uD835\uDD5E",
        mp: "\
\u2213",
        mscr: "\uD835\uDCC2",
        Mscr: "\u2133",
        mstpos: "\u223E",
        Mu: "\u039C",
        mu: "\u03BC",
        multimap: "\u22B8",
        mumap: "\u22B8",
        nabla: "\u2207",
        Nacute: "\u0143",
        nacute: "\u0144",
        nang: "\u2220\u20D2",
        nap: "\u2249",
        napE: "\u2A70\u0338",
        napid: "\u224B\u0338",
        napos: "\u0149",
        napprox: "\
\u2249",
        natural: "\u266E",
        naturals: "\u2115",
        natur: "\u266E",
        nbsp: "\xA0",
        nbump: "\u224E\u0338",
        nbumpe: "\u224F\u0338",
        ncap: "\u2A43",
        Ncaron: "\u0147",
        ncaron: "\u0148",
        Ncedil: "\u0145",
        ncedil: "\u0146",
        ncong: "\u2247",
        ncongdot: "\u2A6D\u0338",
        ncup: "\u2A42",
        Ncy: "\u041D",
        ncy: "\u043D",
        ndash: "\u2013",
        nearhk: "\u2924",
        nearr: "\u2197",
        neArr: "\u21D7",
        nearrow: "\u2197",
        ne: "\u2260",
        nedot: "\u2250\u0338",
        NegativeMediumSpace: "\u200B",
        NegativeThickSpace: "\u200B",
        NegativeThinSpace: "\u200B",
        NegativeVeryThinSpace: "\u200B",
        nequiv: "\u2262",
        nesear: "\u2928",
        nesim: "\u2242\u0338",
        NestedGreaterGreater: "\u226B",
        NestedLessLess: "\u226A",
        NewLine: `
`,
        nexist: "\u2204",
        nexists: "\u2204",
        Nfr: "\uD835\uDD11",
        nfr: "\uD835\uDD2B",
        ngE: "\u2267\u0338",
        nge: "\u2271",
        ngeq: "\u2271",
        ngeqq: "\u2267\u0338",
        ngeqslant: "\u2A7E\u0338",
        nges: "\u2A7E\u0338",
        nGg: "\u22D9\u0338",
        ngsim: "\u2275",
        nGt: "\u226B\u20D2",
        ngt: "\u226F",
        ngtr: "\u226F",
        nGtv: "\u226B\u0338",
        nharr: "\u21AE",
        nhArr: "\u21CE",
        nhpar: "\u2AF2",
        ni: "\u220B",
        nis: "\u22FC",
        nisd: "\u22FA",
        niv: "\u220B",
        NJcy: "\
\u040A",
        njcy: "\u045A",
        nlarr: "\u219A",
        nlArr: "\u21CD",
        nldr: "\u2025",
        nlE: "\u2266\u0338",
        nle: "\u2270",
        nleftarrow: "\u219A",
        nLeftarrow: "\
\u21CD",
        nleftrightarrow: "\u21AE",
        nLeftrightarrow: "\u21CE",
        nleq: "\u2270",
        nleqq: "\u2266\u0338",
        nleqslant: "\u2A7D\u0338",
        nles: "\u2A7D\u0338",
        nless: "\u226E",
        nLl: "\u22D8\u0338",
        nlsim: "\u2274",
        nLt: "\u226A\u20D2",
        nlt: "\u226E",
        nltri: "\u22EA",
        nltrie: "\u22EC",
        nLtv: "\u226A\u0338",
        nmid: "\u2224",
        NoBreak: "\u2060",
        NonBreakingSpace: "\xA0",
        nopf: "\uD835\uDD5F",
        Nopf: "\u2115",
        Not: "\u2AEC",
        not: "\xAC",
        NotCongruent: "\
\u2262",
        NotCupCap: "\u226D",
        NotDoubleVerticalBar: "\u2226",
        NotElement: "\u2209",
        NotEqual: "\u2260",
        NotEqualTilde: "\u2242\u0338",
        NotExists: "\
\u2204",
        NotGreater: "\u226F",
        NotGreaterEqual: "\u2271",
        NotGreaterFullEqual: "\u2267\u0338",
        NotGreaterGreater: "\u226B\u0338",
        NotGreaterLess: "\
\u2279",
        NotGreaterSlantEqual: "\u2A7E\u0338",
        NotGreaterTilde: "\u2275",
        NotHumpDownHump: "\u224E\u0338",
        NotHumpEqual: "\u224F\u0338",
        notin: "\
\u2209",
        notindot: "\u22F5\u0338",
        notinE: "\u22F9\u0338",
        notinva: "\u2209",
        notinvb: "\u22F7",
        notinvc: "\u22F6",
        NotLeftTriangleBar: "\u29CF\u0338",
        NotLeftTriangle: "\u22EA",
        NotLeftTriangleEqual: "\u22EC",
        NotLess: "\u226E",
        NotLessEqual: "\u2270",
        NotLessGreater: "\u2278",
        NotLessLess: "\
\u226A\u0338",
        NotLessSlantEqual: "\u2A7D\u0338",
        NotLessTilde: "\u2274",
        NotNestedGreaterGreater: "\u2AA2\u0338",
        NotNestedLessLess: "\u2AA1\u0338",
        notni: "\u220C",
        notniva: "\u220C",
        notnivb: "\u22FE",
        notnivc: "\u22FD",
        NotPrecedes: "\u2280",
        NotPrecedesEqual: "\u2AAF\u0338",
        NotPrecedesSlantEqual: "\
\u22E0",
        NotReverseElement: "\u220C",
        NotRightTriangleBar: "\u29D0\u0338",
        NotRightTriangle: "\u22EB",
        NotRightTriangleEqual: "\u22ED",
        NotSquareSubset: "\
\u228F\u0338",
        NotSquareSubsetEqual: "\u22E2",
        NotSquareSuperset: "\u2290\u0338",
        NotSquareSupersetEqual: "\u22E3",
        NotSubset: "\u2282\u20D2",
        NotSubsetEqual: "\u2288",
        NotSucceeds: "\u2281",
        NotSucceedsEqual: "\u2AB0\u0338",
        NotSucceedsSlantEqual: "\u22E1",
        NotSucceedsTilde: "\u227F\u0338",
        NotSuperset: "\u2283\u20D2",
        NotSupersetEqual: "\u2289",
        NotTilde: "\u2241",
        NotTildeEqual: "\u2244",
        NotTildeFullEqual: "\u2247",
        NotTildeTilde: "\
\u2249",
        NotVerticalBar: "\u2224",
        nparallel: "\u2226",
        npar: "\u2226",
        nparsl: "\u2AFD\u20E5",
        npart: "\u2202\u0338",
        npolint: "\u2A14",
        npr: "\
\u2280",
        nprcue: "\u22E0",
        nprec: "\u2280",
        npreceq: "\u2AAF\u0338",
        npre: "\u2AAF\u0338",
        nrarrc: "\u2933\u0338",
        nrarr: "\u219B",
        nrArr: "\
\u21CF",
        nrarrw: "\u219D\u0338",
        nrightarrow: "\u219B",
        nRightarrow: "\u21CF",
        nrtri: "\u22EB",
        nrtrie: "\u22ED",
        nsc: "\u2281",
        nsccue: "\u22E1",
        nsce: "\u2AB0\u0338",
        Nscr: "\uD835\uDCA9",
        nscr: "\uD835\uDCC3",
        nshortmid: "\u2224",
        nshortparallel: "\u2226",
        nsim: "\u2241",
        nsime: "\u2244",
        nsimeq: "\u2244",
        nsmid: "\u2224",
        nspar: "\u2226",
        nsqsube: "\u22E2",
        nsqsupe: "\u22E3",
        nsub: "\u2284",
        nsubE: "\u2AC5\u0338",
        nsube: "\u2288",
        nsubset: "\u2282\u20D2",
        nsubseteq: "\u2288",
        nsubseteqq: "\u2AC5\u0338",
        nsucc: "\u2281",
        nsucceq: "\u2AB0\u0338",
        nsup: "\u2285",
        nsupE: "\
\u2AC6\u0338",
        nsupe: "\u2289",
        nsupset: "\u2283\u20D2",
        nsupseteq: "\u2289",
        nsupseteqq: "\u2AC6\u0338",
        ntgl: "\u2279",
        Ntilde: "\xD1",
        ntilde: "\
\xF1",
        ntlg: "\u2278",
        ntriangleleft: "\u22EA",
        ntrianglelefteq: "\u22EC",
        ntriangleright: "\u22EB",
        ntrianglerighteq: "\u22ED",
        Nu: "\u039D",
        nu: "\u03BD",
        num: "#",
        numero: "\u2116",
        numsp: "\u2007",
        nvap: "\u224D\u20D2",
        nvdash: "\u22AC",
        nvDash: "\u22AD",
        nVdash: "\u22AE",
        nVDash: "\
\u22AF",
        nvge: "\u2265\u20D2",
        nvgt: ">\u20D2",
        nvHarr: "\u2904",
        nvinfin: "\u29DE",
        nvlArr: "\u2902",
        nvle: "\u2264\u20D2",
        nvlt: "<\u20D2",
        nvltrie: "\u22B4\u20D2",
        nvrArr: "\u2903",
        nvrtrie: "\u22B5\u20D2",
        nvsim: "\u223C\u20D2",
        nwarhk: "\u2923",
        nwarr: "\u2196",
        nwArr: "\u21D6",
        nwarrow: "\u2196",
        nwnear: "\u2927",
        Oacute: "\xD3",
        oacute: "\xF3",
        oast: "\u229B",
        Ocirc: "\xD4",
        ocirc: "\xF4",
        ocir: "\u229A",
        Ocy: "\u041E",
        ocy: "\u043E",
        odash: "\u229D",
        Odblac: "\u0150",
        odblac: "\u0151",
        odiv: "\u2A38",
        odot: "\u2299",
        odsold: "\u29BC",
        OElig: "\u0152",
        oelig: "\
\u0153",
        ofcir: "\u29BF",
        Ofr: "\uD835\uDD12",
        ofr: "\uD835\uDD2C",
        ogon: "\u02DB",
        Ograve: "\xD2",
        ograve: "\xF2",
        ogt: "\u29C1",
        ohbar: "\u29B5",
        ohm: "\u03A9",
        oint: "\u222E",
        olarr: "\u21BA",
        olcir: "\u29BE",
        olcross: "\u29BB",
        oline: "\u203E",
        olt: "\u29C0",
        Omacr: "\u014C",
        omacr: "\
\u014D",
        Omega: "\u03A9",
        omega: "\u03C9",
        Omicron: "\u039F",
        omicron: "\u03BF",
        omid: "\u29B6",
        ominus: "\u2296",
        Oopf: "\uD835\uDD46",
        oopf: "\uD835\uDD60",
        opar: "\u29B7",
        OpenCurlyDoubleQuote: "\u201C",
        OpenCurlyQuote: "\u2018",
        operp: "\u29B9",
        oplus: "\u2295",
        orarr: "\u21BB",
        Or: "\
\u2A54",
        or: "\u2228",
        ord: "\u2A5D",
        order: "\u2134",
        orderof: "\u2134",
        ordf: "\xAA",
        ordm: "\xBA",
        origof: "\u22B6",
        oror: "\u2A56",
        orslope: "\
\u2A57",
        orv: "\u2A5B",
        oS: "\u24C8",
        Oscr: "\uD835\uDCAA",
        oscr: "\u2134",
        Oslash: "\xD8",
        oslash: "\xF8",
        osol: "\u2298",
        Otilde: "\xD5",
        otilde: "\
\xF5",
        otimesas: "\u2A36",
        Otimes: "\u2A37",
        otimes: "\u2297",
        Ouml: "\xD6",
        ouml: "\xF6",
        ovbar: "\u233D",
        OverBar: "\u203E",
        OverBrace: "\u23DE",
        OverBracket: "\u23B4",
        OverParenthesis: "\u23DC",
        para: "\xB6",
        parallel: "\u2225",
        par: "\u2225",
        parsim: "\u2AF3",
        parsl: "\u2AFD",
        part: "\
\u2202",
        PartialD: "\u2202",
        Pcy: "\u041F",
        pcy: "\u043F",
        percnt: "%",
        period: ".",
        permil: "\u2030",
        perp: "\u22A5",
        pertenk: "\u2031",
        Pfr: "\uD835\uDD13",
        pfr: "\uD835\uDD2D",
        Phi: "\u03A6",
        phi: "\u03C6",
        phiv: "\u03D5",
        phmmat: "\u2133",
        phone: "\u260E",
        Pi: "\u03A0",
        pi: "\u03C0",
        pitchfork: "\
\u22D4",
        piv: "\u03D6",
        planck: "\u210F",
        planckh: "\u210E",
        plankv: "\u210F",
        plusacir: "\u2A23",
        plusb: "\u229E",
        pluscir: "\u2A22",
        plus: "\
+",
        plusdo: "\u2214",
        plusdu: "\u2A25",
        pluse: "\u2A72",
        PlusMinus: "\xB1",
        plusmn: "\xB1",
        plussim: "\u2A26",
        plustwo: "\u2A27",
        pm: "\xB1",
        Poincareplane: "\u210C",
        pointint: "\u2A15",
        popf: "\uD835\uDD61",
        Popf: "\u2119",
        pound: "\xA3",
        prap: "\u2AB7",
        Pr: "\u2ABB",
        pr: "\u227A",
        prcue: "\u227C",
        precapprox: "\u2AB7",
        prec: "\u227A",
        preccurlyeq: "\u227C",
        Precedes: "\u227A",
        PrecedesEqual: "\u2AAF",
        PrecedesSlantEqual: "\
\u227C",
        PrecedesTilde: "\u227E",
        preceq: "\u2AAF",
        precnapprox: "\u2AB9",
        precneqq: "\u2AB5",
        precnsim: "\u22E8",
        pre: "\u2AAF",
        prE: "\u2AB3",
        precsim: "\u227E",
        prime: "\u2032",
        Prime: "\u2033",
        primes: "\u2119",
        prnap: "\u2AB9",
        prnE: "\u2AB5",
        prnsim: "\u22E8",
        prod: "\u220F",
        Product: "\
\u220F",
        profalar: "\u232E",
        profline: "\u2312",
        profsurf: "\u2313",
        prop: "\u221D",
        Proportional: "\u221D",
        Proportion: "\u2237",
        propto: "\
\u221D",
        prsim: "\u227E",
        prurel: "\u22B0",
        Pscr: "\uD835\uDCAB",
        pscr: "\uD835\uDCC5",
        Psi: "\u03A8",
        psi: "\u03C8",
        puncsp: "\u2008",
        Qfr: "\uD835\uDD14",
        qfr: "\uD835\uDD2E",
        qint: "\u2A0C",
        qopf: "\uD835\uDD62",
        Qopf: "\u211A",
        qprime: "\u2057",
        Qscr: "\uD835\uDCAC",
        qscr: "\uD835\uDCC6",
        quaternions: "\
\u210D",
        quatint: "\u2A16",
        quest: "?",
        questeq: "\u225F",
        quot: '"',
        QUOT: '"',
        rAarr: "\u21DB",
        race: "\u223D\u0331",
        Racute: "\u0154",
        racute: "\
\u0155",
        radic: "\u221A",
        raemptyv: "\u29B3",
        rang: "\u27E9",
        Rang: "\u27EB",
        rangd: "\u2992",
        range: "\u29A5",
        rangle: "\u27E9",
        raquo: "\xBB",
        rarrap: "\u2975",
        rarrb: "\u21E5",
        rarrbfs: "\u2920",
        rarrc: "\u2933",
        rarr: "\u2192",
        Rarr: "\u21A0",
        rArr: "\u21D2",
        rarrfs: "\u291E",
        rarrhk: "\
\u21AA",
        rarrlp: "\u21AC",
        rarrpl: "\u2945",
        rarrsim: "\u2974",
        Rarrtl: "\u2916",
        rarrtl: "\u21A3",
        rarrw: "\u219D",
        ratail: "\u291A",
        rAtail: "\
\u291C",
        ratio: "\u2236",
        rationals: "\u211A",
        rbarr: "\u290D",
        rBarr: "\u290F",
        RBarr: "\u2910",
        rbbrk: "\u2773",
        rbrace: "}",
        rbrack: "]",
        rbrke: "\u298C",
        rbrksld: "\u298E",
        rbrkslu: "\u2990",
        Rcaron: "\u0158",
        rcaron: "\u0159",
        Rcedil: "\u0156",
        rcedil: "\u0157",
        rceil: "\u2309",
        rcub: "}",
        Rcy: "\u0420",
        rcy: "\u0440",
        rdca: "\u2937",
        rdldhar: "\u2969",
        rdquo: "\u201D",
        rdquor: "\u201D",
        rdsh: "\u21B3",
        real: "\u211C",
        realine: "\u211B",
        realpart: "\u211C",
        reals: "\u211D",
        Re: "\u211C",
        rect: "\u25AD",
        reg: "\xAE",
        REG: "\xAE",
        ReverseElement: "\u220B",
        ReverseEquilibrium: "\
\u21CB",
        ReverseUpEquilibrium: "\u296F",
        rfisht: "\u297D",
        rfloor: "\u230B",
        rfr: "\uD835\uDD2F",
        Rfr: "\u211C",
        rHar: "\u2964",
        rhard: "\u21C1",
        rharu: "\u21C0",
        rharul: "\u296C",
        Rho: "\u03A1",
        rho: "\u03C1",
        rhov: "\u03F1",
        RightAngleBracket: "\u27E9",
        RightArrowBar: "\u21E5",
        rightarrow: "\
\u2192",
        RightArrow: "\u2192",
        Rightarrow: "\u21D2",
        RightArrowLeftArrow: "\u21C4",
        rightarrowtail: "\u21A3",
        RightCeiling: "\u2309",
        RightDoubleBracket: "\
\u27E7",
        RightDownTeeVector: "\u295D",
        RightDownVectorBar: "\u2955",
        RightDownVector: "\u21C2",
        RightFloor: "\u230B",
        rightharpoondown: "\u21C1",
        rightharpoonup: "\u21C0",
        rightleftarrows: "\u21C4",
        rightleftharpoons: "\u21CC",
        rightrightarrows: "\u21C9",
        rightsquigarrow: "\u219D",
        RightTeeArrow: "\
\u21A6",
        RightTee: "\u22A2",
        RightTeeVector: "\u295B",
        rightthreetimes: "\u22CC",
        RightTriangleBar: "\u29D0",
        RightTriangle: "\u22B3",
        RightTriangleEqual: "\
\u22B5",
        RightUpDownVector: "\u294F",
        RightUpTeeVector: "\u295C",
        RightUpVectorBar: "\u2954",
        RightUpVector: "\u21BE",
        RightVectorBar: "\u2953",
        RightVector: "\u21C0",
        ring: "\u02DA",
        risingdotseq: "\u2253",
        rlarr: "\u21C4",
        rlhar: "\u21CC",
        rlm: "\u200F",
        rmoustache: "\u23B1",
        rmoust: "\
\u23B1",
        rnmid: "\u2AEE",
        roang: "\u27ED",
        roarr: "\u21FE",
        robrk: "\u27E7",
        ropar: "\u2986",
        ropf: "\uD835\uDD63",
        Ropf: "\u211D",
        roplus: "\u2A2E",
        rotimes: "\u2A35",
        RoundImplies: "\u2970",
        rpar: ")",
        rpargt: "\u2994",
        rppolint: "\u2A12",
        rrarr: "\u21C9",
        Rrightarrow: "\u21DB",
        rsaquo: "\
\u203A",
        rscr: "\uD835\uDCC7",
        Rscr: "\u211B",
        rsh: "\u21B1",
        Rsh: "\u21B1",
        rsqb: "]",
        rsquo: "\u2019",
        rsquor: "\u2019",
        rthree: "\u22CC",
        rtimes: "\
\u22CA",
        rtri: "\u25B9",
        rtrie: "\u22B5",
        rtrif: "\u25B8",
        rtriltri: "\u29CE",
        RuleDelayed: "\u29F4",
        ruluhar: "\u2968",
        rx: "\u211E",
        Sacute: "\
\u015A",
        sacute: "\u015B",
        sbquo: "\u201A",
        scap: "\u2AB8",
        Scaron: "\u0160",
        scaron: "\u0161",
        Sc: "\u2ABC",
        sc: "\u227B",
        sccue: "\u227D",
        sce: "\u2AB0",
        scE: "\u2AB4",
        Scedil: "\u015E",
        scedil: "\u015F",
        Scirc: "\u015C",
        scirc: "\u015D",
        scnap: "\u2ABA",
        scnE: "\u2AB6",
        scnsim: "\
\u22E9",
        scpolint: "\u2A13",
        scsim: "\u227F",
        Scy: "\u0421",
        scy: "\u0441",
        sdotb: "\u22A1",
        sdot: "\u22C5",
        sdote: "\u2A66",
        searhk: "\u2925",
        searr: "\u2198",
        seArr: "\u21D8",
        searrow: "\u2198",
        sect: "\xA7",
        semi: ";",
        seswar: "\u2929",
        setminus: "\u2216",
        setmn: "\u2216",
        sext: "\
\u2736",
        Sfr: "\uD835\uDD16",
        sfr: "\uD835\uDD30",
        sfrown: "\u2322",
        sharp: "\u266F",
        SHCHcy: "\u0429",
        shchcy: "\u0449",
        SHcy: "\u0428",
        shcy: "\u0448",
        ShortDownArrow: "\u2193",
        ShortLeftArrow: "\u2190",
        shortmid: "\u2223",
        shortparallel: "\u2225",
        ShortRightArrow: "\u2192",
        ShortUpArrow: "\
\u2191",
        shy: "\xAD",
        Sigma: "\u03A3",
        sigma: "\u03C3",
        sigmaf: "\u03C2",
        sigmav: "\u03C2",
        sim: "\u223C",
        simdot: "\u2A6A",
        sime: "\u2243",
        simeq: "\u2243",
        simg: "\u2A9E",
        simgE: "\u2AA0",
        siml: "\u2A9D",
        simlE: "\u2A9F",
        simne: "\u2246",
        simplus: "\u2A24",
        simrarr: "\u2972",
        slarr: "\
\u2190",
        SmallCircle: "\u2218",
        smallsetminus: "\u2216",
        smashp: "\u2A33",
        smeparsl: "\u29E4",
        smid: "\u2223",
        smile: "\u2323",
        smt: "\u2AAA",
        smte: "\u2AAC",
        smtes: "\u2AAC\uFE00",
        SOFTcy: "\u042C",
        softcy: "\u044C",
        solbar: "\u233F",
        solb: "\u29C4",
        sol: "/",
        Sopf: "\uD835\uDD4A",
        sopf: "\uD835\uDD64",
        spades: "\u2660",
        spadesuit: "\u2660",
        spar: "\u2225",
        sqcap: "\u2293",
        sqcaps: "\u2293\uFE00",
        sqcup: "\u2294",
        sqcups: "\u2294\uFE00",
        Sqrt: "\u221A",
        sqsub: "\u228F",
        sqsube: "\u2291",
        sqsubset: "\u228F",
        sqsubseteq: "\u2291",
        sqsup: "\u2290",
        sqsupe: "\u2292",
        sqsupset: "\
\u2290",
        sqsupseteq: "\u2292",
        square: "\u25A1",
        Square: "\u25A1",
        SquareIntersection: "\u2293",
        SquareSubset: "\u228F",
        SquareSubsetEqual: "\
\u2291",
        SquareSuperset: "\u2290",
        SquareSupersetEqual: "\u2292",
        SquareUnion: "\u2294",
        squarf: "\u25AA",
        squ: "\u25A1",
        squf: "\u25AA",
        srarr: "\
\u2192",
        Sscr: "\uD835\uDCAE",
        sscr: "\uD835\uDCC8",
        ssetmn: "\u2216",
        ssmile: "\u2323",
        sstarf: "\u22C6",
        Star: "\u22C6",
        star: "\u2606",
        starf: "\
\u2605",
        straightepsilon: "\u03F5",
        straightphi: "\u03D5",
        strns: "\xAF",
        sub: "\u2282",
        Sub: "\u22D0",
        subdot: "\u2ABD",
        subE: "\u2AC5",
        sube: "\
\u2286",
        subedot: "\u2AC3",
        submult: "\u2AC1",
        subnE: "\u2ACB",
        subne: "\u228A",
        subplus: "\u2ABF",
        subrarr: "\u2979",
        subset: "\u2282",
        Subset: "\
\u22D0",
        subseteq: "\u2286",
        subseteqq: "\u2AC5",
        SubsetEqual: "\u2286",
        subsetneq: "\u228A",
        subsetneqq: "\u2ACB",
        subsim: "\u2AC7",
        subsub: "\
\u2AD5",
        subsup: "\u2AD3",
        succapprox: "\u2AB8",
        succ: "\u227B",
        succcurlyeq: "\u227D",
        Succeeds: "\u227B",
        SucceedsEqual: "\u2AB0",
        SucceedsSlantEqual: "\
\u227D",
        SucceedsTilde: "\u227F",
        succeq: "\u2AB0",
        succnapprox: "\u2ABA",
        succneqq: "\u2AB6",
        succnsim: "\u22E9",
        succsim: "\u227F",
        SuchThat: "\
\u220B",
        sum: "\u2211",
        Sum: "\u2211",
        sung: "\u266A",
        sup1: "\xB9",
        sup2: "\xB2",
        sup3: "\xB3",
        sup: "\u2283",
        Sup: "\u22D1",
        supdot: "\u2ABE",
        supdsub: "\u2AD8",
        supE: "\u2AC6",
        supe: "\u2287",
        supedot: "\u2AC4",
        Superset: "\u2283",
        SupersetEqual: "\u2287",
        suphsol: "\u27C9",
        suphsub: "\
\u2AD7",
        suplarr: "\u297B",
        supmult: "\u2AC2",
        supnE: "\u2ACC",
        supne: "\u228B",
        supplus: "\u2AC0",
        supset: "\u2283",
        Supset: "\u22D1",
        supseteq: "\
\u2287",
        supseteqq: "\u2AC6",
        supsetneq: "\u228B",
        supsetneqq: "\u2ACC",
        supsim: "\u2AC8",
        supsub: "\u2AD4",
        supsup: "\u2AD6",
        swarhk: "\u2926",
        swarr: "\u2199",
        swArr: "\u21D9",
        swarrow: "\u2199",
        swnwar: "\u292A",
        szlig: "\xDF",
        Tab: "	",
        target: "\u2316",
        Tau: "\u03A4",
        tau: "\u03C4",
        tbrk: "\u23B4",
        Tcaron: "\u0164",
        tcaron: "\u0165",
        Tcedil: "\u0162",
        tcedil: "\u0163",
        Tcy: "\u0422",
        tcy: "\u0442",
        tdot: "\u20DB",
        telrec: "\
\u2315",
        Tfr: "\uD835\uDD17",
        tfr: "\uD835\uDD31",
        there4: "\u2234",
        therefore: "\u2234",
        Therefore: "\u2234",
        Theta: "\u0398",
        theta: "\u03B8",
        thetasym: "\
\u03D1",
        thetav: "\u03D1",
        thickapprox: "\u2248",
        thicksim: "\u223C",
        ThickSpace: "\u205F\u200A",
        ThinSpace: "\u2009",
        thinsp: "\u2009",
        thkap: "\
\u2248",
        thksim: "\u223C",
        THORN: "\xDE",
        thorn: "\xFE",
        tilde: "\u02DC",
        Tilde: "\u223C",
        TildeEqual: "\u2243",
        TildeFullEqual: "\u2245",
        TildeTilde: "\
\u2248",
        timesbar: "\u2A31",
        timesb: "\u22A0",
        times: "\xD7",
        timesd: "\u2A30",
        tint: "\u222D",
        toea: "\u2928",
        topbot: "\u2336",
        topcir: "\u2AF1",
        top: "\u22A4",
        Topf: "\uD835\uDD4B",
        topf: "\uD835\uDD65",
        topfork: "\u2ADA",
        tosa: "\u2929",
        tprime: "\u2034",
        trade: "\u2122",
        TRADE: "\u2122",
        triangle: "\u25B5",
        triangledown: "\u25BF",
        triangleleft: "\u25C3",
        trianglelefteq: "\u22B4",
        triangleq: "\u225C",
        triangleright: "\u25B9",
        trianglerighteq: "\u22B5",
        tridot: "\u25EC",
        trie: "\u225C",
        triminus: "\u2A3A",
        TripleDot: "\u20DB",
        triplus: "\u2A39",
        trisb: "\u29CD",
        tritime: "\
\u2A3B",
        trpezium: "\u23E2",
        Tscr: "\uD835\uDCAF",
        tscr: "\uD835\uDCC9",
        TScy: "\u0426",
        tscy: "\u0446",
        TSHcy: "\u040B",
        tshcy: "\u045B",
        Tstrok: "\
\u0166",
        tstrok: "\u0167",
        twixt: "\u226C",
        twoheadleftarrow: "\u219E",
        twoheadrightarrow: "\u21A0",
        Uacute: "\xDA",
        uacute: "\xFA",
        uarr: "\
\u2191",
        Uarr: "\u219F",
        uArr: "\u21D1",
        Uarrocir: "\u2949",
        Ubrcy: "\u040E",
        ubrcy: "\u045E",
        Ubreve: "\u016C",
        ubreve: "\u016D",
        Ucirc: "\xDB",
        ucirc: "\xFB",
        Ucy: "\u0423",
        ucy: "\u0443",
        udarr: "\u21C5",
        Udblac: "\u0170",
        udblac: "\u0171",
        udhar: "\u296E",
        ufisht: "\u297E",
        Ufr: "\uD835\uDD18",
        ufr: "\uD835\uDD32",
        Ugrave: "\xD9",
        ugrave: "\xF9",
        uHar: "\u2963",
        uharl: "\u21BF",
        uharr: "\u21BE",
        uhblk: "\u2580",
        ulcorn: "\u231C",
        ulcorner: "\u231C",
        ulcrop: "\u230F",
        ultri: "\u25F8",
        Umacr: "\u016A",
        umacr: "\u016B",
        uml: "\xA8",
        UnderBar: "_",
        UnderBrace: "\u23DF",
        UnderBracket: "\u23B5",
        UnderParenthesis: "\u23DD",
        Union: "\u22C3",
        UnionPlus: "\u228E",
        Uogon: "\u0172",
        uogon: "\u0173",
        Uopf: "\uD835\uDD4C",
        uopf: "\uD835\uDD66",
        UpArrowBar: "\u2912",
        uparrow: "\u2191",
        UpArrow: "\u2191",
        Uparrow: "\u21D1",
        UpArrowDownArrow: "\u21C5",
        updownarrow: "\
\u2195",
        UpDownArrow: "\u2195",
        Updownarrow: "\u21D5",
        UpEquilibrium: "\u296E",
        upharpoonleft: "\u21BF",
        upharpoonright: "\u21BE",
        uplus: "\u228E",
        UpperLeftArrow: "\u2196",
        UpperRightArrow: "\u2197",
        upsi: "\u03C5",
        Upsi: "\u03D2",
        upsih: "\u03D2",
        Upsilon: "\u03A5",
        upsilon: "\u03C5",
        UpTeeArrow: "\u21A5",
        UpTee: "\u22A5",
        upuparrows: "\u21C8",
        urcorn: "\u231D",
        urcorner: "\u231D",
        urcrop: "\u230E",
        Uring: "\u016E",
        uring: "\
\u016F",
        urtri: "\u25F9",
        Uscr: "\uD835\uDCB0",
        uscr: "\uD835\uDCCA",
        utdot: "\u22F0",
        Utilde: "\u0168",
        utilde: "\u0169",
        utri: "\u25B5",
        utrif: "\
\u25B4",
        uuarr: "\u21C8",
        Uuml: "\xDC",
        uuml: "\xFC",
        uwangle: "\u29A7",
        vangrt: "\u299C",
        varepsilon: "\u03F5",
        varkappa: "\u03F0",
        varnothing: "\
\u2205",
        varphi: "\u03D5",
        varpi: "\u03D6",
        varpropto: "\u221D",
        varr: "\u2195",
        vArr: "\u21D5",
        varrho: "\u03F1",
        varsigma: "\u03C2",
        varsubsetneq: "\
\u228A\uFE00",
        varsubsetneqq: "\u2ACB\uFE00",
        varsupsetneq: "\u228B\uFE00",
        varsupsetneqq: "\u2ACC\uFE00",
        vartheta: "\u03D1",
        vartriangleleft: "\
\u22B2",
        vartriangleright: "\u22B3",
        vBar: "\u2AE8",
        Vbar: "\u2AEB",
        vBarv: "\u2AE9",
        Vcy: "\u0412",
        vcy: "\u0432",
        vdash: "\u22A2",
        vDash: "\
\u22A8",
        Vdash: "\u22A9",
        VDash: "\u22AB",
        Vdashl: "\u2AE6",
        veebar: "\u22BB",
        vee: "\u2228",
        Vee: "\u22C1",
        veeeq: "\u225A",
        vellip: "\u22EE",
        verbar: "|",
        Verbar: "\u2016",
        vert: "|",
        Vert: "\u2016",
        VerticalBar: "\u2223",
        VerticalLine: "|",
        VerticalSeparator: "\u2758",
        VerticalTilde: "\
\u2240",
        VeryThinSpace: "\u200A",
        Vfr: "\uD835\uDD19",
        vfr: "\uD835\uDD33",
        vltri: "\u22B2",
        vnsub: "\u2282\u20D2",
        vnsup: "\u2283\u20D2",
        Vopf: "\uD835\uDD4D",
        vopf: "\uD835\uDD67",
        vprop: "\u221D",
        vrtri: "\u22B3",
        Vscr: "\uD835\uDCB1",
        vscr: "\uD835\uDCCB",
        vsubnE: "\u2ACB\uFE00",
        vsubne: "\u228A\uFE00",
        vsupnE: "\u2ACC\uFE00",
        vsupne: "\u228B\uFE00",
        Vvdash: "\u22AA",
        vzigzag: "\u299A",
        Wcirc: "\u0174",
        wcirc: "\u0175",
        wedbar: "\u2A5F",
        wedge: "\
\u2227",
        Wedge: "\u22C0",
        wedgeq: "\u2259",
        weierp: "\u2118",
        Wfr: "\uD835\uDD1A",
        wfr: "\uD835\uDD34",
        Wopf: "\uD835\uDD4E",
        wopf: "\uD835\uDD68",
        wp: "\
\u2118",
        wr: "\u2240",
        wreath: "\u2240",
        Wscr: "\uD835\uDCB2",
        wscr: "\uD835\uDCCC",
        xcap: "\u22C2",
        xcirc: "\u25EF",
        xcup: "\u22C3",
        xdtri: "\u25BD",
        Xfr: "\uD835\uDD1B",
        xfr: "\uD835\uDD35",
        xharr: "\u27F7",
        xhArr: "\u27FA",
        Xi: "\u039E",
        xi: "\u03BE",
        xlarr: "\u27F5",
        xlArr: "\u27F8",
        xmap: "\
\u27FC",
        xnis: "\u22FB",
        xodot: "\u2A00",
        Xopf: "\uD835\uDD4F",
        xopf: "\uD835\uDD69",
        xoplus: "\u2A01",
        xotime: "\u2A02",
        xrarr: "\u27F6",
        xrArr: "\
\u27F9",
        Xscr: "\uD835\uDCB3",
        xscr: "\uD835\uDCCD",
        xsqcup: "\u2A06",
        xuplus: "\u2A04",
        xutri: "\u25B3",
        xvee: "\u22C1",
        xwedge: "\u22C0",
        Yacute: "\
\xDD",
        yacute: "\xFD",
        YAcy: "\u042F",
        yacy: "\u044F",
        Ycirc: "\u0176",
        ycirc: "\u0177",
        Ycy: "\u042B",
        ycy: "\u044B",
        yen: "\xA5",
        Yfr: "\uD835\uDD1C",
        yfr: "\uD835\uDD36",
        YIcy: "\u0407",
        yicy: "\u0457",
        Yopf: "\uD835\uDD50",
        yopf: "\uD835\uDD6A",
        Yscr: "\uD835\uDCB4",
        yscr: "\uD835\uDCCE",
        YUcy: "\u042E",
        yucy: "\u044E",
        yuml: "\xFF",
        Yuml: "\u0178",
        Zacute: "\u0179",
        zacute: "\u017A",
        Zcaron: "\u017D",
        zcaron: "\u017E",
        Zcy: "\u0417",
        zcy: "\
\u0437",
        Zdot: "\u017B",
        zdot: "\u017C",
        zeetrf: "\u2128",
        ZeroWidthSpace: "\u200B",
        Zeta: "\u0396",
        zeta: "\u03B6",
        zfr: "\uD835\uDD37",
        Zfr: "\
\u2128",
        ZHcy: "\u0416",
        zhcy: "\u0436",
        zigrarr: "\u21DD",
        zopf: "\uD835\uDD6B",
        Zopf: "\u2124",
        Zscr: "\uD835\uDCB5",
        zscr: "\uD835\uDCCF",
        zwj: "\u200D",
        zwnj: "\u200C"
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/legacy.json
var ha = q((cT, Wu)=>{
    Wu.exports = {
        Aacute: "\xC1",
        aacute: "\xE1",
        Acirc: "\xC2",
        acirc: "\xE2",
        acute: "\xB4",
        AElig: "\xC6",
        aelig: "\xE6",
        Agrave: "\xC0",
        agrave: "\
\xE0",
        amp: "&",
        AMP: "&",
        Aring: "\xC5",
        aring: "\xE5",
        Atilde: "\xC3",
        atilde: "\xE3",
        Auml: "\xC4",
        auml: "\xE4",
        brvbar: "\xA6",
        Ccedil: "\
\xC7",
        ccedil: "\xE7",
        cedil: "\xB8",
        cent: "\xA2",
        copy: "\xA9",
        COPY: "\xA9",
        curren: "\xA4",
        deg: "\xB0",
        divide: "\xF7",
        Eacute: "\xC9",
        eacute: "\xE9",
        Ecirc: "\xCA",
        ecirc: "\xEA",
        Egrave: "\xC8",
        egrave: "\xE8",
        ETH: "\xD0",
        eth: "\xF0",
        Euml: "\xCB",
        euml: "\xEB",
        frac12: "\
\xBD",
        frac14: "\xBC",
        frac34: "\xBE",
        gt: ">",
        GT: ">",
        Iacute: "\xCD",
        iacute: "\xED",
        Icirc: "\xCE",
        icirc: "\xEE",
        iexcl: "\xA1",
        Igrave: "\
\xCC",
        igrave: "\xEC",
        iquest: "\xBF",
        Iuml: "\xCF",
        iuml: "\xEF",
        laquo: "\xAB",
        lt: "<",
        LT: "<",
        macr: "\xAF",
        micro: "\xB5",
        middot: "\xB7",
        nbsp: "\xA0",
        not: "\xAC",
        Ntilde: "\xD1",
        ntilde: "\xF1",
        Oacute: "\xD3",
        oacute: "\xF3",
        Ocirc: "\xD4",
        ocirc: "\xF4",
        Ograve: "\xD2",
        ograve: "\
\xF2",
        ordf: "\xAA",
        ordm: "\xBA",
        Oslash: "\xD8",
        oslash: "\xF8",
        Otilde: "\xD5",
        otilde: "\xF5",
        Ouml: "\xD6",
        ouml: "\xF6",
        para: "\xB6",
        plusmn: "\xB1",
        pound: "\xA3",
        quot: '"',
        QUOT: '"',
        raquo: "\xBB",
        reg: "\xAE",
        REG: "\xAE",
        sect: "\xA7",
        shy: "\xAD",
        sup1: "\xB9",
        sup2: "\
\xB2",
        sup3: "\xB3",
        szlig: "\xDF",
        THORN: "\xDE",
        thorn: "\xFE",
        times: "\xD7",
        Uacute: "\xDA",
        uacute: "\xFA",
        Ucirc: "\xDB",
        ucirc: "\xFB",
        Ugrave: "\xD9",
        ugrave: "\xF9",
        uml: "\xA8",
        Uuml: "\xDC",
        uuml: "\xFC",
        Yacute: "\xDD",
        yacute: "\xFD",
        yen: "\xA5",
        yuml: "\xFF"
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/xml.json
var Xn = q((pT, $u)=>{
    $u.exports = {
        amp: "&",
        apos: "'",
        gt: ">",
        lt: "<",
        quot: '"'
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/decode.json
var ga = q((dT, Yu)=>{
    Yu.exports = {
        "0": 65533,
        "128": 8364,
        "130": 8218,
        "131": 402,
        "132": 8222,
        "133": 8230,
        "134": 8224,
        "135": 8225,
        "136": 710,
        "137": 8240,
        "138": 352,
        "139": 8249,
        "140": 338,
        "142": 381,
        "145": 8216,
        "146": 8217,
        "147": 8220,
        "148": 8221,
        "149": 8226,
        "150": 8211,
        "151": 8212,
        "152": 732,
        "153": 8482,
        "154": 353,
        "155": 8250,
        "156": 339,
        "158": 382,
        "159": 376
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/decode_codepoint.js
var ba = q((zr)=>{
    "use strict";
    var Ku = zr && zr.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty(zr, "__esModule", {
        value: !0
    });
    var Sa = Ku(ga()), Xu = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(r) {
        var e = "";
        return r > 65535 && (r -= 65536, e += String.fromCharCode(r >>> 10 & 1023 | 55296), r = 56320 | r & 1023), e += String.fromCharCode(r), e;
    };
    function Ju(r) {
        return r >= 55296 && r <= 57343 || r > 1114111 ? "\uFFFD" : (r in Sa.default && (r = Sa.default[r]), Xu(r));
    }
    n(Ju, "decodeCodePoint");
    zr.default = Ju;
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/decode.js
var Qn = q((pe)=>{
    "use strict";
    var Lt = pe && pe.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty(pe, "__esModule", {
        value: !0
    });
    pe.decodeHTML = pe.decodeHTMLStrict = pe.decodeXML = void 0;
    var Jn = Lt(Kn()), Qu = Lt(ha()), Zu = Lt(Xn()), Ta = Lt(ba()), ef = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
    pe.decodeXML = Ra(Zu.default);
    pe.decodeHTMLStrict = Ra(Jn.default);
    function Ra(r) {
        var e = Aa(r);
        return function(t) {
            return String(t).replace(ef, e);
        };
    }
    n(Ra, "getStrictDecoder");
    var Ea = /* @__PURE__ */ n(function(r, e) {
        return r < e ? 1 : -1;
    }, "sorter");
    pe.decodeHTML = function() {
        for(var r = Object.keys(Qu.default).sort(Ea), e = Object.keys(Jn.default).sort(Ea), t = 0, o = 0; t < e.length; t++)r[o] === e[t] ? (e[t] += ";?", o++) : e[t] += ";";
        var s = new RegExp("&(?:" + e.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), i = Aa(Jn.default);
        function a(c) {
            return c.substr(-1) !== ";" && (c += ";"), i(c);
        }
        return n(a, "replacer"), function(c) {
            return String(c).replace(s, a);
        };
    }();
    function Aa(r) {
        return /* @__PURE__ */ n(function(t) {
            if (t.charAt(1) === "#") {
                var o = t.charAt(2);
                return o === "X" || o === "x" ? Ta.default(parseInt(t.substr(3), 16)) : Ta.default(parseInt(t.substr(2), 10));
            }
            return r[t.slice(1, -1)] || t;
        }, "replace");
    }
    n(Aa, "getReplacer");
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/encode.js
var es = q((J)=>{
    "use strict";
    var xa = J && J.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty(J, "__esModule", {
        value: !0
    });
    J.escapeUTF8 = J.escape = J.encodeNonAsciiHTML = J.encodeHTML = J.encodeXML = void 0;
    var rf = xa(Xn()), va = _a(rf.default), wa = Ca(va);
    J.encodeXML = Ia(va);
    var tf = xa(Kn()), Zn = _a(tf.default), of = Ca(Zn);
    J.encodeHTML = sf(Zn, of);
    J.encodeNonAsciiHTML = Ia(Zn);
    function _a(r) {
        return Object.keys(r).sort().reduce(function(e, t) {
            return e[r[t]] = "&" + t + ";", e;
        }, {});
    }
    n(_a, "getInverseObj");
    function Ca(r) {
        for(var e = [], t = [], o = 0, s = Object.keys(r); o < s.length; o++){
            var i = s[o];
            i.length === 1 ? e.push("\\" + i) : t.push(i);
        }
        e.sort();
        for(var a = 0; a < e.length - 1; a++){
            for(var c = a; c < e.length - 1 && e[c].charCodeAt(1) + 1 === e[c + 1].charCodeAt(1);)c += 1;
            var l = 1 + c - a;
            l < 3 || e.splice(a, l, e[a] + "-" + e[c]);
        }
        return t.unshift("[" + e.join("") + "]"), new RegExp(t.join("|"), "g");
    }
    n(Ca, "getInverseReplacer");
    var Pa = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, nf = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    function(r) {
        return r.codePointAt(0);
    } : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(r) {
        return (r.charCodeAt(0) - 55296) * 1024 + r.charCodeAt(1) - 56320 + 65536;
    };
    function jt(r) {
        return "&#x" + (r.length > 1 ? nf(r) : r.charCodeAt(0)).toString(16).toUpperCase() + ";";
    }
    n(jt, "singleCharReplacer");
    function sf(r, e) {
        return function(t) {
            return t.replace(e, function(o) {
                return r[o];
            }).replace(Pa, jt);
        };
    }
    n(sf, "getInverse");
    var Oa = new RegExp(wa.source + "|" + Pa.source, "g");
    function af(r) {
        return r.replace(Oa, jt);
    }
    n(af, "escape");
    J.escape = af;
    function lf(r) {
        return r.replace(wa, jt);
    }
    n(lf, "escapeUTF8");
    J.escapeUTF8 = lf;
    function Ia(r) {
        return function(e) {
            return e.replace(Oa, function(t) {
                return r[t] || jt(t);
            });
        };
    }
    n(Ia, "getASCIIEncoder");
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/index.js
var Da = q((O)=>{
    "use strict";
    Object.defineProperty(O, "__esModule", {
        value: !0
    });
    O.decodeXMLStrict = O.decodeHTML5Strict = O.decodeHTML4Strict = O.decodeHTML5 = O.decodeHTML4 = O.decodeHTMLStrict = O.decodeHTML = O.decodeXML = O.encodeHTML5 = O.encodeHTML4 = O.escapeUTF8 = O.escape = O.encodeNonAsciiHTML = O.encodeHTML = O.encodeXML = O.encode = O.decodeStrict = O.decode = void 0;
    var Mt = Qn(), Fa = es();
    function cf(r, e) {
        return (!e || e <= 0 ? Mt.decodeXML : Mt.decodeHTML)(r);
    }
    n(cf, "decode");
    O.decode = cf;
    function pf(r, e) {
        return (!e || e <= 0 ? Mt.decodeXML : Mt.decodeHTMLStrict)(r);
    }
    n(pf, "decodeStrict");
    O.decodeStrict = pf;
    function df(r, e) {
        return (!e || e <= 0 ? Fa.encodeXML : Fa.encodeHTML)(r);
    }
    n(df, "encode");
    O.encode = df;
    var Ve = es();
    Object.defineProperty(O, "encodeXML", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Ve.encodeXML;
        }, "get")
    });
    Object.defineProperty(O, "encodeHTML", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Ve.encodeHTML;
        }, "get")
    });
    Object.defineProperty(O, "encodeNonAsciiHTML", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Ve.encodeNonAsciiHTML;
        }, "get")
    });
    Object.defineProperty(O, "escape", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Ve.escape;
        }, "get")
    });
    Object.defineProperty(O, "escapeUTF8", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Ve.escapeUTF8;
        }, "get")
    });
    Object.defineProperty(O, "encodeHTML4", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Ve.encodeHTML;
        }, "get")
    });
    Object.defineProperty(O, "encodeHTML5", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return Ve.encodeHTML;
        }, "get")
    });
    var ve = Qn();
    Object.defineProperty(O, "decodeXML", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeXML;
        }, "get")
    });
    Object.defineProperty(O, "decodeHTML", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeHTML;
        }, "get")
    });
    Object.defineProperty(O, "decodeHTMLStrict", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeHTMLStrict;
        }, "get")
    });
    Object.defineProperty(O, "decodeHTML4", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeHTML;
        }, "get")
    });
    Object.defineProperty(O, "decodeHTML5", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeHTML;
        }, "get")
    });
    Object.defineProperty(O, "decodeHTML4Strict", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeHTMLStrict;
        }, "get")
    });
    Object.defineProperty(O, "decodeHTML5Strict", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeHTMLStrict;
        }, "get")
    });
    Object.defineProperty(O, "decodeXMLStrict", {
        enumerable: !0,
        get: /* @__PURE__ */ n(function() {
            return ve.decodeXML;
        }, "get")
    });
});
// ../node_modules/ansi-to-html/lib/ansi_to_html.js
var Ha = q((TT, Va)=>{
    "use strict";
    function uf(r, e) {
        if (!(r instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    n(uf, "_classCallCheck");
    function Na(r, e) {
        for(var t = 0; t < e.length; t++){
            var o = e[t];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(r, o.key, o);
        }
    }
    n(Na, "_defineProperties");
    function ff(r, e, t) {
        return e && Na(r.prototype, e), t && Na(r, t), r;
    }
    n(ff, "_createClass");
    function Ga(r, e) {
        var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
        if (!t) {
            if (Array.isArray(r) || (t = yf(r)) || e && r && typeof r.length == "number") {
                t && (r = t);
                var o = 0, s = /* @__PURE__ */ n(function() {}, "F");
                return {
                    s,
                    n: /* @__PURE__ */ n(function() {
                        return o >= r.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: r[o++]
                        };
                    }, "n"),
                    e: /* @__PURE__ */ n(function(p) {
                        throw p;
                    }, "e"),
                    f: s
                };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        var i = !0, a = !1, c;
        return {
            s: /* @__PURE__ */ n(function() {
                t = t.call(r);
            }, "s"),
            n: /* @__PURE__ */ n(function() {
                var p = t.next();
                return i = p.done, p;
            }, "n"),
            e: /* @__PURE__ */ n(function(p) {
                a = !0, c = p;
            }, "e"),
            f: /* @__PURE__ */ n(function() {
                try {
                    !i && t.return != null && t.return();
                } finally{
                    if (a) throw c;
                }
            }, "f")
        };
    }
    n(Ga, "_createForOfIteratorHelper");
    function yf(r, e) {
        if (r) {
            if (typeof r == "string") return ka(r, e);
            var t = Object.prototype.toString.call(r).slice(8, -1);
            if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
            if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ka(r, e);
        }
    }
    n(yf, "_unsupportedIterableToArray");
    function ka(r, e) {
        (e == null || e > r.length) && (e = r.length);
        for(var t = 0, o = new Array(e); t < e; t++)o[t] = r[t];
        return o;
    }
    n(ka, "_arrayLikeToArray");
    var mf = Da(), La = {
        fg: "#FFF",
        bg: "#000",
        newline: !1,
        escapeXML: !1,
        stream: !1,
        colors: hf()
    };
    function hf() {
        var r = {
            0: "#000",
            1: "#A00",
            2: "#0A0",
            3: "#A50",
            4: "#00A",
            5: "#A0A",
            6: "#0AA",
            7: "#AAA",
            8: "#555",
            9: "#F55",
            10: "#5F5",
            11: "#FF5",
            12: "#55F",
            13: "#F5F",
            14: "#5FF",
            15: "#FFF"
        };
        return Ut(0, 5).forEach(function(e) {
            Ut(0, 5).forEach(function(t) {
                Ut(0, 5).forEach(function(o) {
                    return gf(e, t, o, r);
                });
            });
        }), Ut(0, 23).forEach(function(e) {
            var t = e + 232, o = qa(e * 10 + 8);
            r[t] = "#" + o + o + o;
        }), r;
    }
    n(hf, "getDefaultColors");
    function gf(r, e, t, o) {
        var s = 16 + r * 36 + e * 6 + t, i = r > 0 ? r * 40 + 55 : 0, a = e > 0 ? e * 40 + 55 : 0, c = t > 0 ? t * 40 + 55 : 0;
        o[s] = Sf([
            i,
            a,
            c
        ]);
    }
    n(gf, "setStyleColor");
    function qa(r) {
        for(var e = r.toString(16); e.length < 2;)e = "0" + e;
        return e;
    }
    n(qa, "toHexString");
    function Sf(r) {
        var e = [], t = Ga(r), o;
        try {
            for(t.s(); !(o = t.n()).done;){
                var s = o.value;
                e.push(qa(s));
            }
        } catch (i) {
            t.e(i);
        } finally{
            t.f();
        }
        return "#" + e.join("");
    }
    n(Sf, "toColorHexString");
    function ja(r, e, t, o) {
        var s;
        return e === "text" ? s = Rf(t, o) : e === "display" ? s = Tf(r, t, o) : e === "xterm256Foreground" ? s = qt(r, o.colors[t]) : e === "xt\
erm256Background" ? s = Bt(r, o.colors[t]) : e === "rgb" && (s = bf(r, t)), s;
    }
    n(ja, "generateOutput");
    function bf(r, e) {
        e = e.substring(2).slice(0, -1);
        var t = +e.substr(0, 2), o = e.substring(5).split(";"), s = o.map(function(i) {
            return ("0" + Number(i).toString(16)).substr(-2);
        }).join("");
        return Gt(r, (t === 38 ? "color:#" : "background-color:#") + s);
    }
    n(bf, "handleRgb");
    function Tf(r, e, t) {
        e = parseInt(e, 10);
        var o = {
            "-1": /* @__PURE__ */ n(function() {
                return "<br/>";
            }, "_"),
            0: /* @__PURE__ */ n(function() {
                return r.length && Ba(r);
            }, "_"),
            1: /* @__PURE__ */ n(function() {
                return we(r, "b");
            }, "_"),
            3: /* @__PURE__ */ n(function() {
                return we(r, "i");
            }, "_"),
            4: /* @__PURE__ */ n(function() {
                return we(r, "u");
            }, "_"),
            8: /* @__PURE__ */ n(function() {
                return Gt(r, "display:none");
            }, "_"),
            9: /* @__PURE__ */ n(function() {
                return we(r, "strike");
            }, "_"),
            22: /* @__PURE__ */ n(function() {
                return Gt(r, "font-weight:normal;text-decoration:none;font-style:normal");
            }, "_"),
            23: /* @__PURE__ */ n(function() {
                return Ua(r, "i");
            }, "_"),
            24: /* @__PURE__ */ n(function() {
                return Ua(r, "u");
            }, "_"),
            39: /* @__PURE__ */ n(function() {
                return qt(r, t.fg);
            }, "_"),
            49: /* @__PURE__ */ n(function() {
                return Bt(r, t.bg);
            }, "_"),
            53: /* @__PURE__ */ n(function() {
                return Gt(r, "text-decoration:overline");
            }, "_")
        }, s;
        return o[e] ? s = o[e]() : 4 < e && e < 7 ? s = we(r, "blink") : 29 < e && e < 38 ? s = qt(r, t.colors[e - 30]) : 39 < e && e < 48 ? s = Bt(r, t.colors[e - 40]) : 89 < e && e < 98 ? s = qt(r, t.colors[8 + (e - 90)]) : 99 < e && e < 108 && (s = Bt(r, t.colors[8 + (e - 100)])), s;
    }
    n(Tf, "handleDisplay");
    function Ba(r) {
        var e = r.slice(0);
        return r.length = 0, e.reverse().map(function(t) {
            return "</" + t + ">";
        }).join("");
    }
    n(Ba, "resetStyles");
    function Ut(r, e) {
        for(var t = [], o = r; o <= e; o++)t.push(o);
        return t;
    }
    n(Ut, "range");
    function Ef(r) {
        return function(e) {
            return (r === null || e.category !== r) && r !== "all";
        };
    }
    n(Ef, "notCategory");
    function Ma(r) {
        r = parseInt(r, 10);
        var e = null;
        return r === 0 ? e = "all" : r === 1 ? e = "bold" : 2 < r && r < 5 ? e = "underline" : 4 < r && r < 7 ? e = "blink" : r === 8 ? e = "hid\
e" : r === 9 ? e = "strike" : 29 < r && r < 38 || r === 39 || 89 < r && r < 98 ? e = "foreground-color" : (39 < r && r < 48 || r === 49 || 99 < r && r < 108) && (e = "background-color"), e;
    }
    n(Ma, "categoryForCode");
    function Rf(r, e) {
        return e.escapeXML ? mf.encodeXML(r) : r;
    }
    n(Rf, "pushText");
    function we(r, e, t) {
        return t || (t = ""), r.push(e), "<".concat(e).concat(t ? ' style="'.concat(t, '"') : "", ">");
    }
    n(we, "pushTag");
    function Gt(r, e) {
        return we(r, "span", e);
    }
    n(Gt, "pushStyle");
    function qt(r, e) {
        return we(r, "span", "color:" + e);
    }
    n(qt, "pushForegroundColor");
    function Bt(r, e) {
        return we(r, "span", "background-color:" + e);
    }
    n(Bt, "pushBackgroundColor");
    function Ua(r, e) {
        var t;
        if (r.slice(-1)[0] === e && (t = r.pop()), t) return "</" + e + ">";
    }
    n(Ua, "closeTag");
    function Af(r, e, t) {
        var o = !1, s = 3;
        function i() {
            return "";
        }
        n(i, "remove");
        function a(v, C) {
            return t("xterm256Foreground", C), "";
        }
        n(a, "removeXterm256Foreground");
        function c(v, C) {
            return t("xterm256Background", C), "";
        }
        n(c, "removeXterm256Background");
        function l(v) {
            return e.newline ? t("display", -1) : t("text", v), "";
        }
        n(l, "newline");
        function p(v, C) {
            o = !0, C.trim().length === 0 && (C = "0"), C = C.trimRight(";").split(";");
            var F = Ga(C), U;
            try {
                for(F.s(); !(U = F.n()).done;){
                    var B = U.value;
                    t("display", B);
                }
            } catch (W) {
                F.e(W);
            } finally{
                F.f();
            }
            return "";
        }
        n(p, "ansiMess");
        function u(v) {
            return t("text", v), "";
        }
        n(u, "realText");
        function d(v) {
            return t("rgb", v), "";
        }
        n(d, "rgb");
        var h = [
            {
                pattern: /^\x08+/,
                sub: i
            },
            {
                pattern: /^\x1b\[[012]?K/,
                sub: i
            },
            {
                pattern: /^\x1b\[\(B/,
                sub: i
            },
            {
                pattern: /^\x1b\[[34]8;2;\d+;\d+;\d+m/,
                sub: d
            },
            {
                pattern: /^\x1b\[38;5;(\d+)m/,
                sub: a
            },
            {
                pattern: /^\x1b\[48;5;(\d+)m/,
                sub: c
            },
            {
                pattern: /^\n/,
                sub: l
            },
            {
                pattern: /^\r+\n/,
                sub: l
            },
            {
                pattern: /^\r/,
                sub: l
            },
            {
                pattern: /^\x1b\[((?:\d{1,3};?)+|)m/,
                sub: p
            },
            {
                // CSI n J
                // ED - Erase in Display Clears part of the screen.
                // If n is 0 (or missing), clear from cursor to end of screen.
                // If n is 1, clear from cursor to beginning of the screen.
                // If n is 2, clear entire screen (and moves cursor to upper left on DOS ANSI.SYS).
                // If n is 3, clear entire screen and delete all lines saved in the scrollback buffer
                //   (this feature was added for xterm and is supported by other terminal applications).
                pattern: /^\x1b\[\d?J/,
                sub: i
            },
            {
                // CSI n ; m f
                // HVP - Horizontal Vertical Position Same as CUP
                pattern: /^\x1b\[\d{0,3};\d{0,3}f/,
                sub: i
            },
            {
                // catch-all for CSI sequences?
                pattern: /^\x1b\[?[\d;]{0,3}/,
                sub: i
            },
            {
                /**
       * extracts real text - not containing:
       * - `\x1b' - ESC - escape (Ascii 27)
       * - '\x08' - BS - backspace (Ascii 8)
       * - `\n` - Newline - linefeed (LF) (ascii 10)
       * - `\r` - Windows Carriage Return (CR)
       */ pattern: /^(([^\x1b\x08\r\n])+)/,
                sub: u
            }
        ];
        function S(v, C) {
            C > s && o || (o = !1, r = r.replace(v.pattern, v.sub));
        }
        n(S, "process");
        var m = [], T = r, y = T.length;
        e: for(; y > 0;){
            for(var R = 0, x = 0, g = h.length; x < g; R = ++x){
                var b = h[R];
                if (S(b, R), r.length !== y) {
                    y = r.length;
                    continue e;
                }
            }
            if (r.length === y) break;
            m.push(0), y = r.length;
        }
        return m;
    }
    n(Af, "tokenize");
    function xf(r, e, t) {
        return e !== "text" && (r = r.filter(Ef(Ma(t))), r.push({
            token: e,
            data: t,
            category: Ma(t)
        })), r;
    }
    n(xf, "updateStickyStack");
    var vf = /* @__PURE__ */ function() {
        function r(e) {
            uf(this, r), e = e || {}, e.colors && (e.colors = Object.assign({}, La.colors, e.colors)), this.options = Object.assign({}, La, e), this.stack = [], this.stickyStack = [];
        }
        return n(r, "Filter"), ff(r, [
            {
                key: "toHtml",
                value: /* @__PURE__ */ n(function(t) {
                    var o = this;
                    t = typeof t == "string" ? [
                        t
                    ] : t;
                    var s = this.stack, i = this.options, a = [];
                    return this.stickyStack.forEach(function(c) {
                        var l = ja(s, c.token, c.data, i);
                        l && a.push(l);
                    }), Af(t.join(""), i, function(c, l) {
                        var p = ja(s, c, l, i);
                        p && a.push(p), i.stream && (o.stickyStack = xf(o.stickyStack, c, l));
                    }), s.length && a.push(Ba(s)), a.join("");
                }, "toHtml")
            }
        ]), r;
    }();
    Va.exports = vf;
});
// ../node_modules/browser-dtector/browser-dtector.umd.min.js
var Za = q((is, as)=>{
    (function(r, e) {
        typeof is == "object" && typeof as < "u" ? as.exports = e() : typeof define == "function" && define.amd ? define(e) : (r = typeof globalThis < "u" ? globalThis : r || self).BrowserDetector = e();
    })(is, function() {
        "use strict";
        function r(a, c) {
            for(var l = 0; l < c.length; l++){
                var p = c[l];
                p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(a, (u = p.key, d = void 0, typeof (d = function(h, S) {
                    if (typeof h != "object" || h === null) return h;
                    var m = h[Symbol.toPrimitive];
                    if (m !== void 0) {
                        var T = m.call(h, S || "default");
                        if (typeof T != "object") return T;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (S === "string" ? String : Number)(h);
                }(u, "string")) == "symbol" ? d : String(d)), p);
            }
            var u, d;
        }
        n(r, "e");
        var e = {
            chrome: "Google Chrome",
            brave: "Brave",
            crios: "Google Chrome",
            edge: "Microsoft Edge",
            edg: "Microsoft Edge",
            edgios: "Micro\
soft Edge",
            fennec: "Mozilla Firefox",
            jsdom: "JsDOM",
            mozilla: "Mozilla Firefox",
            fxios: "Mozilla Firefox",
            msie: "Microsoft Internet Explo\
rer",
            opera: "Opera",
            opios: "Opera",
            opr: "Opera",
            opt: "Opera",
            rv: "Microsoft Internet Explorer",
            safari: "Safari",
            samsungbrowser: "Sams\
ung Browser",
            electron: "Electron"
        }, t = {
            android: "Android",
            androidTablet: "Android Tablet",
            cros: "Chrome OS",
            fennec: "Android Tablet",
            ipad: "IPad",
            iphone: "IPhone",
            jsdom: "JsDOM",
            linux: "Linux",
            mac: "Macintosh",
            tablet: "Android Tablet",
            win: "Windows",
            "windows pho\
ne": "Windows Phone",
            xbox: "Microsoft Xbox"
        }, o = /* @__PURE__ */ n(function(a) {
            var c = new RegExp("^-?\\d+(?:.\\d{0,".concat(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, "})?")), l = Number(a).toString().match(c);
            return l ? l[0] : null;
        }, "n"), s = /* @__PURE__ */ n(function() {
            return typeof window < "u" ? window.navigator : null;
        }, "i"), i = function() {
            function a(u) {
                var d;
                (function(h, S) {
                    if (!(h instanceof S)) throw new TypeError("Cannot call a class as a function");
                })(this, a), this.userAgent = u || ((d = s()) === null || d === void 0 ? void 0 : d.userAgent) || null;
            }
            n(a, "t");
            var c, l, p;
            return c = a, l = [
                {
                    key: "parseUserAgent",
                    value: /* @__PURE__ */ n(function(u) {
                        var d, h, S, m = {}, T = u || this.userAgent || "", y = T.toLowerCase().replace(/\s\s+/g, " "), R = /(edge)\/([\w.]+)/.exec(y) || /(edg)[/]([\w.]+)/.exec(y) || /(opr)[/]([\w.]+)/.exec(y) || /(opt)[/]([\w.]+)/.exec(y) || /(fxios)[/]([\w.]+)/.exec(y) || /(edgios)[/]([\w.]+)/.exec(y) || /(jsdom)[/]([\w.]+)/.exec(y) || /(samsungbrowser)[/]([\w.]+)/.exec(y) || /(electron)[/]([\w.]+)/.exec(y) || /(chrome)[/]([\w.]+)/.exec(y) || /(crios)[/]([\w.]+)/.exec(y) || /(opios)[/]([\w.]+)/.exec(y) || /(version)(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(y) || /(webkit)[/]([\w.]+).*(version)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(y) || /(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(y) || /(webkit)[/]([\w.]+)/.exec(y) || /(opera)(?:.*version|)[/]([\w.]+)/.exec(y) || /(msie) ([\w.]+)/.exec(y) || /(fennec)[/]([\w.]+)/.exec(y) || y.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(y) || y.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(y) || [], x = /(ipad)/.exec(y) || /(ipod)/.exec(y) || /(iphone)/.exec(y) || /(jsdom)/.exec(y) || /(windows phone)/.exec(y) || /(xbox)/.exec(y) || /(win)/.exec(y) || /(tablet)/.exec(y) || /(android)/.test(y) && /(mobile)/.test(y) === !1 && [
                            "androidTablet"
                        ] || /(android)/.exec(y) || /(mac)/.exec(y) || /(linux)/.exec(y) || /(cros)/.exec(y) || [], g = R[5] || R[3] || R[1] || null, b = x[0] || null, v = R[4] || R[2] || null, C = s();
                        g === "chrome" && typeof (C == null || (d = C.brave) === null || d === void 0 ? void 0 : d.isBrave) == "function" && (g = "brave"), g && (m[g] = !0), b && (m[b] = !0);
                        var F = !!(m.tablet || m.android || m.androidTablet), U = !!(m.ipad || m.tablet || m.androidTablet), B = !!(m.android || m.androidTablet || m.tablet || m.ipad || m.ipod || m.iphone || m["windows phone"]), W = !!(m.cros || m.mac || m.linux || m.win), se = !!(m.brave || m.chrome || m.crios || m.opr || m.safari || m.edg || m.electron), P = !!(m.msie || m.rv);
                        return {
                            name: (h = e[g]) !== null && h !== void 0 ? h : null,
                            platform: (S = t[b]) !== null && S !== void 0 ? S : null,
                            userAgent: T,
                            version: v,
                            shortVersion: v ? o(parseFloat(v), 2) : null,
                            isAndroid: F,
                            isTablet: U,
                            isMobile: B,
                            isDesktop: W,
                            isWebkit: se,
                            isIE: P
                        };
                    }, "value")
                },
                {
                    key: "getBrowserInfo",
                    value: /* @__PURE__ */ n(function() {
                        var u = this.parseUserAgent();
                        return {
                            name: u.name,
                            platform: u.platform,
                            userAgent: u.userAgent,
                            version: u.version,
                            shortVersion: u.shortVersion
                        };
                    }, "value")
                }
            ], p = [
                {
                    key: "VERSION",
                    get: /* @__PURE__ */ n(function() {
                        return "3.4.0";
                    }, "get")
                }
            ], l && r(c.prototype, l), p && r(c, p), Object.defineProperty(c, "prototype", {
                writable: !1
            }), a;
        }();
        return i;
    });
});
// ../node_modules/@storybook/global/dist/index.mjs
var Ht = {};
_e(Ht, {
    global: ()=>E
});
var E = (()=>{
    let r;
    return typeof window < "u" ? r = window : typeof globalThis < "u" ? r = globalThis : typeof global < "u" ? r = global : typeof self < "u" ? r = self : r = {}, r;
})();
// src/core-events/index.ts
var ge = {};
_e(ge, {
    ARGTYPES_INFO_REQUEST: ()=>fo,
    ARGTYPES_INFO_RESPONSE: ()=>nt,
    CHANNEL_CREATED: ()=>cl,
    CHANNEL_WS_DISCONNECT: ()=>Wt,
    CONFIG_ERROR: ()=>$t,
    CREATE_NEW_STORYFILE_REQUEST: ()=>pl,
    CREATE_NEW_STORYFILE_RESPONSE: ()=>dl,
    CURRENT_STORY_WAS_SET: ()=>rt,
    DOCS_PREPARED: ()=>Yt,
    DOCS_RENDERED: ()=>pr,
    FILE_COMPONENT_SEARCH_REQUEST: ()=>ul,
    FILE_COMPONENT_SEARCH_RESPONSE: ()=>fl,
    FORCE_REMOUNT: ()=>Kt,
    FORCE_RE_RENDER: ()=>dr,
    GLOBALS_UPDATED: ()=>Ce,
    NAVIGATE_URL: ()=>yl,
    PLAY_FUNCTION_THREW_EXCEPTION: ()=>Xt,
    PRELOAD_ENTRIES: ()=>Qt,
    PREVIEW_BUILDER_PROGRESS: ()=>ml,
    PREVIEW_KEYDOWN: ()=>Zt,
    REGISTER_SUBSCRIPTION: ()=>hl,
    REQUEST_WHATS_NEW_DATA: ()=>wl,
    RESET_STORY_ARGS: ()=>ur,
    RESULT_WHATS_NEW_DATA: ()=>_l,
    SAVE_STORY_REQUEST: ()=>Ol,
    SAVE_STORY_RESPONSE: ()=>Il,
    SELECT_STORY: ()=>gl,
    SET_CONFIG: ()=>Sl,
    SET_CURRENT_STORY: ()=>eo,
    SET_FILTER: ()=>bl,
    SET_GLOBALS: ()=>ro,
    SET_INDEX: ()=>Tl,
    SET_STORIES: ()=>El,
    SET_WHATS_NEW_CACHE: ()=>Cl,
    SHARED_STATE_CHANGED: ()=>Rl,
    SHARED_STATE_SET: ()=>Al,
    STORIES_COLLAPSE_ALL: ()=>xl,
    STORIES_EXPAND_ALL: ()=>vl,
    STORY_ARGS_UPDATED: ()=>to,
    STORY_CHANGED: ()=>oo,
    STORY_ERRORED: ()=>no,
    STORY_FINISHED: ()=>ot,
    STORY_INDEX_INVALIDATED: ()=>so,
    STORY_MISSING: ()=>tt,
    STORY_PREPARED: ()=>io,
    STORY_RENDERED: ()=>We,
    STORY_RENDER_PHASE_CHANGED: ()=>Pe,
    STORY_SPECIFIED: ()=>ao,
    STORY_THREW_EXCEPTION: ()=>lo,
    STORY_UNCHANGED: ()=>co,
    TELEMETRY_ERROR: ()=>uo,
    TESTING_MODULE_CANCEL_TEST_RUN_REQUEST: ()=>Ll,
    TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE: ()=>jl,
    TESTING_MODULE_CRASH_REPORT: ()=>Fl,
    TESTING_MODULE_PROGRESS_REPORT: ()=>Dl,
    TESTING_MODULE_RUN_ALL_REQUEST: ()=>kl,
    TESTING_MODULE_RUN_REQUEST: ()=>Nl,
    TOGGLE_WHATS_NEW_NOTIFICATIONS: ()=>Pl,
    UNHANDLED_ERRORS_WHILE_PLAYING: ()=>Jt,
    UPDATE_GLOBALS: ()=>fr,
    UPDATE_QUERY_PARAMS: ()=>po,
    UPDATE_STORY_ARGS: ()=>yr,
    default: ()=>ll
});
var zt = /* @__PURE__ */ ((A)=>(A.CHANNEL_WS_DISCONNECT = "channelWSDisconnect", A.CHANNEL_CREATED = "channelCreated", A.CONFIG_ERROR = "c\
onfigError", A.STORY_INDEX_INVALIDATED = "storyIndexInvalidated", A.STORY_SPECIFIED = "storySpecified", A.SET_CONFIG = "setConfig", A.SET_STORIES = "setStories", A.SET_INDEX = "setIndex", A.SET_CURRENT_STORY = "setCurrentStory", A.CURRENT_STORY_WAS_SET = "currentStoryWasSet", A.FORCE_RE_RENDER = "forceReRender", A.FORCE_REMOUNT = "forceRemount", A.PRELOAD_ENTRIES = "preloadStories", A.STORY_PREPARED = "storyPrepared", A.DOCS_PREPARED = "docsPrepared", A.STORY_CHANGED = "storyChanged", A.STORY_UNCHANGED = "storyUnchanged", A.STORY_RENDERED = "storyRendered", A.STORY_FINISHED = "storyFinished", A.STORY_MISSING = "storyMissing", A.STORY_ERRORED = "storyErrored", A.STORY_THREW_EXCEPTION = "storyThrewException", A.STORY_RENDER_PHASE_CHANGED = "storyRenderPhaseChanged", A.PLAY_FUNCTION_THREW_EXCEPTION = "playFunctionThrewException", A.UNHANDLED_ERRORS_WHILE_PLAYING = "unhandledErro\
rsWhilePlaying", A.UPDATE_STORY_ARGS = "updateStoryArgs", A.STORY_ARGS_UPDATED = "storyArgsUpdated", A.RESET_STORY_ARGS = "resetStoryArgs", A.SET_FILTER = "setFilter", A.SET_GLOBALS = "setGlobals", A.UPDATE_GLOBALS = "updateGlobals", A.GLOBALS_UPDATED = "globalsUpdated", A.REGISTER_SUBSCRIPTION = "registerSubscription", A.PREVIEW_KEYDOWN = "previewKeydown", A.PREVIEW_BUILDER_PROGRESS = "preview_builder_progress", A.SELECT_STORY = "sel\
ectStory", A.STORIES_COLLAPSE_ALL = "storiesCollapseAll", A.STORIES_EXPAND_ALL = "storiesExpandAll", A.DOCS_RENDERED = "docsRendered", A.SHARED_STATE_CHANGED = "sharedStateChanged", A.SHARED_STATE_SET = "sharedStateSet", A.NAVIGATE_URL = "navigateUrl", A.UPDATE_QUERY_PARAMS = "updateQueryParams", A.REQUEST_WHATS_NEW_DATA = "requestWhatsNewData", A.RESULT_WHATS_NEW_DATA = "resultWhatsNewData", A.SET_WHATS_NEW_CACHE = "setWhatsNewCache", A.TOGGLE_WHATS_NEW_NOTIFICATIONS = "toggleWhatsNewNotifications", A.TELEMETRY_ERROR = "telemetryError", A.FILE_COMPONENT_SEARCH_REQUEST = "fil\
eComponentSearchRequest", A.FILE_COMPONENT_SEARCH_RESPONSE = "fileComponentSearchResponse", A.SAVE_STORY_REQUEST = "saveStoryRequest", A.SAVE_STORY_RESPONSE = "saveStoryResponse", A.ARGTYPES_INFO_REQUEST = "argtypesInfoRequest", A.ARGTYPES_INFO_RESPONSE = "argtypesInfoResponse", A.CREATE_NEW_STORYFILE_REQUEST = "createNewStoryfileRequest", A.CREATE_NEW_STORYFILE_RESPONSE = "createNewStoryfileResponse", A.TESTING_MODULE_CRASH_REPORT = "testingModuleC\
rashReport", A.TESTING_MODULE_PROGRESS_REPORT = "testingModuleProgressReport", A.TESTING_MODULE_RUN_REQUEST = "testingModuleRunRequest", A.TESTING_MODULE_RUN_ALL_REQUEST = "testingModuleRunAllRequest", A.TESTING_MODULE_CANCEL_TEST_RUN_REQUEST = "testingModuleCancelTestRunRequest", A.TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE = "testingModuleCancelTestRunResponse", A))(zt || {}), ll = zt, { CHANNEL_WS_DISCONNECT: Wt, CHANNEL_CREATED: cl, CONFIG_ERROR: $t, CREATE_NEW_STORYFILE_REQUEST: pl, CREATE_NEW_STORYFILE_RESPONSE: dl, CURRENT_STORY_WAS_SET: rt, DOCS_PREPARED: Yt, DOCS_RENDERED: pr, FILE_COMPONENT_SEARCH_REQUEST: ul, FILE_COMPONENT_SEARCH_RESPONSE: fl, FORCE_RE_RENDER: dr, FORCE_REMOUNT: Kt, GLOBALS_UPDATED: Ce, NAVIGATE_URL: yl, PLAY_FUNCTION_THREW_EXCEPTION: Xt, UNHANDLED_ERRORS_WHILE_PLAYING: Jt, PRELOAD_ENTRIES: Qt, PREVIEW_BUILDER_PROGRESS: ml, PREVIEW_KEYDOWN: Zt, REGISTER_SUBSCRIPTION: hl, RESET_STORY_ARGS: ur, SELECT_STORY: gl, SET_CONFIG: Sl, SET_CURRENT_STORY: eo, SET_FILTER: bl, SET_GLOBALS: ro, SET_INDEX: Tl, SET_STORIES: El, SHARED_STATE_CHANGED: Rl, SHARED_STATE_SET: Al, STORIES_COLLAPSE_ALL: xl, STORIES_EXPAND_ALL: vl, STORY_ARGS_UPDATED: to, STORY_CHANGED: oo, STORY_ERRORED: no, STORY_INDEX_INVALIDATED: so, STORY_MISSING: tt, STORY_PREPARED: io, STORY_RENDER_PHASE_CHANGED: Pe, STORY_RENDERED: We, STORY_FINISHED: ot, STORY_SPECIFIED: ao, STORY_THREW_EXCEPTION: lo, STORY_UNCHANGED: co, UPDATE_GLOBALS: fr, UPDATE_QUERY_PARAMS: po, UPDATE_STORY_ARGS: yr, REQUEST_WHATS_NEW_DATA: wl, RESULT_WHATS_NEW_DATA: _l, SET_WHATS_NEW_CACHE: Cl, TOGGLE_WHATS_NEW_NOTIFICATIONS: Pl, TELEMETRY_ERROR: uo, SAVE_STORY_REQUEST: Ol, SAVE_STORY_RESPONSE: Il, ARGTYPES_INFO_REQUEST: fo, ARGTYPES_INFO_RESPONSE: nt, TESTING_MODULE_CRASH_REPORT: Fl, TESTING_MODULE_PROGRESS_REPORT: Dl, TESTING_MODULE_RUN_REQUEST: Nl, TESTING_MODULE_RUN_ALL_REQUEST: kl, TESTING_MODULE_CANCEL_TEST_RUN_REQUEST: Ll, TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE: jl } = zt;
// src/preview/globals/globals.ts
var yo = {
    "@storybook/global": "__STORYBOOK_MODULE_GLOBAL__",
    "storybook/internal/channels": "__STORYBOOK_MODULE_CHANNELS__",
    "@storybook/channels": "__STORYBOOK_MODULE_CHANNELS__",
    "@storybook/core/channels": "__STORYBOOK_MODULE_CHANNELS__",
    "storybook/internal/client-logger": "__STORYBOOK_MODULE_CLIENT_LOGGER__",
    "@storybook/client-logger": "__STORYBOOK_MODULE_CLIENT_LOGGER__",
    "@storybook/core/client-logger": "__STORYBOOK_MODULE_CLIENT_LOGGER__",
    "storybook/internal/core-events": "__STORYBOOK_MODULE_CORE_EVENTS__",
    "@storybook/core-events": "__STORYBOOK_MODULE_CORE_EVENTS__",
    "@storybook/core/core-events": "__STORYBOOK_MODULE_CORE_EVENTS__",
    "storybook/internal/preview-errors": "__STORYBOOK_MODULE_CORE_EVENTS_PREVIEW_ERRORS__",
    "@storybook/core-events/preview-errors": "__STORYBOOK_MODULE_CORE_EVENTS_PREVIEW_ERRORS__",
    "@storybook/core/preview-errors": "__STORYBOOK_MODULE_CORE_EVENTS_PREVIEW_ERRORS__",
    "storybook/internal/preview-api": "__STORYBOOK_MODULE_PREVIEW_API__",
    "@storybook/preview-api": "__STORYBOOK_MODULE_PREVIEW_API__",
    "@storybook/core/preview-api": "__STORYBOOK_MODULE_PREVIEW_API__",
    "storybook/internal/types": "__STORYBOOK_MODULE_TYPES__",
    "@storybook/types": "__STORYBOOK_MODULE_TYPES__",
    "@storybook/core/types": "__STORYBOOK_MODULE_TYPES__"
}, cs = Object.keys(yo);
// src/channels/index.ts
var br = {};
_e(br, {
    Channel: ()=>ie,
    HEARTBEAT_INTERVAL: ()=>Po,
    HEARTBEAT_MAX_LATENCY: ()=>Oo,
    PostMessageTransport: ()=>Qe,
    WebsocketTransport: ()=>Ze,
    createBrowserChannel: ()=>kd,
    default: ()=>Nd
});
// ../node_modules/ts-dedent/esm/index.js
function _(r) {
    for(var e = [], t = 1; t < arguments.length; t++)e[t - 1] = arguments[t];
    var o = Array.from(typeof r == "string" ? [
        r
    ] : r);
    o[o.length - 1] = o[o.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var s = o.reduce(function(c, l) {
        var p = l.match(/\n([\t ]+|(?!\s).)/g);
        return p ? c.concat(p.map(function(u) {
            var d, h;
            return (h = (d = u.match(/[\t ]/g)) === null || d === void 0 ? void 0 : d.length) !== null && h !== void 0 ? h : 0;
        })) : c;
    }, []);
    if (s.length) {
        var i = new RegExp(`
[	 ]{` + Math.min.apply(Math, s) + "}", "g");
        o = o.map(function(c) {
            return c.replace(i, `
`);
        });
    }
    o[0] = o[0].replace(/^\r?\n/, "");
    var a = o[0];
    return e.forEach(function(c, l) {
        var p = a.match(/(?:^|\n)( *)$/), u = p ? p[1] : "", d = c;
        typeof c == "string" && c.includes(`
`) && (d = String(c).split(`
`).map(function(h, S) {
            return S === 0 ? h : "" + u + h;
        }).join(`
`)), a += d + o[l + 1];
    }), a;
}
n(_, "dedent");
var ps = _;
// src/shared/universal-store/instances.ts
var mo = /* @__PURE__ */ new Map();
// src/shared/universal-store/index.ts
var Ml = "UNIVERSAL_STORE:", ee = {
    PENDING: "PENDING",
    RESOLVED: "RESOLVED",
    REJECTED: "REJECTED"
}, w = class w {
    constructor(e, t){
        /** Enable debug logs for this store */ this.debugging = !1;
        // TODO: narrow type of listeners based on event type
        this.listeners = /* @__PURE__ */ new Map([
            [
                "*",
                /* @__PURE__ */ new Set()
            ]
        ]);
        /** Gets the current state */ this.getState = /* @__PURE__ */ n(()=>(this.debug("getState", {
                state: this.state
            }), this.state), "getState");
        /**
     * Subscribes to store events
     *
     * @returns A function to unsubscribe
     */ this.subscribe = /* @__PURE__ */ n((e, t)=>{
            let o = typeof e == "function", s = o ? "*" : e, i = o ? e : t;
            if (this.debug("subscribe", {
                eventType: s,
                listener: i
            }), !i) throw new TypeError(`Missing first subscribe argument, or second if first is the event type, when subscribing to a UniversalStore with id '${this.id}'`);
            return this.listeners.has(s) || this.listeners.set(s, /* @__PURE__ */ new Set()), this.listeners.get(s).add(i), ()=>{
                this.debug("unsubscribe", {
                    eventType: s,
                    listener: i
                }), this.listeners.has(s) && (this.listeners.get(s).delete(i), this.listeners.get(s)?.size === 0 && this.listeners.delete(s));
            };
        }, "subscribe");
        /** Sends a custom event to the other stores */ this.send = /* @__PURE__ */ n((e)=>{
            if (this.debug("send", {
                event: e
            }), this.status !== w.Status.READY) throw new TypeError(_`Cannot send event before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify({
                event: e,
                id: this.id,
                actor: this.actor,
                environment: this.environment
            }, null, 2)}`);
            this.emitToListeners(e, {
                actor: this.actor
            }), this.emitToChannel(e, {
                actor: this.actor
            });
        }, "send");
        if (this.debugging = e.debug ?? !1, !w.isInternalConstructing) throw new TypeError("UniversalStore is not constructable - use UniversalStore.create() instead");
        if (w.isInternalConstructing = !1, this.id = e.id, this.actorId = Date.now().toString(36) + Math.random().toString(36).substring(2), this.actorType = e.leader ? w.ActorType.LEADER : w.ActorType.FOLLOWER, this.state = e.initialState, this.channelEventName = `${Ml}${this.id}`, this.debug("constructor", {
            options: e,
            environmentOverrides: t,
            channelEventName: this.channelEventName
        }), this.actor.type === w.ActorType.LEADER) this.syncing = {
            state: ee.RESOLVED,
            promise: Promise.resolve()
        };
        else {
            let o, s, i = new Promise((a, c)=>{
                o = /* @__PURE__ */ n(()=>{
                    this.syncing.state === ee.PENDING && (this.syncing.state = ee.RESOLVED, a());
                }, "syncingResolve"), s = /* @__PURE__ */ n((l)=>{
                    this.syncing.state === ee.PENDING && (this.syncing.state = ee.REJECTED, c(l));
                }, "syncingReject");
            });
            this.syncing = {
                state: ee.PENDING,
                promise: i,
                resolve: o,
                reject: s
            };
        }
        this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.subscribe = this.subscribe.bind(this), this.onStateChange = this.onStateChange.bind(this), this.send = this.send.bind(this), this.emitToChannel = this.emitToChannel.bind(this), this.prepareThis = this.prepareThis.bind(this), this.emitToListeners = this.emitToListeners.bind(this), this.handleChannelEvents = this.handleChannelEvents.bind(this), this.debug = this.debug.bind(this), this.channel = t?.channel ?? w.preparation.channel, this.environment = t?.environment ?? w.preparation.environment, this.channel && this.environment ? this.prepareThis({
            channel: this.channel,
            environment: this.environment
        }) : w.preparation.promise.then(this.prepareThis);
    }
    static setupPreparationPromise() {
        let e, t, o = new Promise((s, i)=>{
            e = /* @__PURE__ */ n((a)=>{
                s(a);
            }, "resolveRef"), t = /* @__PURE__ */ n((...a)=>{
                i(a);
            }, "rejectRef");
        });
        w.preparation = {
            resolve: e,
            reject: t,
            promise: o
        };
    }
    /** The actor object representing the store instance with a unique ID and a type */ get actor() {
        return Object.freeze({
            id: this.actorId,
            type: this.actorType,
            environment: this.environment ?? w.Environment.UNKNOWN
        });
    }
    /**
   * The current state of the store, that signals both if the store is prepared by Storybook and
   * also - in the case of a follower - if the state has been synced with the leader's state.
   */ get status() {
        if (!this.channel || !this.environment) return w.Status.UNPREPARED;
        switch(this.syncing?.state){
            case ee.PENDING:
            case void 0:
                return w.Status.SYNCING;
            case ee.REJECTED:
                return w.Status.ERROR;
            case ee.RESOLVED:
            default:
                return w.Status.READY;
        }
    }
    /**
   * A promise that resolves when the store is fully ready. A leader will be ready when the store
   * has been prepared by Storybook, which is almost instantly.
   *
   * A follower will be ready when the state has been synced with the leader's state, within a few
   * hundred milliseconds.
   */ untilReady() {
        return Promise.all([
            w.preparation.promise,
            this.syncing?.promise
        ]);
    }
    /** Creates a new instance of UniversalStore */ static create(e) {
        if (!e || typeof e?.id != "string") throw new TypeError("id is required and must be a string, when creating a UniversalStore");
        e.debug && console.debug(_`[UniversalStore]
        create`, {
            options: e
        });
        let t = mo.get(e.id);
        if (t) return console.warn(_`UniversalStore with id "${e.id}" already exists in this environment, re-using existing.
        You should reuse the existing instance instead of trying to create a new one.`), t;
        w.isInternalConstructing = !0;
        let o = new w(e);
        return mo.set(e.id, o), o;
    }
    /**
   * Used by Storybook to set the channel for all instances of UniversalStore in the given
   * environment.
   *
   * @internal
   */ static __prepare(e, t) {
        w.preparation.channel = e, w.preparation.environment = t, w.preparation.resolve({
            channel: e,
            environment: t
        });
    }
    /**
   * Updates the store's state
   *
   * Either a new state or a state updater function can be passed to the method.
   */ setState(e) {
        let t = this.state, o = typeof e == "function" ? e(t) : e;
        if (this.debug("setState", {
            newState: o,
            previousState: t,
            updater: e
        }), this.status !== w.Status.READY) throw new TypeError(_`Cannot set state before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify({
            newState: o,
            id: this.id,
            actor: this.actor,
            environment: this.environment
        }, null, 2)}`);
        this.state = o;
        let s = {
            type: w.InternalEventType.SET_STATE,
            payload: {
                state: o,
                previousState: t
            }
        };
        this.emitToChannel(s, {
            actor: this.actor
        }), this.emitToListeners(s, {
            actor: this.actor
        });
    }
    /**
   * Subscribes to state changes
   *
   * @returns Unsubscribe function
   */ onStateChange(e) {
        return this.debug("onStateChange", {
            listener: e
        }), this.subscribe(w.InternalEventType.SET_STATE, ({ payload: t }, o)=>{
            e(t.state, t.previousState, o);
        });
    }
    emitToChannel(e, t) {
        this.debug("emitToChannel", {
            event: e,
            eventInfo: t,
            channel: this.channel
        }), this.channel?.emit(this.channelEventName, {
            event: e,
            eventInfo: t
        });
    }
    prepareThis({ channel: e, environment: t }) {
        this.channel = e, this.environment = t, this.debug("prepared", {
            channel: e,
            environment: t
        }), this.channel.on(this.channelEventName, this.handleChannelEvents), this.actor.type === w.ActorType.LEADER ? this.emitToChannel({
            type: w.InternalEventType.LEADER_CREATED
        }, {
            actor: this.actor
        }) : (this.emitToChannel({
            type: w.InternalEventType.FOLLOWER_CREATED
        }, {
            actor: this.actor
        }), this.emitToChannel({
            type: w.InternalEventType.EXISTING_STATE_REQUEST
        }, {
            actor: this.actor
        }), setTimeout(()=>{
            this.syncing.reject(new TypeError(`No existing state found for follower with id: '${this.id}'. Make sure a leader with the same id exists before creating a follower\
.`));
        }, 1e3));
    }
    emitToListeners(e, t) {
        let o = this.listeners.get(e.type), s = this.listeners.get("*");
        this.debug("emitToListeners", {
            event: e,
            eventInfo: t,
            eventTypeListeners: o,
            everythingListeners: s
        }), [
            ...o ?? [],
            ...s ?? []
        ].forEach((i)=>i(e, t));
    }
    handleChannelEvents(e) {
        let { event: t, eventInfo: o } = e;
        if ([
            o.actor.id,
            o.forwardingActor?.id
        ].includes(this.actor.id)) {
            this.debug("handleChannelEvents: Ignoring event from self", {
                channelEvent: e
            });
            return;
        } else if (this.syncing?.state === ee.PENDING && t.type !== w.InternalEventType.EXISTING_STATE_RESPONSE) {
            this.debug("handleChannelEvents: Ignoring event while syncing", {
                channelEvent: e
            });
            return;
        }
        if (this.debug("handleChannelEvents", {
            channelEvent: e
        }), this.actor.type === w.ActorType.LEADER) {
            let s = !0;
            switch(t.type){
                case w.InternalEventType.EXISTING_STATE_REQUEST:
                    s = !1;
                    let i = {
                        type: w.InternalEventType.EXISTING_STATE_RESPONSE,
                        payload: this.state
                    };
                    this.debug("handleChannelEvents: responding to existing state request", {
                        responseEvent: i
                    }), this.emitToChannel(i, {
                        actor: this.actor
                    });
                    break;
                case w.InternalEventType.LEADER_CREATED:
                    s = !1, this.syncing.state = ee.REJECTED, this.debug("handleChannelEvents: erroring due to second leader being created", {
                        event: t
                    }), console.error(_`Detected multiple UniversalStore leaders created with the same id "${this.id}".
            Only one leader can exists at a time, your stores are now in an invalid state.
            Leaders detected:
            this: ${JSON.stringify(this.actor, null, 2)}
            other: ${JSON.stringify(o.actor, null, 2)}`);
                    break;
            }
            s && (this.debug("handleChannelEvents: forwarding event", {
                channelEvent: e
            }), this.emitToChannel(t, {
                actor: o.actor,
                forwardingActor: this.actor
            }));
        }
        if (this.actor.type === w.ActorType.FOLLOWER) switch(t.type){
            case w.InternalEventType.EXISTING_STATE_RESPONSE:
                if (this.debug("handleChannelEvents: Setting state from leader's existing state response", {
                    event: t
                }), this.syncing?.state !== ee.PENDING) break;
                this.syncing.resolve?.();
                let s = {
                    type: w.InternalEventType.SET_STATE,
                    payload: {
                        state: t.payload,
                        previousState: this.state
                    }
                };
                this.state = t.payload, this.emitToListeners(s, o);
                break;
        }
        switch(t.type){
            case w.InternalEventType.SET_STATE:
                this.debug("handleChannelEvents: Setting state", {
                    event: t
                }), this.state = t.payload.state;
                break;
        }
        this.emitToListeners(t, {
            actor: o.actor
        });
    }
    debug(e, t) {
        this.debugging && console.debug(_`[UniversalStore::${this.id}::${this.environment ?? w.Environment.UNKNOWN}]
        ${e}`, JSON.stringify({
            data: t,
            actor: this.actor,
            state: this.state,
            status: this.status
        }, null, 2));
    }
    /**
   * Used to reset the static fields of the UniversalStore class when cleaning up tests
   *
   * @internal
   */ static __reset() {
        w.preparation.reject(new Error("reset")), w.setupPreparationPromise(), w.isInternalConstructing = !1;
    }
};
n(w, "UniversalStore"), /**
 * Defines the possible actor types in the store system
 *
 * @readonly
 */ w.ActorType = {
    LEADER: "LEADER",
    FOLLOWER: "FOLLOWER"
}, /**
 * Defines the possible environments the store can run in
 *
 * @readonly
 */ w.Environment = {
    SERVER: "SERVER",
    MANAGER: "MANAGER",
    PREVIEW: "PREVIEW",
    UNKNOWN: "UNKNOWN",
    MOCK: "MOCK"
}, /**
 * Internal event types used for store synchronization
 *
 * @readonly
 */ w.InternalEventType = {
    EXISTING_STATE_REQUEST: "__EXISTING_STATE_REQUEST",
    EXISTING_STATE_RESPONSE: "__EXISTING_STATE_RESPONSE",
    SET_STATE: "__SET_STATE",
    LEADER_CREATED: "__LEADER_CREATED",
    FOLLOWER_CREATED: "__FOLLOWER_CREATED"
}, w.Status = {
    UNPREPARED: "UNPREPARED",
    SYNCING: "SYNCING",
    READY: "READY",
    ERROR: "ERROR"
}, w.isInternalConstructing = !1, w.setupPreparationPromise();
var Q = w;
// src/channels/main.ts
var Ul = /* @__PURE__ */ n((r)=>r.transports !== void 0, "isMulti"), Gl = /* @__PURE__ */ n(()=>Math.random().toString(16).slice(2), "ge\
nerateRandomId"), ho = class ho {
    constructor(e = {}){
        this.sender = Gl();
        this.events = {};
        this.data = {};
        this.transports = [];
        this.isAsync = e.async || !1, Ul(e) ? (this.transports = e.transports || [], this.transports.forEach((t)=>{
            t.setHandler((o)=>this.handleEvent(o));
        })) : this.transports = e.transport ? [
            e.transport
        ] : [], this.transports.forEach((t)=>{
            t.setHandler((o)=>this.handleEvent(o));
        });
    }
    get hasTransport() {
        return this.transports.length > 0;
    }
    addListener(e, t) {
        this.events[e] = this.events[e] || [], this.events[e].push(t);
    }
    emit(e, ...t) {
        let o = {
            type: e,
            args: t,
            from: this.sender
        }, s = {};
        t.length >= 1 && t[0] && t[0].options && (s = t[0].options);
        let i = /* @__PURE__ */ n(()=>{
            this.transports.forEach((a)=>{
                a.send(o, s);
            }), this.handleEvent(o);
        }, "handler");
        this.isAsync ? setImmediate(i) : i();
    }
    last(e) {
        return this.data[e];
    }
    eventNames() {
        return Object.keys(this.events);
    }
    listenerCount(e) {
        let t = this.listeners(e);
        return t ? t.length : 0;
    }
    listeners(e) {
        return this.events[e] || void 0;
    }
    once(e, t) {
        let o = this.onceListener(e, t);
        this.addListener(e, o);
    }
    removeAllListeners(e) {
        e ? this.events[e] && delete this.events[e] : this.events = {};
    }
    removeListener(e, t) {
        let o = this.listeners(e);
        o && (this.events[e] = o.filter((s)=>s !== t));
    }
    on(e, t) {
        this.addListener(e, t);
    }
    off(e, t) {
        this.removeListener(e, t);
    }
    handleEvent(e) {
        let t = this.listeners(e.type);
        t && t.length && t.forEach((o)=>{
            o.apply(e, e.args);
        }), this.data[e.type] = e.args;
    }
    onceListener(e, t) {
        let o = /* @__PURE__ */ n((...s)=>(this.removeListener(e, o), t(...s)), "onceListener");
        return o;
    }
};
n(ho, "Channel");
var ie = ho;
// src/client-logger/index.ts
var mr = {};
_e(mr, {
    deprecate: ()=>ae,
    logger: ()=>I,
    once: ()=>j,
    pretty: ()=>X
});
var { LOGLEVEL: ql } = E, Se = {
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    silent: 10
}, Bl = ql, $e = Se[Bl] || Se.info, I = {
    trace: /* @__PURE__ */ n((r, ...e)=>{
        $e <= Se.trace && console.trace(r, ...e);
    }, "trace"),
    debug: /* @__PURE__ */ n((r, ...e)=>{
        $e <= Se.debug && console.debug(r, ...e);
    }, "debug"),
    info: /* @__PURE__ */ n((r, ...e)=>{
        $e <= Se.info && console.info(r, ...e);
    }, "info"),
    warn: /* @__PURE__ */ n((r, ...e)=>{
        $e <= Se.warn && console.warn(r, ...e);
    }, "warn"),
    error: /* @__PURE__ */ n((r, ...e)=>{
        $e <= Se.error && console.error(r, ...e);
    }, "error"),
    log: /* @__PURE__ */ n((r, ...e)=>{
        $e < Se.silent && console.log(r, ...e);
    }, "log")
}, go = /* @__PURE__ */ new Set(), j = /* @__PURE__ */ n((r)=>(e, ...t)=>{
        if (!go.has(e)) return go.add(e), I[r](e, ...t);
    }, "once");
j.clear = ()=>go.clear();
j.trace = j("trace");
j.debug = j("debug");
j.info = j("info");
j.warn = j("warn");
j.error = j("error");
j.log = j("log");
var ae = j("warn"), X = /* @__PURE__ */ n((r)=>(...e)=>{
        let t = [];
        if (e.length) {
            let o = /<span\s+style=(['"])([^'"]*)\1\s*>/gi, s = /<\/span>/gi, i;
            for(t.push(e[0].replace(o, "%c").replace(s, "%c")); i = o.exec(e[0]);)t.push(i[2]), t.push("");
            for(let a = 1; a < e.length; a++)t.push(e[a]);
        }
        I[r].apply(I, t);
    }, "pretty");
X.trace = X("trace");
X.debug = X("debug");
X.info = X("info");
X.warn = X("warn");
X.error = X("error");
// ../node_modules/telejson/dist/chunk-465TF3XA.mjs
var Vl = Object.create, ds = Object.defineProperty, Hl = Object.getOwnPropertyDescriptor, us = Object.getOwnPropertyNames, zl = Object.getPrototypeOf, Wl = Object.prototype.hasOwnProperty, Z = /* @__PURE__ */ n((r, e)=>/* @__PURE__ */ n(function() {
        return e || (0, r[us(r)[0]])((e = {
            exports: {}
        }).exports, e), e.exports;
    }, "__require"), "__commonJS"), $l = /* @__PURE__ */ n((r, e, t, o)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let s of us(e))!Wl.call(r, s) && s !== t && ds(r, s, {
        get: /* @__PURE__ */ n(()=>e[s], "get"),
        enumerable: !(o = Hl(e, s)) || o.enumerable
    });
    return r;
}, "__copyProps"), st = /* @__PURE__ */ n((r, e, t)=>(t = r != null ? Vl(zl(r)) : {}, $l(e || !r || !r.__esModule ? ds(t, "default", {
        value: r,
        enumerable: !0
    }) : t, r)), "__toESM"), Yl = [
    "bubbles",
    "cancelBubble",
    "cancelable",
    "composed",
    "currentTarget",
    "defaultPrevented",
    "eventPhase",
    "isTrusted",
    "returnValue",
    "srcElement",
    "target",
    "timeStamp",
    "type"
], Kl = [
    "detail"
];
function fs(r) {
    let e = Yl.filter((t)=>r[t] !== void 0).reduce((t, o)=>({
            ...t,
            [o]: r[o]
        }), {});
    return r instanceof CustomEvent && Kl.filter((t)=>r[t] !== void 0).forEach((t)=>{
        e[t] = r[t];
    }), e;
}
n(fs, "extractEventHiddenProperties");
// ../node_modules/telejson/dist/index.mjs
var Ps = ue(it(), 1);
var Ts = Z({
    "node_modules/has-symbols/shams.js" (r, e) {
        "use strict";
        e.exports = /* @__PURE__ */ n(function() {
            if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
            if (typeof Symbol.iterator == "symbol") return !0;
            var o = {}, s = Symbol("test"), i = Object(s);
            if (typeof s == "string" || Object.prototype.toString.call(s) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object \
Symbol]") return !1;
            var a = 42;
            o[s] = a;
            for(s in o)return !1;
            if (typeof Object.keys == "function" && Object.keys(o).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(o).length !== 0) return !1;
            var c = Object.getOwnPropertySymbols(o);
            if (c.length !== 1 || c[0] !== s || !Object.prototype.propertyIsEnumerable.call(o, s)) return !1;
            if (typeof Object.getOwnPropertyDescriptor == "function") {
                var l = Object.getOwnPropertyDescriptor(o, s);
                if (l.value !== a || l.enumerable !== !0) return !1;
            }
            return !0;
        }, "hasSymbols");
    }
}), Es = Z({
    "node_modules/has-symbols/index.js" (r, e) {
        "use strict";
        var t = typeof Symbol < "u" && Symbol, o = Ts();
        e.exports = /* @__PURE__ */ n(function() {
            return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : o();
        }, "hasNativeSymbols");
    }
}), Xl = Z({
    "node_modules/function-bind/implementation.js" (r, e) {
        "use strict";
        var t = "Function.prototype.bind called on incompatible ", o = Array.prototype.slice, s = Object.prototype.toString, i = "[object Functi\
on]";
        e.exports = /* @__PURE__ */ n(function(c) {
            var l = this;
            if (typeof l != "function" || s.call(l) !== i) throw new TypeError(t + l);
            for(var p = o.call(arguments, 1), u, d = /* @__PURE__ */ n(function() {
                if (this instanceof u) {
                    var y = l.apply(this, p.concat(o.call(arguments)));
                    return Object(y) === y ? y : this;
                } else return l.apply(c, p.concat(o.call(arguments)));
            }, "binder"), h = Math.max(0, l.length - p.length), S = [], m = 0; m < h; m++)S.push("$" + m);
            if (u = Function("binder", "return function (" + S.join(",") + "){ return binder.apply(this,arguments); }")(d), l.prototype) {
                var T = /* @__PURE__ */ n(function() {}, "Empty2");
                T.prototype = l.prototype, u.prototype = new T(), T.prototype = null;
            }
            return u;
        }, "bind");
    }
}), To = Z({
    "node_modules/function-bind/index.js" (r, e) {
        "use strict";
        var t = Xl();
        e.exports = Function.prototype.bind || t;
    }
}), Jl = Z({
    "node_modules/has/src/index.js" (r, e) {
        "use strict";
        var t = To();
        e.exports = t.call(Function.call, Object.prototype.hasOwnProperty);
    }
}), Rs = Z({
    "node_modules/get-intrinsic/index.js" (r, e) {
        "use strict";
        var t, o = SyntaxError, s = Function, i = TypeError, a = /* @__PURE__ */ n(function(P) {
            try {
                return s('"use strict"; return (' + P + ").constructor;")();
            } catch  {}
        }, "getEvalledConstructor"), c = Object.getOwnPropertyDescriptor;
        if (c) try {
            c({}, "");
        } catch  {
            c = null;
        }
        var l = /* @__PURE__ */ n(function() {
            throw new i();
        }, "throwTypeError"), p = c ? function() {
            try {
                return arguments.callee, l;
            } catch  {
                try {
                    return c(arguments, "callee").get;
                } catch  {
                    return l;
                }
            }
        }() : l, u = Es()(), d = Object.getPrototypeOf || function(P) {
            return P.__proto__;
        }, h = {}, S = typeof Uint8Array > "u" ? t : d(Uint8Array), m = {
            "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
            "%Array%": Array,
            "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
            "%ArrayIteratorPrototype%": u ? d([][Symbol.iterator]()) : t,
            "%AsyncFromSyncIteratorPrototype%": t,
            "%AsyncFunction%": h,
            "%AsyncGenerator%": h,
            "%AsyncGeneratorFunction%": h,
            "%AsyncIteratorPrototype%": h,
            "%Atomics%": typeof Atomics > "u" ? t : Atomics,
            "%BigInt%": typeof BigInt > "u" ? t : BigInt,
            "%Boolean%": Boolean,
            "%DataView%": typeof DataView > "u" ? t : DataView,
            "%Date%": Date,
            "%decodeURI%": decodeURI,
            "%decodeURIComponent%": decodeURIComponent,
            "%encodeURI%": encodeURI,
            "%encodeURIComponent%": encodeURIComponent,
            "%Error%": Error,
            "%eval%": eval,
            "%EvalError%": EvalError,
            "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
            "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
            "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
            "%Function%": s,
            "%GeneratorFunction%": h,
            "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
            "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
            "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
            "%isFinite%": isFinite,
            "%isNaN%": isNaN,
            "%IteratorPrototype%": u ? d(d([][Symbol.iterator]())) : t,
            "%JSON%": typeof JSON == "object" ? JSON : t,
            "%Map%": typeof Map > "u" ? t : Map,
            "%MapIteratorPrototype%": typeof Map > "u" || !u ? t : d(/* @__PURE__ */ new Map()[Symbol.iterator]()),
            "%Math%": Math,
            "%Number%": Number,
            "%Object%": Object,
            "%parseFloat%": parseFloat,
            "%parseInt%": parseInt,
            "%Promise%": typeof Promise > "u" ? t : Promise,
            "%Proxy%": typeof Proxy > "u" ? t : Proxy,
            "%RangeError%": RangeError,
            "%ReferenceError%": ReferenceError,
            "%Reflect%": typeof Reflect > "u" ? t : Reflect,
            "%RegExp%": RegExp,
            "%Set%": typeof Set > "u" ? t : Set,
            "%SetIteratorPrototype%": typeof Set > "u" || !u ? t : d(/* @__PURE__ */ new Set()[Symbol.iterator]()),
            "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
            "%String%": String,
            "%StringIteratorPrototype%": u ? d(""[Symbol.iterator]()) : t,
            "%Symbol%": u ? Symbol : t,
            "%SyntaxError%": o,
            "%ThrowTypeError%": p,
            "%TypedArray%": S,
            "%TypeError%": i,
            "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
            "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
            "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
            "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
            "%URIError%": URIError,
            "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
            "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
            "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet
        }, T = /* @__PURE__ */ n(function P(D) {
            var M;
            if (D === "%AsyncFunction%") M = a("async function () {}");
            else if (D === "%GeneratorFunction%") M = a("function* () {}");
            else if (D === "%AsyncGeneratorFunction%") M = a("async function* () {}");
            else if (D === "%AsyncGenerator%") {
                var L = P("%AsyncGeneratorFunction%");
                L && (M = L.prototype);
            } else if (D === "%AsyncIteratorPrototype%") {
                var N = P("%AsyncGenerator%");
                N && (M = d(N.prototype));
            }
            return m[D] = M, M;
        }, "doEval2"), y = {
            "%ArrayBufferPrototype%": [
                "ArrayBuffer",
                "prototype"
            ],
            "%ArrayPrototype%": [
                "Array",
                "prototype"
            ],
            "%ArrayProto_entries%": [
                "Array",
                "prototype",
                "entries"
            ],
            "%ArrayProto_forEach%": [
                "Array",
                "prototype",
                "forEach"
            ],
            "%ArrayProto_keys%": [
                "Array",
                "prototype",
                "keys"
            ],
            "%ArrayProto_values%": [
                "Array",
                "prototype",
                "values"
            ],
            "%AsyncFunctionPrototype%": [
                "AsyncFunction",
                "prototype"
            ],
            "%AsyncGenerator%": [
                "AsyncGeneratorFunction",
                "prototype"
            ],
            "%AsyncGeneratorPrototype%": [
                "AsyncGeneratorFunction",
                "prototype",
                "prototype"
            ],
            "%BooleanPrototype%": [
                "Boolean",
                "prototype"
            ],
            "%DataViewPrototype%": [
                "DataView",
                "prototype"
            ],
            "%DatePrototype%": [
                "Date",
                "prototype"
            ],
            "%ErrorPrototype%": [
                "Error",
                "prototype"
            ],
            "%EvalErrorPrototype%": [
                "EvalError",
                "prototype"
            ],
            "%Float32ArrayPrototype%": [
                "Float32Array",
                "prototype"
            ],
            "%Float64ArrayPrototype%": [
                "Float64Array",
                "prototype"
            ],
            "%FunctionPrototype%": [
                "Function",
                "prototype"
            ],
            "%Generator%": [
                "GeneratorFunction",
                "prototype"
            ],
            "%GeneratorPrototype%": [
                "GeneratorFunction",
                "prototype",
                "prototype"
            ],
            "%Int8ArrayPrototype%": [
                "Int8Array",
                "prototype"
            ],
            "%Int16ArrayPrototype%": [
                "Int16Array",
                "prototype"
            ],
            "%Int32ArrayPrototype%": [
                "Int32Array",
                "prototype"
            ],
            "%JSONParse%": [
                "JSON",
                "parse"
            ],
            "%JSONStringify%": [
                "JSON",
                "stringify"
            ],
            "%MapPrototype%": [
                "Map",
                "prototype"
            ],
            "%NumberPrototype%": [
                "Number",
                "prototype"
            ],
            "%ObjectPrototype%": [
                "Object",
                "prototype"
            ],
            "%ObjProto_toString%": [
                "Object",
                "prototype",
                "toString"
            ],
            "%ObjProto_valueOf%": [
                "Object",
                "prototype",
                "valueOf"
            ],
            "%PromisePrototype%": [
                "Promise",
                "prototype"
            ],
            "%PromiseProto_then%": [
                "Promise",
                "prototype",
                "then"
            ],
            "%Promise_all%": [
                "Promise",
                "all"
            ],
            "%Promise_reject%": [
                "Promise",
                "reject"
            ],
            "%Promise_resolve%": [
                "Promise",
                "resolve"
            ],
            "%RangeErrorPrototype%": [
                "RangeError",
                "prototype"
            ],
            "%ReferenceErrorPrototype%": [
                "ReferenceError",
                "prototype"
            ],
            "%RegExpPrototype%": [
                "RegExp",
                "prototype"
            ],
            "%SetPrototype%": [
                "Set",
                "prototype"
            ],
            "%SharedArrayBufferPrototype%": [
                "SharedArrayBuffer",
                "prototype"
            ],
            "%StringPrototype%": [
                "String",
                "prototype"
            ],
            "%SymbolPrototype%": [
                "Symbol",
                "prototype"
            ],
            "%SyntaxErrorPrototype%": [
                "SyntaxError",
                "prototype"
            ],
            "%TypedArrayPrototype%": [
                "TypedArray",
                "prototype"
            ],
            "%TypeErrorPrototype%": [
                "TypeError",
                "prototype"
            ],
            "%Uint8ArrayPrototype%": [
                "Uint8Array",
                "prototype"
            ],
            "%Uint8ClampedArrayPrototype%": [
                "Uint8ClampedArray",
                "prototype"
            ],
            "%Uint16ArrayPrototype%": [
                "Uint16Array",
                "prototype"
            ],
            "%Uint32ArrayPrototype%": [
                "Uint32Array",
                "prototype"
            ],
            "%URIErrorPrototype%": [
                "URIError",
                "prototype"
            ],
            "%WeakMapPrototype%": [
                "WeakMap",
                "prototype"
            ],
            "%WeakSetPrototype%": [
                "WeakSet",
                "prototype"
            ]
        }, R = To(), x = Jl(), g = R.call(Function.call, Array.prototype.concat), b = R.call(Function.apply, Array.prototype.splice), v = R.call(Function.call, String.prototype.replace), C = R.call(Function.call, String.prototype.slice), F = R.call(Function.call, RegExp.prototype.exec), U = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, B = /\\(\\)?/g, W = /* @__PURE__ */ n(function(D) {
            var M = C(D, 0, 1), L = C(D, -1);
            if (M === "%" && L !== "%") throw new o("invalid intrinsic syntax, expected closing `%`");
            if (L === "%" && M !== "%") throw new o("invalid intrinsic syntax, expected opening `%`");
            var N = [];
            return v(D, U, function(H, re, K, Kr) {
                N[N.length] = K ? v(Kr, B, "$1") : re || H;
            }), N;
        }, "stringToPath3"), se = /* @__PURE__ */ n(function(D, M) {
            var L = D, N;
            if (x(y, L) && (N = y[L], L = "%" + N[0] + "%"), x(m, L)) {
                var H = m[L];
                if (H === h && (H = T(L)), typeof H > "u" && !M) throw new i("intrinsic " + D + " exists, but is not available. Please file an issue!");
                return {
                    alias: N,
                    name: L,
                    value: H
                };
            }
            throw new o("intrinsic " + D + " does not exist!");
        }, "getBaseIntrinsic2");
        e.exports = /* @__PURE__ */ n(function(D, M) {
            if (typeof D != "string" || D.length === 0) throw new i("intrinsic name must be a non-empty string");
            if (arguments.length > 1 && typeof M != "boolean") throw new i('"allowMissing" argument must be a boolean');
            if (F(/^%?[^%]*%?$/, D) === null) throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
            var L = W(D), N = L.length > 0 ? L[0] : "", H = se("%" + N + "%", M), re = H.name, K = H.value, Kr = !1, Vt = H.alias;
            Vt && (N = Vt[0], b(L, g([
                0,
                1
            ], Vt)));
            for(var Xr = 1, lr = !0; Xr < L.length; Xr += 1){
                var de = L[Xr], Jr = C(de, 0, 1), Qr = C(de, -1);
                if ((Jr === '"' || Jr === "'" || Jr === "`" || Qr === '"' || Qr === "'" || Qr === "`") && Jr !== Qr) throw new o("property names with quotes must have matching quotes");
                if ((de === "constructor" || !lr) && (Kr = !0), N += "." + de, re = "%" + N + "%", x(m, re)) K = m[re];
                else if (K != null) {
                    if (!(de in K)) {
                        if (!M) throw new i("base intrinsic for " + D + " exists, but the property is not available.");
                        return;
                    }
                    if (c && Xr + 1 >= L.length) {
                        var Zr = c(K, de);
                        lr = !!Zr, lr && "get" in Zr && !("originalValue" in Zr.get) ? K = Zr.get : K = K[de];
                    } else lr = x(K, de), K = K[de];
                    lr && !Kr && (m[re] = K);
                }
            }
            return K;
        }, "GetIntrinsic");
    }
}), Ql = Z({
    "node_modules/call-bind/index.js" (r, e) {
        "use strict";
        var t = To(), o = Rs(), s = o("%Function.prototype.apply%"), i = o("%Function.prototype.call%"), a = o("%Reflect.apply%", !0) || t.call(i, s), c = o("%Object.getOwnPropertyDescriptor%", !0), l = o("%Object.defineProperty%", !0), p = o("%Math.max%");
        if (l) try {
            l({}, "a", {
                value: 1
            });
        } catch  {
            l = null;
        }
        e.exports = /* @__PURE__ */ n(function(h) {
            var S = a(t, i, arguments);
            if (c && l) {
                var m = c(S, "length");
                m.configurable && l(S, "length", {
                    value: 1 + p(0, h.length - (arguments.length - 1))
                });
            }
            return S;
        }, "callBind");
        var u = /* @__PURE__ */ n(function() {
            return a(t, s, arguments);
        }, "applyBind2");
        l ? l(e.exports, "apply", {
            value: u
        }) : e.exports.apply = u;
    }
}), Zl = Z({
    "node_modules/call-bind/callBound.js" (r, e) {
        "use strict";
        var t = Rs(), o = Ql(), s = o(t("String.prototype.indexOf"));
        e.exports = /* @__PURE__ */ n(function(a, c) {
            var l = t(a, !!c);
            return typeof l == "function" && s(a, ".prototype.") > -1 ? o(l) : l;
        }, "callBoundIntrinsic");
    }
}), ec = Z({
    "node_modules/has-tostringtag/shams.js" (r, e) {
        "use strict";
        var t = Ts();
        e.exports = /* @__PURE__ */ n(function() {
            return t() && !!Symbol.toStringTag;
        }, "hasToStringTagShams");
    }
}), rc = Z({
    "node_modules/is-regex/index.js" (r, e) {
        "use strict";
        var t = Zl(), o = ec()(), s, i, a, c;
        o && (s = t("Object.prototype.hasOwnProperty"), i = t("RegExp.prototype.exec"), a = {}, l = /* @__PURE__ */ n(function() {
            throw a;
        }, "throwRegexMarker"), c = {
            toString: l,
            valueOf: l
        }, typeof Symbol.toPrimitive == "symbol" && (c[Symbol.toPrimitive] = l));
        var l, p = t("Object.prototype.toString"), u = Object.getOwnPropertyDescriptor, d = "[object RegExp]";
        e.exports = /* @__PURE__ */ n(o ? function(S) {
            if (!S || typeof S != "object") return !1;
            var m = u(S, "lastIndex"), T = m && s(m, "value");
            if (!T) return !1;
            try {
                i(S, c);
            } catch (y) {
                return y === a;
            }
        } : function(S) {
            return !S || typeof S != "object" && typeof S != "function" ? !1 : p(S) === d;
        }, "isRegex");
    }
}), tc = Z({
    "node_modules/is-function/index.js" (r, e) {
        e.exports = o;
        var t = Object.prototype.toString;
        function o(s) {
            if (!s) return !1;
            var i = t.call(s);
            return i === "[object Function]" || typeof s == "function" && i !== "[object RegExp]" || typeof window < "u" && (s === window.setTimeout || s === window.alert || s === window.confirm || s === window.prompt);
        }
        n(o, "isFunction3");
    }
}), oc = Z({
    "node_modules/is-symbol/index.js" (r, e) {
        "use strict";
        var t = Object.prototype.toString, o = Es()();
        o ? (s = Symbol.prototype.toString, i = /^Symbol\(.*\)$/, a = /* @__PURE__ */ n(function(l) {
            return typeof l.valueOf() != "symbol" ? !1 : i.test(s.call(l));
        }, "isRealSymbolObject"), e.exports = /* @__PURE__ */ n(function(l) {
            if (typeof l == "symbol") return !0;
            if (t.call(l) !== "[object Symbol]") return !1;
            try {
                return a(l);
            } catch  {
                return !1;
            }
        }, "isSymbol3")) : e.exports = /* @__PURE__ */ n(function(l) {
            return !1;
        }, "isSymbol3");
        var s, i, a;
    }
}), nc = st(rc()), sc = st(tc()), ic = st(oc());
function ac(r) {
    return r != null && typeof r == "object" && Array.isArray(r) === !1;
}
n(ac, "isObject");
var lc = typeof global == "object" && global && global.Object === Object && global, cc = lc, pc = typeof self == "object" && self && self.Object === Object && self, dc = cc || pc || Function("return this")(), Eo = dc, uc = Eo.Symbol, Ye = uc, As = Object.prototype, fc = As.hasOwnProperty, yc = As.toString, hr = Ye ? Ye.toStringTag : void 0;
function mc(r) {
    var e = fc.call(r, hr), t = r[hr];
    try {
        r[hr] = void 0;
        var o = !0;
    } catch  {}
    var s = yc.call(r);
    return o && (e ? r[hr] = t : delete r[hr]), s;
}
n(mc, "getRawTag");
var hc = mc, gc = Object.prototype, Sc = gc.toString;
function bc(r) {
    return Sc.call(r);
}
n(bc, "objectToString");
var Tc = bc, Ec = "[object Null]", Rc = "[object Undefined]", ms = Ye ? Ye.toStringTag : void 0;
function Ac(r) {
    return r == null ? r === void 0 ? Rc : Ec : ms && ms in Object(r) ? hc(r) : Tc(r);
}
n(Ac, "baseGetTag");
var xs = Ac;
function xc(r) {
    return r != null && typeof r == "object";
}
n(xc, "isObjectLike");
var vc = xc, wc = "[object Symbol]";
function _c(r) {
    return typeof r == "symbol" || vc(r) && xs(r) == wc;
}
n(_c, "isSymbol");
var Ro = _c;
function Cc(r, e) {
    for(var t = -1, o = r == null ? 0 : r.length, s = Array(o); ++t < o;)s[t] = e(r[t], t, r);
    return s;
}
n(Cc, "arrayMap");
var Pc = Cc, Oc = Array.isArray, Ao = Oc, Ic = 1 / 0, hs = Ye ? Ye.prototype : void 0, gs = hs ? hs.toString : void 0;
function vs(r) {
    if (typeof r == "string") return r;
    if (Ao(r)) return Pc(r, vs) + "";
    if (Ro(r)) return gs ? gs.call(r) : "";
    var e = r + "";
    return e == "0" && 1 / r == -Ic ? "-0" : e;
}
n(vs, "baseToString");
var Fc = vs;
function Dc(r) {
    var e = typeof r;
    return r != null && (e == "object" || e == "function");
}
n(Dc, "isObject2");
var ws = Dc, Nc = "[object AsyncFunction]", kc = "[object Function]", Lc = "[object GeneratorFunction]", jc = "[object Proxy]";
function Mc(r) {
    if (!ws(r)) return !1;
    var e = xs(r);
    return e == kc || e == Lc || e == Nc || e == jc;
}
n(Mc, "isFunction");
var Uc = Mc, Gc = Eo["__core-js_shared__"], bo = Gc, Ss = function() {
    var r = /[^.]+$/.exec(bo && bo.keys && bo.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
}();
function qc(r) {
    return !!Ss && Ss in r;
}
n(qc, "isMasked");
var Bc = qc, Vc = Function.prototype, Hc = Vc.toString;
function zc(r) {
    if (r != null) {
        try {
            return Hc.call(r);
        } catch  {}
        try {
            return r + "";
        } catch  {}
    }
    return "";
}
n(zc, "toSource");
var Wc = zc, $c = /[\\^$.*+?()[\]{}|]/g, Yc = /^\[object .+?Constructor\]$/, Kc = Function.prototype, Xc = Object.prototype, Jc = Kc.toString, Qc = Xc.hasOwnProperty, Zc = RegExp("^" + Jc.call(Qc).replace($c, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function ep(r) {
    if (!ws(r) || Bc(r)) return !1;
    var e = Uc(r) ? Zc : Yc;
    return e.test(Wc(r));
}
n(ep, "baseIsNative");
var rp = ep;
function tp(r, e) {
    return r?.[e];
}
n(tp, "getValue");
var op = tp;
function np(r, e) {
    var t = op(r, e);
    return rp(t) ? t : void 0;
}
n(np, "getNative");
var _s = np;
function sp(r, e) {
    return r === e || r !== r && e !== e;
}
n(sp, "eq");
var ip = sp, ap = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, lp = /^\w*$/;
function cp(r, e) {
    if (Ao(r)) return !1;
    var t = typeof r;
    return t == "number" || t == "symbol" || t == "boolean" || r == null || Ro(r) ? !0 : lp.test(r) || !ap.test(r) || e != null && r in Object(e);
}
n(cp, "isKey");
var pp = cp, dp = _s(Object, "create"), gr = dp;
function up() {
    this.__data__ = gr ? gr(null) : {}, this.size = 0;
}
n(up, "hashClear");
var fp = up;
function yp(r) {
    var e = this.has(r) && delete this.__data__[r];
    return this.size -= e ? 1 : 0, e;
}
n(yp, "hashDelete");
var mp = yp, hp = "__lodash_hash_undefined__", gp = Object.prototype, Sp = gp.hasOwnProperty;
function bp(r) {
    var e = this.__data__;
    if (gr) {
        var t = e[r];
        return t === hp ? void 0 : t;
    }
    return Sp.call(e, r) ? e[r] : void 0;
}
n(bp, "hashGet");
var Tp = bp, Ep = Object.prototype, Rp = Ep.hasOwnProperty;
function Ap(r) {
    var e = this.__data__;
    return gr ? e[r] !== void 0 : Rp.call(e, r);
}
n(Ap, "hashHas");
var xp = Ap, vp = "__lodash_hash_undefined__";
function wp(r, e) {
    var t = this.__data__;
    return this.size += this.has(r) ? 0 : 1, t[r] = gr && e === void 0 ? vp : e, this;
}
n(wp, "hashSet");
var _p = wp;
function Ke(r) {
    var e = -1, t = r == null ? 0 : r.length;
    for(this.clear(); ++e < t;){
        var o = r[e];
        this.set(o[0], o[1]);
    }
}
n(Ke, "Hash");
Ke.prototype.clear = fp;
Ke.prototype.delete = mp;
Ke.prototype.get = Tp;
Ke.prototype.has = xp;
Ke.prototype.set = _p;
var bs = Ke;
function Cp() {
    this.__data__ = [], this.size = 0;
}
n(Cp, "listCacheClear");
var Pp = Cp;
function Op(r, e) {
    for(var t = r.length; t--;)if (ip(r[t][0], e)) return t;
    return -1;
}
n(Op, "assocIndexOf");
var lt = Op, Ip = Array.prototype, Fp = Ip.splice;
function Dp(r) {
    var e = this.__data__, t = lt(e, r);
    if (t < 0) return !1;
    var o = e.length - 1;
    return t == o ? e.pop() : Fp.call(e, t, 1), --this.size, !0;
}
n(Dp, "listCacheDelete");
var Np = Dp;
function kp(r) {
    var e = this.__data__, t = lt(e, r);
    return t < 0 ? void 0 : e[t][1];
}
n(kp, "listCacheGet");
var Lp = kp;
function jp(r) {
    return lt(this.__data__, r) > -1;
}
n(jp, "listCacheHas");
var Mp = jp;
function Up(r, e) {
    var t = this.__data__, o = lt(t, r);
    return o < 0 ? (++this.size, t.push([
        r,
        e
    ])) : t[o][1] = e, this;
}
n(Up, "listCacheSet");
var Gp = Up;
function Xe(r) {
    var e = -1, t = r == null ? 0 : r.length;
    for(this.clear(); ++e < t;){
        var o = r[e];
        this.set(o[0], o[1]);
    }
}
n(Xe, "ListCache");
Xe.prototype.clear = Pp;
Xe.prototype.delete = Np;
Xe.prototype.get = Lp;
Xe.prototype.has = Mp;
Xe.prototype.set = Gp;
var qp = Xe, Bp = _s(Eo, "Map"), Vp = Bp;
function Hp() {
    this.size = 0, this.__data__ = {
        hash: new bs(),
        map: new (Vp || qp)(),
        string: new bs()
    };
}
n(Hp, "mapCacheClear");
var zp = Hp;
function Wp(r) {
    var e = typeof r;
    return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? r !== "__proto__" : r === null;
}
n(Wp, "isKeyable");
var $p = Wp;
function Yp(r, e) {
    var t = r.__data__;
    return $p(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
n(Yp, "getMapData");
var ct = Yp;
function Kp(r) {
    var e = ct(this, r).delete(r);
    return this.size -= e ? 1 : 0, e;
}
n(Kp, "mapCacheDelete");
var Xp = Kp;
function Jp(r) {
    return ct(this, r).get(r);
}
n(Jp, "mapCacheGet");
var Qp = Jp;
function Zp(r) {
    return ct(this, r).has(r);
}
n(Zp, "mapCacheHas");
var ed = Zp;
function rd(r, e) {
    var t = ct(this, r), o = t.size;
    return t.set(r, e), this.size += t.size == o ? 0 : 1, this;
}
n(rd, "mapCacheSet");
var td = rd;
function Je(r) {
    var e = -1, t = r == null ? 0 : r.length;
    for(this.clear(); ++e < t;){
        var o = r[e];
        this.set(o[0], o[1]);
    }
}
n(Je, "MapCache");
Je.prototype.clear = zp;
Je.prototype.delete = Xp;
Je.prototype.get = Qp;
Je.prototype.has = ed;
Je.prototype.set = td;
var Cs = Je, od = "Expected a function";
function xo(r, e) {
    if (typeof r != "function" || e != null && typeof e != "function") throw new TypeError(od);
    var t = /* @__PURE__ */ n(function() {
        var o = arguments, s = e ? e.apply(this, o) : o[0], i = t.cache;
        if (i.has(s)) return i.get(s);
        var a = r.apply(this, o);
        return t.cache = i.set(s, a) || i, a;
    }, "memoized");
    return t.cache = new (xo.Cache || Cs)(), t;
}
n(xo, "memoize");
xo.Cache = Cs;
var nd = xo, sd = 500;
function id(r) {
    var e = nd(r, function(o) {
        return t.size === sd && t.clear(), o;
    }), t = e.cache;
    return e;
}
n(id, "memoizeCapped");
var ad = id, ld = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, cd = /\\(\\)?/g, pd = ad(function(r) {
    var e = [];
    return r.charCodeAt(0) === 46 && e.push(""), r.replace(ld, function(t, o, s, i) {
        e.push(s ? i.replace(cd, "$1") : o || t);
    }), e;
}), dd = pd;
function ud(r) {
    return r == null ? "" : Fc(r);
}
n(ud, "toString");
var fd = ud;
function yd(r, e) {
    return Ao(r) ? r : pp(r, e) ? [
        r
    ] : dd(fd(r));
}
n(yd, "castPath");
var md = yd, hd = 1 / 0;
function gd(r) {
    if (typeof r == "string" || Ro(r)) return r;
    var e = r + "";
    return e == "0" && 1 / r == -hd ? "-0" : e;
}
n(gd, "toKey");
var Sd = gd;
function bd(r, e) {
    e = md(e, r);
    for(var t = 0, o = e.length; r != null && t < o;)r = r[Sd(e[t++])];
    return t && t == o ? r : void 0;
}
n(bd, "baseGet");
var Td = bd;
function Ed(r, e, t) {
    var o = r == null ? void 0 : Td(r, e);
    return o === void 0 ? t : o;
}
n(Ed, "get");
var Rd = Ed, at = ac, Ad = /* @__PURE__ */ n((r)=>{
    let e = null, t = !1, o = !1, s = !1, i = "";
    if (r.indexOf("//") >= 0 || r.indexOf("/*") >= 0) for(let a = 0; a < r.length; a += 1)!e && !t && !o && !s ? r[a] === '"' || r[a] === "'" || r[a] === "`" ? e = r[a] : r[a] === "/" && r[a + 1] === "*" ? t = !0 : r[a] === "\
/" && r[a + 1] === "/" ? o = !0 : r[a] === "/" && r[a + 1] !== "/" && (s = !0) : (e && (r[a] === e && r[a - 1] !== "\\" || r[a] === `
` && e !== "`") && (e = null), s && (r[a] === "/" && r[a - 1] !== "\\" || r[a] === `
`) && (s = !1), t && r[a - 1] === "/" && r[a - 2] === "*" && (t = !1), o && r[a] === `
` && (o = !1)), !t && !o && (i += r[a]);
    else i = r;
    return i;
}, "removeCodeComments"), xd = (0, Ps.default)(1e4)((r)=>Ad(r).replace(/\n\s*/g, "").trim()), vd = /* @__PURE__ */ n(function(e, t) {
    let o = t.slice(0, t.indexOf("{")), s = t.slice(t.indexOf("{"));
    if (o.includes("=>") || o.includes("function")) return t;
    let i = o;
    return i = i.replace(e, "function"), i + s;
}, "convertShorthandMethods2"), wd = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/, Sr = /* @__PURE__ */ n((r)=>r.match(/^[\[\{\"\}].*[\]\}\"]$/), "isJSON");
function Os(r) {
    if (!at(r)) return r;
    let e = r, t = !1;
    return typeof Event < "u" && r instanceof Event && (e = fs(e), t = !0), e = Object.keys(e).reduce((o, s)=>{
        try {
            e[s] && e[s].toJSON, o[s] = e[s];
        } catch  {
            t = !0;
        }
        return o;
    }, {}), t ? e : r;
}
n(Os, "convertUnconventionalData");
var _d = /* @__PURE__ */ n(function(e) {
    let t, o, s, i;
    return /* @__PURE__ */ n(function(c, l) {
        try {
            if (c === "") return i = [], t = /* @__PURE__ */ new Map([
                [
                    l,
                    "[]"
                ]
            ]), o = /* @__PURE__ */ new Map(), s = [], l;
            let p = o.get(this) || this;
            for(; s.length && p !== s[0];)s.shift(), i.pop();
            if (typeof l == "boolean") return l;
            if (l === void 0) return e.allowUndefined ? "_undefined_" : void 0;
            if (l === null) return null;
            if (typeof l == "number") return l === -1 / 0 ? "_-Infinity_" : l === 1 / 0 ? "_Infinity_" : Number.isNaN(l) ? "_NaN_" : l;
            if (typeof l == "bigint") return `_bigint_${l.toString()}`;
            if (typeof l == "string") return wd.test(l) ? e.allowDate ? `_date_${l}` : void 0 : l;
            if ((0, nc.default)(l)) return e.allowRegExp ? `_regexp_${l.flags}|${l.source}` : void 0;
            if ((0, sc.default)(l)) {
                if (!e.allowFunction) return;
                let { name: d } = l, h = l.toString();
                return h.match(/(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/) ? `_function_${d}|${(()=>{}).toString()}` : `_function_${d}|${xd(vd(c, h))}`;
            }
            if ((0, ic.default)(l)) {
                if (!e.allowSymbol) return;
                let d = Symbol.keyFor(l);
                return d !== void 0 ? `_gsymbol_${d}` : `_symbol_${l.toString().slice(7, -1)}`;
            }
            if (s.length >= e.maxDepth) return Array.isArray(l) ? `[Array(${l.length})]` : "[Object]";
            if (l === this) return `_duplicate_${JSON.stringify(i)}`;
            if (l instanceof Error && e.allowError) return {
                __isConvertedError__: !0,
                errorProperties: {
                    ...l.cause ? {
                        cause: l.cause
                    } : {},
                    ...l,
                    name: l.name,
                    message: l.message,
                    stack: l.stack,
                    "_constructor-name_": l.constructor.name
                }
            };
            if (l.constructor && l.constructor.name && l.constructor.name !== "Object" && !Array.isArray(l) && !e.allowClass) return;
            let u = t.get(l);
            if (!u) {
                let d = Array.isArray(l) ? l : Os(l);
                if (l.constructor && l.constructor.name && l.constructor.name !== "Object" && !Array.isArray(l) && e.allowClass) try {
                    Object.assign(d, {
                        "_constructor-name_": l.constructor.name
                    });
                } catch  {}
                return i.push(c), s.unshift(d), t.set(l, JSON.stringify(i)), l !== d && o.set(l, d), d;
            }
            return `_duplicate_${u}`;
        } catch  {
            return;
        }
    }, "replace");
}, "replacer2"), Cd = /* @__PURE__ */ n(function reviver(options) {
    let refs = [], root;
    return /* @__PURE__ */ n(function revive(key, value) {
        if (key === "" && (root = value, refs.forEach(({ target: r, container: e, replacement: t })=>{
            let o = Sr(t) ? JSON.parse(t) : t.split(".");
            o.length === 0 ? e[r] = root : e[r] = Rd(root, o);
        })), key === "_constructor-name_") return value;
        if (at(value) && value.__isConvertedError__) {
            let { message: r, ...e } = value.errorProperties, t = new Error(r);
            return Object.assign(t, e), t;
        }
        if (at(value) && value["_constructor-name_"] && options.allowFunction) {
            let r = value["_constructor-name_"];
            if (r !== "Object") {
                let e = new Function(`return function ${r.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
                Object.setPrototypeOf(value, new e());
            }
            return delete value["_constructor-name_"], value;
        }
        if (typeof value == "string" && value.startsWith("_function_") && options.allowFunction) {
            let [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [], sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
            if (!options.lazyEval) return eval(`(${sourceSanitized})`);
            let result = /* @__PURE__ */ n((...args)=>{
                let f = eval(`(${sourceSanitized})`);
                return f(...args);
            }, "result");
            return Object.defineProperty(result, "toString", {
                value: /* @__PURE__ */ n(()=>sourceSanitized, "value")
            }), Object.defineProperty(result, "name", {
                value: name
            }), result;
        }
        if (typeof value == "string" && value.startsWith("_regexp_") && options.allowRegExp) {
            let [, r, e] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
            return new RegExp(e, r);
        }
        return typeof value == "string" && value.startsWith("_date_") && options.allowDate ? new Date(value.replace("_date_", "")) : typeof value == "string" && value.startsWith("_duplicate_") ? (refs.push({
            target: key,
            container: this,
            replacement: value.replace(/^_duplicate_/, "")
        }), null) : typeof value == "string" && value.startsWith("_symbol_") && options.allowSymbol ? Symbol(value.replace("_symbol_", "")) : typeof value == "string" && value.startsWith("_gsymbol_") && options.allowSymbol ? Symbol.for(value.replace("_gsymbol_", "")) : typeof value == "string" && value === "_-Infinity_" ? -1 / 0 : typeof value == "string" && value === "_Infinity_" ? 1 / 0 : typeof value == "string" && value === "_\
NaN_" ? NaN : typeof value == "string" && value.startsWith("_bigint_") && typeof BigInt == "function" ? BigInt(value.replace("_bigint_", "")) : value;
    }, "revive");
}, "reviver"), Is = {
    maxDepth: 10,
    space: void 0,
    allowFunction: !0,
    allowRegExp: !0,
    allowDate: !0,
    allowClass: !0,
    allowError: !0,
    allowUndefined: !0,
    allowSymbol: !0,
    lazyEval: !0
}, pt = /* @__PURE__ */ n((r, e = {})=>{
    let t = {
        ...Is,
        ...e
    };
    return JSON.stringify(Os(r), _d(t), e.space);
}, "stringify"), Pd = /* @__PURE__ */ n(()=>{
    let r = /* @__PURE__ */ new Map();
    return /* @__PURE__ */ n(function e(t) {
        at(t) && Object.entries(t).forEach(([o, s])=>{
            s === "_undefined_" ? t[o] = void 0 : r.get(s) || (r.set(s, !0), e(s));
        }), Array.isArray(t) && t.forEach((o, s)=>{
            o === "_undefined_" ? (r.set(o, !0), t[s] = void 0) : r.get(o) || (r.set(o, !0), e(o));
        });
    }, "mutateUndefined");
}, "mutator"), dt = /* @__PURE__ */ n((r, e = {})=>{
    let t = {
        ...Is,
        ...e
    }, o = JSON.parse(r, Cd(t));
    return Pd()(o), o;
}, "parse");
// ../node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var Od = !0, vo = "Invariant failed";
function fe(r, e) {
    if (!r) {
        if (Od) throw new Error(vo);
        var t = typeof e == "function" ? e() : e, o = t ? "".concat(vo, ": ").concat(t) : vo;
        throw new Error(o);
    }
}
n(fe, "invariant");
// src/channels/postmessage/getEventSourceUrl.ts
var Fs = /* @__PURE__ */ n((r)=>{
    let e = Array.from(document.querySelectorAll("iframe[data-is-storybook]")), [t, ...o] = e.filter((i)=>{
        try {
            return i.contentWindow?.location.origin === r.source.location.origin && i.contentWindow?.location.pathname === r.source.location.pathname;
        } catch  {}
        try {
            return i.contentWindow === r.source;
        } catch  {}
        let a = i.getAttribute("src"), c;
        try {
            if (!a) return !1;
            ({ origin: c } = new URL(a, document.location.toString()));
        } catch  {
            return !1;
        }
        return c === r.origin;
    }), s = t?.getAttribute("src");
    if (s && o.length === 0) {
        let { protocol: i, host: a, pathname: c } = new URL(s, document.location.toString());
        return `${i}//${a}${c}`;
    }
    return o.length > 0 && I.error("found multiple candidates for event source"), null;
}, "getEventSourceUrl");
// src/channels/postmessage/index.ts
var { document: wo, location: _o } = E, Ds = "storybook-channel", Id = {
    allowFunction: !1,
    maxDepth: 25
}, Co = class Co {
    constructor(e){
        this.config = e;
        this.connected = !1;
        if (this.buffer = [], typeof E?.addEventListener == "function" && E.addEventListener("message", this.handleEvent.bind(this), !1), e.page !== "manager" && e.page !== "preview") throw new Error(`postmsg-channel: "config.page" cannot be "${e.page}"`);
    }
    setHandler(e) {
        this.handler = (...t)=>{
            e.apply(this, t), !this.connected && this.getLocalFrame().length && (this.flush(), this.connected = !0);
        };
    }
    /**
   * Sends `event` to the associated window. If the window does not yet exist the event will be
   * stored in a buffer and sent when the window exists.
   *
   * @param event
   */ send(e, t) {
        let { target: o, // telejson options
        allowRegExp: s, allowFunction: i, allowSymbol: a, allowDate: c, allowError: l, allowUndefined: p, allowClass: u, maxDepth: d, space: h, lazyEval: S } = t || {}, m = Object.fromEntries(Object.entries({
            allowRegExp: s,
            allowFunction: i,
            allowSymbol: a,
            allowDate: c,
            allowError: l,
            allowUndefined: p,
            allowClass: u,
            maxDepth: d,
            space: h,
            lazyEval: S
        }).filter(([g, b])=>typeof b < "u")), T = {
            ...Id,
            ...E.CHANNEL_OPTIONS || {},
            ...m
        }, y = this.getFrames(o), R = new URLSearchParams(_o?.search || ""), x = pt({
            key: Ds,
            event: e,
            refId: R.get("refId")
        }, T);
        return y.length ? (this.buffer.length && this.flush(), y.forEach((g)=>{
            try {
                g.postMessage(x, "*");
            } catch  {
                I.error("sending over postmessage fail");
            }
        }), Promise.resolve(null)) : new Promise((g, b)=>{
            this.buffer.push({
                event: e,
                resolve: g,
                reject: b
            });
        });
    }
    flush() {
        let { buffer: e } = this;
        this.buffer = [], e.forEach((t)=>{
            this.send(t.event).then(t.resolve).catch(t.reject);
        });
    }
    getFrames(e) {
        if (this.config.page === "manager") {
            let o = Array.from(wo.querySelectorAll("iframe[data-is-storybook][data-is-loaded]")).flatMap((s)=>{
                try {
                    return s.contentWindow && s.dataset.isStorybook !== void 0 && s.id === e ? [
                        s.contentWindow
                    ] : [];
                } catch  {
                    return [];
                }
            });
            return o?.length ? o : this.getCurrentFrames();
        }
        return E && E.parent && E.parent !== E.self ? [
            E.parent
        ] : [];
    }
    getCurrentFrames() {
        return this.config.page === "manager" ? Array.from(wo.querySelectorAll('[data-is-storybook="true"]')).flatMap((t)=>t.contentWindow ? [
                t.contentWindow
            ] : []) : E && E.parent ? [
            E.parent
        ] : [];
    }
    getLocalFrame() {
        return this.config.page === "manager" ? Array.from(wo.querySelectorAll("#storybook-preview-iframe")).flatMap((t)=>t.contentWindow ? [
                t.contentWindow
            ] : []) : E && E.parent ? [
            E.parent
        ] : [];
    }
    handleEvent(e) {
        try {
            let { data: t } = e, { key: o, event: s, refId: i } = typeof t == "string" && Sr(t) ? dt(t, E.CHANNEL_OPTIONS || {}) : t;
            if (o === Ds) {
                let a = this.config.page === "manager" ? '<span style="color: #37D5D3; background: black"> manager </span>' : '<span style="color: #\
1EA7FD; background: black"> preview </span>', c = Object.values(ge).includes(s.type) ? `<span style="color: #FF4785">${s.type}</span>` : `<s\
pan style="color: #FFAE00">${s.type}</span>`;
                if (i && (s.refId = i), s.source = this.config.page === "preview" ? e.origin : Fs(e), !s.source) {
                    X.error(`${a} received ${c} but was unable to determine the source of the event`);
                    return;
                }
                let l = `${a} received ${c} (${t.length})`;
                X.debug(_o.origin !== s.source ? l : `${l} <span style="color: gray">(on ${_o.origin} from ${s.source})</span>`, ...s.args), fe(this.handler, "ChannelHandler should be set"), this.handler(s);
            }
        } catch (t) {
            I.error(t);
        }
    }
};
n(Co, "PostMessageTransport");
var Qe = Co;
// src/channels/websocket/index.ts
var { WebSocket: Fd } = E, Po = 15e3, Oo = 5e3, Io = class Io {
    constructor({ url: e, onError: t, page: o }){
        this.buffer = [];
        this.isReady = !1;
        this.isClosed = !1;
        this.pingTimeout = 0;
        this.socket = new Fd(e), this.socket.onopen = ()=>{
            this.isReady = !0, this.heartbeat(), this.flush();
        }, this.socket.onmessage = ({ data: s })=>{
            let i = typeof s == "string" && Sr(s) ? dt(s) : s;
            fe(this.handler, "WebsocketTransport handler should be set"), this.handler(i), i.type === "ping" && (this.heartbeat(), this.send({
                type: "\
pong"
            }));
        }, this.socket.onerror = (s)=>{
            t && t(s);
        }, this.socket.onclose = (s)=>{
            fe(this.handler, "WebsocketTransport handler should be set"), this.handler({
                type: Wt,
                args: [
                    {
                        reason: s.reason,
                        code: s.code
                    }
                ],
                from: o || "preview"
            }), this.isClosed = !0, clearTimeout(this.pingTimeout);
        };
    }
    heartbeat() {
        clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
            this.socket.close(3008, "timeout");
        }, Po + Oo);
    }
    setHandler(e) {
        this.handler = e;
    }
    send(e) {
        this.isClosed || (this.isReady ? this.sendNow(e) : this.sendLater(e));
    }
    sendLater(e) {
        this.buffer.push(e);
    }
    sendNow(e) {
        let t = pt(e, {
            maxDepth: 15,
            allowFunction: !1,
            ...E.CHANNEL_OPTIONS
        });
        this.socket.send(t);
    }
    flush() {
        let { buffer: e } = this;
        this.buffer = [], e.forEach((t)=>this.send(t));
    }
};
n(Io, "WebsocketTransport");
var Ze = Io;
// src/channels/index.ts
var { CONFIG_TYPE: Dd } = E, Nd = ie;
function kd({ page: r, extraTransports: e = [] }) {
    let t = [
        new Qe({
            page: r
        }),
        ...e
    ];
    if (Dd === "DEVELOPMENT") {
        let s = window.location.protocol === "http:" ? "ws" : "wss", { hostname: i, port: a } = window.location, c = `${s}://${i}:${a}/storybook\
-server-channel`;
        t.push(new Ze({
            url: c,
            onError: /* @__PURE__ */ n(()=>{}, "onError"),
            page: r
        }));
    }
    let o = new ie({
        transports: t
    });
    return Q.__prepare(o, r === "manager" ? Q.Environment.MANAGER : Q.Environment.PREVIEW), o;
}
n(kd, "createBrowserChannel");
// src/types/index.ts
var Tr = {};
_e(Tr, {
    Addon_TypesEnum: ()=>Ns
});
// src/types/modules/addons.ts
var Ns = /* @__PURE__ */ ((p)=>(p.TAB = "tab", p.PANEL = "panel", p.TOOL = "tool", p.TOOLEXTRA = "toolextra", p.PREVIEW = "preview", p.experimental_PAGE = "page", p.experimental_SIDEBAR_BOTTOM = "sidebar-bottom", p.experimental_SIDEBAR_TOP = "sidebar-top", p.experimental_TEST_PROVIDER = "test-p\
rovider", p))(Ns || {});
// src/preview-api/index.ts
var Yr = {};
_e(Yr, {
    DocsContext: ()=>me,
    HooksContext: ()=>be,
    Preview: ()=>Me,
    PreviewWeb: ()=>Wr,
    PreviewWithSelection: ()=>Ue,
    ReporterAPI: ()=>Ee,
    StoryStore: ()=>Le,
    UrlStore: ()=>Be,
    WebView: ()=>He,
    addons: ()=>te,
    applyHooks: ()=>ft,
    combineArgs: ()=>tr,
    combineParameters: ()=>Y,
    composeConfigs: ()=>ke,
    composeStepRunners: ()=>Ct,
    composeStories: ()=>qi,
    composeStory: ()=>Pn,
    createPlaywrightTest: ()=>Bi,
    decorateStory: ()=>xn,
    defaultDecorateStory: ()=>vt,
    definePreview: ()=>ks,
    experimental_MockUniversalStore: ()=>gt,
    experimental_UniversalStore: ()=>Q,
    experimental_useUniversalStore: ()=>Si,
    filterArgTypes: ()=>Mr,
    getCsfFactoryAnnotations: ()=>Pt,
    inferControls: ()=>ir,
    makeDecorator: ()=>$s,
    mockChannel: ()=>ut,
    normalizeProjectAnnotations: ()=>Ne,
    normalizeStory: ()=>De,
    prepareMeta: ()=>wt,
    prepareStory: ()=>sr,
    sanitizeStoryContextUpdate: ()=>vn,
    setDefaultProjectAnnotations: ()=>Ui,
    setProjectAnnotations: ()=>Gi,
    simulateDOMContentLoaded: ()=>$r,
    simulatePageLoad: ()=>ss,
    sortStoriesV7: ()=>Ki,
    useArgs: ()=>zs,
    useCallback: ()=>er,
    useChannel: ()=>Vs,
    useEffect: ()=>Er,
    useGlobals: ()=>Ws,
    useMemo: ()=>Ms,
    useParameter: ()=>Hs,
    useReducer: ()=>Bs,
    useRef: ()=>Gs,
    useState: ()=>mt,
    useStoryContext: ()=>Rr,
    userOrAutoTitle: ()=>Wi,
    userOrAutoTitleFromSpecifier: ()=>Fn
});
// src/preview-api/modules/addons/storybook-channel-mock.ts
function ut() {
    let r = {
        setHandler: /* @__PURE__ */ n(()=>{}, "setHandler"),
        send: /* @__PURE__ */ n(()=>{}, "send")
    };
    return new ie({
        transport: r
    });
}
n(ut, "mockChannel");
// src/preview-api/modules/addons/main.ts
var No = class No {
    constructor(){
        this.getChannel = /* @__PURE__ */ n(()=>{
            if (!this.channel) {
                let e = ut();
                return this.setChannel(e), e;
            }
            return this.channel;
        }, "getChannel");
        this.ready = /* @__PURE__ */ n(()=>this.promise, "ready");
        this.hasChannel = /* @__PURE__ */ n(()=>!!this.channel, "hasChannel");
        this.setChannel = /* @__PURE__ */ n((e)=>{
            this.channel = e, this.resolve();
        }, "setChannel");
        this.promise = new Promise((e)=>{
            this.resolve = ()=>e(this.getChannel());
        });
    }
};
n(No, "AddonStore");
var Do = No, Fo = "__STORYBOOK_ADDONS_PREVIEW";
function Ld() {
    return E[Fo] || (E[Fo] = new Do()), E[Fo];
}
n(Ld, "getAddonsStore");
var te = Ld();
// src/preview-api/modules/addons/definePreview.ts
function ks(r) {
    return r;
}
n(ks, "definePreview");
// src/preview-api/modules/addons/hooks.ts
var Mo = class Mo {
    constructor(){
        this.hookListsMap = void 0;
        this.mountedDecorators = void 0;
        this.prevMountedDecorators = void 0;
        this.currentHooks = void 0;
        this.nextHookIndex = void 0;
        this.currentPhase = void 0;
        this.currentEffects = void 0;
        this.prevEffects = void 0;
        this.currentDecoratorName = void 0;
        this.hasUpdates = void 0;
        this.currentContext = void 0;
        this.renderListener = /* @__PURE__ */ n((e)=>{
            e === this.currentContext?.id && (this.triggerEffects(), this.currentContext = null, this.removeRenderListeners());
        }, "renderListener");
        this.init();
    }
    init() {
        this.hookListsMap = /* @__PURE__ */ new WeakMap(), this.mountedDecorators = /* @__PURE__ */ new Set(), this.prevMountedDecorators = /* @__PURE__ */ new Set(), this.currentHooks = [], this.nextHookIndex = 0, this.currentPhase = "NONE", this.currentEffects = [], this.prevEffects = [], this.currentDecoratorName = null, this.hasUpdates = !1, this.currentContext = null;
    }
    clean() {
        this.prevEffects.forEach((e)=>{
            e.destroy && e.destroy();
        }), this.init(), this.removeRenderListeners();
    }
    getNextHook() {
        let e = this.currentHooks[this.nextHookIndex];
        return this.nextHookIndex += 1, e;
    }
    triggerEffects() {
        this.prevEffects.forEach((e)=>{
            !this.currentEffects.includes(e) && e.destroy && e.destroy();
        }), this.currentEffects.forEach((e)=>{
            this.prevEffects.includes(e) || (e.destroy = e.create());
        }), this.prevEffects = this.currentEffects, this.currentEffects = [];
    }
    addRenderListeners() {
        this.removeRenderListeners(), te.getChannel().on(We, this.renderListener);
    }
    removeRenderListeners() {
        te.getChannel().removeListener(We, this.renderListener);
    }
};
n(Mo, "HooksContext");
var be = Mo;
function Ls(r) {
    let e = /* @__PURE__ */ n((...t)=>{
        let { hooks: o } = typeof t[0] == "function" ? t[1] : t[0], s = o.currentPhase, i = o.currentHooks, a = o.nextHookIndex, c = o.currentDecoratorName;
        o.currentDecoratorName = r.name, o.prevMountedDecorators.has(r) ? (o.currentPhase = "UPDATE", o.currentHooks = o.hookListsMap.get(r) || []) : (o.currentPhase = "MOUNT", o.currentHooks = [], o.hookListsMap.set(r, o.currentHooks), o.prevMountedDecorators.add(r)), o.nextHookIndex = 0;
        let l = E.STORYBOOK_HOOKS_CONTEXT;
        E.STORYBOOK_HOOKS_CONTEXT = o;
        let p = r(...t);
        if (E.STORYBOOK_HOOKS_CONTEXT = l, o.currentPhase === "UPDATE" && o.getNextHook() != null) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return o.currentPhase = s, o.currentHooks = i, o.nextHookIndex = a, o.currentDecoratorName = c, p;
    }, "hookified");
    return e.originalFn = r, e;
}
n(Ls, "hookify");
var ko = 0, jd = 25, ft = /* @__PURE__ */ n((r)=>(e, t)=>{
        let o = r(Ls(e), t.map((s)=>Ls(s)));
        return (s)=>{
            let { hooks: i } = s;
            i.prevMountedDecorators ??= /* @__PURE__ */ new Set(), i.mountedDecorators = /* @__PURE__ */ new Set([
                e,
                ...t
            ]), i.currentContext = s, i.hasUpdates = !1;
            let a = o(s);
            for(ko = 1; i.hasUpdates;)if (i.hasUpdates = !1, i.currentEffects = [], a = o(s), ko += 1, ko > jd) throw new Error("Too many re-renders. Storybook limits the number of renders to prevent an infinite loop.");
            return i.addRenderListeners(), a;
        };
    }, "applyHooks"), Md = /* @__PURE__ */ n((r, e)=>r.length === e.length && r.every((t, o)=>t === e[o]), "areDepsEqual"), Lo = /* @__PURE__ */ n(()=>new Error("Storybook preview hooks can only be called inside decorators and story functions."), "invalidHooksError");
function js() {
    return E.STORYBOOK_HOOKS_CONTEXT || null;
}
n(js, "getHooksContextOrNull");
function jo() {
    let r = js();
    if (r == null) throw Lo();
    return r;
}
n(jo, "getHooksContextOrThrow");
function Ud(r, e, t) {
    let o = jo();
    if (o.currentPhase === "MOUNT") {
        t != null && !Array.isArray(t) && I.warn(`${r} received a final argument that is not an array (instead, received ${t}). When specified, the final argument must be an array.`);
        let s = {
            name: r,
            deps: t
        };
        return o.currentHooks.push(s), e(s), s;
    }
    if (o.currentPhase === "UPDATE") {
        let s = o.getNextHook();
        if (s == null) throw new Error("Rendered more hooks than during the previous render.");
        return s.name !== r && I.warn(`Storybook has detected a change in the order of Hooks${o.currentDecoratorName ? ` called by ${o.currentDecoratorName}` : ""}. This wi\
ll lead to bugs and errors if not fixed.`), t != null && s.deps == null && I.warn(`${r} received a final argument during this render, but not during the previous render. Even though the final argument is optional, it\
s type cannot change between renders.`), t != null && s.deps != null && t.length !== s.deps.length && I.warn(`The final argument passed to ${r} changed size between renders. \
The order and size of this array must remain constant.
Previous: ${s.deps}
Incoming: ${t}`), (t == null || s.deps == null || !Md(t, s.deps)) && (e(s), s.deps = t), s;
    }
    throw Lo();
}
n(Ud, "useHook");
function yt(r, e, t) {
    let { memoizedState: o } = Ud(r, (s)=>{
        s.memoizedState = e();
    }, t);
    return o;
}
n(yt, "useMemoLike");
function Ms(r, e) {
    return yt("useMemo", r, e);
}
n(Ms, "useMemo");
function er(r, e) {
    return yt("useCallback", ()=>r, e);
}
n(er, "useCallback");
function Us(r, e) {
    return yt(r, ()=>({
            current: e
        }), []);
}
n(Us, "useRefLike");
function Gs(r) {
    return Us("useRef", r);
}
n(Gs, "useRef");
function Gd() {
    let r = js();
    if (r != null && r.currentPhase !== "NONE") r.hasUpdates = !0;
    else try {
        te.getChannel().emit(dr);
    } catch  {
        I.warn("State updates of Storybook preview hooks work only in browser");
    }
}
n(Gd, "triggerUpdate");
function qs(r, e) {
    let t = Us(r, // @ts-expect-error S type should never be function, but there's no way to tell that to TypeScript
    typeof e == "function" ? e() : e), o = /* @__PURE__ */ n((s)=>{
        t.current = typeof s == "function" ? s(t.current) : s, Gd();
    }, "setState");
    return [
        t.current,
        o
    ];
}
n(qs, "useStateLike");
function mt(r) {
    return qs("useState", r);
}
n(mt, "useState");
function Bs(r, e, t) {
    let o = t != null ? ()=>t(e) : e, [s, i] = qs("useReducer", o);
    return [
        s,
        /* @__PURE__ */ n((c)=>i((l)=>r(l, c)), "dispatch")
    ];
}
n(Bs, "useReducer");
function Er(r, e) {
    let t = jo(), o = yt("useEffect", ()=>({
            create: r
        }), e);
    t.currentEffects.includes(o) || t.currentEffects.push(o);
}
n(Er, "useEffect");
function Vs(r, e = []) {
    let t = te.getChannel();
    return Er(()=>(Object.entries(r).forEach(([o, s])=>t.on(o, s)), ()=>{
            Object.entries(r).forEach(([o, s])=>t.removeListener(o, s));
        }), [
        ...Object.keys(r),
        ...e
    ]), er(t.emit.bind(t), [
        t
    ]);
}
n(Vs, "useChannel");
function Rr() {
    let { currentContext: r } = jo();
    if (r == null) throw Lo();
    return r;
}
n(Rr, "useStoryContext");
function Hs(r, e) {
    let { parameters: t } = Rr();
    if (r) return t[r] ?? e;
}
n(Hs, "useParameter");
function zs() {
    let r = te.getChannel(), { id: e, args: t } = Rr(), o = er((i)=>r.emit(yr, {
            storyId: e,
            updatedArgs: i
        }), [
        r,
        e
    ]), s = er((i)=>r.emit(ur, {
            storyId: e,
            argNames: i
        }), [
        r,
        e
    ]);
    return [
        t,
        o,
        s
    ];
}
n(zs, "useArgs");
function Ws() {
    let r = te.getChannel(), { globals: e } = Rr(), t = er((o)=>r.emit(fr, {
            globals: o
        }), [
        r
    ]);
    return [
        e,
        t
    ];
}
n(Ws, "useGlobals");
// src/preview-api/modules/addons/make-decorator.ts
var $s = /* @__PURE__ */ n(({ name: r, parameterName: e, wrapper: t, skipIfNoParametersOrOptions: o = !1 })=>{
    let s = /* @__PURE__ */ n((i)=>(a, c)=>{
            let l = c.parameters && c.parameters[e];
            return l && l.disable || o && !i && !l ? a(c) : t(a, c, {
                options: i,
                parameters: l
            });
        }, "decorator");
    return (...i)=>typeof i[0] == "function" ? s()(...i) : (...a)=>{
            if (a.length > 1) return i.length > 1 ? s(i)(...a) : s(...i)(...a);
            throw new Error(`Passing stories directly into ${r}() is not allowed,
        instead use addDecorator(${r}) and pass options with the '${e}' parameter`);
        };
}, "makeDecorator");
// ../node_modules/es-toolkit/dist/object/omitBy.mjs
function Uo(r, e) {
    let t = {}, o = Object.entries(r);
    for(let s = 0; s < o.length; s++){
        let [i, a] = o[s];
        e(a, i) || (t[i] = a);
    }
    return t;
}
n(Uo, "omitBy");
// ../node_modules/es-toolkit/dist/object/pick.mjs
function Go(r, e) {
    let t = {};
    for(let o = 0; o < e.length; o++){
        let s = e[o];
        Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
}
n(Go, "pick");
// ../node_modules/es-toolkit/dist/object/pickBy.mjs
function qo(r, e) {
    let t = {}, o = Object.entries(r);
    for(let s = 0; s < o.length; s++){
        let [i, a] = o[s];
        e(a, i) && (t[i] = a);
    }
    return t;
}
n(qo, "pickBy");
// ../node_modules/es-toolkit/dist/predicate/isPlainObject.mjs
function $(r) {
    if (typeof r != "object" || r == null) return !1;
    if (Object.getPrototypeOf(r) === null) return !0;
    if (r.toString() !== "[object Object]") return !1;
    let e = r;
    for(; Object.getPrototypeOf(e) !== null;)e = Object.getPrototypeOf(e);
    return Object.getPrototypeOf(r) === e;
}
n($, "isPlainObject");
// ../node_modules/es-toolkit/dist/object/mapValues.mjs
function oe(r, e) {
    let t = {}, o = Object.keys(r);
    for(let s = 0; s < o.length; s++){
        let i = o[s], a = r[i];
        t[i] = e(a, i, r);
    }
    return t;
}
n(oe, "mapValues");
// ../node_modules/es-toolkit/dist/compat/_internal/tags.mjs
var Ys = "[object RegExp]", Ks = "[object String]", Xs = "[object Number]", Js = "[object Boolean]", Bo = "[object Arguments]", Qs = "[objec\
t Symbol]", Zs = "[object Date]", ei = "[object Map]", ri = "[object Set]", ti = "[object Array]", oi = "[object Function]", ni = "[object A\
rrayBuffer]", ht = "[object Object]", si = "[object Error]", ii = "[object DataView]", ai = "[object Uint8Array]", li = "[object Uint8Clampe\
dArray]", ci = "[object Uint16Array]", pi = "[object Uint32Array]", di = "[object BigUint64Array]", ui = "[object Int8Array]", fi = "[object\
 Int16Array]", yi = "[object Int32Array]", mi = "[object BigInt64Array]", hi = "[object Float32Array]", gi = "[object Float64Array]";
// ../node_modules/es-toolkit/dist/compat/_internal/getSymbols.mjs
function Vo(r) {
    return Object.getOwnPropertySymbols(r).filter((e)=>Object.prototype.propertyIsEnumerable.call(r, e));
}
n(Vo, "getSymbols");
// ../node_modules/es-toolkit/dist/compat/_internal/getTag.mjs
function Ho(r) {
    return r == null ? r === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(r);
}
n(Ho, "getTag");
// ../node_modules/es-toolkit/dist/predicate/isEqual.mjs
function Ar(r, e) {
    if (typeof r == typeof e) switch(typeof r){
        case "bigint":
        case "string":
        case "boolean":
        case "symbol":
        case "undefined":
            return r === e;
        case "number":
            return r === e || Object.is(r, e);
        case "function":
            return r === e;
        case "object":
            return ye(r, e);
    }
    return ye(r, e);
}
n(Ar, "isEqual");
function ye(r, e, t) {
    if (Object.is(r, e)) return !0;
    let o = Ho(r), s = Ho(e);
    if (o === Bo && (o = ht), s === Bo && (s = ht), o !== s) return !1;
    switch(o){
        case Ks:
            return r.toString() === e.toString();
        case Xs:
            {
                let c = r.valueOf(), l = e.valueOf();
                return c === l || Number.isNaN(c) && Number.isNaN(l);
            }
        case Js:
        case Zs:
        case Qs:
            return Object.is(r.valueOf(), e.valueOf());
        case Ys:
            return r.source === e.source && r.flags === e.flags;
        case oi:
            return r === e;
    }
    t = t ?? /* @__PURE__ */ new Map();
    let i = t.get(r), a = t.get(e);
    if (i != null && a != null) return i === e;
    t.set(r, e), t.set(e, r);
    try {
        switch(o){
            case ei:
                if (r.size !== e.size) return !1;
                for (let [c, l] of r.entries())if (!e.has(c) || !ye(l, e.get(c), t)) return !1;
                return !0;
            case ri:
                {
                    if (r.size !== e.size) return !1;
                    let c = Array.from(r.values()), l = Array.from(e.values());
                    for(let p = 0; p < c.length; p++){
                        let u = c[p], d = l.findIndex((h)=>ye(u, h, t));
                        if (d === -1) return !1;
                        l.splice(d, 1);
                    }
                    return !0;
                }
            case ti:
            case ai:
            case li:
            case ci:
            case pi:
            case di:
            case ui:
            case fi:
            case yi:
            case mi:
            case hi:
            case gi:
                if (typeof Buffer < "u" && Buffer.isBuffer(r) !== Buffer.isBuffer(e) || r.length !== e.length) return !1;
                for(let c = 0; c < r.length; c++)if (!ye(r[c], e[c], t)) return !1;
                return !0;
            case ni:
                return r.byteLength !== e.byteLength ? !1 : ye(new Uint8Array(r), new Uint8Array(e), t);
            case ii:
                return r.byteLength !== e.byteLength || r.byteOffset !== e.byteOffset ? !1 : ye(r.buffer, e.buffer, t);
            case si:
                return r.name === e.name && r.message === e.message;
            case ht:
                {
                    if (!(ye(r.constructor, e.constructor, t) || $(r) && $(e))) return !1;
                    let l = [
                        ...Object.keys(r),
                        ...Vo(r)
                    ], p = [
                        ...Object.keys(e),
                        ...Vo(e)
                    ];
                    if (l.length !== p.length) return !1;
                    for(let u = 0; u < l.length; u++){
                        let d = l[u], h = r[d];
                        if (!Object.prototype.hasOwnProperty.call(e, d)) return !1;
                        let S = e[d];
                        if (!ye(h, S, t)) return !1;
                    }
                    return !0;
                }
            default:
                return !1;
        }
    } finally{
        t.delete(r), t.delete(e);
    }
}
n(ye, "areObjectsEqual");
// src/shared/universal-store/use-universal-store-preview.ts
var Si = /* @__PURE__ */ n((r, e)=>{
    let [t, o] = mt(e ? e(r.getState()) : r.getState());
    return Er(()=>r.onStateChange((s, i)=>{
            if (!e) {
                o(s);
                return;
            }
            let a = e(s), c = e(i);
            !Ar(a, c) && o(a);
        }), [
        r,
        o,
        e
    ]), [
        t,
        r.setState
    ];
}, "useUniversalStore");
// src/shared/universal-store/mock.ts
var St = class St extends Q {
    constructor(e, t){
        Q.isInternalConstructing = !0, super({
            ...e,
            leader: !0
        }, {
            channel: new ie({}),
            environment: Q.Environment.MOCK
        }), Q.isInternalConstructing = !1, typeof t?.fn == "function" && (this.testUtils = t, this.getState = t.fn(this.getState), this.setState = t.fn(this.setState), this.subscribe = t.fn(this.subscribe), this.onStateChange = t.fn(this.onStateChange), this.send = t.fn(this.send));
    }
    /** Create a mock universal store. This is just an alias for the constructor */ static create(e, t) {
        return new St(e, t);
    }
    unsubscribeAll() {
        if (!this.testUtils) throw new Error(ps`Cannot call unsubscribeAll on a store that does not have testUtils.
        Please provide testUtils as the second argument when creating the store.`);
        let e = /* @__PURE__ */ n((t)=>{
            try {
                t.value();
            } catch  {}
        }, "callReturnedUnsubscribeFn");
        this.subscribe.mock?.results.forEach(e), this.onStateChange.mock?.results.forEach(e);
    }
};
n(St, "MockUniversalStore");
var gt = St;
// src/preview-errors.ts
var kr = {};
_e(kr, {
    CalledExtractOnStoreError: ()=>vr,
    CalledPreviewMethodBeforeInitializationError: ()=>V,
    Category: ()=>Ti,
    EmptyIndexError: ()=>Pr,
    ImplicitActionsDuringRendering: ()=>zo,
    MdxFileWithNoCsfReferencesError: ()=>Cr,
    MissingRenderToCanvasError: ()=>wr,
    MissingStoryAfterHmrError: ()=>xr,
    MissingStoryFromCsfFileError: ()=>Ir,
    MountMustBeDestructuredError: ()=>Oe,
    NextJsSharpError: ()=>Wo,
    NextjsRouterMocksNotAvailable: ()=>$o,
    NoRenderFunctionError: ()=>Dr,
    NoStoryMatchError: ()=>Or,
    NoStoryMountedError: ()=>Nr,
    StoryIndexFetchError: ()=>_r,
    StoryStoreAccessedBeforeInitializationError: ()=>Fr,
    UnknownArgTypesError: ()=>Yo,
    UnsupportedViewportDimensionError: ()=>Ko
});
// src/storybook-error.ts
function bi({ code: r, category: e }) {
    let t = String(r).padStart(4, "0");
    return `SB_${e}_${t}`;
}
n(bi, "parseErrorCode");
var bt = class bt extends Error {
    constructor(t){
        super(bt.getFullMessage(t));
        /**
     * Data associated with the error. Used to provide additional information in the error message or
     * to be passed to telemetry.
     */ this.data = {};
        /** Flag used to easily determine if the error originates from Storybook. */ this.fromStorybook = !0;
        this.category = t.category, this.documentation = t.documentation ?? !1, this.code = t.code;
    }
    get fullErrorCode() {
        return bi({
            code: this.code,
            category: this.category
        });
    }
    /** Overrides the default `Error.name` property in the format: SB_<CATEGORY>_<CODE>. */ get name() {
        let t = this.constructor.name;
        return `${this.fullErrorCode} (${t})`;
    }
    /** Generates the error message along with additional documentation link (if applicable). */ static getFullMessage({ documentation: t, code: o, category: s, message: i }) {
        let a;
        return t === !0 ? a = `https://storybook.js.org/error/${bi({
            code: o,
            category: s
        })}` : typeof t == "string" ? a = t : Array.isArray(t) && (a = `
${t.map((c)=>`	- ${c}`).join(`
`)}`), `${i}${a != null ? `

More info: ${a}
` : ""}`;
    }
};
n(bt, "StorybookError");
var G = bt;
// src/preview-errors.ts
var Ti = /* @__PURE__ */ ((b)=>(b.BLOCKS = "BLOCKS", b.DOCS_TOOLS = "DOCS-TOOLS", b.PREVIEW_CLIENT_LOGGER = "PREVIEW_CLIENT-LOGGER", b.PREVIEW_CHANNELS = "PREVIEW_CHANNELS", b.PREVIEW_CORE_EVENTS = "PREVIEW_CORE-EVENTS", b.PREVIEW_INSTRUMENTER = "PREVIEW_INSTRUMENTER", b.PREVIEW_API = "PREVIEW\
_API", b.PREVIEW_REACT_DOM_SHIM = "PREVIEW_REACT-DOM-SHIM", b.PREVIEW_ROUTER = "PREVIEW_ROUTER", b.PREVIEW_THEMING = "PREVIEW_THEMING", b.RENDERER_HTML = "RENDERER_HTML", b.RENDERER_PREACT = "RENDERER_PREACT", b.RENDERER_REACT = "RENDERER_REACT", b.RENDERER_SERVER = "RENDERER_SERVER", b.RENDERER_SVELTE = "RENDERER_SVELTE", b.RENDERER_VUE = "RENDERER_VUE", b.RENDERER_VUE3 = "RENDERER_VUE3", b.RENDERER_WEB_COMPONENTS = "RENDERER_WEB-COMPONENTS", b.FRAMEWORK_NEXTJS = "FRAMEWORK_NEXTJS", b.ADDON_VITEST = "ADDON_VITEST", b))(Ti || {}), Xo = class Xo extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 1,
            message: _`
        Couldn't find story matching id '${t.storyId}' after HMR.
        - Did you just rename a story?
        - Did you remove it from your CSF file?
        - Are you sure a story with the id '${t.storyId}' exists?
        - Please check the values in the stories field of your main.js config and see if they would match your CSF File.
        - Also check the browser console and terminal for potential error messages.`
        });
        this.data = t;
    }
};
n(Xo, "MissingStoryAfterHmrError");
var xr = Xo, Jo = class Jo extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 2,
            documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#using-implicit-actions-during-rendering-is-deprecated-\
for-example-in-the-play-function",
            message: _`
        We detected that you use an implicit action arg while ${t.phase} of your story.  
        ${t.deprecated ? `
This is deprecated and won't work in Storybook 8 anymore.
` : ""}
        Please provide an explicit spy to your args like this:
          import { fn } from '@storybook/test';
          ... 
          args: {
           ${t.name}: fn()
          }`
        });
        this.data = t;
    }
};
n(Jo, "ImplicitActionsDuringRendering");
var zo = Jo, Qo = class Qo extends G {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 3,
            message: _`
        Cannot call \`storyStore.extract()\` without calling \`storyStore.cacheAllCsfFiles()\` first.

        You probably meant to call \`await preview.extract()\` which does the above for you.`
        });
    }
};
n(Qo, "CalledExtractOnStoreError");
var vr = Qo, Zo = class Zo extends G {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 4,
            message: _`
        Expected your framework's preset to export a \`renderToCanvas\` field.

        Perhaps it needs to be upgraded for Storybook 7.0?`,
            documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#mainjs-framework-field"
        });
    }
};
n(Zo, "MissingRenderToCanvasError");
var wr = Zo, en = class en extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 5,
            message: _`
        Called \`Preview.${t.methodName}()\` before initialization.
        
        The preview needs to load the story index before most methods can be called. If you want
        to call \`${t.methodName}\`, try \`await preview.initializationPromise;\` first.
        
        If you didn't call the above code, then likely it was called by an addon that needs to
        do the above.`
        });
        this.data = t;
    }
};
n(en, "CalledPreviewMethodBeforeInitializationError");
var V = en, rn = class rn extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 6,
            message: _`
        Error fetching \`/index.json\`:
        
        ${t.text}

        If you are in development, this likely indicates a problem with your Storybook process,
        check the terminal for errors.

        If you are in a deployed Storybook, there may have been an issue deploying the full Storybook
        build.`
        });
        this.data = t;
    }
};
n(rn, "StoryIndexFetchError");
var _r = rn, tn = class tn extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 7,
            message: _`
        Tried to render docs entry ${t.storyId} but it is a MDX file that has no CSF
        references, or autodocs for a CSF file that some doesn't refer to itself.
        
        This likely is an internal error in Storybook's indexing, or you've attached the
        \`attached-mdx\` tag to an MDX file that is not attached.`
        });
        this.data = t;
    }
};
n(tn, "MdxFileWithNoCsfReferencesError");
var Cr = tn, on = class on extends G {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 8,
            message: _`
        Couldn't find any stories in your Storybook.

        - Please check your stories field of your main.js config: does it match correctly?
        - Also check the browser console and terminal for error messages.`
        });
    }
};
n(on, "EmptyIndexError");
var Pr = on, nn = class nn extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 9,
            message: _`
        Couldn't find story matching '${t.storySpecifier}'.

        - Are you sure a story with that id exists?
        - Please check your stories field of your main.js config.
        - Also check the browser console and terminal for error messages.`
        });
        this.data = t;
    }
};
n(nn, "NoStoryMatchError");
var Or = nn, sn = class sn extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 10,
            message: _`
        Couldn't find story matching id '${t.storyId}' after importing a CSF file.

        The file was indexed as if the story was there, but then after importing the file in the browser
        we didn't find the story. Possible reasons:
        - You are using a custom story indexer that is misbehaving.
        - You have a custom file loader that is removing or renaming exports.

        Please check your browser console and terminal for errors that may explain the issue.`
        });
        this.data = t;
    }
};
n(sn, "MissingStoryFromCsfFileError");
var Ir = sn, an = class an extends G {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 11,
            message: _`
        Cannot access the Story Store until the index is ready.

        It is not recommended to use methods directly on the Story Store anyway, in Storybook 9 we will
        remove access to the store entirely`
        });
    }
};
n(an, "StoryStoreAccessedBeforeInitializationError");
var Fr = an, ln = class ln extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 12,
            message: _`
      Incorrect use of mount in the play function.
      
      To use mount in the play function, you must satisfy the following two requirements: 
      
      1. You *must* destructure the mount property from the \`context\` (the argument passed to your play function). 
         This makes sure that Storybook does not start rendering the story before the play function begins.
      
      2. Your Storybook framework or builder must be configured to transpile to ES2017 or newer. 
         This is because destructuring statements and async/await usages are otherwise transpiled away, 
         which prevents Storybook from recognizing your usage of \`mount\`.
      
      Note that Angular is not supported. As async/await is transpiled to support the zone.js polyfill. 
      
      More info: https://storybook.js.org/docs/writing-tests/interaction-testing#run-code-before-the-component-gets-rendered
      
      Received the following play function:
      ${t.playFunction}`
        });
        this.data = t;
    }
};
n(ln, "MountMustBeDestructuredError");
var Oe = ln, cn = class cn extends G {
    constructor(t){
        super({
            category: "PREVIEW_API",
            code: 14,
            message: _`
        No render function available for storyId '${t.id}'
      `
        });
        this.data = t;
    }
};
n(cn, "NoRenderFunctionError");
var Dr = cn, pn = class pn extends G {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 15,
            message: _`
        No component is mounted in your story.
        
        This usually occurs when you destructure mount in the play function, but forget to call it.
        
        For example:

        async play({ mount, canvasElement }) {
          // 👈 mount should be called: await mount(); 
          const canvas = within(canvasElement);
          const button = await canvas.findByRole('button');
          await userEvent.click(button);
        };

        Make sure to either remove it or call mount in your play function.
      `
        });
    }
};
n(pn, "NoStoryMountedError");
var Nr = pn, dn = class dn extends G {
    constructor(){
        super({
            category: "FRAMEWORK_NEXTJS",
            code: 1,
            documentation: "https://storybook.js.org/docs/get-started/nextjs#faq",
            message: _`
      You are importing avif images, but you don't have sharp installed.

      You have to install sharp in order to use image optimization features in Next.js.
      `
        });
    }
};
n(dn, "NextJsSharpError");
var Wo = dn, un = class un extends G {
    constructor(t){
        super({
            category: "FRAMEWORK_NEXTJS",
            code: 2,
            message: _`
        Tried to access router mocks from "${t.importType}" but they were not created yet. You might be running code in an unsupported environment.
      `
        });
        this.data = t;
    }
};
n(un, "NextjsRouterMocksNotAvailable");
var $o = un, fn = class fn extends G {
    constructor(t){
        super({
            category: "DOCS-TOOLS",
            code: 1,
            documentation: "https://github.com/storybookjs/storybook/issues/26606",
            message: _`
        There was a failure when generating detailed ArgTypes in ${t.language} for:
        ${JSON.stringify(t.type, null, 2)} 
        
        Storybook will fall back to use a generic type description instead.

        This type is either not supported or it is a bug in the docgen generation in Storybook.
        If you think this is a bug, please detail it as much as possible in the Github issue.
      `
        });
        this.data = t;
    }
};
n(fn, "UnknownArgTypesError");
var Yo = fn, yn = class yn extends G {
    constructor(t){
        super({
            category: "ADDON_VITEST",
            code: 1,
            // TODO: Add documentation about viewports support
            // documentation: '',
            message: _`
        Encountered an unsupported value "${t.value}" when setting the viewport ${t.dimension} dimension.
        
        The Storybook plugin only supports values in the following units:
        - px, vh, vw, em, rem and %.
        
        You can either change the viewport for this story to use one of the supported units or skip the test by adding '!test' to the story's tags per https://storybook.js.org/docs/writing-stories/tags
      `
        });
        this.data = t;
    }
};
n(yn, "UnsupportedViewportDimensionError");
var Ko = yn;
// src/preview-api/modules/store/StoryStore.ts
var Ot = ue(it(), 1);
// src/preview-api/modules/store/args.ts
var rr = Symbol("incompatible"), mn = /* @__PURE__ */ n((r, e)=>{
    let t = e.type;
    if (r == null || !t || e.mapping) return r;
    switch(t.name){
        case "string":
            return String(r);
        case "enum":
            return r;
        case "number":
            return Number(r);
        case "boolean":
            return String(r) === "true";
        case "array":
            return !t.value || !Array.isArray(r) ? rr : r.reduce((o, s, i)=>{
                let a = mn(s, {
                    type: t.value
                });
                return a !== rr && (o[i] = a), o;
            }, new Array(r.length));
        case "object":
            return typeof r == "string" || typeof r == "number" ? r : !t.value || typeof r != "object" ? rr : Object.entries(r).reduce((o, [s, i])=>{
                let a = mn(i, {
                    type: t.value[s]
                });
                return a === rr ? o : Object.assign(o, {
                    [s]: a
                });
            }, {});
        default:
            return rr;
    }
}, "map"), Ei = /* @__PURE__ */ n((r, e)=>Object.entries(r).reduce((t, [o, s])=>{
        if (!e[o]) return t;
        let i = mn(s, e[o]);
        return i === rr ? t : Object.assign(t, {
            [o]: i
        });
    }, {}), "mapArgsToTypes"), tr = /* @__PURE__ */ n((r, e)=>Array.isArray(r) && Array.isArray(e) ? e.reduce((t, o, s)=>(t[s] = tr(r[s], e[s]), t), [
        ...r
    ]).filter((t)=>t !== void 0) : !$(r) || !$(e) ? e : Object.keys({
        ...r,
        ...e
    }).reduce((t, o)=>{
        if (o in e) {
            let s = tr(r[o], e[o]);
            s !== void 0 && (t[o] = s);
        } else t[o] = r[o];
        return t;
    }, {}), "combineArgs"), Ri = /* @__PURE__ */ n((r, e)=>Object.entries(e).reduce((t, [o, { options: s }])=>{
        function i() {
            return o in r && (t[o] = r[o]), t;
        }
        if (n(i, "allowArg"), !s) return i();
        if (!Array.isArray(s)) return j.error(_`
        Invalid argType: '${o}.options' should be an array.

        More info: https://storybook.js.org/docs/api/arg-types
      `), i();
        if (s.some((d)=>d && [
                "object",
                "function"
            ].includes(typeof d))) return j.error(_`
        Invalid argType: '${o}.options' should only contain primitives. Use a 'mapping' for complex values.

        More info: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
      `), i();
        let a = Array.isArray(r[o]), c = a && r[o].findIndex((d)=>!s.includes(d)), l = a && c === -1;
        if (r[o] === void 0 || s.includes(r[o]) || l) return i();
        let p = a ? `${o}[${c}]` : o, u = s.map((d)=>typeof d == "string" ? `'${d}'` : String(d)).join(", ");
        return j.warn(`Received illegal value for '${p}'. Supported options: ${u}`), t;
    }, {}), "validateOptions"), Ie = Symbol("Deeply equal"), or = /* @__PURE__ */ n((r, e)=>{
    if (typeof r != typeof e) return e;
    if (Ar(r, e)) return Ie;
    if (Array.isArray(r) && Array.isArray(e)) {
        let t = e.reduce((o, s, i)=>{
            let a = or(r[i], s);
            return a !== Ie && (o[i] = a), o;
        }, new Array(e.length));
        return e.length >= r.length ? t : t.concat(new Array(r.length - e.length).fill(void 0));
    }
    return $(r) && $(e) ? Object.keys({
        ...r,
        ...e
    }).reduce((t, o)=>{
        let s = or(r?.[o], e?.[o]);
        return s === Ie ? t : Object.assign(t, {
            [o]: s
        });
    }, {}) : e;
}, "deepDiff"), hn = "UNTARGETED";
function Ai({ args: r, argTypes: e }) {
    let t = {};
    return Object.entries(r).forEach(([o, s])=>{
        let { target: i = hn } = e[o] || {};
        t[i] = t[i] || {}, t[i][o] = s;
    }), t;
}
n(Ai, "groupArgsByTarget");
// src/preview-api/modules/store/ArgsStore.ts
function qd(r) {
    return Object.keys(r).forEach((e)=>r[e] === void 0 && delete r[e]), r;
}
n(qd, "deleteUndefined");
var gn = class gn {
    constructor(){
        this.initialArgsByStoryId = {};
        this.argsByStoryId = {};
    }
    get(e) {
        if (!(e in this.argsByStoryId)) throw new Error(`No args known for ${e} -- has it been rendered yet?`);
        return this.argsByStoryId[e];
    }
    setInitial(e) {
        if (!this.initialArgsByStoryId[e.id]) this.initialArgsByStoryId[e.id] = e.initialArgs, this.argsByStoryId[e.id] = e.initialArgs;
        else if (this.initialArgsByStoryId[e.id] !== e.initialArgs) {
            let t = or(this.initialArgsByStoryId[e.id], this.argsByStoryId[e.id]);
            this.initialArgsByStoryId[e.id] = e.initialArgs, this.argsByStoryId[e.id] = e.initialArgs, t !== Ie && this.updateFromDelta(e, t);
        }
    }
    updateFromDelta(e, t) {
        let o = Ri(t, e.argTypes);
        this.argsByStoryId[e.id] = tr(this.argsByStoryId[e.id], o);
    }
    updateFromPersisted(e, t) {
        let o = Ei(t, e.argTypes);
        return this.updateFromDelta(e, o);
    }
    update(e, t) {
        if (!(e in this.argsByStoryId)) throw new Error(`No args known for ${e} -- has it been rendered yet?`);
        this.argsByStoryId[e] = qd({
            ...this.argsByStoryId[e],
            ...t
        });
    }
};
n(gn, "ArgsStore");
var Tt = gn;
// src/preview-api/modules/store/csf/getValuesFromArgTypes.ts
var Et = /* @__PURE__ */ n((r = {})=>Object.entries(r).reduce((e, [t, { defaultValue: o }])=>(typeof o < "u" && (e[t] = o), e), {}), "ge\
tValuesFromArgTypes");
// src/preview-api/modules/store/GlobalsStore.ts
var Sn = class Sn {
    constructor({ globals: e = {}, globalTypes: t = {} }){
        this.set({
            globals: e,
            globalTypes: t
        });
    }
    set({ globals: e = {}, globalTypes: t = {} }) {
        let o = this.initialGlobals && or(this.initialGlobals, this.globals);
        this.allowedGlobalNames = /* @__PURE__ */ new Set([
            ...Object.keys(e),
            ...Object.keys(t)
        ]);
        let s = Et(t);
        this.initialGlobals = {
            ...s,
            ...e
        }, this.globals = this.initialGlobals, o && o !== Ie && this.updateFromPersisted(o);
    }
    filterAllowedGlobals(e) {
        return Object.entries(e).reduce((t, [o, s])=>(this.allowedGlobalNames.has(o) ? t[o] = s : I.warn(`Attempted to set a global (${o}) that is not defined in initial globals or globalTypes`), t), {});
    }
    updateFromPersisted(e) {
        let t = this.filterAllowedGlobals(e);
        this.globals = {
            ...this.globals,
            ...t
        };
    }
    get() {
        return this.globals;
    }
    update(e) {
        this.globals = {
            ...this.globals,
            ...this.filterAllowedGlobals(e)
        };
    }
};
n(Sn, "GlobalsStore");
var Rt = Sn;
// src/preview-api/modules/store/StoryIndexStore.ts
var xi = ue(it(), 1);
var Bd = (0, xi.default)(1)((r)=>Object.values(r).reduce((e, t)=>(e[t.importPath] = e[t.importPath] || t, e), {})), bn = class bn {
    constructor({ entries: e } = {
        v: 5,
        entries: {}
    }){
        this.entries = e;
    }
    entryFromSpecifier(e) {
        let t = Object.values(this.entries);
        if (e === "*") return t[0];
        if (typeof e == "string") return this.entries[e] ? this.entries[e] : t.find((i)=>i.id.startsWith(e));
        let { name: o, title: s } = e;
        return t.find((i)=>i.name === o && i.title === s);
    }
    storyIdToEntry(e) {
        let t = this.entries[e];
        if (!t) throw new xr({
            storyId: e
        });
        return t;
    }
    importPathToEntry(e) {
        return Bd(this.entries)[e];
    }
};
n(bn, "StoryIndexStore");
var At = bn;
// src/preview-api/modules/store/csf/normalizeInputTypes.ts
var Vd = /* @__PURE__ */ n((r)=>typeof r == "string" ? {
        name: r
    } : r, "normalizeType"), Hd = /* @__PURE__ */ n((r)=>typeof r == "strin\
g" ? {
        type: r
    } : r, "normalizeControl"), zd = /* @__PURE__ */ n((r, e)=>{
    let { type: t, control: o, ...s } = r, i = {
        name: e,
        ...s
    };
    return t && (i.type = Vd(t)), o ? i.control = Hd(o) : o === !1 && (i.control = {
        disable: !0
    }), i;
}, "normalizeInputType"), Fe = /* @__PURE__ */ n((r)=>oe(r, zd), "normalizeInputTypes");
// src/csf/toStartCaseStr.ts
function vi(r) {
    return r.replace(/_/g, " ").replace(/-/g, " ").replace(/\./g, " ").replace(/([^\n])([A-Z])([a-z])/g, (e, t, o, s)=>`${t} ${o}${s}`).replace(/([a-z])([A-Z])/g, (e, t, o)=>`${t} ${o}`).replace(/([a-z])([0-9])/gi, (e, t, o)=>`${t} ${o}`).replace(/([0-9])([a-z])/gi, (e, t, o)=>`${t}\
 ${o}`).replace(/(\s|^)(\w)/g, (e, t, o)=>`${t}${o.toUpperCase()}`).replace(/ +/g, " ").trim();
}
n(vi, "toStartCaseStr");
// src/csf/includeConditionalArg.ts
var En = ue(wi(), 1);
var _i = /* @__PURE__ */ n((r)=>r.map((e)=>typeof e < "u").filter(Boolean).length, "count"), Wd = /* @__PURE__ */ n((r, e)=>{
    let { exists: t, eq: o, neq: s, truthy: i } = r;
    if (_i([
        t,
        o,
        s,
        i
    ]) > 1) throw new Error(`Invalid conditional test ${JSON.stringify({
        exists: t,
        eq: o,
        neq: s
    })}`);
    if (typeof o < "u") return (0, En.isEqual)(e, o);
    if (typeof s < "u") return !(0, En.isEqual)(e, s);
    if (typeof t < "u") {
        let c = typeof e < "u";
        return t ? c : !c;
    }
    return (typeof i > "u" ? !0 : i) ? !!e : !e;
}, "testValue"), Rn = /* @__PURE__ */ n((r, e, t)=>{
    if (!r.if) return !0;
    let { arg: o, global: s } = r.if;
    if (_i([
        o,
        s
    ]) !== 1) throw new Error(`Invalid conditional value ${JSON.stringify({
        arg: o,
        global: s
    })}`);
    let i = o ? e[o] : t[s];
    return Wd(r.if, i);
}, "includeConditionalArg");
// src/csf/csf-factories.ts
function nr(r) {
    return r != null && typeof r == "object" && "_tag" in r && r?._tag === "Story";
}
n(nr, "isStory");
// src/csf/index.ts
var An = /* @__PURE__ */ n((r)=>r.toLowerCase().replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(/-+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), "sanitize"), Ci = /* @__PURE__ */ n((r, e)=>{
    let t = An(r);
    if (t === "") throw new Error(`Invalid ${e} '${r}', must include alphanumeric characters`);
    return t;
}, "sanitizeSafe"), Oi = /* @__PURE__ */ n((r, e)=>`${Ci(r, "kind")}${e ? `--${Ci(e, "name")}` : ""}`, "toId"), Ii = /* @__PURE__ */ n((r)=>vi(r), "storyNameFromExport");
function Pi(r, e) {
    return Array.isArray(e) ? e.includes(r) : r.match(e);
}
n(Pi, "matches");
function Lr(r, { includeStories: e, excludeStories: t }) {
    return(// https://babeljs.io/docs/en/babel-plugin-transform-modules-commonjs
    r !== "__esModule" && (!e || Pi(r, e)) && (!t || !Pi(r, t)));
}
n(Lr, "isExportStory");
var Fi = /* @__PURE__ */ n((...r)=>{
    let e = r.reduce((t, o)=>(o.startsWith("!") ? t.delete(o.slice(1)) : t.add(o), t), /* @__PURE__ */ new Set());
    return Array.from(e);
}, "combineTags");
// src/preview-api/modules/store/csf/normalizeArrays.ts
var k = /* @__PURE__ */ n((r)=>Array.isArray(r) ? r : r ? [
        r
    ] : [], "normalizeArrays");
// src/preview-api/modules/store/csf/normalizeStory.ts
var $d = _`
CSF .story annotations deprecated; annotate story functions directly:
- StoryFn.story.name => StoryFn.storyName
- StoryFn.story.(parameters|decorators) => StoryFn.(parameters|decorators)
See https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#hoisted-csf-annotations for details and codemod.
`;
function De(r, e, t) {
    let o = e, s = typeof e == "function" ? e : null, { story: i } = o;
    i && (I.debug("deprecated story", i), ae($d));
    let a = Ii(r), c = typeof o != "function" && o.name || o.storyName || i?.name || a, l = [
        ...k(o.decorators),
        ...k(i?.decorators)
    ], p = {
        ...i?.parameters,
        ...o.parameters
    }, u = {
        ...i?.args,
        ...o.args
    }, d = {
        ...i?.argTypes,
        ...o.argTypes
    }, h = [
        ...k(o.loaders),
        ...k(i?.loaders)
    ], S = [
        ...k(o.beforeEach),
        ...k(i?.beforeEach)
    ], m = [
        ...k(o.experimental_afterEach),
        ...k(i?.experimental_afterEach)
    ], { render: T, play: y, tags: R = [], globals: x = {} } = o, g = p.__id || Oi(t.id, a);
    return {
        moduleExport: e,
        id: g,
        name: c,
        tags: R,
        decorators: l,
        parameters: p,
        args: u,
        argTypes: Fe(d),
        loaders: h,
        beforeEach: S,
        experimental_afterEach: m,
        globals: x,
        ...T && {
            render: T
        },
        ...s && {
            userStoryFn: s
        },
        ...y && {
            play: y
        }
    };
}
n(De, "normalizeStory");
// src/preview-api/modules/store/csf/normalizeComponentAnnotations.ts
function jr(r, e = r.title, t) {
    let { id: o, argTypes: s } = r;
    return {
        id: An(o || e),
        ...r,
        title: e,
        ...s && {
            argTypes: Fe(s)
        },
        parameters: {
            fileName: t,
            ...r.parameters
        }
    };
}
n(jr, "normalizeComponentAnnotations");
// src/preview-api/modules/store/csf/processCSFFile.ts
var Yd = /* @__PURE__ */ n((r)=>{
    let { globals: e, globalTypes: t } = r;
    (e || t) && I.error("Global args/argTypes can only be set globally", JSON.stringify({
        globals: e,
        globalTypes: t
    }));
}, "checkGlobals"), Kd = /* @__PURE__ */ n((r)=>{
    let { options: e } = r;
    e?.storySort && I.error("The storySort option parameter can only be set globally");
}, "checkStorySort"), xt = /* @__PURE__ */ n((r)=>{
    r && (Yd(r), Kd(r));
}, "checkDisallowedParameters");
function Di(r, e, t) {
    let { default: o, __namedExportsOrder: s, ...i } = r, a = Object.values(i)[0];
    if (nr(a)) {
        let p = jr(a.meta.input, t, e);
        xt(p.parameters);
        let u = {
            meta: p,
            stories: {},
            moduleExports: r
        };
        return Object.keys(i).forEach((d)=>{
            if (Lr(d, p)) {
                let h = De(d, i[d].input, p);
                xt(h.parameters), u.stories[h.id] = h;
            }
        }), u.projectAnnotations = a.meta.preview.composed, u;
    }
    let c = jr(o, t, e);
    xt(c.parameters);
    let l = {
        meta: c,
        stories: {},
        moduleExports: r
    };
    return Object.keys(i).forEach((p)=>{
        if (Lr(p, c)) {
            let u = De(p, i[p], c);
            xt(u.parameters), l.stories[u.id] = u;
        }
    }), l;
}
n(Di, "processCSFFile");
// src/preview-api/modules/preview-web/render/mount-utils.ts
function ki(r) {
    return r != null && Xd(r).includes("mount");
}
n(ki, "mountDestructured");
function Xd(r) {
    let e = r.toString().match(/[^(]*\(([^)]*)/);
    if (!e) return [];
    let t = Ni(e[1]);
    if (!t.length) return [];
    let o = t[0];
    return o.startsWith("{") && o.endsWith("}") ? Ni(o.slice(1, -1).replace(/\s/g, "")).map((i)=>i.replace(/:.*|=.*/g, "")) : [];
}
n(Xd, "getUsedProps");
function Ni(r) {
    let e = [], t = [], o = 0;
    for(let i = 0; i < r.length; i++)if (r[i] === "{" || r[i] === "[") t.push(r[i] === "{" ? "}" : "]");
    else if (r[i] === t[t.length - 1]) t.pop();
    else if (!t.length && r[i] === ",") {
        let a = r.substring(o, i).trim();
        a && e.push(a), o = i + 1;
    }
    let s = r.substring(o).trim();
    return s && e.push(s), e;
}
n(Ni, "splitByComma");
// src/preview-api/modules/store/decorators.ts
function xn(r, e, t) {
    let o = t(r);
    return (s)=>e(o, s);
}
n(xn, "decorateStory");
function vn({ componentId: r, title: e, kind: t, id: o, name: s, story: i, parameters: a, initialArgs: c, argTypes: l, ...p } = {}) {
    return p;
}
n(vn, "sanitizeStoryContextUpdate");
function vt(r, e) {
    let t = {}, o = /* @__PURE__ */ n((i)=>(a)=>{
            if (!t.value) throw new Error("Decorated function called without init");
            return t.value = {
                ...t.value,
                ...vn(a)
            }, i(t.value);
        }, "bindWithContext"), s = e.reduce((i, a)=>xn(i, a, o), r);
    return (i)=>(t.value = i, s(i));
}
n(vt, "defaultDecorateStory");
// src/preview-api/modules/store/parameters.ts
var Y = /* @__PURE__ */ n((...r)=>{
    let e = {}, t = r.filter(Boolean), o = t.reduce((s, i)=>(Object.entries(i).forEach(([a, c])=>{
            let l = s[a];
            Array.isArray(c) || typeof l > "u" ? s[a] = c : $(c) && $(l) ? e[a] = !0 : typeof c < "u" && (s[a] = c);
        }), s), {});
    return Object.keys(e).forEach((s)=>{
        let i = t.filter(Boolean).map((a)=>a[s]).filter((a)=>typeof a < "u");
        i.every((a)=>$(a)) ? o[s] = Y(...i) : o[s] = i[i.length - 1];
    }), o;
}, "combineParameters");
// src/preview-api/modules/store/csf/prepareStory.ts
function sr(r, e, t) {
    let { moduleExport: o, id: s, name: i } = r || {}, a = Li(r, e, t), c = /* @__PURE__ */ n(async (C)=>{
        let F = {};
        for (let U of [
            ..."__STORYBOOK_TEST_LOADERS__" in E && Array.isArray(E.__STORYBOOK_TEST_LOADERS__) ? [
                E.__STORYBOOK_TEST_LOADERS__
            ] : [],
            k(t.loaders),
            k(e.loaders),
            k(r.loaders)
        ]){
            if (C.abortSignal.aborted) return F;
            let B = await Promise.all(U.map((W)=>W(C)));
            Object.assign(F, ...B);
        }
        return F;
    }, "applyLoaders"), l = /* @__PURE__ */ n(async (C)=>{
        let F = new Array();
        for (let U of [
            ...k(t.beforeEach),
            ...k(e.beforeEach),
            ...k(r.beforeEach)
        ]){
            if (C.abortSignal.aborted) return F;
            let B = await U(C);
            B && F.push(B);
        }
        return F;
    }, "applyBeforeEach"), p = /* @__PURE__ */ n(async (C)=>{
        let F = [
            ...k(t.experimental_afterEach),
            ...k(e.experimental_afterEach),
            ...k(r.experimental_afterEach)
        ].reverse();
        for (let U of F){
            if (C.abortSignal.aborted) return;
            await U(C);
        }
    }, "applyAfterEach"), u = /* @__PURE__ */ n((C)=>C.originalStoryFn(C.args, C), "undecoratedStoryFn"), { applyDecorators: d = vt, runStep: h } = t, S = [
        ...k(r?.decorators),
        ...k(e?.decorators),
        ...k(t?.decorators)
    ], m = r?.userStoryFn || r?.render || e.render || t.render, T = ft(d)(u, S), y = /* @__PURE__ */ n((C)=>T(C), "unboundStoryFn"), R = r?.play ?? e?.play, x = ki(R);
    if (!m && !x) throw new Dr({
        id: s
    });
    let g = /* @__PURE__ */ n((C)=>async ()=>(await C.renderToCanvas(), C.canvas), "defaultMount"), b = r.mount ?? e.mount ?? t.mount ?? g, v = t.testingLibraryRender;
    return {
        storyGlobals: {},
        ...a,
        moduleExport: o,
        id: s,
        name: i,
        story: i,
        originalStoryFn: m,
        undecoratedStoryFn: u,
        unboundStoryFn: y,
        applyLoaders: c,
        applyBeforeEach: l,
        applyAfterEach: p,
        playFunction: R,
        runStep: h,
        mount: b,
        testingLibraryRender: v,
        renderToCanvas: t.renderToCanvas,
        usesMount: x
    };
}
n(sr, "prepareStory");
function wt(r, e, t) {
    return {
        ...Li(void 0, r, e),
        moduleExport: t
    };
}
n(wt, "prepareMeta");
function Li(r, e, t) {
    let o = [
        "dev",
        "test"
    ], s = E.DOCS_OPTIONS?.autodocs === !0 ? [
        "autodocs"
    ] : [], i = Fi(...o, ...s, ...t.tags ?? [], ...e.tags ?? [], ...r?.tags ?? []), a = Y(t.parameters, e.parameters, r?.parameters), { argTypesEnhancers: c = [], argsEnhancers: l = [] } = t, p = Y(t.argTypes, e.argTypes, r?.argTypes);
    if (r) {
        let R = r?.userStoryFn || r?.render || e.render || t.render;
        a.__isArgsStory = R && R.length > 0;
    }
    let u = {
        ...t.args,
        ...e.args,
        ...r?.args
    }, d = {
        ...e.globals,
        ...r?.globals
    }, h = {
        componentId: e.id,
        title: e.title,
        kind: e.title,
        // Back compat
        id: r?.id || e.id,
        // if there's no story name, we create a fake one since enhancers expect a name
        name: r?.name || "__meta",
        story: r?.name || "__meta",
        // Back compat
        component: e.component,
        subcomponents: e.subcomponents,
        tags: i,
        parameters: a,
        initialArgs: u,
        argTypes: p,
        storyGlobals: d
    };
    h.argTypes = c.reduce((R, x)=>x({
            ...h,
            argTypes: R
        }), h.argTypes);
    let S = {
        ...u
    };
    h.initialArgs = l.reduce((R, x)=>({
            ...R,
            ...x({
                ...h,
                initialArgs: R
            })
        }), S);
    let { name: m, story: T, ...y } = h;
    return y;
}
n(Li, "preparePartialAnnotations");
function _t(r) {
    let { args: e } = r, t = {
        ...r,
        allArgs: void 0,
        argsByTarget: void 0
    };
    if (E.FEATURES?.argTypeTargetsV7) {
        let i = Ai(r);
        t = {
            ...r,
            allArgs: r.args,
            argsByTarget: i,
            args: i[hn] || {}
        };
    }
    let o = Object.entries(t.args).reduce((i, [a, c])=>{
        if (!t.argTypes[a]?.mapping) return i[a] = c, i;
        let l = /* @__PURE__ */ n((p)=>{
            let u = t.argTypes[a].mapping;
            return u && p in u ? u[p] : p;
        }, "mappingFn");
        return i[a] = Array.isArray(c) ? c.map(l) : l(c), i;
    }, {}), s = Object.entries(o).reduce((i, [a, c])=>{
        let l = t.argTypes[a] || {};
        return Rn(l, o, t.globals) && (i[a] = c), i;
    }, {});
    return {
        ...t,
        unmappedArgs: e,
        args: s
    };
}
n(_t, "prepareContext");
// src/preview-api/modules/store/inferArgTypes.ts
var wn = /* @__PURE__ */ n((r, e, t)=>{
    let o = typeof r;
    switch(o){
        case "boolean":
        case "string":
        case "number":
        case "function":
        case "symbol":
            return {
                name: o
            };
        default:
            break;
    }
    return r ? t.has(r) ? (I.warn(_`
        We've detected a cycle in arg '${e}'. Args should be JSON-serializable.

        Consider using the mapping feature or fully custom args:
        - Mapping: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
        - Custom args: https://storybook.js.org/docs/essentials/controls#fully-custom-args
      `), {
        name: "other",
        value: "cyclic object"
    }) : (t.add(r), Array.isArray(r) ? {
        name: "array",
        value: r.length > 0 ? wn(r[0], e, new Set(t)) : {
            name: "other",
            value: "unknown"
        }
    } : {
        name: "object",
        value: oe(r, (i)=>wn(i, e, new Set(t)))
    }) : {
        name: "object",
        value: {}
    };
}, "inferType"), _n = /* @__PURE__ */ n((r)=>{
    let { id: e, argTypes: t = {}, initialArgs: o = {} } = r, s = oe(o, (a, c)=>({
            name: c,
            type: wn(a, `${e}.${c}`, /* @__PURE__ */ new Set())
        })), i = oe(t, (a, c)=>({
            name: c
        }));
    return Y(s, i, t);
}, "inferArgTypes");
_n.secondPass = !0;
// src/preview-api/modules/store/filterArgTypes.ts
var ji = /* @__PURE__ */ n((r, e)=>Array.isArray(e) ? e.includes(r) : r.match(e), "matches"), Mr = /* @__PURE__ */ n((r, e, t)=>!e && !t ? r : r && qo(r, (o, s)=>{
        let i = o.name || s.toString();
        return !!(!e || ji(i, e)) && (!t || !ji(i, t));
    }), "filterArgTypes");
// src/preview-api/modules/store/inferControls.ts
var Jd = /* @__PURE__ */ n((r, e, t)=>{
    let { type: o, options: s } = r;
    if (o) {
        if (t.color && t.color.test(e)) {
            let i = o.name;
            if (i === "string") return {
                control: {
                    type: "color"
                }
            };
            i !== "enum" && I.warn(`Addon controls: Control of type color only supports string, received "${i}" instead`);
        }
        if (t.date && t.date.test(e)) return {
            control: {
                type: "date"
            }
        };
        switch(o.name){
            case "array":
                return {
                    control: {
                        type: "object"
                    }
                };
            case "boolean":
                return {
                    control: {
                        type: "boolean"
                    }
                };
            case "string":
                return {
                    control: {
                        type: "text"
                    }
                };
            case "number":
                return {
                    control: {
                        type: "number"
                    }
                };
            case "enum":
                {
                    let { value: i } = o;
                    return {
                        control: {
                            type: i?.length <= 5 ? "radio" : "select"
                        },
                        options: i
                    };
                }
            case "function":
            case "symbol":
                return null;
            default:
                return {
                    control: {
                        type: s ? "select" : "object"
                    }
                };
        }
    }
}, "inferControl"), ir = /* @__PURE__ */ n((r)=>{
    let { argTypes: e, // eslint-disable-next-line @typescript-eslint/naming-convention
    parameters: { __isArgsStory: t, controls: { include: o = null, exclude: s = null, matchers: i = {} } = {} } } = r;
    if (!t) return e;
    let a = Mr(e, o, s), c = oe(a, (l, p)=>l?.type && Jd(l, p.toString(), i));
    return Y(c, a);
}, "inferControls");
ir.secondPass = !0;
// src/preview-api/modules/store/csf/normalizeProjectAnnotations.ts
function Ne({ argTypes: r, globalTypes: e, argTypesEnhancers: t, decorators: o, loaders: s, beforeEach: i, experimental_afterEach: a, globals: c, initialGlobals: l, ...p }) {
    return c && Object.keys(c).length > 0 && ae(_`
      The preview.js 'globals' field is deprecated and will be removed in Storybook 9.0.
      Please use 'initialGlobals' instead. Learn more:

      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#previewjs-globals-renamed-to-initialglobals
    `), {
        ...r && {
            argTypes: Fe(r)
        },
        ...e && {
            globalTypes: Fe(e)
        },
        decorators: k(o),
        loaders: k(s),
        beforeEach: k(i),
        experimental_afterEach: k(a),
        argTypesEnhancers: [
            ...t || [],
            _n,
            // inferControls technically should only run if the user is using the controls addon,
            // and so should be added by a preset there. However, as it seems some code relies on controls
            // annotations (in particular the angular implementation's `cleanArgsDecorator`), for backwards
            // compatibility reasons, we will leave this in the store until 7.0
            ir
        ],
        initialGlobals: Y(l, c),
        ...p
    };
}
n(Ne, "normalizeProjectAnnotations");
// src/preview-api/modules/store/csf/beforeAll.ts
var Mi = /* @__PURE__ */ n((r)=>async ()=>{
        let e = [];
        for (let t of r){
            let o = await t();
            o && e.unshift(o);
        }
        return async ()=>{
            for (let t of e)await t();
        };
    }, "composeBeforeAllHooks");
// src/preview-api/modules/store/csf/stepRunners.ts
function Ct(r) {
    return async (e, t, o)=>{
        await r.reduceRight((i, a)=>async ()=>a(e, i, o), async ()=>t(o))();
    };
}
n(Ct, "composeStepRunners");
// src/preview-api/modules/store/csf/composeConfigs.ts
function Gr(r, e) {
    return r.map((t)=>t.default?.[e] ?? t[e]).filter(Boolean);
}
n(Gr, "getField");
function Te(r, e, t = {}) {
    return Gr(r, e).reduce((o, s)=>{
        let i = k(s);
        return t.reverseFileOrder ? [
            ...i,
            ...o
        ] : [
            ...o,
            ...i
        ];
    }, []);
}
n(Te, "getArrayField");
function Ur(r, e) {
    return Object.assign({}, ...Gr(r, e));
}
n(Ur, "getObjectField");
function ar(r, e) {
    return Gr(r, e).pop();
}
n(ar, "getSingletonField");
function ke(r) {
    let e = Te(r, "argTypesEnhancers"), t = Gr(r, "runStep"), o = Te(r, "beforeAll");
    return {
        parameters: Y(...Gr(r, "parameters")),
        decorators: Te(r, "decorators", {
            reverseFileOrder: !(E.FEATURES?.legacyDecoratorFileOrder ?? !1)
        }),
        args: Ur(r, "args"),
        argsEnhancers: Te(r, "argsEnhancers"),
        argTypes: Ur(r, "argTypes"),
        argTypesEnhancers: [
            ...e.filter((s)=>!s.secondPass),
            ...e.filter((s)=>s.secondPass)
        ],
        globals: Ur(r, "globals"),
        initialGlobals: Ur(r, "initialGlobals"),
        globalTypes: Ur(r, "globalTypes"),
        loaders: Te(r, "loaders"),
        beforeAll: Mi(o),
        beforeEach: Te(r, "beforeEach"),
        experimental_afterEach: Te(r, "experimental_afterEach"),
        render: ar(r, "render"),
        renderToCanvas: ar(r, "renderToCanvas"),
        renderToDOM: ar(r, "renderToDOM"),
        // deprecated
        applyDecorators: ar(r, "applyDecorators"),
        runStep: Ct(t),
        tags: Te(r, "tags"),
        mount: ar(r, "mount"),
        testingLibraryRender: ar(r, "testingLibraryRender")
    };
}
n(ke, "composeConfigs");
// src/preview-api/modules/store/reporter-api.ts
var Cn = class Cn {
    constructor(){
        this.reports = [];
    }
    async addReport(e) {
        this.reports.push(e);
    }
};
n(Cn, "ReporterAPI");
var Ee = Cn;
// src/preview-api/modules/store/csf/csf-factory-utils.ts
function Pt(r, e, t) {
    return nr(r) ? {
        story: r.input,
        meta: r.meta.input,
        preview: r.meta.preview.composed
    } : {
        story: r,
        meta: e,
        preview: t
    };
}
n(Pt, "getCsfFactoryAnnotations");
// src/preview-api/modules/store/csf/portable-stories.ts
function Ui(r) {
    globalThis.defaultProjectAnnotations = r;
}
n(Ui, "setDefaultProjectAnnotations");
var Qd = "ComposedStory", Zd = "Unnamed Story";
function eu(r) {
    return r ? ke([
        r
    ]) : {};
}
n(eu, "extractAnnotation");
function Gi(r) {
    let e = Array.isArray(r) ? r : [
        r
    ];
    return globalThis.globalProjectAnnotations = ke([
        globalThis.defaultProjectAnnotations ?? {},
        ke(e.map(eu))
    ]), globalThis.globalProjectAnnotations ?? {};
}
n(Gi, "setProjectAnnotations");
var Re = [];
function Pn(r, e, t, o, s) {
    if (r === void 0) throw new Error("Expected a story but received undefined.");
    e.title = e.title ?? Qd;
    let i = jr(e), a = s || r.storyName || r.story?.name || r.name || Zd, c = De(a, r, i), l = Ne(ke([
        o ?? globalThis.globalProjectAnnotations ?? {},
        t ?? {}
    ])), p = sr(c, i, l), d = {
        // TODO: remove loading from globalTypes in 9.0
        ...Et(l.globalTypes),
        ...l.initialGlobals,
        ...p.storyGlobals
    }, h = new Ee(), S = /* @__PURE__ */ n(()=>{
        let g = _t({
            hooks: new be(),
            globals: d,
            args: {
                ...p.initialArgs
            },
            viewMode: "story",
            reporting: h,
            loaded: {},
            abortSignal: new AbortController().signal,
            step: /* @__PURE__ */ n((b, v)=>p.runStep(b, v, g), "step"),
            canvasElement: null,
            canvas: {},
            globalTypes: l.globalTypes,
            ...p,
            context: null,
            mount: null
        });
        return g.parameters.__isPortableStory = !0, g.context = g, p.renderToCanvas && (g.renderToCanvas = async ()=>{
            let b = await p.renderToCanvas?.({
                componentId: p.componentId,
                title: p.title,
                id: p.id,
                name: p.name,
                tags: p.tags,
                showMain: /* @__PURE__ */ n(()=>{}, "showMain"),
                showError: /* @__PURE__ */ n((v)=>{
                    throw new Error(`${v.title}
${v.description}`);
                }, "showError"),
                showException: /* @__PURE__ */ n((v)=>{
                    throw v;
                }, "showException"),
                forceRemount: !0,
                storyContext: g,
                storyFn: /* @__PURE__ */ n(()=>p.unboundStoryFn(g), "storyFn"),
                unboundStoryFn: p.unboundStoryFn
            }, g.canvasElement);
            b && Re.push(b);
        }), g.mount = p.mount(g), g;
    }, "initializeContext"), m, T = /* @__PURE__ */ n(async (g)=>{
        let b = S();
        return b.canvasElement ??= globalThis?.document?.body, m && (b.loaded = m.loaded), Object.assign(b, g), p.playFunction(b);
    }, "play"), y = /* @__PURE__ */ n((g)=>{
        let b = S();
        return Object.assign(b, g), tu(p, b);
    }, "run"), R = p.playFunction ? T : void 0;
    return Object.assign(/* @__PURE__ */ n(function(b) {
        let v = S();
        return m && (v.loaded = m.loaded), v.args = {
            ...v.initialArgs,
            ...b
        }, p.unboundStoryFn(v);
    }, "storyFn"), {
        id: p.id,
        storyName: a,
        load: /* @__PURE__ */ n(async ()=>{
            for (let b of [
                ...Re
            ].reverse())await b();
            Re.length = 0;
            let g = S();
            g.loaded = await p.applyLoaders(g), Re.push(...(await p.applyBeforeEach(g)).filter(Boolean)), m = g;
        }, "load"),
        globals: d,
        args: p.initialArgs,
        parameters: p.parameters,
        argTypes: p.argTypes,
        play: R,
        run: y,
        reporting: h,
        tags: p.tags
    });
}
n(Pn, "composeStory");
var ru = /* @__PURE__ */ n((r, e, t, o)=>Pn(r, e, t, {}, o), "defaultComposeStory");
function qi(r, e, t = ru) {
    let { default: o, __esModule: s, __namedExportsOrder: i, ...a } = r, c = o;
    return Object.entries(a).reduce((p, [u, d])=>{
        let { story: h, meta: S } = Pt(d);
        return !c && S && (c = S), Lr(u, c) ? Object.assign(p, {
            [u]: t(h, c, e, u)
        }) : p;
    }, {});
}
n(qi, "composeStories");
function Bi(r) {
    return r.extend({
        mount: /* @__PURE__ */ n(async ({ mount: e, page: t }, o)=>{
            await o(async (s, ...i)=>{
                if (!("__pw_type" in s) || "__pw_type" in s && s.__pw_type !== "jsx") throw new Error(_`
              Portable stories in Playwright CT only work when referencing JSX elements.
              Please use JSX format for your components such as:

              instead of:
              await mount(MyComponent, { props: { foo: 'bar' } })

              do:
              await mount(<MyComponent foo="bar"/>)

              More info: https://storybook.js.org/docs/api/portable-stories-playwright
            `);
                await t.evaluate(async (c)=>{
                    let l = await globalThis.__pwUnwrapObject?.(c);
                    return ("__pw_type" in l ? l.type : l)?.load?.();
                }, s);
                let a = await e(s, ...i);
                return await t.evaluate(async (c)=>{
                    let l = await globalThis.__pwUnwrapObject?.(c), p = "__pw_type" in l ? l.type : l, u = document.querySelector("#root");
                    return p?.play?.({
                        canvasElement: u
                    });
                }, s), a;
            });
        }, "mount")
    });
}
n(Bi, "createPlaywrightTest");
async function tu(r, e) {
    for (let s of [
        ...Re
    ].reverse())await s();
    if (Re.length = 0, !e.canvasElement) {
        let s = document.createElement("div");
        globalThis?.document?.body?.appendChild(s), e.canvasElement = s, Re.push(()=>{
            globalThis?.document?.body?.contains(s) && globalThis?.document?.body?.removeChild(s);
        });
    }
    if (e.loaded = await r.applyLoaders(e), e.abortSignal.aborted) return;
    Re.push(...(await r.applyBeforeEach(e)).filter(Boolean));
    let t = r.playFunction, o = r.usesMount;
    o || await e.mount(), !e.abortSignal.aborted && (t && (o || (e.mount = async ()=>{
        throw new Oe({
            playFunction: t.toString()
        });
    }), await t(e)), await r.applyAfterEach(e));
}
n(tu, "runStory");
// src/preview-api/modules/store/StoryStore.ts
function Vi(r, e) {
    return Uo(Go(r, e), (t)=>t === void 0);
}
n(Vi, "picky");
var Hi = 1e3, ou = 1e4, On = class On {
    constructor(e, t, o){
        this.importFn = t;
        // TODO: Remove in 9.0
        // NOTE: this is legacy `stories.json` data for the `extract` script.
        // It is used to allow v7 Storybooks to be composed in v6 Storybooks, which expect a
        // `stories.json` file with legacy fields (`kind` etc).
        this.getStoriesJsonData = /* @__PURE__ */ n(()=>{
            let e = this.getSetStoriesPayload(), t = [
                "fileName",
                "docsOnly",
                "framework",
                "__id",
                "__isArgsStory"
            ];
            return {
                v: 3,
                stories: oe(e.stories, (s)=>{
                    let { importPath: i } = this.storyIndex.entries[s.id];
                    return {
                        ...Vi(s, [
                            "id",
                            "name",
                            "title"
                        ]),
                        importPath: i,
                        // These 3 fields were going to be dropped in v7, but instead we will keep them for the
                        // 7.x cycle so that v7 Storybooks can be composed successfully in v6 Storybook.
                        // In v8 we will (likely) completely drop support for `extract` and `getStoriesJsonData`
                        kind: s.title,
                        story: s.name,
                        parameters: {
                            ...Vi(s.parameters, t),
                            fileName: i
                        }
                    };
                })
            };
        }, "getStoriesJsonData");
        this.storyIndex = new At(e), this.projectAnnotations = Ne(o);
        let { initialGlobals: s, globalTypes: i } = this.projectAnnotations;
        this.args = new Tt(), this.userGlobals = new Rt({
            globals: s,
            globalTypes: i
        }), this.hooks = {}, this.cleanupCallbacks = {}, this.processCSFFileWithCache = (0, Ot.default)(Hi)(Di), this.prepareMetaWithCache = (0, Ot.default)(Hi)(wt), this.prepareStoryWithCache = (0, Ot.default)(ou)(sr);
    }
    setProjectAnnotations(e) {
        this.projectAnnotations = Ne(e);
        let { initialGlobals: t, globalTypes: o } = e;
        this.userGlobals.set({
            globals: t,
            globalTypes: o
        });
    }
    // This means that one of the CSF files has changed.
    // If the `importFn` has changed, we will invalidate both caches.
    // If the `storyIndex` data has changed, we may or may not invalidate the caches, depending
    // on whether we've loaded the relevant files yet.
    async onStoriesChanged({ importFn: e, storyIndex: t }) {
        e && (this.importFn = e), t && (this.storyIndex.entries = t.entries), this.cachedCSFFiles && await this.cacheAllCSFFiles();
    }
    // Get an entry from the index, waiting on initialization if necessary
    async storyIdToEntry(e) {
        return this.storyIndex.storyIdToEntry(e);
    }
    // To load a single CSF file to service a story we need to look up the importPath in the index
    async loadCSFFileByStoryId(e) {
        let { importPath: t, title: o } = this.storyIndex.storyIdToEntry(e), s = await this.importFn(t);
        return this.processCSFFileWithCache(s, t, o);
    }
    async loadAllCSFFiles() {
        let e = {};
        return Object.entries(this.storyIndex.entries).forEach(([o, { importPath: s }])=>{
            e[s] = o;
        }), (await Promise.all(Object.entries(e).map(async ([o, s])=>({
                importPath: o,
                csfFile: await this.loadCSFFileByStoryId(s)
            })))).reduce((o, { importPath: s, csfFile: i })=>(o[s] = i, o), {});
    }
    async cacheAllCSFFiles() {
        this.cachedCSFFiles = await this.loadAllCSFFiles();
    }
    preparedMetaFromCSFFile({ csfFile: e }) {
        let t = e.meta;
        return this.prepareMetaWithCache(t, this.projectAnnotations, e.moduleExports.default);
    }
    // Load the CSF file for a story and prepare the story from it and the project annotations.
    async loadStory({ storyId: e }) {
        let t = await this.loadCSFFileByStoryId(e);
        return this.storyFromCSFFile({
            storyId: e,
            csfFile: t
        });
    }
    // This function is synchronous for convenience -- often times if you have a CSF file already
    // it is easier not to have to await `loadStory`.
    storyFromCSFFile({ storyId: e, csfFile: t }) {
        let o = t.stories[e];
        if (!o) throw new Ir({
            storyId: e
        });
        let s = t.meta, i = this.prepareStoryWithCache(o, s, t.projectAnnotations ?? this.projectAnnotations);
        return this.args.setInitial(i), this.hooks[i.id] = this.hooks[i.id] || new be(), i;
    }
    // If we have a CSF file we can get all the stories from it synchronously
    componentStoriesFromCSFFile({ csfFile: e }) {
        return Object.keys(this.storyIndex.entries).filter((t)=>!!e.stories[t]).map((t)=>this.storyFromCSFFile({
                storyId: t,
                csfFile: e
            }));
    }
    async loadEntry(e) {
        let t = await this.storyIdToEntry(e), o = t.type === "docs" ? t.storiesImports : [], [s, ...i] = await Promise.all([
            this.importFn(t.importPath),
            ...o.map((a)=>{
                let c = this.storyIndex.importPathToEntry(a);
                return this.loadCSFFileByStoryId(c.id);
            })
        ]);
        return {
            entryExports: s,
            csfFiles: i
        };
    }
    // A prepared story does not include args, globals or hooks. These are stored in the story store
    // and updated separtely to the (immutable) story.
    getStoryContext(e, { forceInitialArgs: t = !1 } = {}) {
        let o = this.userGlobals.get(), { initialGlobals: s } = this.userGlobals, i = new Ee();
        return _t({
            ...e,
            args: t ? e.initialArgs : this.args.get(e.id),
            initialGlobals: s,
            globalTypes: this.projectAnnotations.globalTypes,
            userGlobals: o,
            reporting: i,
            globals: {
                ...o,
                ...e.storyGlobals
            },
            hooks: this.hooks[e.id]
        });
    }
    addCleanupCallbacks(e, t) {
        this.cleanupCallbacks[e.id] = t;
    }
    async cleanupStory(e) {
        this.hooks[e.id].clean();
        let t = this.cleanupCallbacks[e.id];
        if (t) for (let o of [
            ...t
        ].reverse())await o();
        delete this.cleanupCallbacks[e.id];
    }
    extract(e = {
        includeDocsOnly: !1
    }) {
        let { cachedCSFFiles: t } = this;
        if (!t) throw new vr();
        return Object.entries(this.storyIndex.entries).reduce((o, [s, { type: i, importPath: a }])=>{
            if (i === "docs") return o;
            let c = t[a], l = this.storyFromCSFFile({
                storyId: s,
                csfFile: c
            });
            return !e.includeDocsOnly && l.parameters.docsOnly || (o[s] = Object.entries(l).reduce((p, [u, d])=>u === "moduleExport" || typeof d == "function" ? p : Array.isArray(d) ? Object.assign(p, {
                    [u]: d.slice().sort()
                }) : Object.assign(p, {
                    [u]: d
                }), {
                //
                args: l.initialArgs,
                globals: {
                    ...this.userGlobals.initialGlobals,
                    ...this.userGlobals.globals,
                    ...l.storyGlobals
                }
            })), o;
        }, {});
    }
    // TODO: Remove in 9.0
    getSetStoriesPayload() {
        let e = this.extract({
            includeDocsOnly: !0
        }), t = Object.values(e).reduce((o, { title: s })=>(o[s] = {}, o), {});
        return {
            v: 2,
            globals: this.userGlobals.get(),
            globalParameters: {},
            kindParameters: t,
            stories: e
        };
    }
    raw() {
        return ae("StoryStore.raw() is deprecated and will be removed in 9.0, please use extract() instead"), Object.values(this.extract()).map(({ id: e })=>this.fromId(e)).filter(Boolean);
    }
    fromId(e) {
        if (ae("StoryStore.fromId() is deprecated and will be removed in 9.0, please use loadStory() instead"), !this.cachedCSFFiles) throw new Error("Cannot call fromId/raw() unless you call cacheAllCSFFiles() first.");
        let t;
        try {
            ({ importPath: t } = this.storyIndex.storyIdToEntry(e));
        } catch  {
            return null;
        }
        let o = this.cachedCSFFiles[t], s = this.storyFromCSFFile({
            storyId: e,
            csfFile: o
        });
        return {
            ...s,
            storyFn: /* @__PURE__ */ n((i)=>{
                let a = {
                    ...this.getStoryContext(s),
                    abortSignal: new AbortController().signal,
                    canvasElement: null,
                    loaded: {},
                    step: /* @__PURE__ */ n((c, l)=>s.runStep(c, l, a), "step"),
                    context: null,
                    mount: null,
                    canvas: {},
                    viewMode: "story"
                };
                return s.unboundStoryFn({
                    ...a,
                    ...i
                });
            }, "storyFn")
        };
    }
};
n(On, "StoryStore");
var Le = On;
// ../node_modules/slash/index.js
function In(r) {
    return r.startsWith("\\\\?\\") ? r : r.replace(/\\/g, "/");
}
n(In, "slash");
// src/preview-api/modules/store/autoTitle.ts
var nu = /* @__PURE__ */ n((r)=>{
    if (r.length === 0) return r;
    let e = r[r.length - 1], t = e?.replace(/(?:[.](?:story|stories))?([.][^.]+)$/i, "");
    if (r.length === 1) return [
        t
    ];
    let o = r[r.length - 2];
    return t && o && t.toLowerCase() === o.toLowerCase() ? [
        ...r.slice(0, -2),
        t
    ] : t && (/^(story|stories)([.][^.]+)$/i.test(e) || /^index$/i.test(t)) ? r.slice(0, -1) : [
        ...r.slice(0, -1),
        t
    ];
}, "sanitize");
function zi(r) {
    return r.flatMap((e)=>e.split("/")).filter(Boolean).join("/");
}
n(zi, "pathJoin");
var Fn = /* @__PURE__ */ n((r, e, t)=>{
    let { directory: o, importPathMatcher: s, titlePrefix: i = "" } = e || {};
    typeof r == "number" && j.warn(_`
      CSF Auto-title received a numeric fileName. This typically happens when
      webpack is mis-configured in production mode. To force webpack to produce
      filenames, set optimization.moduleIds = "named" in your webpack config.
    `);
    let a = In(String(r));
    if (s.exec(a)) {
        if (!t) {
            let c = a.replace(o, ""), l = zi([
                i,
                c
            ]).split("/");
            return l = nu(l), l.join("/");
        }
        return i ? zi([
            i,
            t
        ]) : t;
    }
}, "userOrAutoTitleFromSpecifier"), Wi = /* @__PURE__ */ n((r, e, t)=>{
    for(let o = 0; o < e.length; o += 1){
        let s = Fn(r, e[o], t);
        if (s) return s;
    }
    return t || void 0;
}, "userOrAutoTitle");
// src/preview-api/modules/store/storySort.ts
var $i = /\s*\/\s*/, Yi = /* @__PURE__ */ n((r = {})=>(e, t)=>{
        if (e.title === t.title && !r.includeNames) return 0;
        let o = r.method || "configure", s = r.order || [], i = e.title.trim().split($i), a = t.title.trim().split($i);
        r.includeNames && (i.push(e.name), a.push(t.name));
        let c = 0;
        for(; i[c] || a[c];){
            if (!i[c]) return -1;
            if (!a[c]) return 1;
            let l = i[c], p = a[c];
            if (l !== p) {
                let d = s.indexOf(l), h = s.indexOf(p), S = s.indexOf("*");
                return d !== -1 || h !== -1 ? (d === -1 && (S !== -1 ? d = S : d = s.length), h === -1 && (S !== -1 ? h = S : h = s.length), d - h) : o === "configure" ? 0 : l.localeCompare(p, r.locales ? r.locales : void 0, {
                    numeric: !0,
                    sensitivity: "accent"
                });
            }
            let u = s.indexOf(l);
            u === -1 && (u = s.indexOf("*")), s = u !== -1 && Array.isArray(s[u + 1]) ? s[u + 1] : [], c += 1;
        }
        return 0;
    }, "storySort");
// src/preview-api/modules/store/sortStories.ts
var su = /* @__PURE__ */ n((r, e, t)=>{
    if (e) {
        let o;
        typeof e == "function" ? o = e : o = Yi(e), r.sort(o);
    } else r.sort((o, s)=>t.indexOf(o.importPath) - t.indexOf(s.importPath));
    return r;
}, "sortStoriesCommon"), Ki = /* @__PURE__ */ n((r, e, t)=>{
    try {
        return su(r, e, t);
    } catch (o) {
        throw new Error(_`
    Error sorting stories with sort parameter ${e}:

    > ${o.message}
    
    Are you using a V6-style sort function in V7 mode?

    More info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#v7-style-story-sort
  `);
    }
}, "sortStoriesV7");
// src/preview-api/modules/preview-web/render/Render.ts
var Ae = new Error("prepareAborted");
// src/preview-api/modules/preview-web/render/StoryRender.ts
var { AbortController: Xi } = globalThis;
function Ji(r) {
    try {
        let { name: e = "Error", message: t = String(r), stack: o } = r;
        return {
            name: e,
            message: t,
            stack: o
        };
    } catch  {
        return {
            name: "Error",
            message: String(r)
        };
    }
}
n(Ji, "serializeError");
var Dn = class Dn {
    constructor(e, t, o, s, i, a, c = {
        autoplay: !0,
        forceInitialArgs: !1
    }, l){
        this.channel = e;
        this.store = t;
        this.renderToScreen = o;
        this.callbacks = s;
        this.id = i;
        this.viewMode = a;
        this.renderOptions = c;
        this.type = "story";
        this.notYetRendered = !0;
        this.rerenderEnqueued = !1;
        this.disableKeyListeners = !1;
        this.teardownRender = /* @__PURE__ */ n(()=>{}, "teardownRender");
        this.torndown = !1;
        this.abortController = new Xi(), l && (this.story = l, this.phase = "preparing");
    }
    async runPhase(e, t, o) {
        this.phase = t, this.channel.emit(Pe, {
            newPhase: this.phase,
            storyId: this.id
        }), o && (await o(), this.checkIfAborted(e));
    }
    checkIfAborted(e) {
        return e.aborted ? (this.phase = "aborted", this.channel.emit(Pe, {
            newPhase: this.phase,
            storyId: this.id
        }), !0) : !1;
    }
    async prepare() {
        if (await this.runPhase(this.abortController.signal, "preparing", async ()=>{
            this.story = await this.store.loadStory({
                storyId: this.id
            });
        }), this.abortController.signal.aborted) throw await this.store.cleanupStory(this.story), Ae;
    }
    // The two story "renders" are equal and have both loaded the same story
    isEqual(e) {
        return !!(this.id === e.id && this.story && this.story === e.story);
    }
    isPreparing() {
        return [
            "preparing"
        ].includes(this.phase);
    }
    isPending() {
        return [
            "loading",
            "beforeEach",
            "rendering",
            "playing",
            "afterEach"
        ].includes(this.phase);
    }
    async renderToElement(e) {
        return this.canvasElement = e, this.render({
            initial: !0,
            forceRemount: !0
        });
    }
    storyContext() {
        if (!this.story) throw new Error("Cannot call storyContext before preparing");
        let { forceInitialArgs: e } = this.renderOptions;
        return this.store.getStoryContext(this.story, {
            forceInitialArgs: e
        });
    }
    async render({ initial: e = !1, forceRemount: t = !1 } = {}) {
        let { canvasElement: o } = this;
        if (!this.story) throw new Error("cannot render when not prepared");
        let s = this.story;
        if (!o) throw new Error("cannot render when canvasElement is unset");
        let { id: i, componentId: a, title: c, name: l, tags: p, applyLoaders: u, applyBeforeEach: d, applyAfterEach: h, unboundStoryFn: S, playFunction: m, runStep: T } = s;
        t && !e && (this.cancelRender(), this.abortController = new Xi());
        let y = this.abortController.signal, R = !1, x = s.usesMount;
        try {
            let g = {
                ...this.storyContext(),
                viewMode: this.viewMode,
                abortSignal: y,
                canvasElement: o,
                loaded: {},
                step: /* @__PURE__ */ n((P, D)=>T(P, D, g), "step"),
                context: null,
                canvas: {},
                renderToCanvas: /* @__PURE__ */ n(async ()=>{
                    let P = await this.renderToScreen(b, o);
                    this.teardownRender = P || (()=>{}), R = !0;
                }, "renderToCanvas"),
                // The story provides (set in a renderer) a mount function that is a higher order function
                // (context) => (...args) => Canvas
                //
                // Before assigning it to the context, we resolve the context dependency,
                // so that a user can just call it as await mount(...args) in their play function.
                mount: /* @__PURE__ */ n(async (...P)=>{
                    this.callbacks.showStoryDuringRender?.();
                    let D = null;
                    return await this.runPhase(y, "rendering", async ()=>{
                        D = await s.mount(g)(...P);
                    }), x && await this.runPhase(y, "playing"), D;
                }, "mount")
            };
            g.context = g;
            let b = {
                componentId: a,
                title: c,
                kind: c,
                id: i,
                name: l,
                story: l,
                tags: p,
                ...this.callbacks,
                showError: /* @__PURE__ */ n((P)=>(this.phase = "errored", this.callbacks.showError(P)), "showError"),
                showException: /* @__PURE__ */ n((P)=>(this.phase = "errored", this.callbacks.showException(P)), "showException"),
                forceRemount: t || this.notYetRendered,
                storyContext: g,
                storyFn: /* @__PURE__ */ n(()=>S(g), "storyFn"),
                unboundStoryFn: S
            };
            if (await this.runPhase(y, "loading", async ()=>{
                g.loaded = await u(g);
            }), y.aborted) return;
            let v = await d(g);
            if (this.store.addCleanupCallbacks(s, v), this.checkIfAborted(y) || (!R && !x && await g.mount(), this.notYetRendered = !1, y.aborted)) return;
            let C = this.story.parameters?.test?.dangerouslyIgnoreUnhandledErrors === !0, F = /* @__PURE__ */ new Set(), U = /* @__PURE__ */ n((P)=>F.add("error" in P ? P.error : P.reason), "onError");
            if (this.renderOptions.autoplay && t && m && this.phase !== "errored") {
                window.addEventListener("error", U), window.addEventListener("unhandledrejection", U), this.disableKeyListeners = !0;
                try {
                    if (x ? await m(g) : (g.mount = async ()=>{
                        throw new Oe({
                            playFunction: m.toString()
                        });
                    }, await this.runPhase(y, "playing", async ()=>m(g))), !R) throw new Nr();
                    this.checkIfAborted(y), !C && F.size > 0 ? await this.runPhase(y, "errored") : await this.runPhase(y, "played");
                } catch (P) {
                    if (this.callbacks.showStoryDuringRender?.(), await this.runPhase(y, "errored", async ()=>{
                        this.channel.emit(Xt, Ji(P));
                    }), this.story.parameters.throwPlayFunctionExceptions !== !1) throw P;
                    console.error(P);
                }
                if (!C && F.size > 0 && this.channel.emit(Jt, Array.from(F).map(Ji)), this.disableKeyListeners = !1, window.removeEventListener("unhandledrejection", U), window.removeEventListener("error", U), y.aborted) return;
            }
            await this.runPhase(y, "completed", async ()=>this.channel.emit(We, i)), this.phase !== "errored" && await this.runPhase(y, "afterEach", async ()=>{
                await h(g);
            });
            let B = !C && F.size > 0, W = g.reporting.reports.some((P)=>P.status === "failed"), se = B || W;
            await this.runPhase(y, "finished", async ()=>this.channel.emit(ot, {
                    storyId: i,
                    status: se ? "error" : "success",
                    reporters: g.reporting.reports
                }));
        } catch (g) {
            this.phase = "errored", this.callbacks.showException(g), await this.runPhase(y, "finished", async ()=>this.channel.emit(ot, {
                    storyId: i,
                    status: "error",
                    reporters: []
                }));
        }
        this.rerenderEnqueued && (this.rerenderEnqueued = !1, this.render());
    }
    /**
   * Rerender the story. If the story is currently pending (loading/rendering), the rerender will be
   * enqueued, and will be executed after the current render is completed. Rerendering while playing
   * will not be enqueued, and will be executed immediately, to support rendering args changes while
   * playing.
   */ async rerender() {
        if (this.isPending() && this.phase !== "playing") this.rerenderEnqueued = !0;
        else return this.render();
    }
    async remount() {
        return await this.teardown(), this.render({
            forceRemount: !0
        });
    }
    // If the story is torn down (either a new story is rendered or the docs page removes it)
    // we need to consider the fact that the initial render may not be finished
    // (possibly the loaders or the play function are still running). We use the controller
    // as a method to abort them, ASAP, but this is not foolproof as we cannot control what
    // happens inside the user's code.
    cancelRender() {
        this.abortController?.abort();
    }
    async teardown() {
        this.torndown = !0, this.cancelRender(), this.story && await this.store.cleanupStory(this.story);
        for(let e = 0; e < 3; e += 1){
            if (!this.isPending()) {
                await this.teardownRender();
                return;
            }
            await new Promise((t)=>setTimeout(t, 0));
        }
        window.location.reload(), await new Promise(()=>{});
    }
};
n(Dn, "StoryRender");
var je = Dn;
// src/preview-api/modules/preview-web/Preview.tsx
var { fetch: iu } = E, au = "./index.json", Nn = class Nn {
    constructor(e, t, o = te.getChannel(), s = !0){
        this.importFn = e;
        this.getProjectAnnotations = t;
        this.channel = o;
        this.storyRenders = [];
        this.storeInitializationPromise = new Promise((i, a)=>{
            this.resolveStoreInitializationPromise = i, this.rejectStoreInitializationPromise = a;
        }), s && this.initialize();
    }
    // Create a proxy object for `__STORYBOOK_STORY_STORE__` and `__STORYBOOK_PREVIEW__.storyStore`
    // That proxies through to the store once ready, and errors beforehand. This means we can set
    // `__STORYBOOK_STORY_STORE__ = __STORYBOOK_PREVIEW__.storyStore` without having to wait, and
    // similarly integrators can access the `storyStore` on the preview at any time, although
    // it is considered deprecated and we will no longer allow access in 9.0
    get storyStore() {
        return new Proxy({}, {
            get: /* @__PURE__ */ n((e, t)=>{
                if (this.storyStoreValue) return ae("Accessing the Story Store is deprecated and will be removed in 9.0"), this.storyStoreValue[t];
                throw new Fr();
            }, "get")
        });
    }
    // INITIALIZATION
    async initialize() {
        this.setupListeners();
        try {
            let e = await this.getProjectAnnotationsOrRenderError();
            await this.runBeforeAllHook(e), await this.initializeWithProjectAnnotations(e);
        } catch (e) {
            this.rejectStoreInitializationPromise(e);
        }
    }
    ready() {
        return this.storeInitializationPromise;
    }
    setupListeners() {
        this.channel.on(so, this.onStoryIndexChanged.bind(this)), this.channel.on(fr, this.onUpdateGlobals.bind(this)), this.channel.on(yr, this.onUpdateArgs.bind(this)), this.channel.on(fo, this.onRequestArgTypesInfo.bind(this)), this.channel.on(ur, this.onResetArgs.bind(this)), this.channel.on(dr, this.onForceReRender.bind(this)), this.channel.on(Kt, this.onForceRemount.bind(this));
    }
    async getProjectAnnotationsOrRenderError() {
        try {
            let e = await this.getProjectAnnotations();
            if (this.renderToCanvas = e.renderToCanvas, !this.renderToCanvas) throw new wr();
            return e;
        } catch (e) {
            throw this.renderPreviewEntryError("Error reading preview.js:", e), e;
        }
    }
    // If initialization gets as far as project annotations, this function runs.
    async initializeWithProjectAnnotations(e) {
        this.projectAnnotationsBeforeInitialization = e;
        try {
            let t = await this.getStoryIndexFromServer();
            return this.initializeWithStoryIndex(t);
        } catch (t) {
            throw this.renderPreviewEntryError("Error loading story index:", t), t;
        }
    }
    async runBeforeAllHook(e) {
        try {
            await this.beforeAllCleanup?.(), this.beforeAllCleanup = await e.beforeAll?.();
        } catch (t) {
            throw this.renderPreviewEntryError("Error in beforeAll hook:", t), t;
        }
    }
    async getStoryIndexFromServer() {
        let e = await iu(au);
        if (e.status === 200) return e.json();
        throw new _r({
            text: await e.text()
        });
    }
    // If initialization gets as far as the story index, this function runs.
    initializeWithStoryIndex(e) {
        if (!this.projectAnnotationsBeforeInitialization) throw new Error("Cannot call initializeWithStoryIndex until project annotations resolve");
        this.storyStoreValue = new Le(e, this.importFn, this.projectAnnotationsBeforeInitialization), delete this.projectAnnotationsBeforeInitialization, this.setInitialGlobals(), this.resolveStoreInitializationPromise();
    }
    async setInitialGlobals() {
        this.emitGlobals();
    }
    emitGlobals() {
        if (!this.storyStoreValue) throw new V({
            methodName: "emitGlobals"
        });
        let e = {
            globals: this.storyStoreValue.userGlobals.get() || {},
            globalTypes: this.storyStoreValue.projectAnnotations.globalTypes || {}
        };
        this.channel.emit(ro, e);
    }
    // EVENT HANDLERS
    // This happens when a config file gets reloaded
    async onGetProjectAnnotationsChanged({ getProjectAnnotations: e }) {
        delete this.previewEntryError, this.getProjectAnnotations = e;
        let t = await this.getProjectAnnotationsOrRenderError();
        if (await this.runBeforeAllHook(t), !this.storyStoreValue) {
            await this.initializeWithProjectAnnotations(t);
            return;
        }
        this.storyStoreValue.setProjectAnnotations(t), this.emitGlobals();
    }
    async onStoryIndexChanged() {
        if (delete this.previewEntryError, !(!this.storyStoreValue && !this.projectAnnotationsBeforeInitialization)) try {
            let e = await this.getStoryIndexFromServer();
            if (this.projectAnnotationsBeforeInitialization) {
                this.initializeWithStoryIndex(e);
                return;
            }
            await this.onStoriesChanged({
                storyIndex: e
            });
        } catch (e) {
            throw this.renderPreviewEntryError("Error loading story index:", e), e;
        }
    }
    // This happens when a glob gets HMR-ed
    async onStoriesChanged({ importFn: e, storyIndex: t }) {
        if (!this.storyStoreValue) throw new V({
            methodName: "onStoriesChanged"
        });
        await this.storyStoreValue.onStoriesChanged({
            importFn: e,
            storyIndex: t
        });
    }
    async onUpdateGlobals({ globals: e, currentStory: t }) {
        if (this.storyStoreValue || await this.storeInitializationPromise, !this.storyStoreValue) throw new V({
            methodName: "onUpdateGlobals"
        });
        if (this.storyStoreValue.userGlobals.update(e), t) {
            let { initialGlobals: o, storyGlobals: s, userGlobals: i, globals: a } = this.storyStoreValue.getStoryContext(t);
            this.channel.emit(Ce, {
                initialGlobals: o,
                userGlobals: i,
                storyGlobals: s,
                globals: a
            });
        } else {
            let { initialGlobals: o, globals: s } = this.storyStoreValue.userGlobals;
            this.channel.emit(Ce, {
                initialGlobals: o,
                userGlobals: s,
                storyGlobals: {},
                globals: s
            });
        }
        await Promise.all(this.storyRenders.map((o)=>o.rerender()));
    }
    async onUpdateArgs({ storyId: e, updatedArgs: t }) {
        if (!this.storyStoreValue) throw new V({
            methodName: "onUpdateArgs"
        });
        this.storyStoreValue.args.update(e, t), await Promise.all(this.storyRenders.filter((o)=>o.id === e && !o.renderOptions.forceInitialArgs).map((o)=>// We only run the play function, with in a force remount.
            // But when mount is destructured, the rendering happens inside of the play function.
            o.story && o.story.usesMount ? o.remount() : o.rerender())), this.channel.emit(to, {
            storyId: e,
            args: this.storyStoreValue.args.get(e)
        });
    }
    async onRequestArgTypesInfo({ id: e, payload: t }) {
        try {
            await this.storeInitializationPromise;
            let o = await this.storyStoreValue?.loadStory(t);
            this.channel.emit(nt, {
                id: e,
                success: !0,
                payload: {
                    argTypes: o?.argTypes || {}
                },
                error: null
            });
        } catch (o) {
            this.channel.emit(nt, {
                id: e,
                success: !1,
                error: o?.message
            });
        }
    }
    async onResetArgs({ storyId: e, argNames: t }) {
        if (!this.storyStoreValue) throw new V({
            methodName: "onResetArgs"
        });
        let s = this.storyRenders.find((c)=>c.id === e)?.story || await this.storyStoreValue.loadStory({
            storyId: e
        }), a = (t || [
            .../* @__PURE__ */ new Set([
                ...Object.keys(s.initialArgs),
                ...Object.keys(this.storyStoreValue.args.get(e))
            ])
        ]).reduce((c, l)=>(c[l] = s.initialArgs[l], c), {});
        await this.onUpdateArgs({
            storyId: e,
            updatedArgs: a
        });
    }
    // ForceReRender does not include a story id, so we simply must
    // re-render all stories in case they are relevant
    async onForceReRender() {
        await Promise.all(this.storyRenders.map((e)=>e.rerender()));
    }
    async onForceRemount({ storyId: e }) {
        await Promise.all(this.storyRenders.filter((t)=>t.id === e).map((t)=>t.remount()));
    }
    // Used by docs to render a story to a given element
    // Note this short-circuits the `prepare()` phase of the StoryRender,
    // main to be consistent with the previous behaviour. In the future,
    // we will change it to go ahead and load the story, which will end up being
    // "instant", although async.
    renderStoryToElement(e, t, o, s) {
        if (!this.renderToCanvas || !this.storyStoreValue) throw new V({
            methodName: "renderStoryToElement"
        });
        let i = new je(this.channel, this.storyStoreValue, this.renderToCanvas, o, e.id, "docs", s, e);
        return i.renderToElement(t), this.storyRenders.push(i), async ()=>{
            await this.teardownRender(i);
        };
    }
    async teardownRender(e, { viewModeChanged: t } = {}) {
        this.storyRenders = this.storyRenders.filter((o)=>o !== e), await e?.teardown?.({
            viewModeChanged: t
        });
    }
    // API
    async loadStory({ storyId: e }) {
        if (!this.storyStoreValue) throw new V({
            methodName: "loadStory"
        });
        return this.storyStoreValue.loadStory({
            storyId: e
        });
    }
    getStoryContext(e, { forceInitialArgs: t = !1 } = {}) {
        if (!this.storyStoreValue) throw new V({
            methodName: "getStoryContext"
        });
        return this.storyStoreValue.getStoryContext(e, {
            forceInitialArgs: t
        });
    }
    async extract(e) {
        if (!this.storyStoreValue) throw new V({
            methodName: "extract"
        });
        if (this.previewEntryError) throw this.previewEntryError;
        return await this.storyStoreValue.cacheAllCSFFiles(), this.storyStoreValue.extract(e);
    }
    // UTILITIES
    renderPreviewEntryError(e, t) {
        this.previewEntryError = t, I.error(e), I.error(t), this.channel.emit($t, t);
    }
};
n(Nn, "Preview");
var Me = Nn;
// src/preview-api/modules/preview-web/docs-context/DocsContext.ts
var kn = class kn {
    constructor(e, t, o, s){
        this.channel = e;
        this.store = t;
        this.renderStoryToElement = o;
        this.storyIdByName = /* @__PURE__ */ n((e)=>{
            let t = this.nameToStoryId.get(e);
            if (t) return t;
            throw new Error(`No story found with that name: ${e}`);
        }, "storyIdByName");
        this.componentStories = /* @__PURE__ */ n(()=>this.componentStoriesValue, "componentStories");
        this.componentStoriesFromCSFFile = /* @__PURE__ */ n((e)=>this.store.componentStoriesFromCSFFile({
                csfFile: e
            }), "componentStoriesFro\
mCSFFile");
        this.storyById = /* @__PURE__ */ n((e)=>{
            if (!e) {
                if (!this.primaryStory) throw new Error("No primary story defined for docs entry. Did you forget to use `<Meta>`?");
                return this.primaryStory;
            }
            let t = this.storyIdToCSFFile.get(e);
            if (!t) throw new Error(`Called \`storyById\` for story that was never loaded: ${e}`);
            return this.store.storyFromCSFFile({
                storyId: e,
                csfFile: t
            });
        }, "storyById");
        this.getStoryContext = /* @__PURE__ */ n((e)=>({
                ...this.store.getStoryContext(e),
                loaded: {},
                viewMode: "docs"
            }), "getStoryContext");
        this.loadStory = /* @__PURE__ */ n((e)=>this.store.loadStory({
                storyId: e
            }), "loadStory");
        this.componentStoriesValue = [], this.storyIdToCSFFile = /* @__PURE__ */ new Map(), this.exportToStory = /* @__PURE__ */ new Map(), this.exportsToCSFFile = /* @__PURE__ */ new Map(), this.nameToStoryId = /* @__PURE__ */ new Map(), this.attachedCSFFiles = /* @__PURE__ */ new Set(), s.forEach((i, a)=>{
            this.referenceCSFFile(i);
        });
    }
    // This docs entry references this CSF file and can synchronously load the stories, as well
    // as reference them by module export. If the CSF is part of the "component" stories, they
    // can also be referenced by name and are in the componentStories list.
    referenceCSFFile(e) {
        this.exportsToCSFFile.set(e.moduleExports, e), this.exportsToCSFFile.set(e.moduleExports.default, e), this.store.componentStoriesFromCSFFile({
            csfFile: e
        }).forEach((o)=>{
            let s = e.stories[o.id];
            this.storyIdToCSFFile.set(s.id, e), this.exportToStory.set(s.moduleExport, o);
        });
    }
    attachCSFFile(e) {
        if (!this.exportsToCSFFile.has(e.moduleExports)) throw new Error("Cannot attach a CSF file that has not been referenced");
        if (this.attachedCSFFiles.has(e)) return;
        this.attachedCSFFiles.add(e), this.store.componentStoriesFromCSFFile({
            csfFile: e
        }).forEach((o)=>{
            this.nameToStoryId.set(o.name, o.id), this.componentStoriesValue.push(o), this.primaryStory || (this.primaryStory = o);
        });
    }
    referenceMeta(e, t) {
        let o = this.resolveModuleExport(e);
        if (o.type !== "meta") throw new Error("<Meta of={} /> must reference a CSF file module export or meta export. Did you mistakenly reference your component instead of your \
CSF file?");
        t && this.attachCSFFile(o.csfFile);
    }
    get projectAnnotations() {
        let { projectAnnotations: e } = this.store;
        if (!e) throw new Error("Can't get projectAnnotations from DocsContext before they are initialized");
        return e;
    }
    resolveAttachedModuleExportType(e) {
        if (e === "story") {
            if (!this.primaryStory) throw new Error("No primary story attached to this docs file, did you forget to use <Meta of={} />?");
            return {
                type: "story",
                story: this.primaryStory
            };
        }
        if (this.attachedCSFFiles.size === 0) throw new Error("No CSF file attached to this docs file, did you forget to use <Meta of={} />?");
        let t = Array.from(this.attachedCSFFiles)[0];
        if (e === "meta") return {
            type: "meta",
            csfFile: t
        };
        let { component: o } = t.meta;
        if (!o) throw new Error("Attached CSF file does not defined a component, did you forget to export one?");
        return {
            type: "component",
            component: o
        };
    }
    resolveModuleExport(e) {
        let t = this.exportsToCSFFile.get(e);
        if (t) return {
            type: "meta",
            csfFile: t
        };
        let o = this.exportToStory.get(nr(e) ? e.input : e);
        return o ? {
            type: "story",
            story: o
        } : {
            type: "component",
            component: e
        };
    }
    resolveOf(e, t = []) {
        let o;
        if ([
            "component",
            "meta",
            "story"
        ].includes(e)) {
            let s = e;
            o = this.resolveAttachedModuleExportType(s);
        } else o = this.resolveModuleExport(e);
        if (t.length && !t.includes(o.type)) {
            let s = o.type === "component" ? "component or unknown" : o.type;
            throw new Error(_`Invalid value passed to the 'of' prop. The value was resolved to a '${s}' type but the only types for this block are: ${t.join(", ")}.
        - Did you pass a component to the 'of' prop when the block only supports a story or a meta?
        - ... or vice versa?
        - Did you pass a story, CSF file or meta to the 'of' prop that is not indexed, ie. is not targeted by the 'stories' globs in the main configuration?`);
        }
        switch(o.type){
            case "component":
                return {
                    ...o,
                    projectAnnotations: this.projectAnnotations
                };
            case "meta":
                return {
                    ...o,
                    preparedMeta: this.store.preparedMetaFromCSFFile({
                        csfFile: o.csfFile
                    })
                };
            case "story":
            default:
                return o;
        }
    }
};
n(kn, "DocsContext");
var me = kn;
// src/preview-api/modules/preview-web/render/CsfDocsRender.ts
var Ln = class Ln {
    constructor(e, t, o, s){
        this.channel = e;
        this.store = t;
        this.entry = o;
        this.callbacks = s;
        this.type = "docs";
        this.subtype = "csf";
        this.torndown = !1;
        this.disableKeyListeners = !1;
        this.preparing = !1;
        this.id = o.id;
    }
    isPreparing() {
        return this.preparing;
    }
    async prepare() {
        this.preparing = !0;
        let { entryExports: e, csfFiles: t = [] } = await this.store.loadEntry(this.id);
        if (this.torndown) throw Ae;
        let { importPath: o, title: s } = this.entry, i = this.store.processCSFFileWithCache(e, o, s), a = Object.keys(i.stories)[0];
        this.story = this.store.storyFromCSFFile({
            storyId: a,
            csfFile: i
        }), this.csfFiles = [
            i,
            ...t
        ], this.preparing = !1;
    }
    isEqual(e) {
        return !!(this.id === e.id && this.story && this.story === e.story);
    }
    docsContext(e) {
        if (!this.csfFiles) throw new Error("Cannot render docs before preparing");
        let t = new me(this.channel, this.store, e, this.csfFiles);
        return this.csfFiles.forEach((o)=>t.attachCSFFile(o)), t;
    }
    async renderToElement(e, t) {
        if (!this.story || !this.csfFiles) throw new Error("Cannot render docs before preparing");
        let o = this.docsContext(t), { docs: s } = this.story.parameters || {};
        if (!s) throw new Error("Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed");
        let i = await s.renderer(), { render: a } = i, c = /* @__PURE__ */ n(async ()=>{
            try {
                await a(o, s, e), this.channel.emit(pr, this.id);
            } catch (l) {
                this.callbacks.showException(l);
            }
        }, "renderDocs");
        return this.rerender = async ()=>c(), this.teardownRender = async ({ viewModeChanged: l })=>{
            !l || !e || i.unmount(e);
        }, c();
    }
    async teardown({ viewModeChanged: e } = {}) {
        this.teardownRender?.({
            viewModeChanged: e
        }), this.torndown = !0;
    }
};
n(Ln, "CsfDocsRender");
var qr = Ln;
// src/preview-api/modules/preview-web/render/MdxDocsRender.ts
var jn = class jn {
    constructor(e, t, o, s){
        this.channel = e;
        this.store = t;
        this.entry = o;
        this.callbacks = s;
        this.type = "docs";
        this.subtype = "mdx";
        this.torndown = !1;
        this.disableKeyListeners = !1;
        this.preparing = !1;
        this.id = o.id;
    }
    isPreparing() {
        return this.preparing;
    }
    async prepare() {
        this.preparing = !0;
        let { entryExports: e, csfFiles: t = [] } = await this.store.loadEntry(this.id);
        if (this.torndown) throw Ae;
        this.csfFiles = t, this.exports = e, this.preparing = !1;
    }
    isEqual(e) {
        return !!(this.id === e.id && this.exports && this.exports === e.exports);
    }
    docsContext(e) {
        if (!this.csfFiles) throw new Error("Cannot render docs before preparing");
        return new me(this.channel, this.store, e, this.csfFiles);
    }
    async renderToElement(e, t) {
        if (!this.exports || !this.csfFiles || !this.store.projectAnnotations) throw new Error("Cannot render docs before preparing");
        let o = this.docsContext(t), { docs: s } = this.store.projectAnnotations.parameters || {};
        if (!s) throw new Error("Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed");
        let i = {
            ...s,
            page: this.exports.default
        }, a = await s.renderer(), { render: c } = a, l = /* @__PURE__ */ n(async ()=>{
            try {
                await c(o, i, e), this.channel.emit(pr, this.id);
            } catch (p) {
                this.callbacks.showException(p);
            }
        }, "renderDocs");
        return this.rerender = async ()=>l(), this.teardownRender = async ({ viewModeChanged: p } = {})=>{
            !p || !e || (a.unmount(e), this.torndown = !0);
        }, l();
    }
    async teardown({ viewModeChanged: e } = {}) {
        this.teardownRender?.({
            viewModeChanged: e
        }), this.torndown = !0;
    }
};
n(jn, "MdxDocsRender");
var Br = jn;
// src/preview-api/modules/preview-web/PreviewWithSelection.tsx
var lu = globalThis;
function cu(r) {
    let e = r.composedPath && r.composedPath()[0] || r.target;
    return /input|textarea/i.test(e.tagName) || e.getAttribute("contenteditable") !== null;
}
n(cu, "focusInInput");
var Qi = "attached-mdx", pu = "unattached-mdx";
function du({ tags: r }) {
    return r?.includes(pu) || r?.includes(Qi);
}
n(du, "isMdxEntry");
function Mn(r) {
    return r.type === "story";
}
n(Mn, "isStoryRender");
function uu(r) {
    return r.type === "docs";
}
n(uu, "isDocsRender");
function fu(r) {
    return uu(r) && r.subtype === "csf";
}
n(fu, "isCsfDocsRender");
var Un = class Un extends Me {
    constructor(t, o, s, i){
        super(t, o, void 0, !1);
        this.importFn = t;
        this.getProjectAnnotations = o;
        this.selectionStore = s;
        this.view = i;
        this.initialize();
    }
    setupListeners() {
        super.setupListeners(), lu.onkeydown = this.onKeydown.bind(this), this.channel.on(eo, this.onSetCurrentStory.bind(this)), this.channel.on(po, this.onUpdateQueryParams.bind(this)), this.channel.on(Qt, this.onPreloadStories.bind(this));
    }
    async setInitialGlobals() {
        if (!this.storyStoreValue) throw new V({
            methodName: "setInitialGlobals"
        });
        let { globals: t } = this.selectionStore.selectionSpecifier || {};
        t && this.storyStoreValue.userGlobals.updateFromPersisted(t), this.emitGlobals();
    }
    // If initialization gets as far as the story index, this function runs.
    async initializeWithStoryIndex(t) {
        return await super.initializeWithStoryIndex(t), this.selectSpecifiedStory();
    }
    // Use the selection specifier to choose a story, then render it
    async selectSpecifiedStory() {
        if (!this.storyStoreValue) throw new V({
            methodName: "selectSpecifiedStory"
        });
        if (this.selectionStore.selection) {
            await this.renderSelection();
            return;
        }
        if (!this.selectionStore.selectionSpecifier) {
            this.renderMissingStory();
            return;
        }
        let { storySpecifier: t, args: o } = this.selectionStore.selectionSpecifier, s = this.storyStoreValue.storyIndex.entryFromSpecifier(t);
        if (!s) {
            t === "*" ? this.renderStoryLoadingException(t, new Pr()) : this.renderStoryLoadingException(t, new Or({
                storySpecifier: t.toString()
            }));
            return;
        }
        let { id: i, type: a } = s;
        this.selectionStore.setSelection({
            storyId: i,
            viewMode: a
        }), this.channel.emit(ao, this.selectionStore.selection), this.channel.emit(rt, this.selectionStore.selection), await this.renderSelection({
            persistedArgs: o
        });
    }
    // EVENT HANDLERS
    // This happens when a config file gets reloaded
    async onGetProjectAnnotationsChanged({ getProjectAnnotations: t }) {
        await super.onGetProjectAnnotationsChanged({
            getProjectAnnotations: t
        }), this.selectionStore.selection && this.renderSelection();
    }
    // This happens when a glob gets HMR-ed
    async onStoriesChanged({ importFn: t, storyIndex: o }) {
        await super.onStoriesChanged({
            importFn: t,
            storyIndex: o
        }), this.selectionStore.selection ? await this.renderSelection() : await this.selectSpecifiedStory();
    }
    onKeydown(t) {
        if (!this.storyRenders.find((o)=>o.disableKeyListeners) && !cu(t)) {
            let { altKey: o, ctrlKey: s, metaKey: i, shiftKey: a, key: c, code: l, keyCode: p } = t;
            this.channel.emit(Zt, {
                event: {
                    altKey: o,
                    ctrlKey: s,
                    metaKey: i,
                    shiftKey: a,
                    key: c,
                    code: l,
                    keyCode: p
                }
            });
        }
    }
    async onSetCurrentStory(t) {
        this.selectionStore.setSelection({
            viewMode: "story",
            ...t
        }), await this.storeInitializationPromise, this.channel.emit(rt, this.selectionStore.selection), this.renderSelection();
    }
    onUpdateQueryParams(t) {
        this.selectionStore.setQueryParams(t);
    }
    async onUpdateGlobals({ globals: t }) {
        let o = this.currentRender instanceof je && this.currentRender.story || void 0;
        super.onUpdateGlobals({
            globals: t,
            currentStory: o
        }), (this.currentRender instanceof Br || this.currentRender instanceof qr) && await this.currentRender.rerender?.();
    }
    async onUpdateArgs({ storyId: t, updatedArgs: o }) {
        super.onUpdateArgs({
            storyId: t,
            updatedArgs: o
        });
    }
    async onPreloadStories({ ids: t }) {
        await this.storeInitializationPromise, this.storyStoreValue && await Promise.allSettled(t.map((o)=>this.storyStoreValue?.loadEntry(o)));
    }
    // RENDERING
    // We can either have:
    // - a story selected in "story" viewMode,
    //     in which case we render it to the root element, OR
    // - a story selected in "docs" viewMode,
    //     in which case we render the docsPage for that story
    async renderSelection({ persistedArgs: t } = {}) {
        let { renderToCanvas: o } = this;
        if (!this.storyStoreValue || !o) throw new V({
            methodName: "renderSelection"
        });
        let { selection: s } = this.selectionStore;
        if (!s) throw new Error("Cannot call renderSelection as no selection was made");
        let { storyId: i } = s, a;
        try {
            a = await this.storyStoreValue.storyIdToEntry(i);
        } catch (S) {
            this.currentRender && await this.teardownRender(this.currentRender), this.renderStoryLoadingException(i, S);
            return;
        }
        let c = this.currentSelection?.storyId !== i, l = this.currentRender?.type !== a.type;
        a.type === "story" ? this.view.showPreparingStory({
            immediate: l
        }) : this.view.showPreparingDocs({
            immediate: l
        }), this.currentRender?.isPreparing() && await this.teardownRender(this.currentRender);
        let p;
        a.type === "story" ? p = new je(this.channel, this.storyStoreValue, o, this.mainStoryCallbacks(i), i, "story") : du(a) ? p = new Br(this.channel, this.storyStoreValue, a, this.mainStoryCallbacks(i)) : p = new qr(this.channel, this.storyStoreValue, a, this.mainStoryCallbacks(i));
        let u = this.currentSelection;
        this.currentSelection = s;
        let d = this.currentRender;
        this.currentRender = p;
        try {
            await p.prepare();
        } catch (S) {
            d && await this.teardownRender(d), S !== Ae && this.renderStoryLoadingException(i, S);
            return;
        }
        let h = !c && d && !p.isEqual(d);
        if (t && Mn(p) && (fe(!!p.story), this.storyStoreValue.args.updateFromPersisted(p.story, t)), d && !d.torndown && !c && !h && !l) {
            this.currentRender = d, this.channel.emit(co, i), this.view.showMain();
            return;
        }
        if (d && await this.teardownRender(d, {
            viewModeChanged: l
        }), u && (c || l) && this.channel.emit(oo, i), Mn(p)) {
            fe(!!p.story);
            let { parameters: S, initialArgs: m, argTypes: T, unmappedArgs: y, initialGlobals: R, userGlobals: x, storyGlobals: g, globals: b } = this.storyStoreValue.getStoryContext(p.story);
            this.channel.emit(io, {
                id: i,
                parameters: S,
                initialArgs: m,
                argTypes: T,
                args: y
            }), this.channel.emit(Ce, {
                userGlobals: x,
                storyGlobals: g,
                globals: b,
                initialGlobals: R
            });
        } else {
            let { parameters: S } = this.storyStoreValue.projectAnnotations, { initialGlobals: m, globals: T } = this.storyStoreValue.userGlobals;
            if (this.channel.emit(Ce, {
                globals: T,
                initialGlobals: m,
                storyGlobals: {},
                userGlobals: T
            }), fu(p) || p.entry.tags?.includes(Qi)) {
                if (!p.csfFiles) throw new Cr({
                    storyId: i
                });
                ({ parameters: S } = this.storyStoreValue.preparedMetaFromCSFFile({
                    csfFile: p.csfFiles[0]
                }));
            }
            this.channel.emit(Yt, {
                id: i,
                parameters: S
            });
        }
        Mn(p) ? (fe(!!p.story), this.storyRenders.push(p), this.currentRender.renderToElement(this.view.prepareForStory(p.story))) : this.currentRender.renderToElement(this.view.prepareForDocs(), // This argument is used for docs, which is currently only compatible with HTMLElements
        this.renderStoryToElement.bind(this));
    }
    async teardownRender(t, { viewModeChanged: o = !1 } = {}) {
        this.storyRenders = this.storyRenders.filter((s)=>s !== t), await t?.teardown?.({
            viewModeChanged: o
        });
    }
    // UTILITIES
    mainStoryCallbacks(t) {
        return {
            showStoryDuringRender: /* @__PURE__ */ n(()=>this.view.showStoryDuringRender(), "showStoryDuringRender"),
            showMain: /* @__PURE__ */ n(()=>this.view.showMain(), "showMain"),
            showError: /* @__PURE__ */ n((o)=>this.renderError(t, o), "showError"),
            showException: /* @__PURE__ */ n((o)=>this.renderException(t, o), "showException")
        };
    }
    renderPreviewEntryError(t, o) {
        super.renderPreviewEntryError(t, o), this.view.showErrorDisplay(o);
    }
    renderMissingStory() {
        this.view.showNoPreview(), this.channel.emit(tt);
    }
    renderStoryLoadingException(t, o) {
        I.error(o), this.view.showErrorDisplay(o), this.channel.emit(tt, t);
    }
    // renderException is used if we fail to render the story and it is uncaught by the app layer
    renderException(t, o) {
        let { name: s = "Error", message: i = String(o), stack: a } = o;
        this.channel.emit(lo, {
            name: s,
            message: i,
            stack: a
        }), this.channel.emit(Pe, {
            newPhase: "errored",
            storyId: t
        }), this.view.showErrorDisplay(o), I.error(`Error rendering story '${t}':`), I.error(o);
    }
    // renderError is used by the various app layers to inform the user they have done something
    // wrong -- for instance returned the wrong thing from a story
    renderError(t, { title: o, description: s }) {
        I.error(`Error rendering story ${o}: ${s}`), this.channel.emit(no, {
            title: o,
            description: s
        }), this.channel.emit(Pe, {
            newPhase: "err\
ored",
            storyId: t
        }), this.view.showErrorDisplay({
            message: o,
            stack: s
        });
    }
};
n(Un, "PreviewWithSelection");
var Ue = Un;
// src/preview-api/modules/preview-web/UrlStore.ts
var Hr = ue(kt(), 1);
// src/preview-api/modules/preview-web/parseArgsParam.ts
var da = ue(kt(), 1);
var pa = /^[a-zA-Z0-9 _-]*$/, ua = /^-?[0-9]+(\.[0-9]+)?$/, Uu = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i, fa = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i, Wn = /* @__PURE__ */ n((r = "", e)=>r === null || r === "" || !pa.test(r) ? !1 : e == null || e instanceof Date || typeof e == "number" || typeof e == "boolean" ? !0 : typeof e == "string" ? pa.test(e) || ua.test(e) || Uu.test(e) || fa.test(e) : Array.isArray(e) ? e.every((t)=>Wn(r, t)) : $(e) ? Object.entries(e).every(([t, o])=>Wn(t, o)) : !1, "validateArgs"), Gu = {
    delimiter: ";",
    // we're parsing a single query param
    nesting: !0,
    arrayRepeat: !0,
    arrayRepeatSyntax: "bracket",
    nestingSyntax: "js",
    // objects are encoded using dot notation
    valueDeserializer (r) {
        if (r.startsWith("!")) {
            if (r === "!undefined") return;
            if (r === "!null") return null;
            if (r === "!true") return !0;
            if (r === "!false") return !1;
            if (r.startsWith("!date(") && r.endsWith(")")) return new Date(r.replaceAll(" ", "+").slice(6, -1));
            if (r.startsWith("!hex(") && r.endsWith(")")) return `#${r.slice(5, -1)}`;
            let e = r.slice(1).match(fa);
            if (e) return r.startsWith("!rgba") || r.startsWith("!RGBA") ? `${e[1]}(${e[2]}, ${e[3]}, ${e[4]}, ${e[5]})` : r.startsWith("!hsla") || r.startsWith("!HSLA") ? `${e[1]}(${e[2]}, ${e[3]}%, ${e[4]}%, ${e[5]})` : r.startsWith("!rgb") || r.startsWith("!RGB") ? `${e[1]}(${e[2]}, ${e[3]}\
, ${e[4]})` : `${e[1]}(${e[2]}, ${e[3]}%, ${e[4]}%)`;
        }
        return ua.test(r) ? Number(r) : r;
    }
}, $n = /* @__PURE__ */ n((r)=>{
    let e = r.split(";").map((t)=>t.replace("=", "~").replace(":", "="));
    return Object.entries((0, da.parse)(e.join(";"), Gu)).reduce((t, [o, s])=>Wn(o, s) ? Object.assign(t, {
            [o]: s
        }) : (j.warn(_`
      Omitted potentially unsafe URL args.

      More info: https://storybook.js.org/docs/writing-stories/args#setting-args-through-the-url
    `), t), {});
}, "parseArgsParam");
// src/preview-api/modules/preview-web/UrlStore.ts
var { history: ya, document: xe } = E;
function qu(r) {
    let e = (r || "").match(/^\/story\/(.+)/);
    if (!e) throw new Error(`Invalid path '${r}',  must start with '/story/'`);
    return e[1];
}
n(qu, "pathToId");
var ma = /* @__PURE__ */ n(({ selection: r, extraParams: e })=>{
    let t = xe?.location.search.slice(1), { path: o, selectedKind: s, selectedStory: i, ...a } = (0, Hr.parse)(t);
    return `?${(0, Hr.stringify)({
        ...a,
        ...e,
        ...r && {
            id: r.storyId,
            viewMode: r.viewMode
        }
    })}`;
}, "getQueryString"), Bu = /* @__PURE__ */ n((r)=>{
    if (!r) return;
    let e = ma({
        selection: r
    }), { hash: t = "" } = xe.location;
    xe.title = r.storyId, ya.replaceState({}, "", `${xe.location.pathname}${e}${t}`);
}, "setPath"), Vu = /* @__PURE__ */ n((r)=>r != null && typeof r == "object" && Array.isArray(r) === !1, "isObject"), Vr = /* @__PURE__ */ n((r)=>{
    if (r !== void 0) {
        if (typeof r == "string") return r;
        if (Array.isArray(r)) return Vr(r[0]);
        if (Vu(r)) return Vr(Object.values(r).filter(Boolean));
    }
}, "getFirstString"), Hu = /* @__PURE__ */ n(()=>{
    if (typeof xe < "u") {
        let r = xe.location.search.slice(1), e = (0, Hr.parse)(r), t = typeof e.args == "string" ? $n(e.args) : void 0, o = typeof e.globals == "\
string" ? $n(e.globals) : void 0, s = Vr(e.viewMode);
        (typeof s != "string" || !s.match(/docs|story/)) && (s = "story");
        let i = Vr(e.path), a = i ? qu(i) : Vr(e.id);
        if (a) return {
            storySpecifier: a,
            args: t,
            globals: o,
            viewMode: s
        };
    }
    return null;
}, "getSelectionSpecifierFromPath"), Yn = class Yn {
    constructor(){
        this.selectionSpecifier = Hu();
    }
    setSelection(e) {
        this.selection = e, Bu(this.selection);
    }
    setQueryParams(e) {
        let t = ma({
            extraParams: e
        }), { hash: o = "" } = xe.location;
        ya.replaceState({}, "", `${xe.location.pathname}${t}${o}`);
    }
};
n(Yn, "UrlStore");
var Be = Yn;
// src/preview-api/modules/preview-web/WebView.ts
var $a = ue(Ha(), 1), Ya = ue(kt(), 1);
var { document: z } = E, za = 100, Ka = /* @__PURE__ */ ((i)=>(i.MAIN = "MAIN", i.NOPREVIEW = "NOPREVIEW", i.PREPARING_STORY = "PREPARING_\
STORY", i.PREPARING_DOCS = "PREPARING_DOCS", i.ERROR = "ERROR", i))(Ka || {}), rs = {
    PREPARING_STORY: "sb-show-preparing-story",
    PREPARING_DOCS: "sb-show-preparing-docs",
    MAIN: "sb-show-main",
    NOPREVIEW: "sb-show-nopreview",
    ERROR: "sb-show-errordisplay"
}, ts = {
    centered: "sb-main-centered",
    fullscreen: "sb-main-fullscreen",
    padded: "sb-main-padded"
}, Wa = new $a.default({
    escapeXML: !0
}), os = class os {
    constructor(){
        this.testing = !1;
        if (typeof z < "u") {
            let { __SPECIAL_TEST_PARAMETER__: e } = (0, Ya.parse)(z.location.search.slice(1));
            switch(e){
                case "preparing-story":
                    this.showPreparingStory(), this.testing = !0;
                    break;
                case "preparing-docs":
                    this.showPreparingDocs(), this.testing = !0;
                    break;
                default:
            }
        }
    }
    // Get ready to render a story, returning the element to render to
    prepareForStory(e) {
        return this.showStory(), this.applyLayout(e.parameters.layout), z.documentElement.scrollTop = 0, z.documentElement.scrollLeft = 0, this.storyRoot();
    }
    storyRoot() {
        return z.getElementById("storybook-root");
    }
    prepareForDocs() {
        return this.showMain(), this.showDocs(), this.applyLayout("fullscreen"), z.documentElement.scrollTop = 0, z.documentElement.scrollLeft = 0, this.docsRoot();
    }
    docsRoot() {
        return z.getElementById("storybook-docs");
    }
    applyLayout(e = "padded") {
        if (e === "none") {
            z.body.classList.remove(this.currentLayoutClass), this.currentLayoutClass = null;
            return;
        }
        this.checkIfLayoutExists(e);
        let t = ts[e];
        z.body.classList.remove(this.currentLayoutClass), z.body.classList.add(t), this.currentLayoutClass = t;
    }
    checkIfLayoutExists(e) {
        ts[e] || I.warn(_`
          The desired layout: ${e} is not a valid option.
          The possible options are: ${Object.keys(ts).join(", ")}, none.
        `);
    }
    showMode(e) {
        clearTimeout(this.preparingTimeout), Object.keys(Ka).forEach((t)=>{
            t === e ? z.body.classList.add(rs[t]) : z.body.classList.remove(rs[t]);
        });
    }
    showErrorDisplay({ message: e = "", stack: t = "" }) {
        let o = e, s = t, i = e.split(`
`);
        i.length > 1 && ([o] = i, s = i.slice(1).join(`
`).replace(/^\n/, "")), z.getElementById("error-message").innerHTML = Wa.toHtml(o), z.getElementById("error-stack").innerHTML = Wa.toHtml(s), this.showMode("ERROR");
    }
    showNoPreview() {
        this.testing || (this.showMode("NOPREVIEW"), this.storyRoot()?.setAttribute("hidden", "true"), this.docsRoot()?.setAttribute("hidden", "\
true"));
    }
    showPreparingStory({ immediate: e = !1 } = {}) {
        clearTimeout(this.preparingTimeout), e ? this.showMode("PREPARING_STORY") : this.preparingTimeout = setTimeout(()=>this.showMode("PREPARING_STORY"), za);
    }
    showPreparingDocs({ immediate: e = !1 } = {}) {
        clearTimeout(this.preparingTimeout), e ? this.showMode("PREPARING_DOCS") : this.preparingTimeout = setTimeout(()=>this.showMode("PREPA\
RING_DOCS"), za);
    }
    showMain() {
        this.showMode("MAIN");
    }
    showDocs() {
        this.storyRoot().setAttribute("hidden", "true"), this.docsRoot().removeAttribute("hidden");
    }
    showStory() {
        this.docsRoot().setAttribute("hidden", "true"), this.storyRoot().removeAttribute("hidden");
    }
    showStoryDuringRender() {
        z.body.classList.add(rs.MAIN);
    }
};
n(os, "WebView");
var He = os;
// src/preview-api/modules/preview-web/PreviewWeb.tsx
var ns = class ns extends Ue {
    constructor(t, o){
        super(t, o, new Be(), new He());
        this.importFn = t;
        this.getProjectAnnotations = o;
        E.__STORYBOOK_PREVIEW__ = this;
    }
};
n(ns, "PreviewWeb");
var Wr = ns;
// src/preview-api/modules/preview-web/simulate-pageload.ts
var { document: ze } = E, wf = [
    "application/javascript",
    "application/ecmascript",
    "application/x-ecmascript",
    "application/x-javascript",
    "text/ecmascript",
    "text/javascript",
    "text/javascript1.0",
    "text/javascript1.1",
    "text/javascript1.2",
    "text/javascript1.3",
    "text/javascript1.4",
    "text/javascript1.5",
    "text/jscript",
    "text/livescript",
    "text/x-ecmascript",
    "text/x-javascript",
    // Support modern javascript
    "module"
], _f = "script", Xa = "scripts-root";
function $r() {
    let r = ze.createEvent("Event");
    r.initEvent("DOMContentLoaded", !0, !0), ze.dispatchEvent(r);
}
n($r, "simulateDOMContentLoaded");
function Cf(r, e, t) {
    let o = ze.createElement("script");
    o.type = r.type === "module" ? "module" : "text/javascript", r.src ? (o.onload = e, o.onerror = e, o.src = r.src) : o.textContent = r.innerText, t ? t.appendChild(o) : ze.head.appendChild(o), r.parentNode.removeChild(r), r.src || e();
}
n(Cf, "insertScript");
function Ja(r, e, t = 0) {
    r[t](()=>{
        t++, t === r.length ? e() : Ja(r, e, t);
    });
}
n(Ja, "insertScriptsSequentially");
function ss(r) {
    let e = ze.getElementById(Xa);
    e ? e.innerHTML = "" : (e = ze.createElement("div"), e.id = Xa, ze.body.appendChild(e));
    let t = Array.from(r.querySelectorAll(_f));
    if (t.length) {
        let o = [];
        t.forEach((s)=>{
            let i = s.getAttribute("type");
            (!i || wf.includes(i)) && o.push((a)=>Cf(s, a, e));
        }), o.length && Ja(o, $r, void 0);
    } else $r();
}
n(ss, "simulatePageLoad");
// src/preview/globals/runtime.ts
var Qa = {
    "@storybook/global": Ht,
    "storybook/internal/channels": br,
    "@storybook/channels": br,
    "@storybook/core/channels": br,
    "storybook/internal/client-logger": mr,
    "@storybook/client-logger": mr,
    "@storybook/core/client-logger": mr,
    "storybook/internal/core-events": ge,
    "@storybook/core-events": ge,
    "@storybook/core/core-events": ge,
    "storybook/internal/preview-errors": kr,
    "@storybook/core-events/preview-errors": kr,
    "@storybook/core/preview-errors": kr,
    "storybook/internal/preview-api": Yr,
    "@storybook/preview-api": Yr,
    "@storybook/core/preview-api": Yr,
    "storybook/internal/types": Tr,
    "@storybook/types": Tr,
    "@storybook/core/types": Tr
};
// src/preview/utils.ts
var el = ue(Za(), 1);
var ls;
function Pf() {
    return ls || (ls = new el.default(E.navigator?.userAgent).getBrowserInfo()), ls;
}
n(Pf, "getBrowserInfo");
function rl(r) {
    return r.browserInfo = Pf(), r;
}
n(rl, "prepareForTelemetry");
// src/preview/runtime.ts
function Of(r) {
    let e = r.error || r;
    e.fromStorybook && E.sendTelemetryError(e);
}
n(Of, "errorListener");
function If({ reason: r }) {
    r.fromStorybook && E.sendTelemetryError(r);
}
n(If, "unhandledRejectionListener");
function Ff() {
    cs.forEach((r)=>{
        E[yo[r]] = Qa[r];
    }), E.sendTelemetryError = (r)=>{
        E.__STORYBOOK_ADDONS_CHANNEL__.emit(uo, rl(r));
    }, E.addEventListener("error", Of), E.addEventListener("unhandledrejection", If);
}
n(Ff, "setup");
Ff();

},{"8fb47097d7775935":"2zU6h","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"2zU6h":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"bElly","aceacb6a4531a9d2":"lgPZv"}],"bElly":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"lgPZv":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"9qIL3":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"fugct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channels = require("@storybook/core/channels");
parcelHelpers.exportAll(_channels, exports);

},{"@storybook/core/channels":"9x1cJ","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"9x1cJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Channel", ()=>B);
parcelHelpers.export(exports, "HEARTBEAT_INTERVAL", ()=>Zt);
parcelHelpers.export(exports, "HEARTBEAT_MAX_LATENCY", ()=>te);
parcelHelpers.export(exports, "PostMessageTransport", ()=>Y);
parcelHelpers.export(exports, "WebsocketTransport", ()=>X);
parcelHelpers.export(exports, "createBrowserChannel", ()=>Qo);
parcelHelpers.export(exports, "default", ()=>Xo);
// src/channels/postmessage/index.ts
var _clientLogger = require("@storybook/core/client-logger");
var _coreEvents = require("@storybook/core/core-events");
var global = arguments[3];
var ae = Object.create;
var ut = Object.defineProperty;
var se = Object.getOwnPropertyDescriptor;
var le = Object.getOwnPropertyNames;
var ce = Object.getPrototypeOf, pe = Object.prototype.hasOwnProperty;
var a = (r, t)=>ut(r, "name", {
        value: t,
        configurable: !0
    }), H = /* @__PURE__ */ ((r)=>undefined)(function(r) {
    return undefined(this, arguments);
});
var ue = (r, t)=>()=>(t || r((t = {
            exports: {}
        }).exports, t), t.exports);
var fe = (r, t, e, n)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let o of le(t))!pe.call(r, o) && o !== e && ut(r, o, {
        get: ()=>t[o],
        enumerable: !(n = se(t, o)) || n.enumerable
    });
    return r;
};
var he = (r, t, e)=>(e = r != null ? ae(ce(r)) : {}, fe(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    t || !r || !r.__esModule ? ut(e, "default", {
        value: r,
        enumerable: !0
    }) : e, r));
// ../node_modules/memoizerific/memoizerific.js
var xt = ue((It, yt)=>{
    (function(r) {
        if (typeof It == "object" && typeof yt < "u") yt.exports = r();
        else if (typeof define == "function" && define.amd) define([], r);
        else {
            var t;
            typeof window < "u" ? t = window : typeof global < "u" ? t = global : typeof self < "u" ? t = self : t = this, t.memoizerific = r();
        }
    })(function() {
        var r, t, e;
        return /* @__PURE__ */ a(function n(o, s, l) {
            function c(p, u) {
                if (!s[p]) {
                    if (!o[p]) {
                        var y = typeof H == "function" && H;
                        if (!u && y) return y(p, !0);
                        if (i) return i(p, !0);
                        var v = new Error("Cannot find module '" + p + "'");
                        throw v.code = "MODULE_NOT_FOUND", v;
                    }
                    var d = s[p] = {
                        exports: {}
                    };
                    o[p][0].call(d.exports, function(m) {
                        var E = o[p][1][m];
                        return c(E || m);
                    }, d, d.exports, n, o, s, l);
                }
                return s[p].exports;
            }
            a(c, "s");
            for(var i = typeof H == "function" && H, g = 0; g < l.length; g++)c(l[g]);
            return c;
        }, "e")({
            1: [
                function(n, o, s) {
                    o.exports = function(l) {
                        if (typeof Map != "function" || l) {
                            var c = n("./similar");
                            return new c();
                        } else return /* @__PURE__ */ new Map();
                    };
                },
                {
                    "./similar": 2
                }
            ],
            2: [
                function(n, o, s) {
                    function l() {
                        return this.list = [], this.lastItem = void 0, this.size = 0, this;
                    }
                    a(l, "Similar"), l.prototype.get = function(c) {
                        var i;
                        if (this.lastItem && this.isEqual(this.lastItem.key, c)) return this.lastItem.val;
                        if (i = this.indexOf(c), i >= 0) return this.lastItem = this.list[i], this.list[i].val;
                    }, l.prototype.set = function(c, i) {
                        var g;
                        return this.lastItem && this.isEqual(this.lastItem.key, c) ? (this.lastItem.val = i, this) : (g = this.indexOf(c), g >= 0 ? (this.lastItem = this.list[g], this.list[g].val = i, this) : (this.lastItem = {
                            key: c,
                            val: i
                        }, this.list.push(this.lastItem), this.size++, this));
                    }, l.prototype.delete = function(c) {
                        var i;
                        if (this.lastItem && this.isEqual(this.lastItem.key, c) && (this.lastItem = void 0), i = this.indexOf(c), i >= 0) return this.size--, this.list.splice(i, 1)[0];
                    }, l.prototype.has = function(c) {
                        var i;
                        return this.lastItem && this.isEqual(this.lastItem.key, c) ? !0 : (i = this.indexOf(c), i >= 0 ? (this.lastItem = this.list[i], !0) : !1);
                    }, l.prototype.forEach = function(c, i) {
                        var g;
                        for(g = 0; g < this.size; g++)c.call(i || this, this.list[g].val, this.list[g].key, this);
                    }, l.prototype.indexOf = function(c) {
                        var i;
                        for(i = 0; i < this.size; i++)if (this.isEqual(this.list[i].key, c)) return i;
                        return -1;
                    }, l.prototype.isEqual = function(c, i) {
                        return c === i || c !== c && i !== i;
                    }, o.exports = l;
                },
                {}
            ],
            3: [
                function(n, o, s) {
                    var l = n("map-or-similar");
                    o.exports = function(p) {
                        var u = new l(!1), y = [];
                        return function(v) {
                            var d = /* @__PURE__ */ a(function() {
                                var m = u, E, I, T = arguments.length - 1, R = Array(T + 1), C = !0, N;
                                if ((d.numArgs || d.numArgs === 0) && d.numArgs !== T + 1) throw new Error("Memoizerific functions should always be called with the same number of arguments");
                                for(N = 0; N < T; N++){
                                    if (R[N] = {
                                        cacheItem: m,
                                        arg: arguments[N]
                                    }, m.has(arguments[N])) {
                                        m = m.get(arguments[N]);
                                        continue;
                                    }
                                    C = !1, E = new l(!1), m.set(arguments[N], E), m = E;
                                }
                                return C && (m.has(arguments[T]) ? I = m.get(arguments[T]) : C = !1), C || (I = v.apply(null, arguments), m.set(arguments[T], I)), p > 0 && (R[T] = {
                                    cacheItem: m,
                                    arg: arguments[T]
                                }, C ? c(y, R) : y.push(R), y.length > p && i(y.shift())), d.wasMemoized = C, d.numArgs = T + 1, I;
                            }, "memoizerific");
                            return d.limit = p, d.wasMemoized = !1, d.cache = u, d.lru = y, d;
                        };
                    };
                    function c(p, u) {
                        var y = p.length, v = u.length, d, m, E;
                        for(m = 0; m < y; m++){
                            for(d = !0, E = 0; E < v; E++)if (!g(p[m][E].arg, u[E].arg)) {
                                d = !1;
                                break;
                            }
                            if (d) break;
                        }
                        p.push(p.splice(m, 1)[0]);
                    }
                    a(c, "moveToMostRecentLru");
                    function i(p) {
                        var u = p.length, y = p[u - 1], v, d;
                        for(y.cacheItem.delete(y.arg), d = u - 2; d >= 0 && (y = p[d], v = y.cacheItem.get(y.arg), !v || !v.size); d--)y.cacheItem.delete(y.arg);
                    }
                    a(i, "removeCachedResult");
                    function g(p, u) {
                        return p === u || p !== p && u !== u;
                    }
                    a(g, "isEqual");
                },
                {
                    "map-or-similar": 1
                }
            ]
        }, {}, [
            3
        ])(3);
    });
});
// ../node_modules/@storybook/global/dist/index.mjs
var S = (()=>{
    let r;
    return typeof window < "u" ? r = window : typeof globalThis < "u" ? r = globalThis : typeof global < "u" ? r = global : typeof self < "u" ? r = self : r = {}, r;
})();
// ../node_modules/ts-dedent/esm/index.js
function F(r) {
    for(var t = [], e = 1; e < arguments.length; e++)t[e - 1] = arguments[e];
    var n = Array.from(typeof r == "string" ? [
        r
    ] : r);
    n[n.length - 1] = n[n.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var o = n.reduce(function(c, i) {
        var g = i.match(/\n([\t ]+|(?!\s).)/g);
        return g ? c.concat(g.map(function(p) {
            var u, y;
            return (y = (u = p.match(/[\t ]/g)) === null || u === void 0 ? void 0 : u.length) !== null && y !== void 0 ? y : 0;
        })) : c;
    }, []);
    if (o.length) {
        var s = new RegExp(`
[	 ]{` + Math.min.apply(Math, o) + "}", "g");
        n = n.map(function(c) {
            return c.replace(s, `
`);
        });
    }
    n[0] = n[0].replace(/^\r?\n/, "");
    var l = n[0];
    return t.forEach(function(c, i) {
        var g = l.match(/(?:^|\n)( *)$/), p = g ? g[1] : "", u = c;
        typeof c == "string" && c.includes(`
`) && (u = String(c).split(`
`).map(function(y, v) {
            return v === 0 ? y : "" + p + y;
        }).join(`
`)), l += u + n[i + 1];
    }), l;
}
a(F, "dedent");
// src/shared/universal-store/instances.ts
var ft = /* @__PURE__ */ new Map();
// src/shared/universal-store/index.ts
var ye = "UNIVERSAL_STORE:", x = {
    PENDING: "PENDING",
    RESOLVED: "RESOLVED",
    REJECTED: "REJECTED"
}, h = class h {
    constructor(t, e){
        /** Enable debug logs for this store */ this.debugging = !1;
        // TODO: narrow type of listeners based on event type
        this.listeners = /* @__PURE__ */ new Map([
            [
                "*",
                /* @__PURE__ */ new Set()
            ]
        ]);
        /** Gets the current state */ this.getState = /* @__PURE__ */ a(()=>(this.debug("getState", {
                state: this.state
            }), this.state), "getState");
        /**
     * Subscribes to store events
     *
     * @returns A function to unsubscribe
     */ this.subscribe = /* @__PURE__ */ a((t, e)=>{
            let n = typeof t == "function", o = n ? "*" : t, s = n ? t : e;
            if (this.debug("subscribe", {
                eventType: o,
                listener: s
            }), !s) throw new TypeError(`Missing first subscribe argument, or second if first is the event type, when subscribing to a UniversalStore with id '${this.id}'`);
            return this.listeners.has(o) || this.listeners.set(o, /* @__PURE__ */ new Set()), this.listeners.get(o).add(s), ()=>{
                this.debug("unsubscribe", {
                    eventType: o,
                    listener: s
                }), this.listeners.has(o) && (this.listeners.get(o).delete(s), this.listeners.get(o)?.size === 0 && this.listeners.delete(o));
            };
        }, "subscribe");
        /** Sends a custom event to the other stores */ this.send = /* @__PURE__ */ a((t)=>{
            if (this.debug("send", {
                event: t
            }), this.status !== h.Status.READY) throw new TypeError(F`Cannot send event before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify({
                event: t,
                id: this.id,
                actor: this.actor,
                environment: this.environment
            }, null, 2)}`);
            this.emitToListeners(t, {
                actor: this.actor
            }), this.emitToChannel(t, {
                actor: this.actor
            });
        }, "send");
        if (this.debugging = t.debug ?? !1, !h.isInternalConstructing) throw new TypeError("UniversalStore is not constructable - use UniversalStore.create() instead");
        if (h.isInternalConstructing = !1, this.id = t.id, this.actorId = Date.now().toString(36) + Math.random().toString(36).substring(2), this.actorType = t.leader ? h.ActorType.LEADER : h.ActorType.FOLLOWER, this.state = t.initialState, this.channelEventName = `${ye}${this.id}`, this.debug("constructor", {
            options: t,
            environmentOverrides: e,
            channelEventName: this.channelEventName
        }), this.actor.type === h.ActorType.LEADER) this.syncing = {
            state: x.RESOLVED,
            promise: Promise.resolve()
        };
        else {
            let n, o, s = new Promise((l, c)=>{
                n = /* @__PURE__ */ a(()=>{
                    this.syncing.state === x.PENDING && (this.syncing.state = x.RESOLVED, l());
                }, "syncingResolve"), o = /* @__PURE__ */ a((i)=>{
                    this.syncing.state === x.PENDING && (this.syncing.state = x.REJECTED, c(i));
                }, "syncingReject");
            });
            this.syncing = {
                state: x.PENDING,
                promise: s,
                resolve: n,
                reject: o
            };
        }
        this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.subscribe = this.subscribe.bind(this), this.onStateChange = this.onStateChange.bind(this), this.send = this.send.bind(this), this.emitToChannel = this.emitToChannel.bind(this), this.prepareThis = this.prepareThis.bind(this), this.emitToListeners = this.emitToListeners.bind(this), this.handleChannelEvents = this.handleChannelEvents.bind(this), this.debug = this.debug.bind(this), this.channel = e?.channel ?? h.preparation.channel, this.environment = e?.environment ?? h.preparation.environment, this.channel && this.environment ? this.prepareThis({
            channel: this.channel,
            environment: this.environment
        }) : h.preparation.promise.then(this.prepareThis);
    }
    static setupPreparationPromise() {
        let t, e, n = new Promise((o, s)=>{
            t = /* @__PURE__ */ a((l)=>{
                o(l);
            }, "resolveRef"), e = /* @__PURE__ */ a((...l)=>{
                s(l);
            }, "rejectRef");
        });
        h.preparation = {
            resolve: t,
            reject: e,
            promise: n
        };
    }
    /** The actor object representing the store instance with a unique ID and a type */ get actor() {
        return Object.freeze({
            id: this.actorId,
            type: this.actorType,
            environment: this.environment ?? h.Environment.UNKNOWN
        });
    }
    /**
   * The current state of the store, that signals both if the store is prepared by Storybook and
   * also - in the case of a follower - if the state has been synced with the leader's state.
   */ get status() {
        if (!this.channel || !this.environment) return h.Status.UNPREPARED;
        switch(this.syncing?.state){
            case x.PENDING:
            case void 0:
                return h.Status.SYNCING;
            case x.REJECTED:
                return h.Status.ERROR;
            case x.RESOLVED:
            default:
                return h.Status.READY;
        }
    }
    /**
   * A promise that resolves when the store is fully ready. A leader will be ready when the store
   * has been prepared by Storybook, which is almost instantly.
   *
   * A follower will be ready when the state has been synced with the leader's state, within a few
   * hundred milliseconds.
   */ untilReady() {
        return Promise.all([
            h.preparation.promise,
            this.syncing?.promise
        ]);
    }
    /** Creates a new instance of UniversalStore */ static create(t) {
        if (!t || typeof t?.id != "string") throw new TypeError("id is required and must be a string, when creating a UniversalStore");
        t.debug && console.debug(F`[UniversalStore]
        create`, {
            options: t
        });
        let e = ft.get(t.id);
        if (e) return console.warn(F`UniversalStore with id "${t.id}" already exists in this environment, re-using existing.
        You should reuse the existing instance instead of trying to create a new one.`), e;
        h.isInternalConstructing = !0;
        let n = new h(t);
        return ft.set(t.id, n), n;
    }
    /**
   * Used by Storybook to set the channel for all instances of UniversalStore in the given
   * environment.
   *
   * @internal
   */ static __prepare(t, e) {
        h.preparation.channel = t, h.preparation.environment = e, h.preparation.resolve({
            channel: t,
            environment: e
        });
    }
    /**
   * Updates the store's state
   *
   * Either a new state or a state updater function can be passed to the method.
   */ setState(t) {
        let e = this.state, n = typeof t == "function" ? t(e) : t;
        if (this.debug("setState", {
            newState: n,
            previousState: e,
            updater: t
        }), this.status !== h.Status.READY) throw new TypeError(F`Cannot set state before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify({
            newState: n,
            id: this.id,
            actor: this.actor,
            environment: this.environment
        }, null, 2)}`);
        this.state = n;
        let o = {
            type: h.InternalEventType.SET_STATE,
            payload: {
                state: n,
                previousState: e
            }
        };
        this.emitToChannel(o, {
            actor: this.actor
        }), this.emitToListeners(o, {
            actor: this.actor
        });
    }
    /**
   * Subscribes to state changes
   *
   * @returns Unsubscribe function
   */ onStateChange(t) {
        return this.debug("onStateChange", {
            listener: t
        }), this.subscribe(h.InternalEventType.SET_STATE, ({ payload: e }, n)=>{
            t(e.state, e.previousState, n);
        });
    }
    emitToChannel(t, e) {
        this.debug("emitToChannel", {
            event: t,
            eventInfo: e,
            channel: this.channel
        }), this.channel?.emit(this.channelEventName, {
            event: t,
            eventInfo: e
        });
    }
    prepareThis({ channel: t, environment: e }) {
        this.channel = t, this.environment = e, this.debug("prepared", {
            channel: t,
            environment: e
        }), this.channel.on(this.channelEventName, this.handleChannelEvents), this.actor.type === h.ActorType.LEADER ? this.emitToChannel({
            type: h.InternalEventType.LEADER_CREATED
        }, {
            actor: this.actor
        }) : (this.emitToChannel({
            type: h.InternalEventType.FOLLOWER_CREATED
        }, {
            actor: this.actor
        }), this.emitToChannel({
            type: h.InternalEventType.EXISTING_STATE_REQUEST
        }, {
            actor: this.actor
        }), setTimeout(()=>{
            this.syncing.reject(new TypeError(`No existing state found for follower with id: '${this.id}'. Make sure a leader with the same id exists before creating a follower\
.`));
        }, 1e3));
    }
    emitToListeners(t, e) {
        let n = this.listeners.get(t.type), o = this.listeners.get("*");
        this.debug("emitToListeners", {
            event: t,
            eventInfo: e,
            eventTypeListeners: n,
            everythingListeners: o
        }), [
            ...n ?? [],
            ...o ?? []
        ].forEach((s)=>s(t, e));
    }
    handleChannelEvents(t) {
        let { event: e, eventInfo: n } = t;
        if ([
            n.actor.id,
            n.forwardingActor?.id
        ].includes(this.actor.id)) {
            this.debug("handleChannelEvents: Ignoring event from self", {
                channelEvent: t
            });
            return;
        } else if (this.syncing?.state === x.PENDING && e.type !== h.InternalEventType.EXISTING_STATE_RESPONSE) {
            this.debug("handleChannelEvents: Ignoring event while syncing", {
                channelEvent: t
            });
            return;
        }
        if (this.debug("handleChannelEvents", {
            channelEvent: t
        }), this.actor.type === h.ActorType.LEADER) {
            let o = !0;
            switch(e.type){
                case h.InternalEventType.EXISTING_STATE_REQUEST:
                    o = !1;
                    let s = {
                        type: h.InternalEventType.EXISTING_STATE_RESPONSE,
                        payload: this.state
                    };
                    this.debug("handleChannelEvents: responding to existing state request", {
                        responseEvent: s
                    }), this.emitToChannel(s, {
                        actor: this.actor
                    });
                    break;
                case h.InternalEventType.LEADER_CREATED:
                    o = !1, this.syncing.state = x.REJECTED, this.debug("handleChannelEvents: erroring due to second leader being created", {
                        event: e
                    }), console.error(F`Detected multiple UniversalStore leaders created with the same id "${this.id}".
            Only one leader can exists at a time, your stores are now in an invalid state.
            Leaders detected:
            this: ${JSON.stringify(this.actor, null, 2)}
            other: ${JSON.stringify(n.actor, null, 2)}`);
                    break;
            }
            o && (this.debug("handleChannelEvents: forwarding event", {
                channelEvent: t
            }), this.emitToChannel(e, {
                actor: n.actor,
                forwardingActor: this.actor
            }));
        }
        if (this.actor.type === h.ActorType.FOLLOWER) switch(e.type){
            case h.InternalEventType.EXISTING_STATE_RESPONSE:
                if (this.debug("handleChannelEvents: Setting state from leader's existing state response", {
                    event: e
                }), this.syncing?.state !== x.PENDING) break;
                this.syncing.resolve?.();
                let o = {
                    type: h.InternalEventType.SET_STATE,
                    payload: {
                        state: e.payload,
                        previousState: this.state
                    }
                };
                this.state = e.payload, this.emitToListeners(o, n);
                break;
        }
        switch(e.type){
            case h.InternalEventType.SET_STATE:
                this.debug("handleChannelEvents: Setting state", {
                    event: e
                }), this.state = e.payload.state;
                break;
        }
        this.emitToListeners(e, {
            actor: n.actor
        });
    }
    debug(t, e) {
        this.debugging && console.debug(F`[UniversalStore::${this.id}::${this.environment ?? h.Environment.UNKNOWN}]
        ${t}`, JSON.stringify({
            data: e,
            actor: this.actor,
            state: this.state,
            status: this.status
        }, null, 2));
    }
    /**
   * Used to reset the static fields of the UniversalStore class when cleaning up tests
   *
   * @internal
   */ static __reset() {
        h.preparation.reject(new Error("reset")), h.setupPreparationPromise(), h.isInternalConstructing = !1;
    }
};
a(h, "UniversalStore"), /**
 * Defines the possible actor types in the store system
 *
 * @readonly
 */ h.ActorType = {
    LEADER: "LEADER",
    FOLLOWER: "FOLLOWER"
}, /**
 * Defines the possible environments the store can run in
 *
 * @readonly
 */ h.Environment = {
    SERVER: "SERVER",
    MANAGER: "MANAGER",
    PREVIEW: "PREVIEW",
    UNKNOWN: "UNKNOWN",
    MOCK: "MOCK"
}, /**
 * Internal event types used for store synchronization
 *
 * @readonly
 */ h.InternalEventType = {
    EXISTING_STATE_REQUEST: "__EXISTING_STATE_REQUEST",
    EXISTING_STATE_RESPONSE: "__EXISTING_STATE_RESPONSE",
    SET_STATE: "__SET_STATE",
    LEADER_CREATED: "__LEADER_CREATED",
    FOLLOWER_CREATED: "__FOLLOWER_CREATED"
}, h.Status = {
    UNPREPARED: "UNPREPARED",
    SYNCING: "SYNCING",
    READY: "READY",
    ERROR: "ERROR"
}, h.isInternalConstructing = !1, h.setupPreparationPromise();
var $ = h;
// src/channels/main.ts
var de = /* @__PURE__ */ a((r)=>r.transports !== void 0, "isMulti"), ge = /* @__PURE__ */ a(()=>Math.random().toString(16).slice(2), "ge\
nerateRandomId"), ht = class ht {
    constructor(t = {}){
        this.sender = ge();
        this.events = {};
        this.data = {};
        this.transports = [];
        this.isAsync = t.async || !1, de(t) ? (this.transports = t.transports || [], this.transports.forEach((e)=>{
            e.setHandler((n)=>this.handleEvent(n));
        })) : this.transports = t.transport ? [
            t.transport
        ] : [], this.transports.forEach((e)=>{
            e.setHandler((n)=>this.handleEvent(n));
        });
    }
    get hasTransport() {
        return this.transports.length > 0;
    }
    addListener(t, e) {
        this.events[t] = this.events[t] || [], this.events[t].push(e);
    }
    emit(t, ...e) {
        let n = {
            type: t,
            args: e,
            from: this.sender
        }, o = {};
        e.length >= 1 && e[0] && e[0].options && (o = e[0].options);
        let s = /* @__PURE__ */ a(()=>{
            this.transports.forEach((l)=>{
                l.send(n, o);
            }), this.handleEvent(n);
        }, "handler");
        this.isAsync ? setImmediate(s) : s();
    }
    last(t) {
        return this.data[t];
    }
    eventNames() {
        return Object.keys(this.events);
    }
    listenerCount(t) {
        let e = this.listeners(t);
        return e ? e.length : 0;
    }
    listeners(t) {
        return this.events[t] || void 0;
    }
    once(t, e) {
        let n = this.onceListener(t, e);
        this.addListener(t, n);
    }
    removeAllListeners(t) {
        t ? this.events[t] && delete this.events[t] : this.events = {};
    }
    removeListener(t, e) {
        let n = this.listeners(t);
        n && (this.events[t] = n.filter((o)=>o !== e));
    }
    on(t, e) {
        this.addListener(t, e);
    }
    off(t, e) {
        this.removeListener(t, e);
    }
    handleEvent(t) {
        let e = this.listeners(t.type);
        e && e.length && e.forEach((n)=>{
            n.apply(t, t.args);
        }), this.data[t.type] = t.args;
    }
    onceListener(t, e) {
        let n = /* @__PURE__ */ a((...o)=>(this.removeListener(t, n), e(...o)), "onceListener");
        return n;
    }
};
a(ht, "Channel");
var B = ht;
// ../node_modules/telejson/dist/chunk-465TF3XA.mjs
var ve = Object.create, Ot = Object.defineProperty, me = Object.getOwnPropertyDescriptor, Ct = Object.getOwnPropertyNames, Ee = Object.getPrototypeOf, be = Object.prototype.hasOwnProperty, P = /* @__PURE__ */ a((r, t)=>/* @__PURE__ */ a(function() {
        return t || (0, r[Ct(r)[0]])((t = {
            exports: {}
        }).exports, t), t.exports;
    }, "__require"), "__commonJS"), Se = /* @__PURE__ */ a((r, t, e, n)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let o of Ct(t))!be.call(r, o) && o !== e && Ot(r, o, {
        get: /* @__PURE__ */ a(()=>t[o], "get"),
        enumerable: !(n = me(t, o)) || n.enumerable
    });
    return r;
}, "__copyProps"), ot = /* @__PURE__ */ a((r, t, e)=>(e = r != null ? ve(Ee(r)) : {}, Se(t || !r || !r.__esModule ? Ot(e, "default", {
        value: r,
        enumerable: !0
    }) : e, r)), "__toESM"), _e = [
    "bubbles",
    "cancelBubble",
    "cancelable",
    "composed",
    "currentTarget",
    "defaultPrevented",
    "eventPhase",
    "isTrusted",
    "returnValue",
    "srcElement",
    "target",
    "timeStamp",
    "type"
], Te = [
    "detail"
];
function Pt(r) {
    let t = _e.filter((e)=>r[e] !== void 0).reduce((e, n)=>({
            ...e,
            [n]: r[n]
        }), {});
    return r instanceof CustomEvent && Te.filter((e)=>r[e] !== void 0).forEach((e)=>{
        t[e] = r[e];
    }), t;
}
a(Pt, "extractEventHiddenProperties");
// ../node_modules/telejson/dist/index.mjs
var Bt = he(xt(), 1);
var Ft = P({
    "node_modules/has-symbols/shams.js" (r, t) {
        "use strict";
        t.exports = /* @__PURE__ */ a(function() {
            if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
            if (typeof Symbol.iterator == "symbol") return !0;
            var n = {}, o = Symbol("test"), s = Object(o);
            if (typeof o == "string" || Object.prototype.toString.call(o) !== "[object Symbol]" || Object.prototype.toString.call(s) !== "[object \
Symbol]") return !1;
            var l = 42;
            n[o] = l;
            for(o in n)return !1;
            if (typeof Object.keys == "function" && Object.keys(n).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(n).length !== 0) return !1;
            var c = Object.getOwnPropertySymbols(n);
            if (c.length !== 1 || c[0] !== o || !Object.prototype.propertyIsEnumerable.call(n, o)) return !1;
            if (typeof Object.getOwnPropertyDescriptor == "function") {
                var i = Object.getOwnPropertyDescriptor(n, o);
                if (i.value !== l || i.enumerable !== !0) return !1;
            }
            return !0;
        }, "hasSymbols");
    }
}), Mt = P({
    "node_modules/has-symbols/index.js" (r, t) {
        "use strict";
        var e = typeof Symbol < "u" && Symbol, n = Ft();
        t.exports = /* @__PURE__ */ a(function() {
            return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : n();
        }, "hasNativeSymbols");
    }
}), Ae = P({
    "node_modules/function-bind/implementation.js" (r, t) {
        "use strict";
        var e = "Function.prototype.bind called on incompatible ", n = Array.prototype.slice, o = Object.prototype.toString, s = "[object Functi\
on]";
        t.exports = /* @__PURE__ */ a(function(c) {
            var i = this;
            if (typeof i != "function" || o.call(i) !== s) throw new TypeError(e + i);
            for(var g = n.call(arguments, 1), p, u = /* @__PURE__ */ a(function() {
                if (this instanceof p) {
                    var E = i.apply(this, g.concat(n.call(arguments)));
                    return Object(E) === E ? E : this;
                } else return i.apply(c, g.concat(n.call(arguments)));
            }, "binder"), y = Math.max(0, i.length - g.length), v = [], d = 0; d < y; d++)v.push("$" + d);
            if (p = Function("binder", "return function (" + v.join(",") + "){ return binder.apply(this,arguments); }")(u), i.prototype) {
                var m = /* @__PURE__ */ a(function() {}, "Empty2");
                m.prototype = i.prototype, p.prototype = new m(), m.prototype = null;
            }
            return p;
        }, "bind");
    }
}), gt = P({
    "node_modules/function-bind/index.js" (r, t) {
        "use strict";
        var e = Ae();
        t.exports = Function.prototype.bind || e;
    }
}), we = P({
    "node_modules/has/src/index.js" (r, t) {
        "use strict";
        var e = gt();
        t.exports = e.call(Function.call, Object.prototype.hasOwnProperty);
    }
}), $t = P({
    "node_modules/get-intrinsic/index.js" (r, t) {
        "use strict";
        var e, n = SyntaxError, o = Function, s = TypeError, l = /* @__PURE__ */ a(function(j) {
            try {
                return o('"use strict"; return (' + j + ").constructor;")();
            } catch  {}
        }, "getEvalledConstructor"), c = Object.getOwnPropertyDescriptor;
        if (c) try {
            c({}, "");
        } catch  {
            c = null;
        }
        var i = /* @__PURE__ */ a(function() {
            throw new s();
        }, "throwTypeError"), g = c ? function() {
            try {
                return arguments.callee, i;
            } catch  {
                try {
                    return c(arguments, "callee").get;
                } catch  {
                    return i;
                }
            }
        }() : i, p = Mt()(), u = Object.getPrototypeOf || function(j) {
            return j.__proto__;
        }, y = {}, v = typeof Uint8Array > "u" ? e : u(Uint8Array), d = {
            "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
            "%Array%": Array,
            "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
            "%ArrayIteratorPrototype%": p ? u([][Symbol.iterator]()) : e,
            "%AsyncFromSyncIteratorPrototype%": e,
            "%AsyncFunction%": y,
            "%AsyncGenerator%": y,
            "%AsyncGeneratorFunction%": y,
            "%AsyncIteratorPrototype%": y,
            "%Atomics%": typeof Atomics > "u" ? e : Atomics,
            "%BigInt%": typeof BigInt > "u" ? e : BigInt,
            "%Boolean%": Boolean,
            "%DataView%": typeof DataView > "u" ? e : DataView,
            "%Date%": Date,
            "%decodeURI%": decodeURI,
            "%decodeURIComponent%": decodeURIComponent,
            "%encodeURI%": encodeURI,
            "%encodeURIComponent%": encodeURIComponent,
            "%Error%": Error,
            "%eval%": eval,
            "%EvalError%": EvalError,
            "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
            "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
            "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
            "%Function%": o,
            "%GeneratorFunction%": y,
            "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
            "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
            "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
            "%isFinite%": isFinite,
            "%isNaN%": isNaN,
            "%IteratorPrototype%": p ? u(u([][Symbol.iterator]())) : e,
            "%JSON%": typeof JSON == "object" ? JSON : e,
            "%Map%": typeof Map > "u" ? e : Map,
            "%MapIteratorPrototype%": typeof Map > "u" || !p ? e : u(/* @__PURE__ */ new Map()[Symbol.iterator]()),
            "%Math%": Math,
            "%Number%": Number,
            "%Object%": Object,
            "%parseFloat%": parseFloat,
            "%parseInt%": parseInt,
            "%Promise%": typeof Promise > "u" ? e : Promise,
            "%Proxy%": typeof Proxy > "u" ? e : Proxy,
            "%RangeError%": RangeError,
            "%ReferenceError%": ReferenceError,
            "%Reflect%": typeof Reflect > "u" ? e : Reflect,
            "%RegExp%": RegExp,
            "%Set%": typeof Set > "u" ? e : Set,
            "%SetIteratorPrototype%": typeof Set > "u" || !p ? e : u(/* @__PURE__ */ new Set()[Symbol.iterator]()),
            "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
            "%String%": String,
            "%StringIteratorPrototype%": p ? u(""[Symbol.iterator]()) : e,
            "%Symbol%": p ? Symbol : e,
            "%SyntaxError%": n,
            "%ThrowTypeError%": g,
            "%TypedArray%": v,
            "%TypeError%": s,
            "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
            "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
            "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
            "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
            "%URIError%": URIError,
            "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
            "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
            "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
        }, m = /* @__PURE__ */ a(function j(b) {
            var A;
            if (b === "%AsyncFunction%") A = l("async function () {}");
            else if (b === "%GeneratorFunction%") A = l("function* () {}");
            else if (b === "%AsyncGeneratorFunction%") A = l("async function* () {}");
            else if (b === "%AsyncGenerator%") {
                var _ = j("%AsyncGeneratorFunction%");
                _ && (A = _.prototype);
            } else if (b === "%AsyncIteratorPrototype%") {
                var w = j("%AsyncGenerator%");
                w && (A = u(w.prototype));
            }
            return d[b] = A, A;
        }, "doEval2"), E = {
            "%ArrayBufferPrototype%": [
                "ArrayBuffer",
                "prototype"
            ],
            "%ArrayPrototype%": [
                "Array",
                "prototype"
            ],
            "%ArrayProto_entries%": [
                "Array",
                "prototype",
                "entries"
            ],
            "%ArrayProto_forEach%": [
                "Array",
                "prototype",
                "forEach"
            ],
            "%ArrayProto_keys%": [
                "Array",
                "prototype",
                "keys"
            ],
            "%ArrayProto_values%": [
                "Array",
                "prototype",
                "values"
            ],
            "%AsyncFunctionPrototype%": [
                "AsyncFunction",
                "prototype"
            ],
            "%AsyncGenerator%": [
                "AsyncGeneratorFunction",
                "prototype"
            ],
            "%AsyncGeneratorPrototype%": [
                "AsyncGeneratorFunction",
                "prototype",
                "prototype"
            ],
            "%BooleanPrototype%": [
                "Boolean",
                "prototype"
            ],
            "%DataViewPrototype%": [
                "DataView",
                "prototype"
            ],
            "%DatePrototype%": [
                "Date",
                "prototype"
            ],
            "%ErrorPrototype%": [
                "Error",
                "prototype"
            ],
            "%EvalErrorPrototype%": [
                "EvalError",
                "prototype"
            ],
            "%Float32ArrayPrototype%": [
                "Float32Array",
                "prototype"
            ],
            "%Float64ArrayPrototype%": [
                "Float64Array",
                "prototype"
            ],
            "%FunctionPrototype%": [
                "Function",
                "prototype"
            ],
            "%Generator%": [
                "GeneratorFunction",
                "prototype"
            ],
            "%GeneratorPrototype%": [
                "GeneratorFunction",
                "prototype",
                "prototype"
            ],
            "%Int8ArrayPrototype%": [
                "Int8Array",
                "prototype"
            ],
            "%Int16ArrayPrototype%": [
                "Int16Array",
                "prototype"
            ],
            "%Int32ArrayPrototype%": [
                "Int32Array",
                "prototype"
            ],
            "%JSONParse%": [
                "JSON",
                "parse"
            ],
            "%JSONStringify%": [
                "JSON",
                "stringify"
            ],
            "%MapPrototype%": [
                "Map",
                "prototype"
            ],
            "%NumberPrototype%": [
                "Number",
                "prototype"
            ],
            "%ObjectPrototype%": [
                "Object",
                "prototype"
            ],
            "%ObjProto_toString%": [
                "Object",
                "prototype",
                "toString"
            ],
            "%ObjProto_valueOf%": [
                "Object",
                "prototype",
                "valueOf"
            ],
            "%PromisePrototype%": [
                "Promise",
                "prototype"
            ],
            "%PromiseProto_then%": [
                "Promise",
                "prototype",
                "then"
            ],
            "%Promise_all%": [
                "Promise",
                "all"
            ],
            "%Promise_reject%": [
                "Promise",
                "reject"
            ],
            "%Promise_resolve%": [
                "Promise",
                "resolve"
            ],
            "%RangeErrorPrototype%": [
                "RangeError",
                "prototype"
            ],
            "%ReferenceErrorPrototype%": [
                "ReferenceError",
                "prototype"
            ],
            "%RegExpPrototype%": [
                "RegExp",
                "prototype"
            ],
            "%SetPrototype%": [
                "Set",
                "prototype"
            ],
            "%SharedArrayBufferPrototype%": [
                "SharedArrayBuffer",
                "prototype"
            ],
            "%StringPrototype%": [
                "String",
                "prototype"
            ],
            "%SymbolPrototype%": [
                "Symbol",
                "prototype"
            ],
            "%SyntaxErrorPrototype%": [
                "SyntaxError",
                "prototype"
            ],
            "%TypedArrayPrototype%": [
                "TypedArray",
                "prototype"
            ],
            "%TypeErrorPrototype%": [
                "TypeError",
                "prototype"
            ],
            "%Uint8ArrayPrototype%": [
                "Uint8Array",
                "prototype"
            ],
            "%Uint8ClampedArrayPrototype%": [
                "Uint8ClampedArray",
                "prototype"
            ],
            "%Uint16ArrayPrototype%": [
                "Uint16Array",
                "prototype"
            ],
            "%Uint32ArrayPrototype%": [
                "Uint32Array",
                "prototype"
            ],
            "%URIErrorPrototype%": [
                "URIError",
                "prototype"
            ],
            "%WeakMapPrototype%": [
                "WeakMap",
                "prototype"
            ],
            "%WeakSetPrototype%": [
                "WeakSet",
                "prototype"
            ]
        }, I = gt(), T = we(), R = I.call(Function.call, Array.prototype.concat), C = I.call(Function.apply, Array.prototype.splice), N = I.call(Function.call, String.prototype.replace), Q = I.call(Function.call, String.prototype.slice), ee = I.call(Function.call, RegExp.prototype.exec), re = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ne = /\\(\\)?/g, oe = /* @__PURE__ */ a(function(b) {
            var A = Q(b, 0, 1), _ = Q(b, -1);
            if (A === "%" && _ !== "%") throw new n("invalid intrinsic syntax, expected closing `%`");
            if (_ === "%" && A !== "%") throw new n("invalid intrinsic syntax, expected opening `%`");
            var w = [];
            return N(b, re, function(L, M, O, Z) {
                w[w.length] = O ? N(Z, ne, "$1") : M || L;
            }), w;
        }, "stringToPath3"), ie = /* @__PURE__ */ a(function(b, A) {
            var _ = b, w;
            if (T(E, _) && (w = E[_], _ = "%" + w[0] + "%"), T(d, _)) {
                var L = d[_];
                if (L === y && (L = m(_)), typeof L > "u" && !A) throw new s("intrinsic " + b + " exists, but is not available. Please file an issue!");
                return {
                    alias: w,
                    name: _,
                    value: L
                };
            }
            throw new n("intrinsic " + b + " does not exist!");
        }, "getBaseIntrinsic2");
        t.exports = /* @__PURE__ */ a(function(b, A) {
            if (typeof b != "string" || b.length === 0) throw new s("intrinsic name must be a non-empty string");
            if (arguments.length > 1 && typeof A != "boolean") throw new s('"allowMissing" argument must be a boolean');
            if (ee(/^%?[^%]*%?$/, b) === null) throw new n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
            var _ = oe(b), w = _.length > 0 ? _[0] : "", L = ie("%" + w + "%", A), M = L.name, O = L.value, Z = !1, pt = L.alias;
            pt && (w = pt[0], C(_, R([
                0,
                1
            ], pt)));
            for(var tt = 1, z = !0; tt < _.length; tt += 1){
                var D = _[tt], et = Q(D, 0, 1), rt = Q(D, -1);
                if ((et === '"' || et === "'" || et === "`" || rt === '"' || rt === "'" || rt === "`") && et !== rt) throw new n("property names with quotes must have matching quotes");
                if ((D === "constructor" || !z) && (Z = !0), w += "." + D, M = "%" + w + "%", T(d, M)) O = d[M];
                else if (O != null) {
                    if (!(D in O)) {
                        if (!A) throw new s("base intrinsic for " + b + " exists, but the property is not available.");
                        return;
                    }
                    if (c && tt + 1 >= _.length) {
                        var nt = c(O, D);
                        z = !!nt, z && "get" in nt && !("originalValue" in nt.get) ? O = nt.get : O = O[D];
                    } else z = T(O, D), O = O[D];
                    z && !Z && (d[M] = O);
                }
            }
            return O;
        }, "GetIntrinsic");
    }
}), Oe = P({
    "node_modules/call-bind/index.js" (r, t) {
        "use strict";
        var e = gt(), n = $t(), o = n("%Function.prototype.apply%"), s = n("%Function.prototype.call%"), l = n("%Reflect.apply%", !0) || e.call(s, o), c = n("%Object.getOwnPropertyDescriptor%", !0), i = n("%Object.defineProperty%", !0), g = n("%Math.max%");
        if (i) try {
            i({}, "a", {
                value: 1
            });
        } catch  {
            i = null;
        }
        t.exports = /* @__PURE__ */ a(function(y) {
            var v = l(e, s, arguments);
            if (c && i) {
                var d = c(v, "length");
                d.configurable && i(v, "length", {
                    value: 1 + g(0, y.length - (arguments.length - 1))
                });
            }
            return v;
        }, "callBind");
        var p = /* @__PURE__ */ a(function() {
            return l(e, o, arguments);
        }, "applyBind2");
        i ? i(t.exports, "apply", {
            value: p
        }) : t.exports.apply = p;
    }
}), Ce = P({
    "node_modules/call-bind/callBound.js" (r, t) {
        "use strict";
        var e = $t(), n = Oe(), o = n(e("String.prototype.indexOf"));
        t.exports = /* @__PURE__ */ a(function(l, c) {
            var i = e(l, !!c);
            return typeof i == "function" && o(l, ".prototype.") > -1 ? n(i) : i;
        }, "callBoundIntrinsic");
    }
}), Pe = P({
    "node_modules/has-tostringtag/shams.js" (r, t) {
        "use strict";
        var e = Ft();
        t.exports = /* @__PURE__ */ a(function() {
            return e() && !!Symbol.toStringTag;
        }, "hasToStringTagShams");
    }
}), Ie = P({
    "node_modules/is-regex/index.js" (r, t) {
        "use strict";
        var e = Ce(), n = Pe()(), o, s, l, c;
        n && (o = e("Object.prototype.hasOwnProperty"), s = e("RegExp.prototype.exec"), l = {}, i = /* @__PURE__ */ a(function() {
            throw l;
        }, "throwRegexMarker"), c = {
            toString: i,
            valueOf: i
        }, typeof Symbol.toPrimitive == "symbol" && (c[Symbol.toPrimitive] = i));
        var i, g = e("Object.prototype.toString"), p = Object.getOwnPropertyDescriptor, u = "[object RegExp]";
        t.exports = /* @__PURE__ */ a(n ? function(v) {
            if (!v || typeof v != "object") return !1;
            var d = p(v, "lastIndex"), m = d && o(d, "value");
            if (!m) return !1;
            try {
                s(v, c);
            } catch (E) {
                return E === l;
            }
        } : function(v) {
            return !v || typeof v != "object" && typeof v != "function" ? !1 : g(v) === u;
        }, "isRegex");
    }
}), xe = P({
    "node_modules/is-function/index.js" (r, t) {
        t.exports = n;
        var e = Object.prototype.toString;
        function n(o) {
            if (!o) return !1;
            var s = e.call(o);
            return s === "[object Function]" || typeof o == "function" && s !== "[object RegExp]" || typeof window < "u" && (o === window.setTimeout || o === window.alert || o === window.confirm || o === window.prompt);
        }
        a(n, "isFunction3");
    }
}), Re = P({
    "node_modules/is-symbol/index.js" (r, t) {
        "use strict";
        var e = Object.prototype.toString, n = Mt()();
        n ? (o = Symbol.prototype.toString, s = /^Symbol\(.*\)$/, l = /* @__PURE__ */ a(function(i) {
            return typeof i.valueOf() != "symbol" ? !1 : s.test(o.call(i));
        }, "isRealSymbolObject"), t.exports = /* @__PURE__ */ a(function(i) {
            if (typeof i == "symbol") return !0;
            if (e.call(i) !== "[object Symbol]") return !1;
            try {
                return l(i);
            } catch  {
                return !1;
            }
        }, "isSymbol3")) : t.exports = /* @__PURE__ */ a(function(i) {
            return !1;
        }, "isSymbol3");
        var o, s, l;
    }
}), Ne = ot(Ie()), je = ot(xe()), Le = ot(Re());
function De(r) {
    return r != null && typeof r == "object" && Array.isArray(r) === !1;
}
a(De, "isObject");
var Fe = typeof global == "object" && global && global.Object === Object && global, Me = Fe, $e = typeof self == "object" && self && self.Object === Object && self, Ue = Me || $e || Function("return this")(), vt = Ue, ke = vt.Symbol, U = ke, Ut = Object.prototype, Ge = Ut.hasOwnProperty, We = Ut.toString, q = U ? U.toStringTag : void 0;
function ze(r) {
    var t = Ge.call(r, q), e = r[q];
    try {
        r[q] = void 0;
        var n = !0;
    } catch  {}
    var o = We.call(r);
    return n && (t ? r[q] = e : delete r[q]), o;
}
a(ze, "getRawTag");
var He = ze, Be = Object.prototype, qe = Be.toString;
function Ve(r) {
    return qe.call(r);
}
a(Ve, "objectToString");
var Je = Ve, Ke = "[object Null]", Ye = "[object Undefined]", Rt = U ? U.toStringTag : void 0;
function Xe(r) {
    return r == null ? r === void 0 ? Ye : Ke : Rt && Rt in Object(r) ? He(r) : Je(r);
}
a(Xe, "baseGetTag");
var kt = Xe;
function Qe(r) {
    return r != null && typeof r == "object";
}
a(Qe, "isObjectLike");
var Ze = Qe, tr = "[object Symbol]";
function er(r) {
    return typeof r == "symbol" || Ze(r) && kt(r) == tr;
}
a(er, "isSymbol");
var mt = er;
function rr(r, t) {
    for(var e = -1, n = r == null ? 0 : r.length, o = Array(n); ++e < n;)o[e] = t(r[e], e, r);
    return o;
}
a(rr, "arrayMap");
var nr = rr, or = Array.isArray, Et = or, ir = 1 / 0, Nt = U ? U.prototype : void 0, jt = Nt ? Nt.toString : void 0;
function Gt(r) {
    if (typeof r == "string") return r;
    if (Et(r)) return nr(r, Gt) + "";
    if (mt(r)) return jt ? jt.call(r) : "";
    var t = r + "";
    return t == "0" && 1 / r == -ir ? "-0" : t;
}
a(Gt, "baseToString");
var ar = Gt;
function sr(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
}
a(sr, "isObject2");
var Wt = sr, lr = "[object AsyncFunction]", cr = "[object Function]", pr = "[object GeneratorFunction]", ur = "[object Proxy]";
function fr(r) {
    if (!Wt(r)) return !1;
    var t = kt(r);
    return t == cr || t == pr || t == lr || t == ur;
}
a(fr, "isFunction");
var hr = fr, yr = vt["__core-js_shared__"], dt = yr, Lt = function() {
    var r = /[^.]+$/.exec(dt && dt.keys && dt.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
}();
function dr(r) {
    return !!Lt && Lt in r;
}
a(dr, "isMasked");
var gr = dr, vr = Function.prototype, mr = vr.toString;
function Er(r) {
    if (r != null) {
        try {
            return mr.call(r);
        } catch  {}
        try {
            return r + "";
        } catch  {}
    }
    return "";
}
a(Er, "toSource");
var br = Er, Sr = /[\\^$.*+?()[\]{}|]/g, _r = /^\[object .+?Constructor\]$/, Tr = Function.prototype, Ar = Object.prototype, wr = Tr.toString, Or = Ar.hasOwnProperty, Cr = RegExp("^" + wr.call(Or).replace(Sr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Pr(r) {
    if (!Wt(r) || gr(r)) return !1;
    var t = hr(r) ? Cr : _r;
    return t.test(br(r));
}
a(Pr, "baseIsNative");
var Ir = Pr;
function xr(r, t) {
    return r?.[t];
}
a(xr, "getValue");
var Rr = xr;
function Nr(r, t) {
    var e = Rr(r, t);
    return Ir(e) ? e : void 0;
}
a(Nr, "getNative");
var zt = Nr;
function jr(r, t) {
    return r === t || r !== r && t !== t;
}
a(jr, "eq");
var Lr = jr, Dr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Fr = /^\w*$/;
function Mr(r, t) {
    if (Et(r)) return !1;
    var e = typeof r;
    return e == "number" || e == "symbol" || e == "boolean" || r == null || mt(r) ? !0 : Fr.test(r) || !Dr.test(r) || t != null && r in Object(t);
}
a(Mr, "isKey");
var $r = Mr, Ur = zt(Object, "create"), V = Ur;
function kr() {
    this.__data__ = V ? V(null) : {}, this.size = 0;
}
a(kr, "hashClear");
var Gr = kr;
function Wr(r) {
    var t = this.has(r) && delete this.__data__[r];
    return this.size -= t ? 1 : 0, t;
}
a(Wr, "hashDelete");
var zr = Wr, Hr = "__lodash_hash_undefined__", Br = Object.prototype, qr = Br.hasOwnProperty;
function Vr(r) {
    var t = this.__data__;
    if (V) {
        var e = t[r];
        return e === Hr ? void 0 : e;
    }
    return qr.call(t, r) ? t[r] : void 0;
}
a(Vr, "hashGet");
var Jr = Vr, Kr = Object.prototype, Yr = Kr.hasOwnProperty;
function Xr(r) {
    var t = this.__data__;
    return V ? t[r] !== void 0 : Yr.call(t, r);
}
a(Xr, "hashHas");
var Qr = Xr, Zr = "__lodash_hash_undefined__";
function tn(r, t) {
    var e = this.__data__;
    return this.size += this.has(r) ? 0 : 1, e[r] = V && t === void 0 ? Zr : t, this;
}
a(tn, "hashSet");
var en = tn;
function k(r) {
    var t = -1, e = r == null ? 0 : r.length;
    for(this.clear(); ++t < e;){
        var n = r[t];
        this.set(n[0], n[1]);
    }
}
a(k, "Hash");
k.prototype.clear = Gr;
k.prototype.delete = zr;
k.prototype.get = Jr;
k.prototype.has = Qr;
k.prototype.set = en;
var Dt = k;
function rn() {
    this.__data__ = [], this.size = 0;
}
a(rn, "listCacheClear");
var nn = rn;
function on(r, t) {
    for(var e = r.length; e--;)if (Lr(r[e][0], t)) return e;
    return -1;
}
a(on, "assocIndexOf");
var at = on, an = Array.prototype, sn = an.splice;
function ln(r) {
    var t = this.__data__, e = at(t, r);
    if (e < 0) return !1;
    var n = t.length - 1;
    return e == n ? t.pop() : sn.call(t, e, 1), --this.size, !0;
}
a(ln, "listCacheDelete");
var cn = ln;
function pn(r) {
    var t = this.__data__, e = at(t, r);
    return e < 0 ? void 0 : t[e][1];
}
a(pn, "listCacheGet");
var un = pn;
function fn(r) {
    return at(this.__data__, r) > -1;
}
a(fn, "listCacheHas");
var hn = fn;
function yn(r, t) {
    var e = this.__data__, n = at(e, r);
    return n < 0 ? (++this.size, e.push([
        r,
        t
    ])) : e[n][1] = t, this;
}
a(yn, "listCacheSet");
var dn = yn;
function G(r) {
    var t = -1, e = r == null ? 0 : r.length;
    for(this.clear(); ++t < e;){
        var n = r[t];
        this.set(n[0], n[1]);
    }
}
a(G, "ListCache");
G.prototype.clear = nn;
G.prototype.delete = cn;
G.prototype.get = un;
G.prototype.has = hn;
G.prototype.set = dn;
var gn = G, vn = zt(vt, "Map"), mn = vn;
function En() {
    this.size = 0, this.__data__ = {
        hash: new Dt(),
        map: new (mn || gn)(),
        string: new Dt()
    };
}
a(En, "mapCacheClear");
var bn = En;
function Sn(r) {
    var t = typeof r;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
}
a(Sn, "isKeyable");
var _n = Sn;
function Tn(r, t) {
    var e = r.__data__;
    return _n(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
a(Tn, "getMapData");
var st = Tn;
function An(r) {
    var t = st(this, r).delete(r);
    return this.size -= t ? 1 : 0, t;
}
a(An, "mapCacheDelete");
var wn = An;
function On(r) {
    return st(this, r).get(r);
}
a(On, "mapCacheGet");
var Cn = On;
function Pn(r) {
    return st(this, r).has(r);
}
a(Pn, "mapCacheHas");
var In = Pn;
function xn(r, t) {
    var e = st(this, r), n = e.size;
    return e.set(r, t), this.size += e.size == n ? 0 : 1, this;
}
a(xn, "mapCacheSet");
var Rn = xn;
function W(r) {
    var t = -1, e = r == null ? 0 : r.length;
    for(this.clear(); ++t < e;){
        var n = r[t];
        this.set(n[0], n[1]);
    }
}
a(W, "MapCache");
W.prototype.clear = bn;
W.prototype.delete = wn;
W.prototype.get = Cn;
W.prototype.has = In;
W.prototype.set = Rn;
var Ht = W, Nn = "Expected a function";
function bt(r, t) {
    if (typeof r != "function" || t != null && typeof t != "function") throw new TypeError(Nn);
    var e = /* @__PURE__ */ a(function() {
        var n = arguments, o = t ? t.apply(this, n) : n[0], s = e.cache;
        if (s.has(o)) return s.get(o);
        var l = r.apply(this, n);
        return e.cache = s.set(o, l) || s, l;
    }, "memoized");
    return e.cache = new (bt.Cache || Ht)(), e;
}
a(bt, "memoize");
bt.Cache = Ht;
var jn = bt, Ln = 500;
function Dn(r) {
    var t = jn(r, function(n) {
        return e.size === Ln && e.clear(), n;
    }), e = t.cache;
    return t;
}
a(Dn, "memoizeCapped");
var Fn = Dn, Mn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $n = /\\(\\)?/g, Un = Fn(function(r) {
    var t = [];
    return r.charCodeAt(0) === 46 && t.push(""), r.replace(Mn, function(e, n, o, s) {
        t.push(o ? s.replace($n, "$1") : n || e);
    }), t;
}), kn = Un;
function Gn(r) {
    return r == null ? "" : ar(r);
}
a(Gn, "toString");
var Wn = Gn;
function zn(r, t) {
    return Et(r) ? r : $r(r, t) ? [
        r
    ] : kn(Wn(r));
}
a(zn, "castPath");
var Hn = zn, Bn = 1 / 0;
function qn(r) {
    if (typeof r == "string" || mt(r)) return r;
    var t = r + "";
    return t == "0" && 1 / r == -Bn ? "-0" : t;
}
a(qn, "toKey");
var Vn = qn;
function Jn(r, t) {
    t = Hn(t, r);
    for(var e = 0, n = t.length; r != null && e < n;)r = r[Vn(t[e++])];
    return e && e == n ? r : void 0;
}
a(Jn, "baseGet");
var Kn = Jn;
function Yn(r, t, e) {
    var n = r == null ? void 0 : Kn(r, t);
    return n === void 0 ? e : n;
}
a(Yn, "get");
var Xn = Yn, it = De, Qn = /* @__PURE__ */ a((r)=>{
    let t = null, e = !1, n = !1, o = !1, s = "";
    if (r.indexOf("//") >= 0 || r.indexOf("/*") >= 0) for(let l = 0; l < r.length; l += 1)!t && !e && !n && !o ? r[l] === '"' || r[l] === "'" || r[l] === "`" ? t = r[l] : r[l] === "/" && r[l + 1] === "*" ? e = !0 : r[l] === "\
/" && r[l + 1] === "/" ? n = !0 : r[l] === "/" && r[l + 1] !== "/" && (o = !0) : (t && (r[l] === t && r[l - 1] !== "\\" || r[l] === `
` && t !== "`") && (t = null), o && (r[l] === "/" && r[l - 1] !== "\\" || r[l] === `
`) && (o = !1), e && r[l - 1] === "/" && r[l - 2] === "*" && (e = !1), n && r[l] === `
` && (n = !1)), !e && !n && (s += r[l]);
    else s = r;
    return s;
}, "removeCodeComments"), Zn = (0, Bt.default)(1e4)((r)=>Qn(r).replace(/\n\s*/g, "").trim()), to = /* @__PURE__ */ a(function(t, e) {
    let n = e.slice(0, e.indexOf("{")), o = e.slice(e.indexOf("{"));
    if (n.includes("=>") || n.includes("function")) return e;
    let s = n;
    return s = s.replace(t, "function"), s + o;
}, "convertShorthandMethods2"), eo = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/, J = /* @__PURE__ */ a((r)=>r.match(/^[\[\{\"\}].*[\]\}\"]$/), "isJSON");
function qt(r) {
    if (!it(r)) return r;
    let t = r, e = !1;
    return typeof Event < "u" && r instanceof Event && (t = Pt(t), e = !0), t = Object.keys(t).reduce((n, o)=>{
        try {
            t[o] && t[o].toJSON, n[o] = t[o];
        } catch  {
            e = !0;
        }
        return n;
    }, {}), e ? t : r;
}
a(qt, "convertUnconventionalData");
var ro = /* @__PURE__ */ a(function(t) {
    let e, n, o, s;
    return /* @__PURE__ */ a(function(c, i) {
        try {
            if (c === "") return s = [], e = /* @__PURE__ */ new Map([
                [
                    i,
                    "[]"
                ]
            ]), n = /* @__PURE__ */ new Map(), o = [], i;
            let g = n.get(this) || this;
            for(; o.length && g !== o[0];)o.shift(), s.pop();
            if (typeof i == "boolean") return i;
            if (i === void 0) return t.allowUndefined ? "_undefined_" : void 0;
            if (i === null) return null;
            if (typeof i == "number") return i === -1 / 0 ? "_-Infinity_" : i === 1 / 0 ? "_Infinity_" : Number.isNaN(i) ? "_NaN_" : i;
            if (typeof i == "bigint") return `_bigint_${i.toString()}`;
            if (typeof i == "string") return eo.test(i) ? t.allowDate ? `_date_${i}` : void 0 : i;
            if ((0, Ne.default)(i)) return t.allowRegExp ? `_regexp_${i.flags}|${i.source}` : void 0;
            if ((0, je.default)(i)) {
                if (!t.allowFunction) return;
                let { name: u } = i, y = i.toString();
                return y.match(/(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/) ? `_function_${u}|${(()=>{}).toString()}` : `_function_${u}|${Zn(to(c, y))}`;
            }
            if ((0, Le.default)(i)) {
                if (!t.allowSymbol) return;
                let u = Symbol.keyFor(i);
                return u !== void 0 ? `_gsymbol_${u}` : `_symbol_${i.toString().slice(7, -1)}`;
            }
            if (o.length >= t.maxDepth) return Array.isArray(i) ? `[Array(${i.length})]` : "[Object]";
            if (i === this) return `_duplicate_${JSON.stringify(s)}`;
            if (i instanceof Error && t.allowError) return {
                __isConvertedError__: !0,
                errorProperties: {
                    ...i.cause ? {
                        cause: i.cause
                    } : {},
                    ...i,
                    name: i.name,
                    message: i.message,
                    stack: i.stack,
                    "_constructor-name_": i.constructor.name
                }
            };
            if (i.constructor && i.constructor.name && i.constructor.name !== "Object" && !Array.isArray(i) && !t.allowClass) return;
            let p = e.get(i);
            if (!p) {
                let u = Array.isArray(i) ? i : qt(i);
                if (i.constructor && i.constructor.name && i.constructor.name !== "Object" && !Array.isArray(i) && t.allowClass) try {
                    Object.assign(u, {
                        "_constructor-name_": i.constructor.name
                    });
                } catch  {}
                return s.push(c), o.unshift(u), e.set(i, JSON.stringify(s)), i !== u && n.set(i, u), u;
            }
            return `_duplicate_${p}`;
        } catch  {
            return;
        }
    }, "replace");
}, "replacer2"), no = /* @__PURE__ */ a(function reviver(options) {
    let refs = [], root;
    return /* @__PURE__ */ a(function revive(key, value) {
        if (key === "" && (root = value, refs.forEach(({ target: r, container: t, replacement: e })=>{
            let n = J(e) ? JSON.parse(e) : e.split(".");
            n.length === 0 ? t[r] = root : t[r] = Xn(root, n);
        })), key === "_constructor-name_") return value;
        if (it(value) && value.__isConvertedError__) {
            let { message: r, ...t } = value.errorProperties, e = new Error(r);
            return Object.assign(e, t), e;
        }
        if (it(value) && value["_constructor-name_"] && options.allowFunction) {
            let r = value["_constructor-name_"];
            if (r !== "Object") {
                let t = new Function(`return function ${r.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
                Object.setPrototypeOf(value, new t());
            }
            return delete value["_constructor-name_"], value;
        }
        if (typeof value == "string" && value.startsWith("_function_") && options.allowFunction) {
            let [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [], sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
            if (!options.lazyEval) return eval(`(${sourceSanitized})`);
            let result = /* @__PURE__ */ a((...args)=>{
                let f = eval(`(${sourceSanitized})`);
                return f(...args);
            }, "result");
            return Object.defineProperty(result, "toString", {
                value: /* @__PURE__ */ a(()=>sourceSanitized, "value")
            }), Object.defineProperty(result, "name", {
                value: name
            }), result;
        }
        if (typeof value == "string" && value.startsWith("_regexp_") && options.allowRegExp) {
            let [, r, t] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
            return new RegExp(t, r);
        }
        return typeof value == "string" && value.startsWith("_date_") && options.allowDate ? new Date(value.replace("_date_", "")) : typeof value == "string" && value.startsWith("_duplicate_") ? (refs.push({
            target: key,
            container: this,
            replacement: value.replace(/^_duplicate_/, "")
        }), null) : typeof value == "string" && value.startsWith("_symbol_") && options.allowSymbol ? Symbol(value.replace("_symbol_", "")) : typeof value == "string" && value.startsWith("_gsymbol_") && options.allowSymbol ? Symbol.for(value.replace("_gsymbol_", "")) : typeof value == "string" && value === "_-Infinity_" ? -1 / 0 : typeof value == "string" && value === "_Infinity_" ? 1 / 0 : typeof value == "string" && value === "_\
NaN_" ? NaN : typeof value == "string" && value.startsWith("_bigint_") && typeof BigInt == "function" ? BigInt(value.replace("_bigint_", "")) : value;
    }, "revive");
}, "reviver"), Vt = {
    maxDepth: 10,
    space: void 0,
    allowFunction: !0,
    allowRegExp: !0,
    allowDate: !0,
    allowClass: !0,
    allowError: !0,
    allowUndefined: !0,
    allowSymbol: !0,
    lazyEval: !0
}, lt = /* @__PURE__ */ a((r, t = {})=>{
    let e = {
        ...Vt,
        ...t
    };
    return JSON.stringify(qt(r), ro(e), t.space);
}, "stringify"), oo = /* @__PURE__ */ a(()=>{
    let r = /* @__PURE__ */ new Map();
    return /* @__PURE__ */ a(function t(e) {
        it(e) && Object.entries(e).forEach(([n, o])=>{
            o === "_undefined_" ? e[n] = void 0 : r.get(o) || (r.set(o, !0), t(o));
        }), Array.isArray(e) && e.forEach((n, o)=>{
            n === "_undefined_" ? (r.set(n, !0), e[o] = void 0) : r.get(n) || (r.set(n, !0), t(n));
        });
    }, "mutateUndefined");
}, "mutator"), ct = /* @__PURE__ */ a((r, t = {})=>{
    let e = {
        ...Vt,
        ...t
    }, n = JSON.parse(r, no(e));
    return oo()(n), n;
}, "parse");
// ../node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var io = !1, St = "Invariant failed";
function K(r, t) {
    if (!r) {
        if (io) throw new Error(St);
        var e = typeof t == "function" ? t() : t, n = e ? "".concat(St, ": ").concat(e) : St;
        throw new Error(n);
    }
}
a(K, "invariant");
var Jt = /* @__PURE__ */ a((r)=>{
    let t = Array.from(document.querySelectorAll("iframe[data-is-storybook]")), [e, ...n] = t.filter((s)=>{
        try {
            return s.contentWindow?.location.origin === r.source.location.origin && s.contentWindow?.location.pathname === r.source.location.pathname;
        } catch  {}
        try {
            return s.contentWindow === r.source;
        } catch  {}
        let l = s.getAttribute("src"), c;
        try {
            if (!l) return !1;
            ({ origin: c } = new URL(l, document.location.toString()));
        } catch  {
            return !1;
        }
        return c === r.origin;
    }), o = e?.getAttribute("src");
    if (o && n.length === 0) {
        let { protocol: s, host: l, pathname: c } = new URL(o, document.location.toString());
        return `${s}//${l}${c}`;
    }
    return n.length > 0 && (0, _clientLogger.logger).error("found multiple candidates for event source"), null;
}, "getEventSourceUrl");
// src/channels/postmessage/index.ts
var { document: _t, location: Tt } = S, Xt = "storybook-channel", lo = {
    allowFunction: !1,
    maxDepth: 25
}, At = class At {
    constructor(t){
        this.config = t;
        this.connected = !1;
        if (this.buffer = [], typeof S?.addEventListener == "function" && S.addEventListener("message", this.handleEvent.bind(this), !1), t.page !== "manager" && t.page !== "preview") throw new Error(`postmsg-channel: "config.page" cannot be "${t.page}"`);
    }
    setHandler(t) {
        this.handler = (...e)=>{
            t.apply(this, e), !this.connected && this.getLocalFrame().length && (this.flush(), this.connected = !0);
        };
    }
    /**
   * Sends `event` to the associated window. If the window does not yet exist the event will be
   * stored in a buffer and sent when the window exists.
   *
   * @param event
   */ send(t, e) {
        let { target: n, // telejson options
        allowRegExp: o, allowFunction: s, allowSymbol: l, allowDate: c, allowError: i, allowUndefined: g, allowClass: p, maxDepth: u, space: y, lazyEval: v } = e || {}, d = Object.fromEntries(Object.entries({
            allowRegExp: o,
            allowFunction: s,
            allowSymbol: l,
            allowDate: c,
            allowError: i,
            allowUndefined: g,
            allowClass: p,
            maxDepth: u,
            space: y,
            lazyEval: v
        }).filter(([R, C])=>typeof C < "u")), m = {
            ...lo,
            ...S.CHANNEL_OPTIONS || {},
            ...d
        }, E = this.getFrames(n), I = new URLSearchParams(Tt?.search || ""), T = lt({
            key: Xt,
            event: t,
            refId: I.get("refId")
        }, m);
        return E.length ? (this.buffer.length && this.flush(), E.forEach((R)=>{
            try {
                R.postMessage(T, "*");
            } catch  {
                (0, _clientLogger.logger).error("sending over postmessage fail");
            }
        }), Promise.resolve(null)) : new Promise((R, C)=>{
            this.buffer.push({
                event: t,
                resolve: R,
                reject: C
            });
        });
    }
    flush() {
        let { buffer: t } = this;
        this.buffer = [], t.forEach((e)=>{
            this.send(e.event).then(e.resolve).catch(e.reject);
        });
    }
    getFrames(t) {
        if (this.config.page === "manager") {
            let n = Array.from(_t.querySelectorAll("iframe[data-is-storybook][data-is-loaded]")).flatMap((o)=>{
                try {
                    return o.contentWindow && o.dataset.isStorybook !== void 0 && o.id === t ? [
                        o.contentWindow
                    ] : [];
                } catch  {
                    return [];
                }
            });
            return n?.length ? n : this.getCurrentFrames();
        }
        return S && S.parent && S.parent !== S.self ? [
            S.parent
        ] : [];
    }
    getCurrentFrames() {
        return this.config.page === "manager" ? Array.from(_t.querySelectorAll('[data-is-storybook="true"]')).flatMap((e)=>e.contentWindow ? [
                e.contentWindow
            ] : []) : S && S.parent ? [
            S.parent
        ] : [];
    }
    getLocalFrame() {
        return this.config.page === "manager" ? Array.from(_t.querySelectorAll("#storybook-preview-iframe")).flatMap((e)=>e.contentWindow ? [
                e.contentWindow
            ] : []) : S && S.parent ? [
            S.parent
        ] : [];
    }
    handleEvent(t) {
        try {
            let { data: e } = t, { key: n, event: o, refId: s } = typeof e == "string" && J(e) ? ct(e, S.CHANNEL_OPTIONS || {}) : e;
            if (n === Xt) {
                let l = this.config.page === "manager" ? '<span style="color: #37D5D3; background: black"> manager </span>' : '<span style="color: #\
1EA7FD; background: black"> preview </span>', c = Object.values(_coreEvents).includes(o.type) ? `<span style="color: #FF4785">${o.type}</span>` : `<s\
pan style="color: #FFAE00">${o.type}</span>`;
                if (s && (o.refId = s), o.source = this.config.page === "preview" ? t.origin : Jt(t), !o.source) {
                    (0, _clientLogger.pretty).error(`${l} received ${c} but was unable to determine the source of the event`);
                    return;
                }
                let i = `${l} received ${c} (${e.length})`;
                (0, _clientLogger.pretty).debug(Tt.origin !== o.source ? i : `${i} <span style="color: gray">(on ${Tt.origin} from ${o.source})</span>`, ...o.args), K(this.handler, "ChannelHandler should be set"), this.handler(o);
            }
        } catch (e) {
            (0, _clientLogger.logger).error(e);
        }
    }
};
a(At, "PostMessageTransport");
var Y = At;
var { WebSocket: co } = S, Zt = 15e3, te = 5e3, wt = class wt {
    constructor({ url: t, onError: e, page: n }){
        this.buffer = [];
        this.isReady = !1;
        this.isClosed = !1;
        this.pingTimeout = 0;
        this.socket = new co(t), this.socket.onopen = ()=>{
            this.isReady = !0, this.heartbeat(), this.flush();
        }, this.socket.onmessage = ({ data: o })=>{
            let s = typeof o == "string" && J(o) ? ct(o) : o;
            K(this.handler, "WebsocketTransport handler should be set"), this.handler(s), s.type === "ping" && (this.heartbeat(), this.send({
                type: "\
pong"
            }));
        }, this.socket.onerror = (o)=>{
            e && e(o);
        }, this.socket.onclose = (o)=>{
            K(this.handler, "WebsocketTransport handler should be set"), this.handler({
                type: _coreEvents.CHANNEL_WS_DISCONNECT,
                args: [
                    {
                        reason: o.reason,
                        code: o.code
                    }
                ],
                from: n || "preview"
            }), this.isClosed = !0, clearTimeout(this.pingTimeout);
        };
    }
    heartbeat() {
        clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
            this.socket.close(3008, "timeout");
        }, Zt + te);
    }
    setHandler(t) {
        this.handler = t;
    }
    send(t) {
        this.isClosed || (this.isReady ? this.sendNow(t) : this.sendLater(t));
    }
    sendLater(t) {
        this.buffer.push(t);
    }
    sendNow(t) {
        let e = lt(t, {
            maxDepth: 15,
            allowFunction: !1,
            ...S.CHANNEL_OPTIONS
        });
        this.socket.send(e);
    }
    flush() {
        let { buffer: t } = this;
        this.buffer = [], t.forEach((e)=>this.send(e));
    }
};
a(wt, "WebsocketTransport");
var X = wt;
// src/channels/index.ts
var { CONFIG_TYPE: po } = S, Xo = B;
function Qo({ page: r, extraTransports: t = [] }) {
    let e = [
        new Y({
            page: r
        }),
        ...t
    ];
    if (po === "DEVELOPMENT") {
        let o = window.location.protocol === "http:" ? "ws" : "wss", { hostname: s, port: l } = window.location, c = `${o}://${s}:${l}/storybook\
-server-channel`;
        e.push(new X({
            url: c,
            onError: /* @__PURE__ */ a(()=>{}, "onError"),
            page: r
        }));
    }
    let n = new B({
        transports: e
    });
    return $.__prepare(n, r === "manager" ? $.Environment.MANAGER : $.Environment.PREVIEW), n;
}
a(Qo, "createBrowserChannel");

},{"@storybook/core/client-logger":"a4BZx","@storybook/core/core-events":"l8kjz","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"a4BZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deprecate", ()=>m);
parcelHelpers.export(exports, "logger", ()=>s);
parcelHelpers.export(exports, "once", ()=>n);
parcelHelpers.export(exports, "pretty", ()=>r);
var global = arguments[3];
var u = Object.defineProperty;
var a = (e, o)=>u(e, "name", {
        value: o,
        configurable: !0
    });
// ../node_modules/@storybook/global/dist/index.mjs
var y = (()=>{
    let e;
    return typeof window < "u" ? e = window : typeof globalThis < "u" ? e = globalThis : typeof global < "u" ? e = global : typeof self < "u" ? e = self : e = {}, e;
})();
// src/client-logger/index.ts
var { LOGLEVEL: b } = y, t = {
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    silent: 10
}, L = b, i = t[L] || t.info, s = {
    trace: /* @__PURE__ */ a((e, ...o)=>{
        i <= t.trace && console.trace(e, ...o);
    }, "trace"),
    debug: /* @__PURE__ */ a((e, ...o)=>{
        i <= t.debug && console.debug(e, ...o);
    }, "debug"),
    info: /* @__PURE__ */ a((e, ...o)=>{
        i <= t.info && console.info(e, ...o);
    }, "info"),
    warn: /* @__PURE__ */ a((e, ...o)=>{
        i <= t.warn && console.warn(e, ...o);
    }, "warn"),
    error: /* @__PURE__ */ a((e, ...o)=>{
        i <= t.error && console.error(e, ...o);
    }, "error"),
    log: /* @__PURE__ */ a((e, ...o)=>{
        i < t.silent && console.log(e, ...o);
    }, "log")
}, c = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ a((e)=>(o, ...l)=>{
        if (!c.has(o)) return c.add(o), s[e](o, ...l);
    }, "once");
n.clear = ()=>c.clear();
n.trace = n("trace");
n.debug = n("debug");
n.info = n("info");
n.warn = n("warn");
n.error = n("error");
n.log = n("log");
var m = n("warn"), r = /* @__PURE__ */ a((e)=>(...o)=>{
        let l = [];
        if (o.length) {
            let f = /<span\s+style=(['"])([^'"]*)\1\s*>/gi, p = /<\/span>/gi, d;
            for(l.push(o[0].replace(f, "%c").replace(p, "%c")); d = f.exec(o[0]);)l.push(d[2]), l.push("");
            for(let g = 1; g < o.length; g++)l.push(o[g]);
        }
        s[e].apply(s, l);
    }, "pretty");
r.trace = r("trace");
r.debug = r("debug");
r.info = r("info");
r.warn = r("warn");
r.error = r("error");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"l8kjz":[function(require,module,exports,__globalThis) {
// src/core-events/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARGTYPES_INFO_REQUEST", ()=>SE);
parcelHelpers.export(exports, "ARGTYPES_INFO_RESPONSE", ()=>TE);
parcelHelpers.export(exports, "CHANNEL_CREATED", ()=>T);
parcelHelpers.export(exports, "CHANNEL_WS_DISCONNECT", ()=>S);
parcelHelpers.export(exports, "CONFIG_ERROR", ()=>N);
parcelHelpers.export(exports, "CREATE_NEW_STORYFILE_REQUEST", ()=>O);
parcelHelpers.export(exports, "CREATE_NEW_STORYFILE_RESPONSE", ()=>A);
parcelHelpers.export(exports, "CURRENT_STORY_WAS_SET", ()=>r);
parcelHelpers.export(exports, "DOCS_PREPARED", ()=>D);
parcelHelpers.export(exports, "DOCS_RENDERED", ()=>I);
parcelHelpers.export(exports, "FILE_COMPONENT_SEARCH_REQUEST", ()=>o);
parcelHelpers.export(exports, "FILE_COMPONENT_SEARCH_RESPONSE", ()=>C);
parcelHelpers.export(exports, "FORCE_REMOUNT", ()=>P);
parcelHelpers.export(exports, "FORCE_RE_RENDER", ()=>L);
parcelHelpers.export(exports, "GLOBALS_UPDATED", ()=>U);
parcelHelpers.export(exports, "NAVIGATE_URL", ()=>G);
parcelHelpers.export(exports, "PLAY_FUNCTION_THREW_EXCEPTION", ()=>a);
parcelHelpers.export(exports, "PRELOAD_ENTRIES", ()=>t);
parcelHelpers.export(exports, "PREVIEW_BUILDER_PROGRESS", ()=>d);
parcelHelpers.export(exports, "PREVIEW_KEYDOWN", ()=>e);
parcelHelpers.export(exports, "REGISTER_SUBSCRIPTION", ()=>H);
parcelHelpers.export(exports, "REQUEST_WHATS_NEW_DATA", ()=>J);
parcelHelpers.export(exports, "RESET_STORY_ARGS", ()=>W);
parcelHelpers.export(exports, "RESULT_WHATS_NEW_DATA", ()=>Z);
parcelHelpers.export(exports, "SAVE_STORY_REQUEST", ()=>RE);
parcelHelpers.export(exports, "SAVE_STORY_RESPONSE", ()=>_E);
parcelHelpers.export(exports, "SELECT_STORY", ()=>l);
parcelHelpers.export(exports, "SET_CONFIG", ()=>i);
parcelHelpers.export(exports, "SET_CURRENT_STORY", ()=>p);
parcelHelpers.export(exports, "SET_FILTER", ()=>F);
parcelHelpers.export(exports, "SET_GLOBALS", ()=>u);
parcelHelpers.export(exports, "SET_INDEX", ()=>M);
parcelHelpers.export(exports, "SET_STORIES", ()=>s);
parcelHelpers.export(exports, "SET_WHATS_NEW_CACHE", ()=>$);
parcelHelpers.export(exports, "SHARED_STATE_CHANGED", ()=>y);
parcelHelpers.export(exports, "SHARED_STATE_SET", ()=>c);
parcelHelpers.export(exports, "STORIES_COLLAPSE_ALL", ()=>g);
parcelHelpers.export(exports, "STORIES_EXPAND_ALL", ()=>h);
parcelHelpers.export(exports, "STORY_ARGS_UPDATED", ()=>f);
parcelHelpers.export(exports, "STORY_CHANGED", ()=>Q);
parcelHelpers.export(exports, "STORY_ERRORED", ()=>x);
parcelHelpers.export(exports, "STORY_FINISHED", ()=>q);
parcelHelpers.export(exports, "STORY_INDEX_INVALIDATED", ()=>m);
parcelHelpers.export(exports, "STORY_MISSING", ()=>V);
parcelHelpers.export(exports, "STORY_PREPARED", ()=>w);
parcelHelpers.export(exports, "STORY_RENDERED", ()=>X);
parcelHelpers.export(exports, "STORY_RENDER_PHASE_CHANGED", ()=>B);
parcelHelpers.export(exports, "STORY_SPECIFIED", ()=>b);
parcelHelpers.export(exports, "STORY_THREW_EXCEPTION", ()=>K);
parcelHelpers.export(exports, "STORY_UNCHANGED", ()=>j);
parcelHelpers.export(exports, "TELEMETRY_ERROR", ()=>EE);
parcelHelpers.export(exports, "TESTING_MODULE_CANCEL_TEST_RUN_REQUEST", ()=>DE);
parcelHelpers.export(exports, "TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE", ()=>IE);
parcelHelpers.export(exports, "TESTING_MODULE_CRASH_REPORT", ()=>NE);
parcelHelpers.export(exports, "TESTING_MODULE_PROGRESS_REPORT", ()=>OE);
parcelHelpers.export(exports, "TESTING_MODULE_RUN_ALL_REQUEST", ()=>rE);
parcelHelpers.export(exports, "TESTING_MODULE_RUN_REQUEST", ()=>AE);
parcelHelpers.export(exports, "TOGGLE_WHATS_NEW_NOTIFICATIONS", ()=>v);
parcelHelpers.export(exports, "UNHANDLED_ERRORS_WHILE_PLAYING", ()=>Y);
parcelHelpers.export(exports, "UPDATE_GLOBALS", ()=>k);
parcelHelpers.export(exports, "UPDATE_QUERY_PARAMS", ()=>n);
parcelHelpers.export(exports, "UPDATE_STORY_ARGS", ()=>z);
parcelHelpers.export(exports, "default", ()=>_);
var R = /* @__PURE__ */ ((E)=>(E.CHANNEL_WS_DISCONNECT = "channelWSDisconnect", E.CHANNEL_CREATED = "channelCreated", E.CONFIG_ERROR = "co\
nfigError", E.STORY_INDEX_INVALIDATED = "storyIndexInvalidated", E.STORY_SPECIFIED = "storySpecified", E.SET_CONFIG = "setConfig", E.SET_STORIES = "setStories", E.SET_INDEX = "setIndex", E.SET_CURRENT_STORY = "setCurrentStory", E.CURRENT_STORY_WAS_SET = "currentStoryWasSet", E.FORCE_RE_RENDER = "forceReRender", E.FORCE_REMOUNT = "forceRemount", E.PRELOAD_ENTRIES = "preloadStories", E.STORY_PREPARED = "storyPrepared", E.DOCS_PREPARED = "docsPrepared", E.STORY_CHANGED = "storyChanged", E.STORY_UNCHANGED = "storyUnchanged", E.STORY_RENDERED = "storyRendered", E.STORY_FINISHED = "storyFinished", E.STORY_MISSING = "storyMissing", E.STORY_ERRORED = "storyErrored", E.STORY_THREW_EXCEPTION = "storyThrewException", E.STORY_RENDER_PHASE_CHANGED = "storyRenderPhaseChanged", E.PLAY_FUNCTION_THREW_EXCEPTION = "playFunctionThrewException", E.UNHANDLED_ERRORS_WHILE_PLAYING = "unhandledErro\
rsWhilePlaying", E.UPDATE_STORY_ARGS = "updateStoryArgs", E.STORY_ARGS_UPDATED = "storyArgsUpdated", E.RESET_STORY_ARGS = "resetStoryArgs", E.SET_FILTER = "setFilter", E.SET_GLOBALS = "setGlobals", E.UPDATE_GLOBALS = "updateGlobals", E.GLOBALS_UPDATED = "globalsUpdated", E.REGISTER_SUBSCRIPTION = "registerSubscription", E.PREVIEW_KEYDOWN = "previewKeydown", E.PREVIEW_BUILDER_PROGRESS = "preview_builder_progress", E.SELECT_STORY = "sel\
ectStory", E.STORIES_COLLAPSE_ALL = "storiesCollapseAll", E.STORIES_EXPAND_ALL = "storiesExpandAll", E.DOCS_RENDERED = "docsRendered", E.SHARED_STATE_CHANGED = "sharedStateChanged", E.SHARED_STATE_SET = "sharedStateSet", E.NAVIGATE_URL = "navigateUrl", E.UPDATE_QUERY_PARAMS = "updateQueryParams", E.REQUEST_WHATS_NEW_DATA = "requestWhatsNewData", E.RESULT_WHATS_NEW_DATA = "resultWhatsNewData", E.SET_WHATS_NEW_CACHE = "setWhatsNewCache", E.TOGGLE_WHATS_NEW_NOTIFICATIONS = "toggleWhatsNewNotifications", E.TELEMETRY_ERROR = "telemetryError", E.FILE_COMPONENT_SEARCH_REQUEST = "fil\
eComponentSearchRequest", E.FILE_COMPONENT_SEARCH_RESPONSE = "fileComponentSearchResponse", E.SAVE_STORY_REQUEST = "saveStoryRequest", E.SAVE_STORY_RESPONSE = "saveStoryResponse", E.ARGTYPES_INFO_REQUEST = "argtypesInfoRequest", E.ARGTYPES_INFO_RESPONSE = "argtypesInfoResponse", E.CREATE_NEW_STORYFILE_REQUEST = "createNewStoryfileRequest", E.CREATE_NEW_STORYFILE_RESPONSE = "createNewStoryfileResponse", E.TESTING_MODULE_CRASH_REPORT = "testingModuleC\
rashReport", E.TESTING_MODULE_PROGRESS_REPORT = "testingModuleProgressReport", E.TESTING_MODULE_RUN_REQUEST = "testingModuleRunRequest", E.TESTING_MODULE_RUN_ALL_REQUEST = "testingModuleRunAllRequest", E.TESTING_MODULE_CANCEL_TEST_RUN_REQUEST = "testingModuleCancelTestRunRequest", E.TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE = "testingModuleCancelTestRunResponse", E))(R || {}), _ = R, { CHANNEL_WS_DISCONNECT: S, CHANNEL_CREATED: T, CONFIG_ERROR: N, CREATE_NEW_STORYFILE_REQUEST: O, CREATE_NEW_STORYFILE_RESPONSE: A, CURRENT_STORY_WAS_SET: r, DOCS_PREPARED: D, DOCS_RENDERED: I, FILE_COMPONENT_SEARCH_REQUEST: o, FILE_COMPONENT_SEARCH_RESPONSE: C, FORCE_RE_RENDER: L, FORCE_REMOUNT: P, GLOBALS_UPDATED: U, NAVIGATE_URL: G, PLAY_FUNCTION_THREW_EXCEPTION: a, UNHANDLED_ERRORS_WHILE_PLAYING: Y, PRELOAD_ENTRIES: t, PREVIEW_BUILDER_PROGRESS: d, PREVIEW_KEYDOWN: e, REGISTER_SUBSCRIPTION: H, RESET_STORY_ARGS: W, SELECT_STORY: l, SET_CONFIG: i, SET_CURRENT_STORY: p, SET_FILTER: F, SET_GLOBALS: u, SET_INDEX: M, SET_STORIES: s, SHARED_STATE_CHANGED: y, SHARED_STATE_SET: c, STORIES_COLLAPSE_ALL: g, STORIES_EXPAND_ALL: h, STORY_ARGS_UPDATED: f, STORY_CHANGED: Q, STORY_ERRORED: x, STORY_INDEX_INVALIDATED: m, STORY_MISSING: V, STORY_PREPARED: w, STORY_RENDER_PHASE_CHANGED: B, STORY_RENDERED: X, STORY_FINISHED: q, STORY_SPECIFIED: b, STORY_THREW_EXCEPTION: K, STORY_UNCHANGED: j, UPDATE_GLOBALS: k, UPDATE_QUERY_PARAMS: n, UPDATE_STORY_ARGS: z, REQUEST_WHATS_NEW_DATA: J, RESULT_WHATS_NEW_DATA: Z, SET_WHATS_NEW_CACHE: $, TOGGLE_WHATS_NEW_NOTIFICATIONS: v, TELEMETRY_ERROR: EE, SAVE_STORY_REQUEST: RE, SAVE_STORY_RESPONSE: _E, ARGTYPES_INFO_REQUEST: SE, ARGTYPES_INFO_RESPONSE: TE, TESTING_MODULE_CRASH_REPORT: NE, TESTING_MODULE_PROGRESS_REPORT: OE, TESTING_MODULE_RUN_REQUEST: AE, TESTING_MODULE_RUN_ALL_REQUEST: rE, TESTING_MODULE_CANCEL_TEST_RUN_REQUEST: DE, TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE: IE } = R;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"iduAM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _previewApi = require("@storybook/core/preview-api");
parcelHelpers.exportAll(_previewApi, exports);

},{"@storybook/core/preview-api":"fer43","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"fer43":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocsContext", ()=>re);
parcelHelpers.export(exports, "HooksContext", ()=>se);
parcelHelpers.export(exports, "Preview", ()=>xe);
parcelHelpers.export(exports, "PreviewWeb", ()=>gr);
parcelHelpers.export(exports, "PreviewWithSelection", ()=>we);
parcelHelpers.export(exports, "ReporterAPI", ()=>le);
parcelHelpers.export(exports, "StoryStore", ()=>Re);
parcelHelpers.export(exports, "UrlStore", ()=>ve);
parcelHelpers.export(exports, "WebView", ()=>Ae);
parcelHelpers.export(exports, "addons", ()=>V);
parcelHelpers.export(exports, "applyHooks", ()=>vr);
parcelHelpers.export(exports, "combineArgs", ()=>ke);
parcelHelpers.export(exports, "combineParameters", ()=>M);
parcelHelpers.export(exports, "composeConfigs", ()=>Ee);
parcelHelpers.export(exports, "composeStepRunners", ()=>Kr);
parcelHelpers.export(exports, "composeStories", ()=>Zs);
parcelHelpers.export(exports, "composeStory", ()=>Ro);
parcelHelpers.export(exports, "createPlaywrightTest", ()=>ei);
parcelHelpers.export(exports, "decorateStory", ()=>go);
parcelHelpers.export(exports, "defaultDecorateStory", ()=>Hr);
parcelHelpers.export(exports, "definePreview", ()=>Jn);
parcelHelpers.export(exports, "experimental_MockUniversalStore", ()=>Nr);
parcelHelpers.export(exports, "experimental_UniversalStore", ()=>J);
parcelHelpers.export(exports, "experimental_useUniversalStore", ()=>Ss);
parcelHelpers.export(exports, "filterArgTypes", ()=>rr);
parcelHelpers.export(exports, "getCsfFactoryAnnotations", ()=>Jr);
parcelHelpers.export(exports, "inferControls", ()=>Ne);
parcelHelpers.export(exports, "makeDecorator", ()=>ys);
parcelHelpers.export(exports, "mockChannel", ()=>Tr);
parcelHelpers.export(exports, "normalizeProjectAnnotations", ()=>be);
parcelHelpers.export(exports, "normalizeStory", ()=>Se);
parcelHelpers.export(exports, "prepareMeta", ()=>Wr);
parcelHelpers.export(exports, "prepareStory", ()=>Le);
parcelHelpers.export(exports, "sanitizeStoryContextUpdate", ()=>So);
parcelHelpers.export(exports, "setDefaultProjectAnnotations", ()=>$s);
parcelHelpers.export(exports, "setProjectAnnotations", ()=>Js);
parcelHelpers.export(exports, "simulateDOMContentLoaded", ()=>Sr);
parcelHelpers.export(exports, "simulatePageLoad", ()=>Bn);
parcelHelpers.export(exports, "sortStoriesV7", ()=>ci);
parcelHelpers.export(exports, "useArgs", ()=>us);
parcelHelpers.export(exports, "useCallback", ()=>Oe);
parcelHelpers.export(exports, "useChannel", ()=>ds);
parcelHelpers.export(exports, "useEffect", ()=>jt);
parcelHelpers.export(exports, "useGlobals", ()=>fs);
parcelHelpers.export(exports, "useMemo", ()=>ss);
parcelHelpers.export(exports, "useParameter", ()=>ps);
parcelHelpers.export(exports, "useReducer", ()=>cs);
parcelHelpers.export(exports, "useRef", ()=>is);
parcelHelpers.export(exports, "useState", ()=>ls);
parcelHelpers.export(exports, "useStoryContext", ()=>We);
parcelHelpers.export(exports, "userOrAutoTitle", ()=>ai);
parcelHelpers.export(exports, "userOrAutoTitleFromSpecifier", ()=>Co);
// src/preview-api/modules/addons/storybook-channel-mock.ts
var _channels = require("@storybook/core/channels");
// src/preview-api/modules/addons/hooks.ts
var _clientLogger = require("@storybook/core/client-logger");
var _coreEvents = require("@storybook/core/core-events");
// src/shared/universal-store/use-universal-store-preview.ts
var _previewApi = require("@storybook/core/preview-api");
var _previewErrors = require("@storybook/core/preview-errors");
// src/preview-api/modules/store/csf/normalizeStory.ts
var _csf = require("@storybook/core/csf");
var global = arguments[3];
var Buffer = require("9a66d1ff730df16a").Buffer;
var zn = Object.create;
var br = Object.defineProperty;
var Vn = Object.getOwnPropertyDescriptor;
var Hn = Object.getOwnPropertyNames;
var Wn = Object.getPrototypeOf, $n = Object.prototype.hasOwnProperty;
var s = (r, e)=>br(r, "name", {
        value: e,
        configurable: !0
    }), Fe = /* @__PURE__ */ ((r)=>undefined)(function(r) {
    return undefined(this, arguments);
});
var k = (r, e)=>()=>(e || r((e = {
            exports: {}
        }).exports, e), e.exports);
var Yn = (r, e, t, o)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let n of Hn(e))!$n.call(r, n) && n !== t && br(r, n, {
        get: ()=>e[n],
        enumerable: !(o = Vn(e, n)) || o.enumerable
    });
    return r;
};
var he = (r, e, t)=>(t = r != null ? zn(Wn(r)) : {}, Yn(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    e || !r || !r.__esModule ? br(t, "default", {
        value: r,
        enumerable: !0
    }) : t, r));
// ../node_modules/memoizerific/memoizerific.js
var _r = k((io, Mr)=>{
    (function(r) {
        if (typeof io == "object" && typeof Mr < "u") Mr.exports = r();
        else if (typeof define == "function" && define.amd) define([], r);
        else {
            var e;
            typeof window < "u" ? e = window : typeof global < "u" ? e = global : typeof self < "u" ? e = self : e = this, e.memoizerific = r();
        }
    })(function() {
        var r, e, t;
        return /* @__PURE__ */ s(function o(n, i, a) {
            function l(p, u) {
                if (!i[p]) {
                    if (!n[p]) {
                        var y = typeof Fe == "function" && Fe;
                        if (!u && y) return y(p, !0);
                        if (c) return c(p, !0);
                        var m = new Error("Cannot find module '" + p + "'");
                        throw m.code = "MODULE_NOT_FOUND", m;
                    }
                    var g = i[p] = {
                        exports: {}
                    };
                    n[p][0].call(g.exports, function(S) {
                        var h = n[p][1][S];
                        return l(h || S);
                    }, g, g.exports, o, n, i, a);
                }
                return i[p].exports;
            }
            s(l, "s");
            for(var c = typeof Fe == "function" && Fe, d = 0; d < a.length; d++)l(a[d]);
            return l;
        }, "e")({
            1: [
                function(o, n, i) {
                    n.exports = function(a) {
                        if (typeof Map != "function" || a) {
                            var l = o("./similar");
                            return new l();
                        } else return /* @__PURE__ */ new Map();
                    };
                },
                {
                    "./similar": 2
                }
            ],
            2: [
                function(o, n, i) {
                    function a() {
                        return this.list = [], this.lastItem = void 0, this.size = 0, this;
                    }
                    s(a, "Similar"), a.prototype.get = function(l) {
                        var c;
                        if (this.lastItem && this.isEqual(this.lastItem.key, l)) return this.lastItem.val;
                        if (c = this.indexOf(l), c >= 0) return this.lastItem = this.list[c], this.list[c].val;
                    }, a.prototype.set = function(l, c) {
                        var d;
                        return this.lastItem && this.isEqual(this.lastItem.key, l) ? (this.lastItem.val = c, this) : (d = this.indexOf(l), d >= 0 ? (this.lastItem = this.list[d], this.list[d].val = c, this) : (this.lastItem = {
                            key: l,
                            val: c
                        }, this.list.push(this.lastItem), this.size++, this));
                    }, a.prototype.delete = function(l) {
                        var c;
                        if (this.lastItem && this.isEqual(this.lastItem.key, l) && (this.lastItem = void 0), c = this.indexOf(l), c >= 0) return this.size--, this.list.splice(c, 1)[0];
                    }, a.prototype.has = function(l) {
                        var c;
                        return this.lastItem && this.isEqual(this.lastItem.key, l) ? !0 : (c = this.indexOf(l), c >= 0 ? (this.lastItem = this.list[c], !0) : !1);
                    }, a.prototype.forEach = function(l, c) {
                        var d;
                        for(d = 0; d < this.size; d++)l.call(c || this, this.list[d].val, this.list[d].key, this);
                    }, a.prototype.indexOf = function(l) {
                        var c;
                        for(c = 0; c < this.size; c++)if (this.isEqual(this.list[c].key, l)) return c;
                        return -1;
                    }, a.prototype.isEqual = function(l, c) {
                        return l === c || l !== l && c !== c;
                    }, n.exports = a;
                },
                {}
            ],
            3: [
                function(o, n, i) {
                    var a = o("map-or-similar");
                    n.exports = function(p) {
                        var u = new a(!1), y = [];
                        return function(m) {
                            var g = /* @__PURE__ */ s(function() {
                                var S = u, h, E, R = arguments.length - 1, f = Array(R + 1), b = !0, x;
                                if ((g.numArgs || g.numArgs === 0) && g.numArgs !== R + 1) throw new Error("Memoizerific functions should always be called with the same number of arguments");
                                for(x = 0; x < R; x++){
                                    if (f[x] = {
                                        cacheItem: S,
                                        arg: arguments[x]
                                    }, S.has(arguments[x])) {
                                        S = S.get(arguments[x]);
                                        continue;
                                    }
                                    b = !1, h = new a(!1), S.set(arguments[x], h), S = h;
                                }
                                return b && (S.has(arguments[R]) ? E = S.get(arguments[R]) : b = !1), b || (E = m.apply(null, arguments), S.set(arguments[R], E)), p > 0 && (f[R] = {
                                    cacheItem: S,
                                    arg: arguments[R]
                                }, b ? l(y, f) : y.push(f), y.length > p && c(y.shift())), g.wasMemoized = b, g.numArgs = R + 1, E;
                            }, "memoizerific");
                            return g.limit = p, g.wasMemoized = !1, g.cache = u, g.lru = y, g;
                        };
                    };
                    function l(p, u) {
                        var y = p.length, m = u.length, g, S, h;
                        for(S = 0; S < y; S++){
                            for(g = !0, h = 0; h < m; h++)if (!d(p[S][h].arg, u[h].arg)) {
                                g = !1;
                                break;
                            }
                            if (g) break;
                        }
                        p.push(p.splice(S, 1)[0]);
                    }
                    s(l, "moveToMostRecentLru");
                    function c(p) {
                        var u = p.length, y = p[u - 1], m, g;
                        for(y.cacheItem.delete(y.arg), g = u - 2; g >= 0 && (y = p[g], m = y.cacheItem.get(y.arg), !m || !m.size); g--)y.cacheItem.delete(y.arg);
                    }
                    s(c, "removeCachedResult");
                    function d(p, u) {
                        return p === u || p !== p && u !== u;
                    }
                    s(d, "isEqual");
                },
                {
                    "map-or-similar": 1
                }
            ]
        }, {}, [
            3
        ])(3);
    });
});
// ../node_modules/picoquery/lib/string-util.js
var dt = k((ct)=>{
    "use strict";
    Object.defineProperty(ct, "__esModule", {
        value: !0
    });
    ct.encodeString = ta;
    var H = Array.from({
        length: 256
    }, (r, e)=>"%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase()), ra = new Int8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0
    ]);
    function ta(r) {
        let e = r.length;
        if (e === 0) return "";
        let t = "", o = 0, n = 0;
        e: for(; n < e; n++){
            let i = r.charCodeAt(n);
            for(; i < 128;){
                if (ra[i] !== 1 && (o < n && (t += r.slice(o, n)), o = n + 1, t += H[i]), ++n === e) break e;
                i = r.charCodeAt(n);
            }
            if (o < n && (t += r.slice(o, n)), i < 2048) {
                o = n + 1, t += H[192 | i >> 6] + H[128 | i & 63];
                continue;
            }
            if (i < 55296 || i >= 57344) {
                o = n + 1, t += H[224 | i >> 12] + H[128 | i >> 6 & 63] + H[128 | i & 63];
                continue;
            }
            if (++n, n >= e) throw new Error("URI malformed");
            let a = r.charCodeAt(n) & 1023;
            o = n + 1, i = 65536 + ((i & 1023) << 10 | a), t += H[240 | i >> 18] + H[128 | i >> 12 & 63] + H[128 | i >> 6 & 63] + H[128 | i & 63];
        }
        return o === 0 ? r : o < e ? t + r.slice(o) : t;
    }
    s(ta, "encodeString");
});
// ../node_modules/picoquery/lib/shared.js
var sr = k((W)=>{
    "use strict";
    Object.defineProperty(W, "__esModule", {
        value: !0
    });
    W.defaultOptions = W.defaultShouldSerializeObject = W.defaultValueSerializer = void 0;
    var pt = dt(), oa = /* @__PURE__ */ s((r)=>{
        switch(typeof r){
            case "string":
                return (0, pt.encodeString)(r);
            case "bigint":
            case "boolean":
                return "" + r;
            case "number":
                if (Number.isFinite(r)) return r < 1e21 ? "" + r : (0, pt.encodeString)("" + r);
                break;
        }
        return r instanceof Date ? (0, pt.encodeString)(r.toISOString()) : "";
    }, "defaultValueSerializer");
    W.defaultValueSerializer = oa;
    var na = /* @__PURE__ */ s((r)=>r instanceof Date, "defaultShouldSerializeObject");
    W.defaultShouldSerializeObject = na;
    var Bo = /* @__PURE__ */ s((r)=>r, "identityFunc");
    W.defaultOptions = {
        nesting: !0,
        nestingSyntax: "dot",
        arrayRepeat: !1,
        arrayRepeatSyntax: "repeat",
        delimiter: 38,
        valueDeserializer: Bo,
        valueSerializer: W.defaultValueSerializer,
        keyDeserializer: Bo,
        shouldSerializeObject: W.defaultShouldSerializeObject
    };
});
// ../node_modules/picoquery/lib/object-util.js
var ut = k((ir)=>{
    "use strict";
    Object.defineProperty(ir, "__esModule", {
        value: !0
    });
    ir.getDeepObject = aa;
    ir.stringifyObject = zo;
    var de = sr(), sa = dt();
    function ia(r) {
        return r === "__proto__" || r === "constructor" || r === "prototype";
    }
    s(ia, "isPrototypeKey");
    function aa(r, e, t, o, n) {
        if (ia(e)) return r;
        let i = r[e];
        return typeof i == "object" && i !== null ? i : !o && (n || typeof t == "number" || typeof t == "string" && t * 0 === 0 && t.indexOf(".") === -1) ? r[e] = [] : r[e] = {};
    }
    s(aa, "getDeepObject");
    var la = 20, ca = "[]", da = "[", pa = "]", ua = ".";
    function zo(r, e, t = 0, o, n) {
        let { nestingSyntax: i = de.defaultOptions.nestingSyntax, arrayRepeat: a = de.defaultOptions.arrayRepeat, arrayRepeatSyntax: l = de.defaultOptions.arrayRepeatSyntax, nesting: c = de.defaultOptions.nesting, delimiter: d = de.defaultOptions.delimiter, valueSerializer: p = de.defaultOptions.valueSerializer, shouldSerializeObject: u = de.defaultOptions.shouldSerializeObject } = e, y = typeof d == "number" ? String.fromCharCode(d) : d, m = n === !0 && a, g = i === "dot" || i === "js" && !n;
        if (t > la) return "";
        let S = "", h = !0, E = !1;
        for(let R in r){
            let f = r[R], b;
            o ? (b = o, m ? l === "bracket" && (b += ca) : g ? (b += ua, b += R) : (b += da, b += R, b += pa)) : b = R, h || (S += y), typeof f == "object" && f !== null && !u(f) ? (E = f.pop !== void 0, (c || a && E) && (S += zo(f, e, t + 1, b, E))) : (S += (0, sa.encodeString)(b), S += "=", S += p(f, R)), h && (h = !1);
        }
        return S;
    }
    s(zo, "stringifyObject");
});
// ../node_modules/fast-decode-uri-component/index.js
var $o = k((df, Wo)=>{
    "use strict";
    var Vo = 12, fa = 0, ft = [
        // The first part of the table maps bytes to character to a transition.
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        4,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        6,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        8,
        7,
        7,
        10,
        9,
        9,
        9,
        11,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        // The second part of the table maps a state to a new state when adding a
        // transition.
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        24,
        36,
        48,
        60,
        72,
        84,
        96,
        0,
        12,
        12,
        12,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        24,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        48,
        48,
        48,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        48,
        48,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        48,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // The third part maps the current transition to a mask that needs to apply
        // to the byte.
        127,
        63,
        63,
        63,
        0,
        31,
        15,
        15,
        15,
        7,
        7,
        7
    ];
    function ya(r) {
        var e = r.indexOf("%");
        if (e === -1) return r;
        for(var t = r.length, o = "", n = 0, i = 0, a = e, l = Vo; e > -1 && e < t;){
            var c = Ho(r[e + 1], 4), d = Ho(r[e + 2], 0), p = c | d, u = ft[p];
            if (l = ft[256 + l + u], i = i << 6 | p & ft[364 + u], l === Vo) o += r.slice(n, a), o += i <= 65535 ? String.fromCharCode(i) : String.fromCharCode(55232 + (i >> 10), 56320 + (i & 1023)), i = 0, n = e + 3, e = a = r.indexOf("%", n);
            else {
                if (l === fa) return null;
                if (e += 3, e < t && r.charCodeAt(e) === 37) continue;
                return null;
            }
        }
        return o + r.slice(n);
    }
    s(ya, "decodeURIComponent");
    var ha = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        a: 10,
        A: 10,
        b: 11,
        B: 11,
        c: 12,
        C: 12,
        d: 13,
        D: 13,
        e: 14,
        E: 14,
        f: 15,
        F: 15
    };
    function Ho(r, e) {
        var t = ha[r];
        return t === void 0 ? 255 : t << e;
    }
    s(Ho, "hexCodeToInt");
    Wo.exports = ya;
});
// ../node_modules/picoquery/lib/parse.js
var Jo = k((X)=>{
    "use strict";
    var ma = X && X.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty(X, "__esModule", {
        value: !0
    });
    X.numberValueDeserializer = X.numberKeyDeserializer = void 0;
    X.parse = ba;
    var ar = ut(), pe = sr(), Yo = ma($o()), ga = /* @__PURE__ */ s((r)=>{
        let e = Number(r);
        return Number.isNaN(e) ? r : e;
    }, "numberKeyDeserializer");
    X.numberKeyDeserializer = ga;
    var Sa = /* @__PURE__ */ s((r)=>{
        let e = Number(r);
        return Number.isNaN(e) ? r : e;
    }, "numberValueDeserializer");
    X.numberValueDeserializer = Sa;
    var Ko = /\+/g, Xo = /* @__PURE__ */ s(function() {}, "Empty");
    Xo.prototype = /* @__PURE__ */ Object.create(null);
    function lr(r, e, t, o, n) {
        let i = r.substring(e, t);
        return o && (i = i.replace(Ko, " ")), n && (i = (0, Yo.default)(i) || i), i;
    }
    s(lr, "computeKeySlice");
    function ba(r, e) {
        let { valueDeserializer: t = pe.defaultOptions.valueDeserializer, keyDeserializer: o = pe.defaultOptions.keyDeserializer, arrayRepeatSyntax: n = pe.defaultOptions.arrayRepeatSyntax, nesting: i = pe.defaultOptions.nesting, arrayRepeat: a = pe.defaultOptions.arrayRepeat, nestingSyntax: l = pe.defaultOptions.nestingSyntax, delimiter: c = pe.defaultOptions.delimiter } = e ?? {}, d = typeof c == "string" ? c.charCodeAt(0) : c, p = l === "js", u = new Xo();
        if (typeof r != "string") return u;
        let y = r.length, m = "", g = -1, S = -1, h = -1, E = u, R, f = "", b = "", x = !1, w = !1, A = !1, O = !1, N = !1, U = !1, ye = !1, C = 0, z = -1, Ce = -1, Pt = -1;
        for(let D = 0; D < y + 1; D++){
            if (C = D !== y ? r.charCodeAt(D) : d, C === d) {
                if (ye = S > g, ye || (S = D), h !== S - 1 && (b = lr(r, h + 1, z > -1 ? z : S, A, x), f = o(b), R !== void 0 && (E = (0, ar.getDeepObject)(E, R, f, p && N, p && U))), ye || f !== "") {
                    ye && (m = r.slice(S + 1, D), O && (m = m.replace(Ko, " ")), w && (m = (0, Yo.default)(m) || m));
                    let Pe = t(m, f);
                    if (a) {
                        let Ve = E[f];
                        Ve === void 0 ? z > -1 ? E[f] = [
                            Pe
                        ] : E[f] = Pe : Ve.pop ? Ve.push(Pe) : E[f] = [
                            Ve,
                            Pe
                        ];
                    } else E[f] = Pe;
                }
                m = "", g = D, S = D, x = !1, w = !1, A = !1, O = !1, N = !1, U = !1, z = -1, h = D, E = u, R = void 0, f = "";
            } else C === 93 ? (a && n === "bracket" && Pt === 91 && (z = Ce), i && (l === "index" || p) && S <= g && (h !== Ce && (b = lr(r, h + 1, D, A, x), f = o(b), R !== void 0 && (E = (0, ar.getDeepObject)(E, R, f, void 0, p)), R = f, A = !1, x = !1), h = D, U = !0, N = !1)) : C === 46 ? i && (l === "dot" || p) && S <= g && (h !== Ce && (b = lr(r, h + 1, D, A, x), f = o(b), R !== void 0 && (E = (0, ar.getDeepObject)(E, R, f, p)), R = f, A = !1, x = !1), N = !0, U = !1, h = D) : C === 91 ? i && (l === "index" || p) && S <= g && (h !== Ce && (b = lr(r, h + 1, D, A, x), f = o(b), p && R !== void 0 && (E = (0, ar.getDeepObject)(E, R, f, p)), R = f, A = !1, x = !1, N = !1, U = !0), h = D) : C === 61 ? S <= g ? S = D : w = !0 : C === 43 ? S > g ? O = !0 : A = !0 : C === 37 && (S > g ? w = !0 : x = !0);
            Ce = D, Pt = C;
        }
        return u;
    }
    s(ba, "parse");
});
// ../node_modules/picoquery/lib/stringify.js
var Qo = k((yt)=>{
    "use strict";
    Object.defineProperty(yt, "__esModule", {
        value: !0
    });
    yt.stringify = Ea;
    var Ta = ut();
    function Ea(r, e) {
        if (r === null || typeof r != "object") return "";
        let t = e ?? {};
        return (0, Ta.stringifyObject)(r, t);
    }
    s(Ea, "stringify");
});
// ../node_modules/picoquery/lib/main.js
var cr = k((B)=>{
    "use strict";
    var Ra = B && B.__createBinding || (Object.create ? function(r, e, t, o) {
        o === void 0 && (o = t);
        var n = Object.getOwnPropertyDescriptor(e, t);
        (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = {
            enumerable: !0,
            get: /* @__PURE__ */ s(function() {
                return e[t];
            }, "get")
        }), Object.defineProperty(r, o, n);
    } : function(r, e, t, o) {
        o === void 0 && (o = t), r[o] = e[t];
    }), xa = B && B.__exportStar || function(r, e) {
        for(var t in r)t !== "default" && !Object.prototype.hasOwnProperty.call(e, t) && Ra(e, r, t);
    };
    Object.defineProperty(B, "__esModule", {
        value: !0
    });
    B.stringify = B.parse = void 0;
    var wa = Jo();
    Object.defineProperty(B, "parse", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return wa.parse;
        }, "get")
    });
    var va = Qo();
    Object.defineProperty(B, "stringify", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return va.stringify;
        }, "get")
    });
    xa(sr(), B);
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/entities.json
var St = k((Cf, ka)=>{
    ka.exports = {
        Aacute: "\xC1",
        aacute: "\xE1",
        Abreve: "\u0102",
        abreve: "\u0103",
        ac: "\u223E",
        acd: "\u223F",
        acE: "\u223E\u0333",
        Acirc: "\
\xC2",
        acirc: "\xE2",
        acute: "\xB4",
        Acy: "\u0410",
        acy: "\u0430",
        AElig: "\xC6",
        aelig: "\xE6",
        af: "\u2061",
        Afr: "\uD835\uDD04",
        afr: "\uD835\uDD1E",
        Agrave: "\xC0",
        agrave: "\xE0",
        alefsym: "\u2135",
        aleph: "\u2135",
        Alpha: "\u0391",
        alpha: "\u03B1",
        Amacr: "\u0100",
        amacr: "\u0101",
        amalg: "\
\u2A3F",
        amp: "&",
        AMP: "&",
        andand: "\u2A55",
        And: "\u2A53",
        and: "\u2227",
        andd: "\u2A5C",
        andslope: "\u2A58",
        andv: "\u2A5A",
        ang: "\u2220",
        ange: "\u29A4",
        angle: "\u2220",
        angmsdaa: "\u29A8",
        angmsdab: "\u29A9",
        angmsdac: "\u29AA",
        angmsdad: "\u29AB",
        angmsdae: "\u29AC",
        angmsdaf: "\
\u29AD",
        angmsdag: "\u29AE",
        angmsdah: "\u29AF",
        angmsd: "\u2221",
        angrt: "\u221F",
        angrtvb: "\u22BE",
        angrtvbd: "\u299D",
        angsph: "\u2222",
        angst: "\xC5",
        angzarr: "\u237C",
        Aogon: "\u0104",
        aogon: "\u0105",
        Aopf: "\uD835\uDD38",
        aopf: "\uD835\uDD52",
        apacir: "\u2A6F",
        ap: "\u2248",
        apE: "\
\u2A70",
        ape: "\u224A",
        apid: "\u224B",
        apos: "'",
        ApplyFunction: "\u2061",
        approx: "\u2248",
        approxeq: "\u224A",
        Aring: "\xC5",
        aring: "\xE5",
        Ascr: "\uD835\uDC9C",
        ascr: "\uD835\uDCB6",
        Assign: "\u2254",
        ast: "*",
        asymp: "\u2248",
        asympeq: "\u224D",
        Atilde: "\xC3",
        atilde: "\xE3",
        Auml: "\
\xC4",
        auml: "\xE4",
        awconint: "\u2233",
        awint: "\u2A11",
        backcong: "\u224C",
        backepsilon: "\u03F6",
        backprime: "\u2035",
        backsim: "\u223D",
        backsimeq: "\u22CD",
        Backslash: "\u2216",
        Barv: "\u2AE7",
        barvee: "\u22BD",
        barwed: "\u2305",
        Barwed: "\u2306",
        barwedge: "\u2305",
        bbrk: "\
\u23B5",
        bbrktbrk: "\u23B6",
        bcong: "\u224C",
        Bcy: "\u0411",
        bcy: "\u0431",
        bdquo: "\u201E",
        becaus: "\u2235",
        because: "\u2235",
        Because: "\
\u2235",
        bemptyv: "\u29B0",
        bepsi: "\u03F6",
        bernou: "\u212C",
        Bernoullis: "\u212C",
        Beta: "\u0392",
        beta: "\u03B2",
        beth: "\u2136",
        between: "\
\u226C",
        Bfr: "\uD835\uDD05",
        bfr: "\uD835\uDD1F",
        bigcap: "\u22C2",
        bigcirc: "\u25EF",
        bigcup: "\u22C3",
        bigodot: "\u2A00",
        bigoplus: "\u2A01",
        bigotimes: "\
\u2A02",
        bigsqcup: "\u2A06",
        bigstar: "\u2605",
        bigtriangledown: "\u25BD",
        bigtriangleup: "\u25B3",
        biguplus: "\u2A04",
        bigvee: "\u22C1",
        bigwedge: "\
\u22C0",
        bkarow: "\u290D",
        blacklozenge: "\u29EB",
        blacksquare: "\u25AA",
        blacktriangle: "\u25B4",
        blacktriangledown: "\u25BE",
        blacktriangleleft: "\
\u25C2",
        blacktriangleright: "\u25B8",
        blank: "\u2423",
        blk12: "\u2592",
        blk14: "\u2591",
        blk34: "\u2593",
        block: "\u2588",
        bne: "=\u20E5",
        bnequiv: "\
\u2261\u20E5",
        bNot: "\u2AED",
        bnot: "\u2310",
        Bopf: "\uD835\uDD39",
        bopf: "\uD835\uDD53",
        bot: "\u22A5",
        bottom: "\u22A5",
        bowtie: "\u22C8",
        boxbox: "\
\u29C9",
        boxdl: "\u2510",
        boxdL: "\u2555",
        boxDl: "\u2556",
        boxDL: "\u2557",
        boxdr: "\u250C",
        boxdR: "\u2552",
        boxDr: "\u2553",
        boxDR: "\u2554",
        boxh: "\u2500",
        boxH: "\u2550",
        boxhd: "\u252C",
        boxHd: "\u2564",
        boxhD: "\u2565",
        boxHD: "\u2566",
        boxhu: "\u2534",
        boxHu: "\u2567",
        boxhU: "\
\u2568",
        boxHU: "\u2569",
        boxminus: "\u229F",
        boxplus: "\u229E",
        boxtimes: "\u22A0",
        boxul: "\u2518",
        boxuL: "\u255B",
        boxUl: "\u255C",
        boxUL: "\
\u255D",
        boxur: "\u2514",
        boxuR: "\u2558",
        boxUr: "\u2559",
        boxUR: "\u255A",
        boxv: "\u2502",
        boxV: "\u2551",
        boxvh: "\u253C",
        boxvH: "\u256A",
        boxVh: "\u256B",
        boxVH: "\u256C",
        boxvl: "\u2524",
        boxvL: "\u2561",
        boxVl: "\u2562",
        boxVL: "\u2563",
        boxvr: "\u251C",
        boxvR: "\u255E",
        boxVr: "\
\u255F",
        boxVR: "\u2560",
        bprime: "\u2035",
        breve: "\u02D8",
        Breve: "\u02D8",
        brvbar: "\xA6",
        bscr: "\uD835\uDCB7",
        Bscr: "\u212C",
        bsemi: "\u204F",
        bsim: "\u223D",
        bsime: "\u22CD",
        bsolb: "\u29C5",
        bsol: "\\",
        bsolhsub: "\u27C8",
        bull: "\u2022",
        bullet: "\u2022",
        bump: "\u224E",
        bumpE: "\
\u2AAE",
        bumpe: "\u224F",
        Bumpeq: "\u224E",
        bumpeq: "\u224F",
        Cacute: "\u0106",
        cacute: "\u0107",
        capand: "\u2A44",
        capbrcup: "\u2A49",
        capcap: "\
\u2A4B",
        cap: "\u2229",
        Cap: "\u22D2",
        capcup: "\u2A47",
        capdot: "\u2A40",
        CapitalDifferentialD: "\u2145",
        caps: "\u2229\uFE00",
        caret: "\u2041",
        caron: "\u02C7",
        Cayleys: "\u212D",
        ccaps: "\u2A4D",
        Ccaron: "\u010C",
        ccaron: "\u010D",
        Ccedil: "\xC7",
        ccedil: "\xE7",
        Ccirc: "\u0108",
        ccirc: "\
\u0109",
        Cconint: "\u2230",
        ccups: "\u2A4C",
        ccupssm: "\u2A50",
        Cdot: "\u010A",
        cdot: "\u010B",
        cedil: "\xB8",
        Cedilla: "\xB8",
        cemptyv: "\u29B2",
        cent: "\xA2",
        centerdot: "\xB7",
        CenterDot: "\xB7",
        cfr: "\uD835\uDD20",
        Cfr: "\u212D",
        CHcy: "\u0427",
        chcy: "\u0447",
        check: "\u2713",
        checkmark: "\
\u2713",
        Chi: "\u03A7",
        chi: "\u03C7",
        circ: "\u02C6",
        circeq: "\u2257",
        circlearrowleft: "\u21BA",
        circlearrowright: "\u21BB",
        circledast: "\
\u229B",
        circledcirc: "\u229A",
        circleddash: "\u229D",
        CircleDot: "\u2299",
        circledR: "\xAE",
        circledS: "\u24C8",
        CircleMinus: "\u2296",
        CirclePlus: "\
\u2295",
        CircleTimes: "\u2297",
        cir: "\u25CB",
        cirE: "\u29C3",
        cire: "\u2257",
        cirfnint: "\u2A10",
        cirmid: "\u2AEF",
        cirscir: "\u29C2",
        ClockwiseContourIntegral: "\
\u2232",
        CloseCurlyDoubleQuote: "\u201D",
        CloseCurlyQuote: "\u2019",
        clubs: "\u2663",
        clubsuit: "\u2663",
        colon: ":",
        Colon: "\u2237",
        Colone: "\
\u2A74",
        colone: "\u2254",
        coloneq: "\u2254",
        comma: ",",
        commat: "@",
        comp: "\u2201",
        compfn: "\u2218",
        complement: "\u2201",
        complexes: "\u2102",
        cong: "\u2245",
        congdot: "\u2A6D",
        Congruent: "\u2261",
        conint: "\u222E",
        Conint: "\u222F",
        ContourIntegral: "\u222E",
        copf: "\uD835\uDD54",
        Copf: "\
\u2102",
        coprod: "\u2210",
        Coproduct: "\u2210",
        copy: "\xA9",
        COPY: "\xA9",
        copysr: "\u2117",
        CounterClockwiseContourIntegral: "\u2233",
        crarr: "\
\u21B5",
        cross: "\u2717",
        Cross: "\u2A2F",
        Cscr: "\uD835\uDC9E",
        cscr: "\uD835\uDCB8",
        csub: "\u2ACF",
        csube: "\u2AD1",
        csup: "\u2AD0",
        csupe: "\u2AD2",
        ctdot: "\u22EF",
        cudarrl: "\u2938",
        cudarrr: "\u2935",
        cuepr: "\u22DE",
        cuesc: "\u22DF",
        cularr: "\u21B6",
        cularrp: "\u293D",
        cupbrcap: "\u2A48",
        cupcap: "\u2A46",
        CupCap: "\u224D",
        cup: "\u222A",
        Cup: "\u22D3",
        cupcup: "\u2A4A",
        cupdot: "\u228D",
        cupor: "\u2A45",
        cups: "\u222A\uFE00",
        curarr: "\u21B7",
        curarrm: "\u293C",
        curlyeqprec: "\u22DE",
        curlyeqsucc: "\u22DF",
        curlyvee: "\u22CE",
        curlywedge: "\u22CF",
        curren: "\xA4",
        curvearrowleft: "\u21B6",
        curvearrowright: "\u21B7",
        cuvee: "\u22CE",
        cuwed: "\u22CF",
        cwconint: "\u2232",
        cwint: "\u2231",
        cylcty: "\u232D",
        dagger: "\u2020",
        Dagger: "\u2021",
        daleth: "\u2138",
        darr: "\u2193",
        Darr: "\u21A1",
        dArr: "\u21D3",
        dash: "\u2010",
        Dashv: "\u2AE4",
        dashv: "\
\u22A3",
        dbkarow: "\u290F",
        dblac: "\u02DD",
        Dcaron: "\u010E",
        dcaron: "\u010F",
        Dcy: "\u0414",
        dcy: "\u0434",
        ddagger: "\u2021",
        ddarr: "\u21CA",
        DD: "\u2145",
        dd: "\u2146",
        DDotrahd: "\u2911",
        ddotseq: "\u2A77",
        deg: "\xB0",
        Del: "\u2207",
        Delta: "\u0394",
        delta: "\u03B4",
        demptyv: "\
\u29B1",
        dfisht: "\u297F",
        Dfr: "\uD835\uDD07",
        dfr: "\uD835\uDD21",
        dHar: "\u2965",
        dharl: "\u21C3",
        dharr: "\u21C2",
        DiacriticalAcute: "\xB4",
        DiacriticalDot: "\
\u02D9",
        DiacriticalDoubleAcute: "\u02DD",
        DiacriticalGrave: "`",
        DiacriticalTilde: "\u02DC",
        diam: "\u22C4",
        diamond: "\u22C4",
        Diamond: "\u22C4",
        diamondsuit: "\u2666",
        diams: "\u2666",
        die: "\xA8",
        DifferentialD: "\u2146",
        digamma: "\u03DD",
        disin: "\u22F2",
        div: "\xF7",
        divide: "\xF7",
        divideontimes: "\u22C7",
        divonx: "\u22C7",
        DJcy: "\u0402",
        djcy: "\u0452",
        dlcorn: "\u231E",
        dlcrop: "\u230D",
        dollar: "$",
        Dopf: "\uD835\uDD3B",
        dopf: "\uD835\uDD55",
        Dot: "\xA8",
        dot: "\u02D9",
        DotDot: "\u20DC",
        doteq: "\u2250",
        doteqdot: "\u2251",
        DotEqual: "\u2250",
        dotminus: "\u2238",
        dotplus: "\u2214",
        dotsquare: "\u22A1",
        doublebarwedge: "\u2306",
        DoubleContourIntegral: "\u222F",
        DoubleDot: "\xA8",
        DoubleDownArrow: "\u21D3",
        DoubleLeftArrow: "\u21D0",
        DoubleLeftRightArrow: "\u21D4",
        DoubleLeftTee: "\u2AE4",
        DoubleLongLeftArrow: "\u27F8",
        DoubleLongLeftRightArrow: "\
\u27FA",
        DoubleLongRightArrow: "\u27F9",
        DoubleRightArrow: "\u21D2",
        DoubleRightTee: "\u22A8",
        DoubleUpArrow: "\u21D1",
        DoubleUpDownArrow: "\
\u21D5",
        DoubleVerticalBar: "\u2225",
        DownArrowBar: "\u2913",
        downarrow: "\u2193",
        DownArrow: "\u2193",
        Downarrow: "\u21D3",
        DownArrowUpArrow: "\
\u21F5",
        DownBreve: "\u0311",
        downdownarrows: "\u21CA",
        downharpoonleft: "\u21C3",
        downharpoonright: "\u21C2",
        DownLeftRightVector: "\u2950",
        DownLeftTeeVector: "\u295E",
        DownLeftVectorBar: "\u2956",
        DownLeftVector: "\u21BD",
        DownRightTeeVector: "\u295F",
        DownRightVectorBar: "\u2957",
        DownRightVector: "\u21C1",
        DownTeeArrow: "\u21A7",
        DownTee: "\u22A4",
        drbkarow: "\u2910",
        drcorn: "\u231F",
        drcrop: "\u230C",
        Dscr: "\uD835\uDC9F",
        dscr: "\uD835\uDCB9",
        DScy: "\u0405",
        dscy: "\u0455",
        dsol: "\u29F6",
        Dstrok: "\u0110",
        dstrok: "\u0111",
        dtdot: "\u22F1",
        dtri: "\u25BF",
        dtrif: "\
\u25BE",
        duarr: "\u21F5",
        duhar: "\u296F",
        dwangle: "\u29A6",
        DZcy: "\u040F",
        dzcy: "\u045F",
        dzigrarr: "\u27FF",
        Eacute: "\xC9",
        eacute: "\xE9",
        easter: "\u2A6E",
        Ecaron: "\u011A",
        ecaron: "\u011B",
        Ecirc: "\xCA",
        ecirc: "\xEA",
        ecir: "\u2256",
        ecolon: "\u2255",
        Ecy: "\u042D",
        ecy: "\
\u044D",
        eDDot: "\u2A77",
        Edot: "\u0116",
        edot: "\u0117",
        eDot: "\u2251",
        ee: "\u2147",
        efDot: "\u2252",
        Efr: "\uD835\uDD08",
        efr: "\uD835\uDD22",
        eg: "\u2A9A",
        Egrave: "\xC8",
        egrave: "\xE8",
        egs: "\u2A96",
        egsdot: "\u2A98",
        el: "\u2A99",
        Element: "\u2208",
        elinters: "\u23E7",
        ell: "\
\u2113",
        els: "\u2A95",
        elsdot: "\u2A97",
        Emacr: "\u0112",
        emacr: "\u0113",
        empty: "\u2205",
        emptyset: "\u2205",
        EmptySmallSquare: "\u25FB",
        emptyv: "\u2205",
        EmptyVerySmallSquare: "\u25AB",
        emsp13: "\u2004",
        emsp14: "\u2005",
        emsp: "\u2003",
        ENG: "\u014A",
        eng: "\u014B",
        ensp: "\
\u2002",
        Eogon: "\u0118",
        eogon: "\u0119",
        Eopf: "\uD835\uDD3C",
        eopf: "\uD835\uDD56",
        epar: "\u22D5",
        eparsl: "\u29E3",
        eplus: "\u2A71",
        epsi: "\u03B5",
        Epsilon: "\u0395",
        epsilon: "\u03B5",
        epsiv: "\u03F5",
        eqcirc: "\u2256",
        eqcolon: "\u2255",
        eqsim: "\u2242",
        eqslantgtr: "\u2A96",
        eqslantless: "\
\u2A95",
        Equal: "\u2A75",
        equals: "=",
        EqualTilde: "\u2242",
        equest: "\u225F",
        Equilibrium: "\u21CC",
        equiv: "\u2261",
        equivDD: "\u2A78",
        eqvparsl: "\
\u29E5",
        erarr: "\u2971",
        erDot: "\u2253",
        escr: "\u212F",
        Escr: "\u2130",
        esdot: "\u2250",
        Esim: "\u2A73",
        esim: "\u2242",
        Eta: "\u0397",
        eta: "\
\u03B7",
        ETH: "\xD0",
        eth: "\xF0",
        Euml: "\xCB",
        euml: "\xEB",
        euro: "\u20AC",
        excl: "!",
        exist: "\u2203",
        Exists: "\u2203",
        expectation: "\u2130",
        exponentiale: "\u2147",
        ExponentialE: "\u2147",
        fallingdotseq: "\u2252",
        Fcy: "\u0424",
        fcy: "\u0444",
        female: "\u2640",
        ffilig: "\uFB03",
        fflig: "\uFB00",
        ffllig: "\uFB04",
        Ffr: "\uD835\uDD09",
        ffr: "\uD835\uDD23",
        filig: "\uFB01",
        FilledSmallSquare: "\u25FC",
        FilledVerySmallSquare: "\
\u25AA",
        fjlig: "fj",
        flat: "\u266D",
        fllig: "\uFB02",
        fltns: "\u25B1",
        fnof: "\u0192",
        Fopf: "\uD835\uDD3D",
        fopf: "\uD835\uDD57",
        forall: "\u2200",
        ForAll: "\u2200",
        fork: "\u22D4",
        forkv: "\u2AD9",
        Fouriertrf: "\u2131",
        fpartint: "\u2A0D",
        frac12: "\xBD",
        frac13: "\u2153",
        frac14: "\xBC",
        frac15: "\u2155",
        frac16: "\u2159",
        frac18: "\u215B",
        frac23: "\u2154",
        frac25: "\u2156",
        frac34: "\xBE",
        frac35: "\u2157",
        frac38: "\u215C",
        frac45: "\u2158",
        frac56: "\u215A",
        frac58: "\u215D",
        frac78: "\u215E",
        frasl: "\u2044",
        frown: "\u2322",
        fscr: "\uD835\uDCBB",
        Fscr: "\u2131",
        gacute: "\u01F5",
        Gamma: "\u0393",
        gamma: "\u03B3",
        Gammad: "\u03DC",
        gammad: "\u03DD",
        gap: "\u2A86",
        Gbreve: "\u011E",
        gbreve: "\u011F",
        Gcedil: "\u0122",
        Gcirc: "\u011C",
        gcirc: "\u011D",
        Gcy: "\u0413",
        gcy: "\u0433",
        Gdot: "\u0120",
        gdot: "\u0121",
        ge: "\u2265",
        gE: "\u2267",
        gEl: "\u2A8C",
        gel: "\u22DB",
        geq: "\u2265",
        geqq: "\u2267",
        geqslant: "\u2A7E",
        gescc: "\u2AA9",
        ges: "\u2A7E",
        gesdot: "\u2A80",
        gesdoto: "\
\u2A82",
        gesdotol: "\u2A84",
        gesl: "\u22DB\uFE00",
        gesles: "\u2A94",
        Gfr: "\uD835\uDD0A",
        gfr: "\uD835\uDD24",
        gg: "\u226B",
        Gg: "\u22D9",
        ggg: "\u22D9",
        gimel: "\u2137",
        GJcy: "\u0403",
        gjcy: "\u0453",
        gla: "\u2AA5",
        gl: "\u2277",
        glE: "\u2A92",
        glj: "\u2AA4",
        gnap: "\u2A8A",
        gnapprox: "\u2A8A",
        gne: "\u2A88",
        gnE: "\u2269",
        gneq: "\u2A88",
        gneqq: "\u2269",
        gnsim: "\u22E7",
        Gopf: "\uD835\uDD3E",
        gopf: "\uD835\uDD58",
        grave: "`",
        GreaterEqual: "\
\u2265",
        GreaterEqualLess: "\u22DB",
        GreaterFullEqual: "\u2267",
        GreaterGreater: "\u2AA2",
        GreaterLess: "\u2277",
        GreaterSlantEqual: "\u2A7E",
        GreaterTilde: "\u2273",
        Gscr: "\uD835\uDCA2",
        gscr: "\u210A",
        gsim: "\u2273",
        gsime: "\u2A8E",
        gsiml: "\u2A90",
        gtcc: "\u2AA7",
        gtcir: "\u2A7A",
        gt: ">",
        GT: ">",
        Gt: "\u226B",
        gtdot: "\u22D7",
        gtlPar: "\u2995",
        gtquest: "\u2A7C",
        gtrapprox: "\u2A86",
        gtrarr: "\u2978",
        gtrdot: "\u22D7",
        gtreqless: "\u22DB",
        gtreqqless: "\u2A8C",
        gtrless: "\u2277",
        gtrsim: "\u2273",
        gvertneqq: "\u2269\uFE00",
        gvnE: "\u2269\uFE00",
        Hacek: "\u02C7",
        hairsp: "\u200A",
        half: "\xBD",
        hamilt: "\u210B",
        HARDcy: "\u042A",
        hardcy: "\u044A",
        harrcir: "\u2948",
        harr: "\u2194",
        hArr: "\u21D4",
        harrw: "\
\u21AD",
        Hat: "^",
        hbar: "\u210F",
        Hcirc: "\u0124",
        hcirc: "\u0125",
        hearts: "\u2665",
        heartsuit: "\u2665",
        hellip: "\u2026",
        hercon: "\u22B9",
        hfr: "\uD835\uDD25",
        Hfr: "\u210C",
        HilbertSpace: "\u210B",
        hksearow: "\u2925",
        hkswarow: "\u2926",
        hoarr: "\u21FF",
        homtht: "\u223B",
        hookleftarrow: "\
\u21A9",
        hookrightarrow: "\u21AA",
        hopf: "\uD835\uDD59",
        Hopf: "\u210D",
        horbar: "\u2015",
        HorizontalLine: "\u2500",
        hscr: "\uD835\uDCBD",
        Hscr: "\
\u210B",
        hslash: "\u210F",
        Hstrok: "\u0126",
        hstrok: "\u0127",
        HumpDownHump: "\u224E",
        HumpEqual: "\u224F",
        hybull: "\u2043",
        hyphen: "\u2010",
        Iacute: "\xCD",
        iacute: "\xED",
        ic: "\u2063",
        Icirc: "\xCE",
        icirc: "\xEE",
        Icy: "\u0418",
        icy: "\u0438",
        Idot: "\u0130",
        IEcy: "\u0415",
        iecy: "\
\u0435",
        iexcl: "\xA1",
        iff: "\u21D4",
        ifr: "\uD835\uDD26",
        Ifr: "\u2111",
        Igrave: "\xCC",
        igrave: "\xEC",
        ii: "\u2148",
        iiiint: "\u2A0C",
        iiint: "\
\u222D",
        iinfin: "\u29DC",
        iiota: "\u2129",
        IJlig: "\u0132",
        ijlig: "\u0133",
        Imacr: "\u012A",
        imacr: "\u012B",
        image: "\u2111",
        ImaginaryI: "\
\u2148",
        imagline: "\u2110",
        imagpart: "\u2111",
        imath: "\u0131",
        Im: "\u2111",
        imof: "\u22B7",
        imped: "\u01B5",
        Implies: "\u21D2",
        incare: "\
\u2105",
        in: "\u2208",
        infin: "\u221E",
        infintie: "\u29DD",
        inodot: "\u0131",
        intcal: "\u22BA",
        int: "\u222B",
        Int: "\u222C",
        integers: "\u2124",
        Integral: "\u222B",
        intercal: "\u22BA",
        Intersection: "\u22C2",
        intlarhk: "\u2A17",
        intprod: "\u2A3C",
        InvisibleComma: "\u2063",
        InvisibleTimes: "\
\u2062",
        IOcy: "\u0401",
        iocy: "\u0451",
        Iogon: "\u012E",
        iogon: "\u012F",
        Iopf: "\uD835\uDD40",
        iopf: "\uD835\uDD5A",
        Iota: "\u0399",
        iota: "\u03B9",
        iprod: "\u2A3C",
        iquest: "\xBF",
        iscr: "\uD835\uDCBE",
        Iscr: "\u2110",
        isin: "\u2208",
        isindot: "\u22F5",
        isinE: "\u22F9",
        isins: "\u22F4",
        isinsv: "\
\u22F3",
        isinv: "\u2208",
        it: "\u2062",
        Itilde: "\u0128",
        itilde: "\u0129",
        Iukcy: "\u0406",
        iukcy: "\u0456",
        Iuml: "\xCF",
        iuml: "\xEF",
        Jcirc: "\
\u0134",
        jcirc: "\u0135",
        Jcy: "\u0419",
        jcy: "\u0439",
        Jfr: "\uD835\uDD0D",
        jfr: "\uD835\uDD27",
        jmath: "\u0237",
        Jopf: "\uD835\uDD41",
        jopf: "\uD835\uDD5B",
        Jscr: "\uD835\uDCA5",
        jscr: "\uD835\uDCBF",
        Jsercy: "\u0408",
        jsercy: "\u0458",
        Jukcy: "\u0404",
        jukcy: "\u0454",
        Kappa: "\u039A",
        kappa: "\u03BA",
        kappav: "\u03F0",
        Kcedil: "\u0136",
        kcedil: "\u0137",
        Kcy: "\u041A",
        kcy: "\u043A",
        Kfr: "\uD835\uDD0E",
        kfr: "\uD835\uDD28",
        kgreen: "\u0138",
        KHcy: "\
\u0425",
        khcy: "\u0445",
        KJcy: "\u040C",
        kjcy: "\u045C",
        Kopf: "\uD835\uDD42",
        kopf: "\uD835\uDD5C",
        Kscr: "\uD835\uDCA6",
        kscr: "\uD835\uDCC0",
        lAarr: "\
\u21DA",
        Lacute: "\u0139",
        lacute: "\u013A",
        laemptyv: "\u29B4",
        lagran: "\u2112",
        Lambda: "\u039B",
        lambda: "\u03BB",
        lang: "\u27E8",
        Lang: "\
\u27EA",
        langd: "\u2991",
        langle: "\u27E8",
        lap: "\u2A85",
        Laplacetrf: "\u2112",
        laquo: "\xAB",
        larrb: "\u21E4",
        larrbfs: "\u291F",
        larr: "\u2190",
        Larr: "\u219E",
        lArr: "\u21D0",
        larrfs: "\u291D",
        larrhk: "\u21A9",
        larrlp: "\u21AB",
        larrpl: "\u2939",
        larrsim: "\u2973",
        larrtl: "\u21A2",
        latail: "\u2919",
        lAtail: "\u291B",
        lat: "\u2AAB",
        late: "\u2AAD",
        lates: "\u2AAD\uFE00",
        lbarr: "\u290C",
        lBarr: "\u290E",
        lbbrk: "\u2772",
        lbrace: "{",
        lbrack: "[",
        lbrke: "\u298B",
        lbrksld: "\u298F",
        lbrkslu: "\u298D",
        Lcaron: "\u013D",
        lcaron: "\u013E",
        Lcedil: "\u013B",
        lcedil: "\
\u013C",
        lceil: "\u2308",
        lcub: "{",
        Lcy: "\u041B",
        lcy: "\u043B",
        ldca: "\u2936",
        ldquo: "\u201C",
        ldquor: "\u201E",
        ldrdhar: "\u2967",
        ldrushar: "\
\u294B",
        ldsh: "\u21B2",
        le: "\u2264",
        lE: "\u2266",
        LeftAngleBracket: "\u27E8",
        LeftArrowBar: "\u21E4",
        leftarrow: "\u2190",
        LeftArrow: "\u2190",
        Leftarrow: "\u21D0",
        LeftArrowRightArrow: "\u21C6",
        leftarrowtail: "\u21A2",
        LeftCeiling: "\u2308",
        LeftDoubleBracket: "\u27E6",
        LeftDownTeeVector: "\
\u2961",
        LeftDownVectorBar: "\u2959",
        LeftDownVector: "\u21C3",
        LeftFloor: "\u230A",
        leftharpoondown: "\u21BD",
        leftharpoonup: "\u21BC",
        leftleftarrows: "\
\u21C7",
        leftrightarrow: "\u2194",
        LeftRightArrow: "\u2194",
        Leftrightarrow: "\u21D4",
        leftrightarrows: "\u21C6",
        leftrightharpoons: "\u21CB",
        leftrightsquigarrow: "\u21AD",
        LeftRightVector: "\u294E",
        LeftTeeArrow: "\u21A4",
        LeftTee: "\u22A3",
        LeftTeeVector: "\u295A",
        leftthreetimes: "\
\u22CB",
        LeftTriangleBar: "\u29CF",
        LeftTriangle: "\u22B2",
        LeftTriangleEqual: "\u22B4",
        LeftUpDownVector: "\u2951",
        LeftUpTeeVector: "\u2960",
        LeftUpVectorBar: "\u2958",
        LeftUpVector: "\u21BF",
        LeftVectorBar: "\u2952",
        LeftVector: "\u21BC",
        lEg: "\u2A8B",
        leg: "\u22DA",
        leq: "\u2264",
        leqq: "\u2266",
        leqslant: "\u2A7D",
        lescc: "\u2AA8",
        les: "\u2A7D",
        lesdot: "\u2A7F",
        lesdoto: "\u2A81",
        lesdotor: "\u2A83",
        lesg: "\u22DA\uFE00",
        lesges: "\u2A93",
        lessapprox: "\u2A85",
        lessdot: "\u22D6",
        lesseqgtr: "\u22DA",
        lesseqqgtr: "\u2A8B",
        LessEqualGreater: "\u22DA",
        LessFullEqual: "\
\u2266",
        LessGreater: "\u2276",
        lessgtr: "\u2276",
        LessLess: "\u2AA1",
        lesssim: "\u2272",
        LessSlantEqual: "\u2A7D",
        LessTilde: "\u2272",
        lfisht: "\
\u297C",
        lfloor: "\u230A",
        Lfr: "\uD835\uDD0F",
        lfr: "\uD835\uDD29",
        lg: "\u2276",
        lgE: "\u2A91",
        lHar: "\u2962",
        lhard: "\u21BD",
        lharu: "\u21BC",
        lharul: "\u296A",
        lhblk: "\u2584",
        LJcy: "\u0409",
        ljcy: "\u0459",
        llarr: "\u21C7",
        ll: "\u226A",
        Ll: "\u22D8",
        llcorner: "\u231E",
        Lleftarrow: "\
\u21DA",
        llhard: "\u296B",
        lltri: "\u25FA",
        Lmidot: "\u013F",
        lmidot: "\u0140",
        lmoustache: "\u23B0",
        lmoust: "\u23B0",
        lnap: "\u2A89",
        lnapprox: "\
\u2A89",
        lne: "\u2A87",
        lnE: "\u2268",
        lneq: "\u2A87",
        lneqq: "\u2268",
        lnsim: "\u22E6",
        loang: "\u27EC",
        loarr: "\u21FD",
        lobrk: "\u27E6",
        longleftarrow: "\
\u27F5",
        LongLeftArrow: "\u27F5",
        Longleftarrow: "\u27F8",
        longleftrightarrow: "\u27F7",
        LongLeftRightArrow: "\u27F7",
        Longleftrightarrow: "\
\u27FA",
        longmapsto: "\u27FC",
        longrightarrow: "\u27F6",
        LongRightArrow: "\u27F6",
        Longrightarrow: "\u27F9",
        looparrowleft: "\u21AB",
        looparrowright: "\
\u21AC",
        lopar: "\u2985",
        Lopf: "\uD835\uDD43",
        lopf: "\uD835\uDD5D",
        loplus: "\u2A2D",
        lotimes: "\u2A34",
        lowast: "\u2217",
        lowbar: "_",
        LowerLeftArrow: "\
\u2199",
        LowerRightArrow: "\u2198",
        loz: "\u25CA",
        lozenge: "\u25CA",
        lozf: "\u29EB",
        lpar: "(",
        lparlt: "\u2993",
        lrarr: "\u21C6",
        lrcorner: "\
\u231F",
        lrhar: "\u21CB",
        lrhard: "\u296D",
        lrm: "\u200E",
        lrtri: "\u22BF",
        lsaquo: "\u2039",
        lscr: "\uD835\uDCC1",
        Lscr: "\u2112",
        lsh: "\u21B0",
        Lsh: "\u21B0",
        lsim: "\u2272",
        lsime: "\u2A8D",
        lsimg: "\u2A8F",
        lsqb: "[",
        lsquo: "\u2018",
        lsquor: "\u201A",
        Lstrok: "\u0141",
        lstrok: "\
\u0142",
        ltcc: "\u2AA6",
        ltcir: "\u2A79",
        lt: "<",
        LT: "<",
        Lt: "\u226A",
        ltdot: "\u22D6",
        lthree: "\u22CB",
        ltimes: "\u22C9",
        ltlarr: "\u2976",
        ltquest: "\u2A7B",
        ltri: "\u25C3",
        ltrie: "\u22B4",
        ltrif: "\u25C2",
        ltrPar: "\u2996",
        lurdshar: "\u294A",
        luruhar: "\u2966",
        lvertneqq: "\
\u2268\uFE00",
        lvnE: "\u2268\uFE00",
        macr: "\xAF",
        male: "\u2642",
        malt: "\u2720",
        maltese: "\u2720",
        Map: "\u2905",
        map: "\u21A6",
        mapsto: "\
\u21A6",
        mapstodown: "\u21A7",
        mapstoleft: "\u21A4",
        mapstoup: "\u21A5",
        marker: "\u25AE",
        mcomma: "\u2A29",
        Mcy: "\u041C",
        mcy: "\u043C",
        mdash: "\
\u2014",
        mDDot: "\u223A",
        measuredangle: "\u2221",
        MediumSpace: "\u205F",
        Mellintrf: "\u2133",
        Mfr: "\uD835\uDD10",
        mfr: "\uD835\uDD2A",
        mho: "\u2127",
        micro: "\xB5",
        midast: "*",
        midcir: "\u2AF0",
        mid: "\u2223",
        middot: "\xB7",
        minusb: "\u229F",
        minus: "\u2212",
        minusd: "\u2238",
        minusdu: "\
\u2A2A",
        MinusPlus: "\u2213",
        mlcp: "\u2ADB",
        mldr: "\u2026",
        mnplus: "\u2213",
        models: "\u22A7",
        Mopf: "\uD835\uDD44",
        mopf: "\uD835\uDD5E",
        mp: "\
\u2213",
        mscr: "\uD835\uDCC2",
        Mscr: "\u2133",
        mstpos: "\u223E",
        Mu: "\u039C",
        mu: "\u03BC",
        multimap: "\u22B8",
        mumap: "\u22B8",
        nabla: "\u2207",
        Nacute: "\u0143",
        nacute: "\u0144",
        nang: "\u2220\u20D2",
        nap: "\u2249",
        napE: "\u2A70\u0338",
        napid: "\u224B\u0338",
        napos: "\u0149",
        napprox: "\
\u2249",
        natural: "\u266E",
        naturals: "\u2115",
        natur: "\u266E",
        nbsp: "\xA0",
        nbump: "\u224E\u0338",
        nbumpe: "\u224F\u0338",
        ncap: "\u2A43",
        Ncaron: "\u0147",
        ncaron: "\u0148",
        Ncedil: "\u0145",
        ncedil: "\u0146",
        ncong: "\u2247",
        ncongdot: "\u2A6D\u0338",
        ncup: "\u2A42",
        Ncy: "\u041D",
        ncy: "\u043D",
        ndash: "\u2013",
        nearhk: "\u2924",
        nearr: "\u2197",
        neArr: "\u21D7",
        nearrow: "\u2197",
        ne: "\u2260",
        nedot: "\u2250\u0338",
        NegativeMediumSpace: "\u200B",
        NegativeThickSpace: "\u200B",
        NegativeThinSpace: "\u200B",
        NegativeVeryThinSpace: "\u200B",
        nequiv: "\u2262",
        nesear: "\u2928",
        nesim: "\u2242\u0338",
        NestedGreaterGreater: "\u226B",
        NestedLessLess: "\u226A",
        NewLine: `
`,
        nexist: "\u2204",
        nexists: "\u2204",
        Nfr: "\uD835\uDD11",
        nfr: "\uD835\uDD2B",
        ngE: "\u2267\u0338",
        nge: "\u2271",
        ngeq: "\u2271",
        ngeqq: "\u2267\u0338",
        ngeqslant: "\u2A7E\u0338",
        nges: "\u2A7E\u0338",
        nGg: "\u22D9\u0338",
        ngsim: "\u2275",
        nGt: "\u226B\u20D2",
        ngt: "\u226F",
        ngtr: "\u226F",
        nGtv: "\u226B\u0338",
        nharr: "\u21AE",
        nhArr: "\u21CE",
        nhpar: "\u2AF2",
        ni: "\u220B",
        nis: "\u22FC",
        nisd: "\u22FA",
        niv: "\u220B",
        NJcy: "\
\u040A",
        njcy: "\u045A",
        nlarr: "\u219A",
        nlArr: "\u21CD",
        nldr: "\u2025",
        nlE: "\u2266\u0338",
        nle: "\u2270",
        nleftarrow: "\u219A",
        nLeftarrow: "\
\u21CD",
        nleftrightarrow: "\u21AE",
        nLeftrightarrow: "\u21CE",
        nleq: "\u2270",
        nleqq: "\u2266\u0338",
        nleqslant: "\u2A7D\u0338",
        nles: "\u2A7D\u0338",
        nless: "\u226E",
        nLl: "\u22D8\u0338",
        nlsim: "\u2274",
        nLt: "\u226A\u20D2",
        nlt: "\u226E",
        nltri: "\u22EA",
        nltrie: "\u22EC",
        nLtv: "\u226A\u0338",
        nmid: "\u2224",
        NoBreak: "\u2060",
        NonBreakingSpace: "\xA0",
        nopf: "\uD835\uDD5F",
        Nopf: "\u2115",
        Not: "\u2AEC",
        not: "\xAC",
        NotCongruent: "\
\u2262",
        NotCupCap: "\u226D",
        NotDoubleVerticalBar: "\u2226",
        NotElement: "\u2209",
        NotEqual: "\u2260",
        NotEqualTilde: "\u2242\u0338",
        NotExists: "\
\u2204",
        NotGreater: "\u226F",
        NotGreaterEqual: "\u2271",
        NotGreaterFullEqual: "\u2267\u0338",
        NotGreaterGreater: "\u226B\u0338",
        NotGreaterLess: "\
\u2279",
        NotGreaterSlantEqual: "\u2A7E\u0338",
        NotGreaterTilde: "\u2275",
        NotHumpDownHump: "\u224E\u0338",
        NotHumpEqual: "\u224F\u0338",
        notin: "\
\u2209",
        notindot: "\u22F5\u0338",
        notinE: "\u22F9\u0338",
        notinva: "\u2209",
        notinvb: "\u22F7",
        notinvc: "\u22F6",
        NotLeftTriangleBar: "\u29CF\u0338",
        NotLeftTriangle: "\u22EA",
        NotLeftTriangleEqual: "\u22EC",
        NotLess: "\u226E",
        NotLessEqual: "\u2270",
        NotLessGreater: "\u2278",
        NotLessLess: "\
\u226A\u0338",
        NotLessSlantEqual: "\u2A7D\u0338",
        NotLessTilde: "\u2274",
        NotNestedGreaterGreater: "\u2AA2\u0338",
        NotNestedLessLess: "\u2AA1\u0338",
        notni: "\u220C",
        notniva: "\u220C",
        notnivb: "\u22FE",
        notnivc: "\u22FD",
        NotPrecedes: "\u2280",
        NotPrecedesEqual: "\u2AAF\u0338",
        NotPrecedesSlantEqual: "\
\u22E0",
        NotReverseElement: "\u220C",
        NotRightTriangleBar: "\u29D0\u0338",
        NotRightTriangle: "\u22EB",
        NotRightTriangleEqual: "\u22ED",
        NotSquareSubset: "\
\u228F\u0338",
        NotSquareSubsetEqual: "\u22E2",
        NotSquareSuperset: "\u2290\u0338",
        NotSquareSupersetEqual: "\u22E3",
        NotSubset: "\u2282\u20D2",
        NotSubsetEqual: "\u2288",
        NotSucceeds: "\u2281",
        NotSucceedsEqual: "\u2AB0\u0338",
        NotSucceedsSlantEqual: "\u22E1",
        NotSucceedsTilde: "\u227F\u0338",
        NotSuperset: "\u2283\u20D2",
        NotSupersetEqual: "\u2289",
        NotTilde: "\u2241",
        NotTildeEqual: "\u2244",
        NotTildeFullEqual: "\u2247",
        NotTildeTilde: "\
\u2249",
        NotVerticalBar: "\u2224",
        nparallel: "\u2226",
        npar: "\u2226",
        nparsl: "\u2AFD\u20E5",
        npart: "\u2202\u0338",
        npolint: "\u2A14",
        npr: "\
\u2280",
        nprcue: "\u22E0",
        nprec: "\u2280",
        npreceq: "\u2AAF\u0338",
        npre: "\u2AAF\u0338",
        nrarrc: "\u2933\u0338",
        nrarr: "\u219B",
        nrArr: "\
\u21CF",
        nrarrw: "\u219D\u0338",
        nrightarrow: "\u219B",
        nRightarrow: "\u21CF",
        nrtri: "\u22EB",
        nrtrie: "\u22ED",
        nsc: "\u2281",
        nsccue: "\u22E1",
        nsce: "\u2AB0\u0338",
        Nscr: "\uD835\uDCA9",
        nscr: "\uD835\uDCC3",
        nshortmid: "\u2224",
        nshortparallel: "\u2226",
        nsim: "\u2241",
        nsime: "\u2244",
        nsimeq: "\u2244",
        nsmid: "\u2224",
        nspar: "\u2226",
        nsqsube: "\u22E2",
        nsqsupe: "\u22E3",
        nsub: "\u2284",
        nsubE: "\u2AC5\u0338",
        nsube: "\u2288",
        nsubset: "\u2282\u20D2",
        nsubseteq: "\u2288",
        nsubseteqq: "\u2AC5\u0338",
        nsucc: "\u2281",
        nsucceq: "\u2AB0\u0338",
        nsup: "\u2285",
        nsupE: "\
\u2AC6\u0338",
        nsupe: "\u2289",
        nsupset: "\u2283\u20D2",
        nsupseteq: "\u2289",
        nsupseteqq: "\u2AC6\u0338",
        ntgl: "\u2279",
        Ntilde: "\xD1",
        ntilde: "\
\xF1",
        ntlg: "\u2278",
        ntriangleleft: "\u22EA",
        ntrianglelefteq: "\u22EC",
        ntriangleright: "\u22EB",
        ntrianglerighteq: "\u22ED",
        Nu: "\u039D",
        nu: "\u03BD",
        num: "#",
        numero: "\u2116",
        numsp: "\u2007",
        nvap: "\u224D\u20D2",
        nvdash: "\u22AC",
        nvDash: "\u22AD",
        nVdash: "\u22AE",
        nVDash: "\
\u22AF",
        nvge: "\u2265\u20D2",
        nvgt: ">\u20D2",
        nvHarr: "\u2904",
        nvinfin: "\u29DE",
        nvlArr: "\u2902",
        nvle: "\u2264\u20D2",
        nvlt: "<\u20D2",
        nvltrie: "\u22B4\u20D2",
        nvrArr: "\u2903",
        nvrtrie: "\u22B5\u20D2",
        nvsim: "\u223C\u20D2",
        nwarhk: "\u2923",
        nwarr: "\u2196",
        nwArr: "\u21D6",
        nwarrow: "\u2196",
        nwnear: "\u2927",
        Oacute: "\xD3",
        oacute: "\xF3",
        oast: "\u229B",
        Ocirc: "\xD4",
        ocirc: "\xF4",
        ocir: "\u229A",
        Ocy: "\u041E",
        ocy: "\u043E",
        odash: "\u229D",
        Odblac: "\u0150",
        odblac: "\u0151",
        odiv: "\u2A38",
        odot: "\u2299",
        odsold: "\u29BC",
        OElig: "\u0152",
        oelig: "\
\u0153",
        ofcir: "\u29BF",
        Ofr: "\uD835\uDD12",
        ofr: "\uD835\uDD2C",
        ogon: "\u02DB",
        Ograve: "\xD2",
        ograve: "\xF2",
        ogt: "\u29C1",
        ohbar: "\u29B5",
        ohm: "\u03A9",
        oint: "\u222E",
        olarr: "\u21BA",
        olcir: "\u29BE",
        olcross: "\u29BB",
        oline: "\u203E",
        olt: "\u29C0",
        Omacr: "\u014C",
        omacr: "\
\u014D",
        Omega: "\u03A9",
        omega: "\u03C9",
        Omicron: "\u039F",
        omicron: "\u03BF",
        omid: "\u29B6",
        ominus: "\u2296",
        Oopf: "\uD835\uDD46",
        oopf: "\uD835\uDD60",
        opar: "\u29B7",
        OpenCurlyDoubleQuote: "\u201C",
        OpenCurlyQuote: "\u2018",
        operp: "\u29B9",
        oplus: "\u2295",
        orarr: "\u21BB",
        Or: "\
\u2A54",
        or: "\u2228",
        ord: "\u2A5D",
        order: "\u2134",
        orderof: "\u2134",
        ordf: "\xAA",
        ordm: "\xBA",
        origof: "\u22B6",
        oror: "\u2A56",
        orslope: "\
\u2A57",
        orv: "\u2A5B",
        oS: "\u24C8",
        Oscr: "\uD835\uDCAA",
        oscr: "\u2134",
        Oslash: "\xD8",
        oslash: "\xF8",
        osol: "\u2298",
        Otilde: "\xD5",
        otilde: "\
\xF5",
        otimesas: "\u2A36",
        Otimes: "\u2A37",
        otimes: "\u2297",
        Ouml: "\xD6",
        ouml: "\xF6",
        ovbar: "\u233D",
        OverBar: "\u203E",
        OverBrace: "\u23DE",
        OverBracket: "\u23B4",
        OverParenthesis: "\u23DC",
        para: "\xB6",
        parallel: "\u2225",
        par: "\u2225",
        parsim: "\u2AF3",
        parsl: "\u2AFD",
        part: "\
\u2202",
        PartialD: "\u2202",
        Pcy: "\u041F",
        pcy: "\u043F",
        percnt: "%",
        period: ".",
        permil: "\u2030",
        perp: "\u22A5",
        pertenk: "\u2031",
        Pfr: "\uD835\uDD13",
        pfr: "\uD835\uDD2D",
        Phi: "\u03A6",
        phi: "\u03C6",
        phiv: "\u03D5",
        phmmat: "\u2133",
        phone: "\u260E",
        Pi: "\u03A0",
        pi: "\u03C0",
        pitchfork: "\
\u22D4",
        piv: "\u03D6",
        planck: "\u210F",
        planckh: "\u210E",
        plankv: "\u210F",
        plusacir: "\u2A23",
        plusb: "\u229E",
        pluscir: "\u2A22",
        plus: "\
+",
        plusdo: "\u2214",
        plusdu: "\u2A25",
        pluse: "\u2A72",
        PlusMinus: "\xB1",
        plusmn: "\xB1",
        plussim: "\u2A26",
        plustwo: "\u2A27",
        pm: "\xB1",
        Poincareplane: "\u210C",
        pointint: "\u2A15",
        popf: "\uD835\uDD61",
        Popf: "\u2119",
        pound: "\xA3",
        prap: "\u2AB7",
        Pr: "\u2ABB",
        pr: "\u227A",
        prcue: "\u227C",
        precapprox: "\u2AB7",
        prec: "\u227A",
        preccurlyeq: "\u227C",
        Precedes: "\u227A",
        PrecedesEqual: "\u2AAF",
        PrecedesSlantEqual: "\
\u227C",
        PrecedesTilde: "\u227E",
        preceq: "\u2AAF",
        precnapprox: "\u2AB9",
        precneqq: "\u2AB5",
        precnsim: "\u22E8",
        pre: "\u2AAF",
        prE: "\u2AB3",
        precsim: "\u227E",
        prime: "\u2032",
        Prime: "\u2033",
        primes: "\u2119",
        prnap: "\u2AB9",
        prnE: "\u2AB5",
        prnsim: "\u22E8",
        prod: "\u220F",
        Product: "\
\u220F",
        profalar: "\u232E",
        profline: "\u2312",
        profsurf: "\u2313",
        prop: "\u221D",
        Proportional: "\u221D",
        Proportion: "\u2237",
        propto: "\
\u221D",
        prsim: "\u227E",
        prurel: "\u22B0",
        Pscr: "\uD835\uDCAB",
        pscr: "\uD835\uDCC5",
        Psi: "\u03A8",
        psi: "\u03C8",
        puncsp: "\u2008",
        Qfr: "\uD835\uDD14",
        qfr: "\uD835\uDD2E",
        qint: "\u2A0C",
        qopf: "\uD835\uDD62",
        Qopf: "\u211A",
        qprime: "\u2057",
        Qscr: "\uD835\uDCAC",
        qscr: "\uD835\uDCC6",
        quaternions: "\
\u210D",
        quatint: "\u2A16",
        quest: "?",
        questeq: "\u225F",
        quot: '"',
        QUOT: '"',
        rAarr: "\u21DB",
        race: "\u223D\u0331",
        Racute: "\u0154",
        racute: "\
\u0155",
        radic: "\u221A",
        raemptyv: "\u29B3",
        rang: "\u27E9",
        Rang: "\u27EB",
        rangd: "\u2992",
        range: "\u29A5",
        rangle: "\u27E9",
        raquo: "\xBB",
        rarrap: "\u2975",
        rarrb: "\u21E5",
        rarrbfs: "\u2920",
        rarrc: "\u2933",
        rarr: "\u2192",
        Rarr: "\u21A0",
        rArr: "\u21D2",
        rarrfs: "\u291E",
        rarrhk: "\
\u21AA",
        rarrlp: "\u21AC",
        rarrpl: "\u2945",
        rarrsim: "\u2974",
        Rarrtl: "\u2916",
        rarrtl: "\u21A3",
        rarrw: "\u219D",
        ratail: "\u291A",
        rAtail: "\
\u291C",
        ratio: "\u2236",
        rationals: "\u211A",
        rbarr: "\u290D",
        rBarr: "\u290F",
        RBarr: "\u2910",
        rbbrk: "\u2773",
        rbrace: "}",
        rbrack: "]",
        rbrke: "\u298C",
        rbrksld: "\u298E",
        rbrkslu: "\u2990",
        Rcaron: "\u0158",
        rcaron: "\u0159",
        Rcedil: "\u0156",
        rcedil: "\u0157",
        rceil: "\u2309",
        rcub: "}",
        Rcy: "\u0420",
        rcy: "\u0440",
        rdca: "\u2937",
        rdldhar: "\u2969",
        rdquo: "\u201D",
        rdquor: "\u201D",
        rdsh: "\u21B3",
        real: "\u211C",
        realine: "\u211B",
        realpart: "\u211C",
        reals: "\u211D",
        Re: "\u211C",
        rect: "\u25AD",
        reg: "\xAE",
        REG: "\xAE",
        ReverseElement: "\u220B",
        ReverseEquilibrium: "\
\u21CB",
        ReverseUpEquilibrium: "\u296F",
        rfisht: "\u297D",
        rfloor: "\u230B",
        rfr: "\uD835\uDD2F",
        Rfr: "\u211C",
        rHar: "\u2964",
        rhard: "\u21C1",
        rharu: "\u21C0",
        rharul: "\u296C",
        Rho: "\u03A1",
        rho: "\u03C1",
        rhov: "\u03F1",
        RightAngleBracket: "\u27E9",
        RightArrowBar: "\u21E5",
        rightarrow: "\
\u2192",
        RightArrow: "\u2192",
        Rightarrow: "\u21D2",
        RightArrowLeftArrow: "\u21C4",
        rightarrowtail: "\u21A3",
        RightCeiling: "\u2309",
        RightDoubleBracket: "\
\u27E7",
        RightDownTeeVector: "\u295D",
        RightDownVectorBar: "\u2955",
        RightDownVector: "\u21C2",
        RightFloor: "\u230B",
        rightharpoondown: "\u21C1",
        rightharpoonup: "\u21C0",
        rightleftarrows: "\u21C4",
        rightleftharpoons: "\u21CC",
        rightrightarrows: "\u21C9",
        rightsquigarrow: "\u219D",
        RightTeeArrow: "\
\u21A6",
        RightTee: "\u22A2",
        RightTeeVector: "\u295B",
        rightthreetimes: "\u22CC",
        RightTriangleBar: "\u29D0",
        RightTriangle: "\u22B3",
        RightTriangleEqual: "\
\u22B5",
        RightUpDownVector: "\u294F",
        RightUpTeeVector: "\u295C",
        RightUpVectorBar: "\u2954",
        RightUpVector: "\u21BE",
        RightVectorBar: "\u2953",
        RightVector: "\u21C0",
        ring: "\u02DA",
        risingdotseq: "\u2253",
        rlarr: "\u21C4",
        rlhar: "\u21CC",
        rlm: "\u200F",
        rmoustache: "\u23B1",
        rmoust: "\
\u23B1",
        rnmid: "\u2AEE",
        roang: "\u27ED",
        roarr: "\u21FE",
        robrk: "\u27E7",
        ropar: "\u2986",
        ropf: "\uD835\uDD63",
        Ropf: "\u211D",
        roplus: "\u2A2E",
        rotimes: "\u2A35",
        RoundImplies: "\u2970",
        rpar: ")",
        rpargt: "\u2994",
        rppolint: "\u2A12",
        rrarr: "\u21C9",
        Rrightarrow: "\u21DB",
        rsaquo: "\
\u203A",
        rscr: "\uD835\uDCC7",
        Rscr: "\u211B",
        rsh: "\u21B1",
        Rsh: "\u21B1",
        rsqb: "]",
        rsquo: "\u2019",
        rsquor: "\u2019",
        rthree: "\u22CC",
        rtimes: "\
\u22CA",
        rtri: "\u25B9",
        rtrie: "\u22B5",
        rtrif: "\u25B8",
        rtriltri: "\u29CE",
        RuleDelayed: "\u29F4",
        ruluhar: "\u2968",
        rx: "\u211E",
        Sacute: "\
\u015A",
        sacute: "\u015B",
        sbquo: "\u201A",
        scap: "\u2AB8",
        Scaron: "\u0160",
        scaron: "\u0161",
        Sc: "\u2ABC",
        sc: "\u227B",
        sccue: "\u227D",
        sce: "\u2AB0",
        scE: "\u2AB4",
        Scedil: "\u015E",
        scedil: "\u015F",
        Scirc: "\u015C",
        scirc: "\u015D",
        scnap: "\u2ABA",
        scnE: "\u2AB6",
        scnsim: "\
\u22E9",
        scpolint: "\u2A13",
        scsim: "\u227F",
        Scy: "\u0421",
        scy: "\u0441",
        sdotb: "\u22A1",
        sdot: "\u22C5",
        sdote: "\u2A66",
        searhk: "\u2925",
        searr: "\u2198",
        seArr: "\u21D8",
        searrow: "\u2198",
        sect: "\xA7",
        semi: ";",
        seswar: "\u2929",
        setminus: "\u2216",
        setmn: "\u2216",
        sext: "\
\u2736",
        Sfr: "\uD835\uDD16",
        sfr: "\uD835\uDD30",
        sfrown: "\u2322",
        sharp: "\u266F",
        SHCHcy: "\u0429",
        shchcy: "\u0449",
        SHcy: "\u0428",
        shcy: "\u0448",
        ShortDownArrow: "\u2193",
        ShortLeftArrow: "\u2190",
        shortmid: "\u2223",
        shortparallel: "\u2225",
        ShortRightArrow: "\u2192",
        ShortUpArrow: "\
\u2191",
        shy: "\xAD",
        Sigma: "\u03A3",
        sigma: "\u03C3",
        sigmaf: "\u03C2",
        sigmav: "\u03C2",
        sim: "\u223C",
        simdot: "\u2A6A",
        sime: "\u2243",
        simeq: "\u2243",
        simg: "\u2A9E",
        simgE: "\u2AA0",
        siml: "\u2A9D",
        simlE: "\u2A9F",
        simne: "\u2246",
        simplus: "\u2A24",
        simrarr: "\u2972",
        slarr: "\
\u2190",
        SmallCircle: "\u2218",
        smallsetminus: "\u2216",
        smashp: "\u2A33",
        smeparsl: "\u29E4",
        smid: "\u2223",
        smile: "\u2323",
        smt: "\u2AAA",
        smte: "\u2AAC",
        smtes: "\u2AAC\uFE00",
        SOFTcy: "\u042C",
        softcy: "\u044C",
        solbar: "\u233F",
        solb: "\u29C4",
        sol: "/",
        Sopf: "\uD835\uDD4A",
        sopf: "\uD835\uDD64",
        spades: "\u2660",
        spadesuit: "\u2660",
        spar: "\u2225",
        sqcap: "\u2293",
        sqcaps: "\u2293\uFE00",
        sqcup: "\u2294",
        sqcups: "\u2294\uFE00",
        Sqrt: "\u221A",
        sqsub: "\u228F",
        sqsube: "\u2291",
        sqsubset: "\u228F",
        sqsubseteq: "\u2291",
        sqsup: "\u2290",
        sqsupe: "\u2292",
        sqsupset: "\
\u2290",
        sqsupseteq: "\u2292",
        square: "\u25A1",
        Square: "\u25A1",
        SquareIntersection: "\u2293",
        SquareSubset: "\u228F",
        SquareSubsetEqual: "\
\u2291",
        SquareSuperset: "\u2290",
        SquareSupersetEqual: "\u2292",
        SquareUnion: "\u2294",
        squarf: "\u25AA",
        squ: "\u25A1",
        squf: "\u25AA",
        srarr: "\
\u2192",
        Sscr: "\uD835\uDCAE",
        sscr: "\uD835\uDCC8",
        ssetmn: "\u2216",
        ssmile: "\u2323",
        sstarf: "\u22C6",
        Star: "\u22C6",
        star: "\u2606",
        starf: "\
\u2605",
        straightepsilon: "\u03F5",
        straightphi: "\u03D5",
        strns: "\xAF",
        sub: "\u2282",
        Sub: "\u22D0",
        subdot: "\u2ABD",
        subE: "\u2AC5",
        sube: "\
\u2286",
        subedot: "\u2AC3",
        submult: "\u2AC1",
        subnE: "\u2ACB",
        subne: "\u228A",
        subplus: "\u2ABF",
        subrarr: "\u2979",
        subset: "\u2282",
        Subset: "\
\u22D0",
        subseteq: "\u2286",
        subseteqq: "\u2AC5",
        SubsetEqual: "\u2286",
        subsetneq: "\u228A",
        subsetneqq: "\u2ACB",
        subsim: "\u2AC7",
        subsub: "\
\u2AD5",
        subsup: "\u2AD3",
        succapprox: "\u2AB8",
        succ: "\u227B",
        succcurlyeq: "\u227D",
        Succeeds: "\u227B",
        SucceedsEqual: "\u2AB0",
        SucceedsSlantEqual: "\
\u227D",
        SucceedsTilde: "\u227F",
        succeq: "\u2AB0",
        succnapprox: "\u2ABA",
        succneqq: "\u2AB6",
        succnsim: "\u22E9",
        succsim: "\u227F",
        SuchThat: "\
\u220B",
        sum: "\u2211",
        Sum: "\u2211",
        sung: "\u266A",
        sup1: "\xB9",
        sup2: "\xB2",
        sup3: "\xB3",
        sup: "\u2283",
        Sup: "\u22D1",
        supdot: "\u2ABE",
        supdsub: "\u2AD8",
        supE: "\u2AC6",
        supe: "\u2287",
        supedot: "\u2AC4",
        Superset: "\u2283",
        SupersetEqual: "\u2287",
        suphsol: "\u27C9",
        suphsub: "\
\u2AD7",
        suplarr: "\u297B",
        supmult: "\u2AC2",
        supnE: "\u2ACC",
        supne: "\u228B",
        supplus: "\u2AC0",
        supset: "\u2283",
        Supset: "\u22D1",
        supseteq: "\
\u2287",
        supseteqq: "\u2AC6",
        supsetneq: "\u228B",
        supsetneqq: "\u2ACC",
        supsim: "\u2AC8",
        supsub: "\u2AD4",
        supsup: "\u2AD6",
        swarhk: "\u2926",
        swarr: "\u2199",
        swArr: "\u21D9",
        swarrow: "\u2199",
        swnwar: "\u292A",
        szlig: "\xDF",
        Tab: "	",
        target: "\u2316",
        Tau: "\u03A4",
        tau: "\u03C4",
        tbrk: "\u23B4",
        Tcaron: "\u0164",
        tcaron: "\u0165",
        Tcedil: "\u0162",
        tcedil: "\u0163",
        Tcy: "\u0422",
        tcy: "\u0442",
        tdot: "\u20DB",
        telrec: "\
\u2315",
        Tfr: "\uD835\uDD17",
        tfr: "\uD835\uDD31",
        there4: "\u2234",
        therefore: "\u2234",
        Therefore: "\u2234",
        Theta: "\u0398",
        theta: "\u03B8",
        thetasym: "\
\u03D1",
        thetav: "\u03D1",
        thickapprox: "\u2248",
        thicksim: "\u223C",
        ThickSpace: "\u205F\u200A",
        ThinSpace: "\u2009",
        thinsp: "\u2009",
        thkap: "\
\u2248",
        thksim: "\u223C",
        THORN: "\xDE",
        thorn: "\xFE",
        tilde: "\u02DC",
        Tilde: "\u223C",
        TildeEqual: "\u2243",
        TildeFullEqual: "\u2245",
        TildeTilde: "\
\u2248",
        timesbar: "\u2A31",
        timesb: "\u22A0",
        times: "\xD7",
        timesd: "\u2A30",
        tint: "\u222D",
        toea: "\u2928",
        topbot: "\u2336",
        topcir: "\u2AF1",
        top: "\u22A4",
        Topf: "\uD835\uDD4B",
        topf: "\uD835\uDD65",
        topfork: "\u2ADA",
        tosa: "\u2929",
        tprime: "\u2034",
        trade: "\u2122",
        TRADE: "\u2122",
        triangle: "\u25B5",
        triangledown: "\u25BF",
        triangleleft: "\u25C3",
        trianglelefteq: "\u22B4",
        triangleq: "\u225C",
        triangleright: "\u25B9",
        trianglerighteq: "\u22B5",
        tridot: "\u25EC",
        trie: "\u225C",
        triminus: "\u2A3A",
        TripleDot: "\u20DB",
        triplus: "\u2A39",
        trisb: "\u29CD",
        tritime: "\
\u2A3B",
        trpezium: "\u23E2",
        Tscr: "\uD835\uDCAF",
        tscr: "\uD835\uDCC9",
        TScy: "\u0426",
        tscy: "\u0446",
        TSHcy: "\u040B",
        tshcy: "\u045B",
        Tstrok: "\
\u0166",
        tstrok: "\u0167",
        twixt: "\u226C",
        twoheadleftarrow: "\u219E",
        twoheadrightarrow: "\u21A0",
        Uacute: "\xDA",
        uacute: "\xFA",
        uarr: "\
\u2191",
        Uarr: "\u219F",
        uArr: "\u21D1",
        Uarrocir: "\u2949",
        Ubrcy: "\u040E",
        ubrcy: "\u045E",
        Ubreve: "\u016C",
        ubreve: "\u016D",
        Ucirc: "\xDB",
        ucirc: "\xFB",
        Ucy: "\u0423",
        ucy: "\u0443",
        udarr: "\u21C5",
        Udblac: "\u0170",
        udblac: "\u0171",
        udhar: "\u296E",
        ufisht: "\u297E",
        Ufr: "\uD835\uDD18",
        ufr: "\uD835\uDD32",
        Ugrave: "\xD9",
        ugrave: "\xF9",
        uHar: "\u2963",
        uharl: "\u21BF",
        uharr: "\u21BE",
        uhblk: "\u2580",
        ulcorn: "\u231C",
        ulcorner: "\u231C",
        ulcrop: "\u230F",
        ultri: "\u25F8",
        Umacr: "\u016A",
        umacr: "\u016B",
        uml: "\xA8",
        UnderBar: "_",
        UnderBrace: "\u23DF",
        UnderBracket: "\u23B5",
        UnderParenthesis: "\u23DD",
        Union: "\u22C3",
        UnionPlus: "\u228E",
        Uogon: "\u0172",
        uogon: "\u0173",
        Uopf: "\uD835\uDD4C",
        uopf: "\uD835\uDD66",
        UpArrowBar: "\u2912",
        uparrow: "\u2191",
        UpArrow: "\u2191",
        Uparrow: "\u21D1",
        UpArrowDownArrow: "\u21C5",
        updownarrow: "\
\u2195",
        UpDownArrow: "\u2195",
        Updownarrow: "\u21D5",
        UpEquilibrium: "\u296E",
        upharpoonleft: "\u21BF",
        upharpoonright: "\u21BE",
        uplus: "\u228E",
        UpperLeftArrow: "\u2196",
        UpperRightArrow: "\u2197",
        upsi: "\u03C5",
        Upsi: "\u03D2",
        upsih: "\u03D2",
        Upsilon: "\u03A5",
        upsilon: "\u03C5",
        UpTeeArrow: "\u21A5",
        UpTee: "\u22A5",
        upuparrows: "\u21C8",
        urcorn: "\u231D",
        urcorner: "\u231D",
        urcrop: "\u230E",
        Uring: "\u016E",
        uring: "\
\u016F",
        urtri: "\u25F9",
        Uscr: "\uD835\uDCB0",
        uscr: "\uD835\uDCCA",
        utdot: "\u22F0",
        Utilde: "\u0168",
        utilde: "\u0169",
        utri: "\u25B5",
        utrif: "\
\u25B4",
        uuarr: "\u21C8",
        Uuml: "\xDC",
        uuml: "\xFC",
        uwangle: "\u29A7",
        vangrt: "\u299C",
        varepsilon: "\u03F5",
        varkappa: "\u03F0",
        varnothing: "\
\u2205",
        varphi: "\u03D5",
        varpi: "\u03D6",
        varpropto: "\u221D",
        varr: "\u2195",
        vArr: "\u21D5",
        varrho: "\u03F1",
        varsigma: "\u03C2",
        varsubsetneq: "\
\u228A\uFE00",
        varsubsetneqq: "\u2ACB\uFE00",
        varsupsetneq: "\u228B\uFE00",
        varsupsetneqq: "\u2ACC\uFE00",
        vartheta: "\u03D1",
        vartriangleleft: "\
\u22B2",
        vartriangleright: "\u22B3",
        vBar: "\u2AE8",
        Vbar: "\u2AEB",
        vBarv: "\u2AE9",
        Vcy: "\u0412",
        vcy: "\u0432",
        vdash: "\u22A2",
        vDash: "\
\u22A8",
        Vdash: "\u22A9",
        VDash: "\u22AB",
        Vdashl: "\u2AE6",
        veebar: "\u22BB",
        vee: "\u2228",
        Vee: "\u22C1",
        veeeq: "\u225A",
        vellip: "\u22EE",
        verbar: "|",
        Verbar: "\u2016",
        vert: "|",
        Vert: "\u2016",
        VerticalBar: "\u2223",
        VerticalLine: "|",
        VerticalSeparator: "\u2758",
        VerticalTilde: "\
\u2240",
        VeryThinSpace: "\u200A",
        Vfr: "\uD835\uDD19",
        vfr: "\uD835\uDD33",
        vltri: "\u22B2",
        vnsub: "\u2282\u20D2",
        vnsup: "\u2283\u20D2",
        Vopf: "\uD835\uDD4D",
        vopf: "\uD835\uDD67",
        vprop: "\u221D",
        vrtri: "\u22B3",
        Vscr: "\uD835\uDCB1",
        vscr: "\uD835\uDCCB",
        vsubnE: "\u2ACB\uFE00",
        vsubne: "\u228A\uFE00",
        vsupnE: "\u2ACC\uFE00",
        vsupne: "\u228B\uFE00",
        Vvdash: "\u22AA",
        vzigzag: "\u299A",
        Wcirc: "\u0174",
        wcirc: "\u0175",
        wedbar: "\u2A5F",
        wedge: "\
\u2227",
        Wedge: "\u22C0",
        wedgeq: "\u2259",
        weierp: "\u2118",
        Wfr: "\uD835\uDD1A",
        wfr: "\uD835\uDD34",
        Wopf: "\uD835\uDD4E",
        wopf: "\uD835\uDD68",
        wp: "\
\u2118",
        wr: "\u2240",
        wreath: "\u2240",
        Wscr: "\uD835\uDCB2",
        wscr: "\uD835\uDCCC",
        xcap: "\u22C2",
        xcirc: "\u25EF",
        xcup: "\u22C3",
        xdtri: "\u25BD",
        Xfr: "\uD835\uDD1B",
        xfr: "\uD835\uDD35",
        xharr: "\u27F7",
        xhArr: "\u27FA",
        Xi: "\u039E",
        xi: "\u03BE",
        xlarr: "\u27F5",
        xlArr: "\u27F8",
        xmap: "\
\u27FC",
        xnis: "\u22FB",
        xodot: "\u2A00",
        Xopf: "\uD835\uDD4F",
        xopf: "\uD835\uDD69",
        xoplus: "\u2A01",
        xotime: "\u2A02",
        xrarr: "\u27F6",
        xrArr: "\
\u27F9",
        Xscr: "\uD835\uDCB3",
        xscr: "\uD835\uDCCD",
        xsqcup: "\u2A06",
        xuplus: "\u2A04",
        xutri: "\u25B3",
        xvee: "\u22C1",
        xwedge: "\u22C0",
        Yacute: "\
\xDD",
        yacute: "\xFD",
        YAcy: "\u042F",
        yacy: "\u044F",
        Ycirc: "\u0176",
        ycirc: "\u0177",
        Ycy: "\u042B",
        ycy: "\u044B",
        yen: "\xA5",
        Yfr: "\uD835\uDD1C",
        yfr: "\uD835\uDD36",
        YIcy: "\u0407",
        yicy: "\u0457",
        Yopf: "\uD835\uDD50",
        yopf: "\uD835\uDD6A",
        Yscr: "\uD835\uDCB4",
        yscr: "\uD835\uDCCE",
        YUcy: "\u042E",
        yucy: "\u044E",
        yuml: "\xFF",
        Yuml: "\u0178",
        Zacute: "\u0179",
        zacute: "\u017A",
        Zcaron: "\u017D",
        zcaron: "\u017E",
        Zcy: "\u0417",
        zcy: "\
\u0437",
        Zdot: "\u017B",
        zdot: "\u017C",
        zeetrf: "\u2128",
        ZeroWidthSpace: "\u200B",
        Zeta: "\u0396",
        zeta: "\u03B6",
        zfr: "\uD835\uDD37",
        Zfr: "\
\u2128",
        ZHcy: "\u0416",
        zhcy: "\u0436",
        zigrarr: "\u21DD",
        zopf: "\uD835\uDD6B",
        Zopf: "\u2124",
        Zscr: "\uD835\uDCB5",
        zscr: "\uD835\uDCCF",
        zwj: "\u200D",
        zwnj: "\u200C"
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/legacy.json
var sn = k((Pf, ja)=>{
    ja.exports = {
        Aacute: "\xC1",
        aacute: "\xE1",
        Acirc: "\xC2",
        acirc: "\xE2",
        acute: "\xB4",
        AElig: "\xC6",
        aelig: "\xE6",
        Agrave: "\xC0",
        agrave: "\
\xE0",
        amp: "&",
        AMP: "&",
        Aring: "\xC5",
        aring: "\xE5",
        Atilde: "\xC3",
        atilde: "\xE3",
        Auml: "\xC4",
        auml: "\xE4",
        brvbar: "\xA6",
        Ccedil: "\
\xC7",
        ccedil: "\xE7",
        cedil: "\xB8",
        cent: "\xA2",
        copy: "\xA9",
        COPY: "\xA9",
        curren: "\xA4",
        deg: "\xB0",
        divide: "\xF7",
        Eacute: "\xC9",
        eacute: "\xE9",
        Ecirc: "\xCA",
        ecirc: "\xEA",
        Egrave: "\xC8",
        egrave: "\xE8",
        ETH: "\xD0",
        eth: "\xF0",
        Euml: "\xCB",
        euml: "\xEB",
        frac12: "\
\xBD",
        frac14: "\xBC",
        frac34: "\xBE",
        gt: ">",
        GT: ">",
        Iacute: "\xCD",
        iacute: "\xED",
        Icirc: "\xCE",
        icirc: "\xEE",
        iexcl: "\xA1",
        Igrave: "\
\xCC",
        igrave: "\xEC",
        iquest: "\xBF",
        Iuml: "\xCF",
        iuml: "\xEF",
        laquo: "\xAB",
        lt: "<",
        LT: "<",
        macr: "\xAF",
        micro: "\xB5",
        middot: "\xB7",
        nbsp: "\xA0",
        not: "\xAC",
        Ntilde: "\xD1",
        ntilde: "\xF1",
        Oacute: "\xD3",
        oacute: "\xF3",
        Ocirc: "\xD4",
        ocirc: "\xF4",
        Ograve: "\xD2",
        ograve: "\
\xF2",
        ordf: "\xAA",
        ordm: "\xBA",
        Oslash: "\xD8",
        oslash: "\xF8",
        Otilde: "\xD5",
        otilde: "\xF5",
        Ouml: "\xD6",
        ouml: "\xF6",
        para: "\xB6",
        plusmn: "\xB1",
        pound: "\xA3",
        quot: '"',
        QUOT: '"',
        raquo: "\xBB",
        reg: "\xAE",
        REG: "\xAE",
        sect: "\xA7",
        shy: "\xAD",
        sup1: "\xB9",
        sup2: "\
\xB2",
        sup3: "\xB3",
        szlig: "\xDF",
        THORN: "\xDE",
        thorn: "\xFE",
        times: "\xD7",
        Uacute: "\xDA",
        uacute: "\xFA",
        Ucirc: "\xDB",
        ucirc: "\xFB",
        Ugrave: "\xD9",
        ugrave: "\xF9",
        uml: "\xA8",
        Uuml: "\xDC",
        uuml: "\xFC",
        Yacute: "\xDD",
        yacute: "\xFD",
        yen: "\xA5",
        yuml: "\xFF"
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/xml.json
var bt = k((Ff, La)=>{
    La.exports = {
        amp: "&",
        apos: "'",
        gt: ">",
        lt: "<",
        quot: '"'
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/maps/decode.json
var an = k((If, Na)=>{
    Na.exports = {
        "0": 65533,
        "128": 8364,
        "130": 8218,
        "131": 402,
        "132": 8222,
        "133": 8230,
        "134": 8224,
        "135": 8225,
        "136": 710,
        "137": 8240,
        "138": 352,
        "139": 8249,
        "140": 338,
        "142": 381,
        "145": 8216,
        "146": 8217,
        "147": 8220,
        "148": 8221,
        "149": 8226,
        "150": 8211,
        "151": 8212,
        "152": 732,
        "153": 8482,
        "154": 353,
        "155": 8250,
        "156": 339,
        "158": 382,
        "159": 376
    };
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/decode_codepoint.js
var cn = k((ze)=>{
    "use strict";
    var Ma = ze && ze.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty(ze, "__esModule", {
        value: !0
    });
    var ln = Ma(an()), _a = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(r) {
        var e = "";
        return r > 65535 && (r -= 65536, e += String.fromCharCode(r >>> 10 & 1023 | 55296), r = 56320 | r & 1023), e += String.fromCharCode(r), e;
    };
    function qa(r) {
        return r >= 55296 && r <= 57343 || r > 1114111 ? "\uFFFD" : (r in ln.default && (r = ln.default[r]), _a(r));
    }
    s(qa, "decodeCodePoint");
    ze.default = qa;
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/decode.js
var Et = k(($)=>{
    "use strict";
    var dr = $ && $.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty($, "__esModule", {
        value: !0
    });
    $.decodeHTML = $.decodeHTMLStrict = $.decodeXML = void 0;
    var Tt = dr(St()), Ua = dr(sn()), Ga = dr(bt()), dn = dr(cn()), Ba = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
    $.decodeXML = un(Ga.default);
    $.decodeHTMLStrict = un(Tt.default);
    function un(r) {
        var e = fn(r);
        return function(t) {
            return String(t).replace(Ba, e);
        };
    }
    s(un, "getStrictDecoder");
    var pn = /* @__PURE__ */ s(function(r, e) {
        return r < e ? 1 : -1;
    }, "sorter");
    $.decodeHTML = function() {
        for(var r = Object.keys(Ua.default).sort(pn), e = Object.keys(Tt.default).sort(pn), t = 0, o = 0; t < e.length; t++)r[o] === e[t] ? (e[t] += ";?", o++) : e[t] += ";";
        var n = new RegExp("&(?:" + e.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), i = fn(Tt.default);
        function a(l) {
            return l.substr(-1) !== ";" && (l += ";"), i(l);
        }
        return s(a, "replacer"), function(l) {
            return String(l).replace(n, a);
        };
    }();
    function fn(r) {
        return /* @__PURE__ */ s(function(t) {
            if (t.charAt(1) === "#") {
                var o = t.charAt(2);
                return o === "X" || o === "x" ? dn.default(parseInt(t.substr(3), 16)) : dn.default(parseInt(t.substr(2), 10));
            }
            return r[t.slice(1, -1)] || t;
        }, "replace");
    }
    s(fn, "getReplacer");
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/encode.js
var xt = k((_)=>{
    "use strict";
    var yn = _ && _.__importDefault || function(r) {
        return r && r.__esModule ? r : {
            default: r
        };
    };
    Object.defineProperty(_, "__esModule", {
        value: !0
    });
    _.escapeUTF8 = _.escape = _.encodeNonAsciiHTML = _.encodeHTML = _.encodeXML = void 0;
    var za = yn(bt()), hn = gn(za.default), mn = Sn(hn);
    _.encodeXML = En(hn);
    var Va = yn(St()), Rt = gn(Va.default), Ha = Sn(Rt);
    _.encodeHTML = $a(Rt, Ha);
    _.encodeNonAsciiHTML = En(Rt);
    function gn(r) {
        return Object.keys(r).sort().reduce(function(e, t) {
            return e[r[t]] = "&" + t + ";", e;
        }, {});
    }
    s(gn, "getInverseObj");
    function Sn(r) {
        for(var e = [], t = [], o = 0, n = Object.keys(r); o < n.length; o++){
            var i = n[o];
            i.length === 1 ? e.push("\\" + i) : t.push(i);
        }
        e.sort();
        for(var a = 0; a < e.length - 1; a++){
            for(var l = a; l < e.length - 1 && e[l].charCodeAt(1) + 1 === e[l + 1].charCodeAt(1);)l += 1;
            var c = 1 + l - a;
            c < 3 || e.splice(a, c, e[a] + "-" + e[l]);
        }
        return t.unshift("[" + e.join("") + "]"), new RegExp(t.join("|"), "g");
    }
    s(Sn, "getInverseReplacer");
    var bn = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, Wa = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    function(r) {
        return r.codePointAt(0);
    } : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(r) {
        return (r.charCodeAt(0) - 55296) * 1024 + r.charCodeAt(1) - 56320 + 65536;
    };
    function pr(r) {
        return "&#x" + (r.length > 1 ? Wa(r) : r.charCodeAt(0)).toString(16).toUpperCase() + ";";
    }
    s(pr, "singleCharReplacer");
    function $a(r, e) {
        return function(t) {
            return t.replace(e, function(o) {
                return r[o];
            }).replace(bn, pr);
        };
    }
    s($a, "getInverse");
    var Tn = new RegExp(mn.source + "|" + bn.source, "g");
    function Ya(r) {
        return r.replace(Tn, pr);
    }
    s(Ya, "escape");
    _.escape = Ya;
    function Ka(r) {
        return r.replace(mn, pr);
    }
    s(Ka, "escapeUTF8");
    _.escapeUTF8 = Ka;
    function En(r) {
        return function(e) {
            return e.replace(Tn, function(t) {
                return r[t] || pr(t);
            });
        };
    }
    s(En, "getASCIIEncoder");
});
// ../node_modules/ansi-to-html/node_modules/entities/lib/index.js
var xn = k((v)=>{
    "use strict";
    Object.defineProperty(v, "__esModule", {
        value: !0
    });
    v.decodeXMLStrict = v.decodeHTML5Strict = v.decodeHTML4Strict = v.decodeHTML5 = v.decodeHTML4 = v.decodeHTMLStrict = v.decodeHTML = v.decodeXML = v.encodeHTML5 = v.encodeHTML4 = v.escapeUTF8 = v.escape = v.encodeNonAsciiHTML = v.encodeHTML = v.encodeXML = v.encode = v.decodeStrict = v.decode = void 0;
    var ur = Et(), Rn = xt();
    function Xa(r, e) {
        return (!e || e <= 0 ? ur.decodeXML : ur.decodeHTML)(r);
    }
    s(Xa, "decode");
    v.decode = Xa;
    function Ja(r, e) {
        return (!e || e <= 0 ? ur.decodeXML : ur.decodeHTMLStrict)(r);
    }
    s(Ja, "decodeStrict");
    v.decodeStrict = Ja;
    function Qa(r, e) {
        return (!e || e <= 0 ? Rn.encodeXML : Rn.encodeHTML)(r);
    }
    s(Qa, "encode");
    v.encode = Qa;
    var ue = xt();
    Object.defineProperty(v, "encodeXML", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return ue.encodeXML;
        }, "get")
    });
    Object.defineProperty(v, "encodeHTML", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return ue.encodeHTML;
        }, "get")
    });
    Object.defineProperty(v, "encodeNonAsciiHTML", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return ue.encodeNonAsciiHTML;
        }, "get")
    });
    Object.defineProperty(v, "escape", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return ue.escape;
        }, "get")
    });
    Object.defineProperty(v, "escapeUTF8", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return ue.escapeUTF8;
        }, "get")
    });
    Object.defineProperty(v, "encodeHTML4", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return ue.encodeHTML;
        }, "get")
    });
    Object.defineProperty(v, "encodeHTML5", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return ue.encodeHTML;
        }, "get")
    });
    var oe = Et();
    Object.defineProperty(v, "decodeXML", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeXML;
        }, "get")
    });
    Object.defineProperty(v, "decodeHTML", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeHTML;
        }, "get")
    });
    Object.defineProperty(v, "decodeHTMLStrict", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeHTMLStrict;
        }, "get")
    });
    Object.defineProperty(v, "decodeHTML4", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeHTML;
        }, "get")
    });
    Object.defineProperty(v, "decodeHTML5", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeHTML;
        }, "get")
    });
    Object.defineProperty(v, "decodeHTML4Strict", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeHTMLStrict;
        }, "get")
    });
    Object.defineProperty(v, "decodeHTML5Strict", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeHTMLStrict;
        }, "get")
    });
    Object.defineProperty(v, "decodeXMLStrict", {
        enumerable: !0,
        get: /* @__PURE__ */ s(function() {
            return oe.decodeXML;
        }, "get")
    });
});
// ../node_modules/ansi-to-html/lib/ansi_to_html.js
var jn = k((qf, kn)=>{
    "use strict";
    function Za(r, e) {
        if (!(r instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    s(Za, "_classCallCheck");
    function wn(r, e) {
        for(var t = 0; t < e.length; t++){
            var o = e[t];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(r, o.key, o);
        }
    }
    s(wn, "_defineProperties");
    function el(r, e, t) {
        return e && wn(r.prototype, e), t && wn(r, t), r;
    }
    s(el, "_createClass");
    function In(r, e) {
        var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
        if (!t) {
            if (Array.isArray(r) || (t = rl(r)) || e && r && typeof r.length == "number") {
                t && (r = t);
                var o = 0, n = /* @__PURE__ */ s(function() {}, "F");
                return {
                    s: n,
                    n: /* @__PURE__ */ s(function() {
                        return o >= r.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: r[o++]
                        };
                    }, "n"),
                    e: /* @__PURE__ */ s(function(d) {
                        throw d;
                    }, "e"),
                    f: n
                };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        var i = !0, a = !1, l;
        return {
            s: /* @__PURE__ */ s(function() {
                t = t.call(r);
            }, "s"),
            n: /* @__PURE__ */ s(function() {
                var d = t.next();
                return i = d.done, d;
            }, "n"),
            e: /* @__PURE__ */ s(function(d) {
                a = !0, l = d;
            }, "e"),
            f: /* @__PURE__ */ s(function() {
                try {
                    !i && t.return != null && t.return();
                } finally{
                    if (a) throw l;
                }
            }, "f")
        };
    }
    s(In, "_createForOfIteratorHelper");
    function rl(r, e) {
        if (r) {
            if (typeof r == "string") return vn(r, e);
            var t = Object.prototype.toString.call(r).slice(8, -1);
            if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
            if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return vn(r, e);
        }
    }
    s(rl, "_unsupportedIterableToArray");
    function vn(r, e) {
        (e == null || e > r.length) && (e = r.length);
        for(var t = 0, o = new Array(e); t < e; t++)o[t] = r[t];
        return o;
    }
    s(vn, "_arrayLikeToArray");
    var tl = xn(), An = {
        fg: "#FFF",
        bg: "#000",
        newline: !1,
        escapeXML: !1,
        stream: !1,
        colors: ol()
    };
    function ol() {
        var r = {
            0: "#000",
            1: "#A00",
            2: "#0A0",
            3: "#A50",
            4: "#00A",
            5: "#A0A",
            6: "#0AA",
            7: "#AAA",
            8: "#555",
            9: "#F55",
            10: "#5F5",
            11: "#FF5",
            12: "#55F",
            13: "#F5F",
            14: "#5FF",
            15: "#FFF"
        };
        return fr(0, 5).forEach(function(e) {
            fr(0, 5).forEach(function(t) {
                fr(0, 5).forEach(function(o) {
                    return nl(e, t, o, r);
                });
            });
        }), fr(0, 23).forEach(function(e) {
            var t = e + 232, o = On(e * 10 + 8);
            r[t] = "#" + o + o + o;
        }), r;
    }
    s(ol, "getDefaultColors");
    function nl(r, e, t, o) {
        var n = 16 + r * 36 + e * 6 + t, i = r > 0 ? r * 40 + 55 : 0, a = e > 0 ? e * 40 + 55 : 0, l = t > 0 ? t * 40 + 55 : 0;
        o[n] = sl([
            i,
            a,
            l
        ]);
    }
    s(nl, "setStyleColor");
    function On(r) {
        for(var e = r.toString(16); e.length < 2;)e = "0" + e;
        return e;
    }
    s(On, "toHexString");
    function sl(r) {
        var e = [], t = In(r), o;
        try {
            for(t.s(); !(o = t.n()).done;){
                var n = o.value;
                e.push(On(n));
            }
        } catch (i) {
            t.e(i);
        } finally{
            t.f();
        }
        return "#" + e.join("");
    }
    s(sl, "toColorHexString");
    function Cn(r, e, t, o) {
        var n;
        return e === "text" ? n = cl(t, o) : e === "display" ? n = al(r, t, o) : e === "xterm256Foreground" ? n = hr(r, o.colors[t]) : e === "xt\
erm256Background" ? n = mr(r, o.colors[t]) : e === "rgb" && (n = il(r, t)), n;
    }
    s(Cn, "generateOutput");
    function il(r, e) {
        e = e.substring(2).slice(0, -1);
        var t = +e.substr(0, 2), o = e.substring(5).split(";"), n = o.map(function(i) {
            return ("0" + Number(i).toString(16)).substr(-2);
        }).join("");
        return yr(r, (t === 38 ? "color:#" : "background-color:#") + n);
    }
    s(il, "handleRgb");
    function al(r, e, t) {
        e = parseInt(e, 10);
        var o = {
            "-1": /* @__PURE__ */ s(function() {
                return "<br/>";
            }, "_"),
            0: /* @__PURE__ */ s(function() {
                return r.length && Dn(r);
            }, "_"),
            1: /* @__PURE__ */ s(function() {
                return ne(r, "b");
            }, "_"),
            3: /* @__PURE__ */ s(function() {
                return ne(r, "i");
            }, "_"),
            4: /* @__PURE__ */ s(function() {
                return ne(r, "u");
            }, "_"),
            8: /* @__PURE__ */ s(function() {
                return yr(r, "display:none");
            }, "_"),
            9: /* @__PURE__ */ s(function() {
                return ne(r, "strike");
            }, "_"),
            22: /* @__PURE__ */ s(function() {
                return yr(r, "font-weight:normal;text-decoration:none;font-style:normal");
            }, "_"),
            23: /* @__PURE__ */ s(function() {
                return Fn(r, "i");
            }, "_"),
            24: /* @__PURE__ */ s(function() {
                return Fn(r, "u");
            }, "_"),
            39: /* @__PURE__ */ s(function() {
                return hr(r, t.fg);
            }, "_"),
            49: /* @__PURE__ */ s(function() {
                return mr(r, t.bg);
            }, "_"),
            53: /* @__PURE__ */ s(function() {
                return yr(r, "text-decoration:overline");
            }, "_")
        }, n;
        return o[e] ? n = o[e]() : 4 < e && e < 7 ? n = ne(r, "blink") : 29 < e && e < 38 ? n = hr(r, t.colors[e - 30]) : 39 < e && e < 48 ? n = mr(r, t.colors[e - 40]) : 89 < e && e < 98 ? n = hr(r, t.colors[8 + (e - 90)]) : 99 < e && e < 108 && (n = mr(r, t.colors[8 + (e - 100)])), n;
    }
    s(al, "handleDisplay");
    function Dn(r) {
        var e = r.slice(0);
        return r.length = 0, e.reverse().map(function(t) {
            return "</" + t + ">";
        }).join("");
    }
    s(Dn, "resetStyles");
    function fr(r, e) {
        for(var t = [], o = r; o <= e; o++)t.push(o);
        return t;
    }
    s(fr, "range");
    function ll(r) {
        return function(e) {
            return (r === null || e.category !== r) && r !== "all";
        };
    }
    s(ll, "notCategory");
    function Pn(r) {
        r = parseInt(r, 10);
        var e = null;
        return r === 0 ? e = "all" : r === 1 ? e = "bold" : 2 < r && r < 5 ? e = "underline" : 4 < r && r < 7 ? e = "blink" : r === 8 ? e = "hid\
e" : r === 9 ? e = "strike" : 29 < r && r < 38 || r === 39 || 89 < r && r < 98 ? e = "foreground-color" : (39 < r && r < 48 || r === 49 || 99 < r && r < 108) && (e = "background-color"), e;
    }
    s(Pn, "categoryForCode");
    function cl(r, e) {
        return e.escapeXML ? tl.encodeXML(r) : r;
    }
    s(cl, "pushText");
    function ne(r, e, t) {
        return t || (t = ""), r.push(e), "<".concat(e).concat(t ? ' style="'.concat(t, '"') : "", ">");
    }
    s(ne, "pushTag");
    function yr(r, e) {
        return ne(r, "span", e);
    }
    s(yr, "pushStyle");
    function hr(r, e) {
        return ne(r, "span", "color:" + e);
    }
    s(hr, "pushForegroundColor");
    function mr(r, e) {
        return ne(r, "span", "background-color:" + e);
    }
    s(mr, "pushBackgroundColor");
    function Fn(r, e) {
        var t;
        if (r.slice(-1)[0] === e && (t = r.pop()), t) return "</" + e + ">";
    }
    s(Fn, "closeTag");
    function dl(r, e, t) {
        var o = !1, n = 3;
        function i() {
            return "";
        }
        s(i, "remove");
        function a(x, w) {
            return t("xterm256Foreground", w), "";
        }
        s(a, "removeXterm256Foreground");
        function l(x, w) {
            return t("xterm256Background", w), "";
        }
        s(l, "removeXterm256Background");
        function c(x) {
            return e.newline ? t("display", -1) : t("text", x), "";
        }
        s(c, "newline");
        function d(x, w) {
            o = !0, w.trim().length === 0 && (w = "0"), w = w.trimRight(";").split(";");
            var A = In(w), O;
            try {
                for(A.s(); !(O = A.n()).done;){
                    var N = O.value;
                    t("display", N);
                }
            } catch (U) {
                A.e(U);
            } finally{
                A.f();
            }
            return "";
        }
        s(d, "ansiMess");
        function p(x) {
            return t("text", x), "";
        }
        s(p, "realText");
        function u(x) {
            return t("rgb", x), "";
        }
        s(u, "rgb");
        var y = [
            {
                pattern: /^\x08+/,
                sub: i
            },
            {
                pattern: /^\x1b\[[012]?K/,
                sub: i
            },
            {
                pattern: /^\x1b\[\(B/,
                sub: i
            },
            {
                pattern: /^\x1b\[[34]8;2;\d+;\d+;\d+m/,
                sub: u
            },
            {
                pattern: /^\x1b\[38;5;(\d+)m/,
                sub: a
            },
            {
                pattern: /^\x1b\[48;5;(\d+)m/,
                sub: l
            },
            {
                pattern: /^\n/,
                sub: c
            },
            {
                pattern: /^\r+\n/,
                sub: c
            },
            {
                pattern: /^\r/,
                sub: c
            },
            {
                pattern: /^\x1b\[((?:\d{1,3};?)+|)m/,
                sub: d
            },
            {
                // CSI n J
                // ED - Erase in Display Clears part of the screen.
                // If n is 0 (or missing), clear from cursor to end of screen.
                // If n is 1, clear from cursor to beginning of the screen.
                // If n is 2, clear entire screen (and moves cursor to upper left on DOS ANSI.SYS).
                // If n is 3, clear entire screen and delete all lines saved in the scrollback buffer
                //   (this feature was added for xterm and is supported by other terminal applications).
                pattern: /^\x1b\[\d?J/,
                sub: i
            },
            {
                // CSI n ; m f
                // HVP - Horizontal Vertical Position Same as CUP
                pattern: /^\x1b\[\d{0,3};\d{0,3}f/,
                sub: i
            },
            {
                // catch-all for CSI sequences?
                pattern: /^\x1b\[?[\d;]{0,3}/,
                sub: i
            },
            {
                /**
       * extracts real text - not containing:
       * - `\x1b' - ESC - escape (Ascii 27)
       * - '\x08' - BS - backspace (Ascii 8)
       * - `\n` - Newline - linefeed (LF) (ascii 10)
       * - `\r` - Windows Carriage Return (CR)
       */ pattern: /^(([^\x1b\x08\r\n])+)/,
                sub: p
            }
        ];
        function m(x, w) {
            w > n && o || (o = !1, r = r.replace(x.pattern, x.sub));
        }
        s(m, "process");
        var g = [], S = r, h = S.length;
        e: for(; h > 0;){
            for(var E = 0, R = 0, f = y.length; R < f; E = ++R){
                var b = y[E];
                if (m(b, E), r.length !== h) {
                    h = r.length;
                    continue e;
                }
            }
            if (r.length === h) break;
            g.push(0), h = r.length;
        }
        return g;
    }
    s(dl, "tokenize");
    function pl(r, e, t) {
        return e !== "text" && (r = r.filter(ll(Pn(t))), r.push({
            token: e,
            data: t,
            category: Pn(t)
        })), r;
    }
    s(pl, "updateStickyStack");
    var ul = /* @__PURE__ */ function() {
        function r(e) {
            Za(this, r), e = e || {}, e.colors && (e.colors = Object.assign({}, An.colors, e.colors)), this.options = Object.assign({}, An, e), this.stack = [], this.stickyStack = [];
        }
        return s(r, "Filter"), el(r, [
            {
                key: "toHtml",
                value: /* @__PURE__ */ s(function(t) {
                    var o = this;
                    t = typeof t == "string" ? [
                        t
                    ] : t;
                    var n = this.stack, i = this.options, a = [];
                    return this.stickyStack.forEach(function(l) {
                        var c = Cn(n, l.token, l.data, i);
                        c && a.push(c);
                    }), dl(t.join(""), i, function(l, c) {
                        var d = Cn(n, l, c, i);
                        d && a.push(d), i.stream && (o.stickyStack = pl(o.stickyStack, l, c));
                    }), n.length && a.push(Dn(n)), a.join("");
                }, "toHtml")
            }
        ]), r;
    }();
    kn.exports = ul;
});
// ../node_modules/@storybook/global/dist/index.mjs
var I = (()=>{
    let r;
    return typeof window < "u" ? r = window : typeof globalThis < "u" ? r = globalThis : typeof global < "u" ? r = global : typeof self < "u" ? r = self : r = {}, r;
})();
function Tr() {
    let r = {
        setHandler: /* @__PURE__ */ s(()=>{}, "setHandler"),
        send: /* @__PURE__ */ s(()=>{}, "send")
    };
    return new (0, _channels.Channel)({
        transport: r
    });
}
s(Tr, "mockChannel");
// src/preview-api/modules/addons/main.ts
var xr = class xr {
    constructor(){
        this.getChannel = /* @__PURE__ */ s(()=>{
            if (!this.channel) {
                let e = Tr();
                return this.setChannel(e), e;
            }
            return this.channel;
        }, "getChannel");
        this.ready = /* @__PURE__ */ s(()=>this.promise, "ready");
        this.hasChannel = /* @__PURE__ */ s(()=>!!this.channel, "hasChannel");
        this.setChannel = /* @__PURE__ */ s((e)=>{
            this.channel = e, this.resolve();
        }, "setChannel");
        this.promise = new Promise((e)=>{
            this.resolve = ()=>e(this.getChannel());
        });
    }
};
s(xr, "AddonStore");
var Rr = xr, Er = "__STORYBOOK_ADDONS_PREVIEW";
function Xn() {
    return I[Er] || (I[Er] = new Rr()), I[Er];
}
s(Xn, "getAddonsStore");
var V = Xn();
// src/preview-api/modules/addons/definePreview.ts
function Jn(r) {
    return r;
}
s(Jn, "definePreview");
var Pr = class Pr {
    constructor(){
        this.hookListsMap = void 0;
        this.mountedDecorators = void 0;
        this.prevMountedDecorators = void 0;
        this.currentHooks = void 0;
        this.nextHookIndex = void 0;
        this.currentPhase = void 0;
        this.currentEffects = void 0;
        this.prevEffects = void 0;
        this.currentDecoratorName = void 0;
        this.hasUpdates = void 0;
        this.currentContext = void 0;
        this.renderListener = /* @__PURE__ */ s((e)=>{
            e === this.currentContext?.id && (this.triggerEffects(), this.currentContext = null, this.removeRenderListeners());
        }, "renderListener");
        this.init();
    }
    init() {
        this.hookListsMap = /* @__PURE__ */ new WeakMap(), this.mountedDecorators = /* @__PURE__ */ new Set(), this.prevMountedDecorators = /* @__PURE__ */ new Set(), this.currentHooks = [], this.nextHookIndex = 0, this.currentPhase = "NONE", this.currentEffects = [], this.prevEffects = [], this.currentDecoratorName = null, this.hasUpdates = !1, this.currentContext = null;
    }
    clean() {
        this.prevEffects.forEach((e)=>{
            e.destroy && e.destroy();
        }), this.init(), this.removeRenderListeners();
    }
    getNextHook() {
        let e = this.currentHooks[this.nextHookIndex];
        return this.nextHookIndex += 1, e;
    }
    triggerEffects() {
        this.prevEffects.forEach((e)=>{
            !this.currentEffects.includes(e) && e.destroy && e.destroy();
        }), this.currentEffects.forEach((e)=>{
            this.prevEffects.includes(e) || (e.destroy = e.create());
        }), this.prevEffects = this.currentEffects, this.currentEffects = [];
    }
    addRenderListeners() {
        this.removeRenderListeners(), V.getChannel().on((0, _coreEvents.STORY_RENDERED), this.renderListener);
    }
    removeRenderListeners() {
        V.getChannel().removeListener((0, _coreEvents.STORY_RENDERED), this.renderListener);
    }
};
s(Pr, "HooksContext");
var se = Pr;
function It(r) {
    let e = /* @__PURE__ */ s((...t)=>{
        let { hooks: o } = typeof t[0] == "function" ? t[1] : t[0], n = o.currentPhase, i = o.currentHooks, a = o.nextHookIndex, l = o.currentDecoratorName;
        o.currentDecoratorName = r.name, o.prevMountedDecorators.has(r) ? (o.currentPhase = "UPDATE", o.currentHooks = o.hookListsMap.get(r) || []) : (o.currentPhase = "MOUNT", o.currentHooks = [], o.hookListsMap.set(r, o.currentHooks), o.prevMountedDecorators.add(r)), o.nextHookIndex = 0;
        let c = I.STORYBOOK_HOOKS_CONTEXT;
        I.STORYBOOK_HOOKS_CONTEXT = o;
        let d = r(...t);
        if (I.STORYBOOK_HOOKS_CONTEXT = c, o.currentPhase === "UPDATE" && o.getNextHook() != null) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return o.currentPhase = n, o.currentHooks = i, o.nextHookIndex = a, o.currentDecoratorName = l, d;
    }, "hookified");
    return e.originalFn = r, e;
}
s(It, "hookify");
var wr = 0, ts = 25, vr = /* @__PURE__ */ s((r)=>(e, t)=>{
        let o = r(It(e), t.map((n)=>It(n)));
        return (n)=>{
            let { hooks: i } = n;
            i.prevMountedDecorators ??= /* @__PURE__ */ new Set(), i.mountedDecorators = /* @__PURE__ */ new Set([
                e,
                ...t
            ]), i.currentContext = n, i.hasUpdates = !1;
            let a = o(n);
            for(wr = 1; i.hasUpdates;)if (i.hasUpdates = !1, i.currentEffects = [], a = o(n), wr += 1, wr > ts) throw new Error("Too many re-renders. Storybook limits the number of renders to prevent an infinite loop.");
            return i.addRenderListeners(), a;
        };
    }, "applyHooks"), os = /* @__PURE__ */ s((r, e)=>r.length === e.length && r.every((t, o)=>t === e[o]), "areDepsEqual"), Ar = /* @__PURE__ */ s(()=>new Error("Storybook preview hooks can only be called inside decorators and story functions."), "invalidHooksError");
function Ot() {
    return I.STORYBOOK_HOOKS_CONTEXT || null;
}
s(Ot, "getHooksContextOrNull");
function Cr() {
    let r = Ot();
    if (r == null) throw Ar();
    return r;
}
s(Cr, "getHooksContextOrThrow");
function ns(r, e, t) {
    let o = Cr();
    if (o.currentPhase === "MOUNT") {
        t != null && !Array.isArray(t) && (0, _clientLogger.logger).warn(`${r} received a final argument that is not an array (instead, received ${t}). When specified, the final argument must be an array.`);
        let n = {
            name: r,
            deps: t
        };
        return o.currentHooks.push(n), e(n), n;
    }
    if (o.currentPhase === "UPDATE") {
        let n = o.getNextHook();
        if (n == null) throw new Error("Rendered more hooks than during the previous render.");
        return n.name !== r && (0, _clientLogger.logger).warn(`Storybook has detected a change in the order of Hooks${o.currentDecoratorName ? ` called by ${o.currentDecoratorName}` : ""}. This wi\
ll lead to bugs and errors if not fixed.`), t != null && n.deps == null && (0, _clientLogger.logger).warn(`${r} received a final argument during this render, but not during the previous render. Even though the final argument is optional, it\
s type cannot change between renders.`), t != null && n.deps != null && t.length !== n.deps.length && (0, _clientLogger.logger).warn(`The final argument passed to ${r} changed size between renders.\
 The order and size of this array must remain constant.
Previous: ${n.deps}
Incoming: ${t}`), (t == null || n.deps == null || !os(t, n.deps)) && (e(n), n.deps = t), n;
    }
    throw Ar();
}
s(ns, "useHook");
function He(r, e, t) {
    let { memoizedState: o } = ns(r, (n)=>{
        n.memoizedState = e();
    }, t);
    return o;
}
s(He, "useMemoLike");
function ss(r, e) {
    return He("useMemo", r, e);
}
s(ss, "useMemo");
function Oe(r, e) {
    return He("useCallback", ()=>r, e);
}
s(Oe, "useCallback");
function Dt(r, e) {
    return He(r, ()=>({
            current: e
        }), []);
}
s(Dt, "useRefLike");
function is(r) {
    return Dt("useRef", r);
}
s(is, "useRef");
function as() {
    let r = Ot();
    if (r != null && r.currentPhase !== "NONE") r.hasUpdates = !0;
    else try {
        V.getChannel().emit((0, _coreEvents.FORCE_RE_RENDER));
    } catch  {
        (0, _clientLogger.logger).warn("State updates of Storybook preview hooks work only in browser");
    }
}
s(as, "triggerUpdate");
function kt(r, e) {
    let t = Dt(r, // @ts-expect-error S type should never be function, but there's no way to tell that to TypeScript
    typeof e == "function" ? e() : e), o = /* @__PURE__ */ s((n)=>{
        t.current = typeof n == "function" ? n(t.current) : n, as();
    }, "setState");
    return [
        t.current,
        o
    ];
}
s(kt, "useStateLike");
function ls(r) {
    return kt("useState", r);
}
s(ls, "useState");
function cs(r, e, t) {
    let o = t != null ? ()=>t(e) : e, [n, i] = kt("useReducer", o);
    return [
        n,
        /* @__PURE__ */ s((l)=>i((c)=>r(c, l)), "dispatch")
    ];
}
s(cs, "useReducer");
function jt(r, e) {
    let t = Cr(), o = He("useEffect", ()=>({
            create: r
        }), e);
    t.currentEffects.includes(o) || t.currentEffects.push(o);
}
s(jt, "useEffect");
function ds(r, e = []) {
    let t = V.getChannel();
    return jt(()=>(Object.entries(r).forEach(([o, n])=>t.on(o, n)), ()=>{
            Object.entries(r).forEach(([o, n])=>t.removeListener(o, n));
        }), [
        ...Object.keys(r),
        ...e
    ]), Oe(t.emit.bind(t), [
        t
    ]);
}
s(ds, "useChannel");
function We() {
    let { currentContext: r } = Cr();
    if (r == null) throw Ar();
    return r;
}
s(We, "useStoryContext");
function ps(r, e) {
    let { parameters: t } = We();
    if (r) return t[r] ?? e;
}
s(ps, "useParameter");
function us() {
    let r = V.getChannel(), { id: e, args: t } = We(), o = Oe((i)=>r.emit((0, _coreEvents.UPDATE_STORY_ARGS), {
            storyId: e,
            updatedArgs: i
        }), [
        r,
        e
    ]), n = Oe((i)=>r.emit((0, _coreEvents.RESET_STORY_ARGS), {
            storyId: e,
            argNames: i
        }), [
        r,
        e
    ]);
    return [
        t,
        o,
        n
    ];
}
s(us, "useArgs");
function fs() {
    let r = V.getChannel(), { globals: e } = We(), t = Oe((o)=>r.emit((0, _coreEvents.UPDATE_GLOBALS), {
            globals: o
        }), [
        r
    ]);
    return [
        e,
        t
    ];
}
s(fs, "useGlobals");
// src/preview-api/modules/addons/make-decorator.ts
var ys = /* @__PURE__ */ s(({ name: r, parameterName: e, wrapper: t, skipIfNoParametersOrOptions: o = !1 })=>{
    let n = /* @__PURE__ */ s((i)=>(a, l)=>{
            let c = l.parameters && l.parameters[e];
            return c && c.disable || o && !i && !c ? a(l) : t(a, l, {
                options: i,
                parameters: c
            });
        }, "decorator");
    return (...i)=>typeof i[0] == "function" ? n()(...i) : (...a)=>{
            if (a.length > 1) return i.length > 1 ? n(i)(...a) : n(...i)(...a);
            throw new Error(`Passing stories directly into ${r}() is not allowed,
        instead use addDecorator(${r}) and pass options with the '${e}' parameter`);
        };
}, "makeDecorator");
// ../node_modules/ts-dedent/esm/index.js
function P(r) {
    for(var e = [], t = 1; t < arguments.length; t++)e[t - 1] = arguments[t];
    var o = Array.from(typeof r == "string" ? [
        r
    ] : r);
    o[o.length - 1] = o[o.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var n = o.reduce(function(l, c) {
        var d = c.match(/\n([\t ]+|(?!\s).)/g);
        return d ? l.concat(d.map(function(p) {
            var u, y;
            return (y = (u = p.match(/[\t ]/g)) === null || u === void 0 ? void 0 : u.length) !== null && y !== void 0 ? y : 0;
        })) : l;
    }, []);
    if (n.length) {
        var i = new RegExp(`
[	 ]{` + Math.min.apply(Math, n) + "}", "g");
        o = o.map(function(l) {
            return l.replace(i, `
`);
        });
    }
    o[0] = o[0].replace(/^\r?\n/, "");
    var a = o[0];
    return e.forEach(function(l, c) {
        var d = a.match(/(?:^|\n)( *)$/), p = d ? d[1] : "", u = l;
        typeof l == "string" && l.includes(`
`) && (u = String(l).split(`
`).map(function(y, m) {
            return m === 0 ? y : "" + p + y;
        }).join(`
`)), a += u + o[c + 1];
    }), a;
}
s(P, "dedent");
var Lt = P;
// src/shared/universal-store/instances.ts
var Fr = /* @__PURE__ */ new Map();
// src/shared/universal-store/index.ts
var hs = "UNIVERSAL_STORE:", q = {
    PENDING: "PENDING",
    RESOLVED: "RESOLVED",
    REJECTED: "REJECTED"
}, T = class T {
    constructor(e, t){
        /** Enable debug logs for this store */ this.debugging = !1;
        // TODO: narrow type of listeners based on event type
        this.listeners = /* @__PURE__ */ new Map([
            [
                "*",
                /* @__PURE__ */ new Set()
            ]
        ]);
        /** Gets the current state */ this.getState = /* @__PURE__ */ s(()=>(this.debug("getState", {
                state: this.state
            }), this.state), "getState");
        /**
     * Subscribes to store events
     *
     * @returns A function to unsubscribe
     */ this.subscribe = /* @__PURE__ */ s((e, t)=>{
            let o = typeof e == "function", n = o ? "*" : e, i = o ? e : t;
            if (this.debug("subscribe", {
                eventType: n,
                listener: i
            }), !i) throw new TypeError(`Missing first subscribe argument, or second if first is the event type, when subscribing to a UniversalStore with id '${this.id}'`);
            return this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(i), ()=>{
                this.debug("unsubscribe", {
                    eventType: n,
                    listener: i
                }), this.listeners.has(n) && (this.listeners.get(n).delete(i), this.listeners.get(n)?.size === 0 && this.listeners.delete(n));
            };
        }, "subscribe");
        /** Sends a custom event to the other stores */ this.send = /* @__PURE__ */ s((e)=>{
            if (this.debug("send", {
                event: e
            }), this.status !== T.Status.READY) throw new TypeError(P`Cannot send event before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify({
                event: e,
                id: this.id,
                actor: this.actor,
                environment: this.environment
            }, null, 2)}`);
            this.emitToListeners(e, {
                actor: this.actor
            }), this.emitToChannel(e, {
                actor: this.actor
            });
        }, "send");
        if (this.debugging = e.debug ?? !1, !T.isInternalConstructing) throw new TypeError("UniversalStore is not constructable - use UniversalStore.create() instead");
        if (T.isInternalConstructing = !1, this.id = e.id, this.actorId = Date.now().toString(36) + Math.random().toString(36).substring(2), this.actorType = e.leader ? T.ActorType.LEADER : T.ActorType.FOLLOWER, this.state = e.initialState, this.channelEventName = `${hs}${this.id}`, this.debug("constructor", {
            options: e,
            environmentOverrides: t,
            channelEventName: this.channelEventName
        }), this.actor.type === T.ActorType.LEADER) this.syncing = {
            state: q.RESOLVED,
            promise: Promise.resolve()
        };
        else {
            let o, n, i = new Promise((a, l)=>{
                o = /* @__PURE__ */ s(()=>{
                    this.syncing.state === q.PENDING && (this.syncing.state = q.RESOLVED, a());
                }, "syncingResolve"), n = /* @__PURE__ */ s((c)=>{
                    this.syncing.state === q.PENDING && (this.syncing.state = q.REJECTED, l(c));
                }, "syncingReject");
            });
            this.syncing = {
                state: q.PENDING,
                promise: i,
                resolve: o,
                reject: n
            };
        }
        this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.subscribe = this.subscribe.bind(this), this.onStateChange = this.onStateChange.bind(this), this.send = this.send.bind(this), this.emitToChannel = this.emitToChannel.bind(this), this.prepareThis = this.prepareThis.bind(this), this.emitToListeners = this.emitToListeners.bind(this), this.handleChannelEvents = this.handleChannelEvents.bind(this), this.debug = this.debug.bind(this), this.channel = t?.channel ?? T.preparation.channel, this.environment = t?.environment ?? T.preparation.environment, this.channel && this.environment ? this.prepareThis({
            channel: this.channel,
            environment: this.environment
        }) : T.preparation.promise.then(this.prepareThis);
    }
    static setupPreparationPromise() {
        let e, t, o = new Promise((n, i)=>{
            e = /* @__PURE__ */ s((a)=>{
                n(a);
            }, "resolveRef"), t = /* @__PURE__ */ s((...a)=>{
                i(a);
            }, "rejectRef");
        });
        T.preparation = {
            resolve: e,
            reject: t,
            promise: o
        };
    }
    /** The actor object representing the store instance with a unique ID and a type */ get actor() {
        return Object.freeze({
            id: this.actorId,
            type: this.actorType,
            environment: this.environment ?? T.Environment.UNKNOWN
        });
    }
    /**
   * The current state of the store, that signals both if the store is prepared by Storybook and
   * also - in the case of a follower - if the state has been synced with the leader's state.
   */ get status() {
        if (!this.channel || !this.environment) return T.Status.UNPREPARED;
        switch(this.syncing?.state){
            case q.PENDING:
            case void 0:
                return T.Status.SYNCING;
            case q.REJECTED:
                return T.Status.ERROR;
            case q.RESOLVED:
            default:
                return T.Status.READY;
        }
    }
    /**
   * A promise that resolves when the store is fully ready. A leader will be ready when the store
   * has been prepared by Storybook, which is almost instantly.
   *
   * A follower will be ready when the state has been synced with the leader's state, within a few
   * hundred milliseconds.
   */ untilReady() {
        return Promise.all([
            T.preparation.promise,
            this.syncing?.promise
        ]);
    }
    /** Creates a new instance of UniversalStore */ static create(e) {
        if (!e || typeof e?.id != "string") throw new TypeError("id is required and must be a string, when creating a UniversalStore");
        e.debug && console.debug(P`[UniversalStore]
        create`, {
            options: e
        });
        let t = Fr.get(e.id);
        if (t) return console.warn(P`UniversalStore with id "${e.id}" already exists in this environment, re-using existing.
        You should reuse the existing instance instead of trying to create a new one.`), t;
        T.isInternalConstructing = !0;
        let o = new T(e);
        return Fr.set(e.id, o), o;
    }
    /**
   * Used by Storybook to set the channel for all instances of UniversalStore in the given
   * environment.
   *
   * @internal
   */ static __prepare(e, t) {
        T.preparation.channel = e, T.preparation.environment = t, T.preparation.resolve({
            channel: e,
            environment: t
        });
    }
    /**
   * Updates the store's state
   *
   * Either a new state or a state updater function can be passed to the method.
   */ setState(e) {
        let t = this.state, o = typeof e == "function" ? e(t) : e;
        if (this.debug("setState", {
            newState: o,
            previousState: t,
            updater: e
        }), this.status !== T.Status.READY) throw new TypeError(P`Cannot set state before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify({
            newState: o,
            id: this.id,
            actor: this.actor,
            environment: this.environment
        }, null, 2)}`);
        this.state = o;
        let n = {
            type: T.InternalEventType.SET_STATE,
            payload: {
                state: o,
                previousState: t
            }
        };
        this.emitToChannel(n, {
            actor: this.actor
        }), this.emitToListeners(n, {
            actor: this.actor
        });
    }
    /**
   * Subscribes to state changes
   *
   * @returns Unsubscribe function
   */ onStateChange(e) {
        return this.debug("onStateChange", {
            listener: e
        }), this.subscribe(T.InternalEventType.SET_STATE, ({ payload: t }, o)=>{
            e(t.state, t.previousState, o);
        });
    }
    emitToChannel(e, t) {
        this.debug("emitToChannel", {
            event: e,
            eventInfo: t,
            channel: this.channel
        }), this.channel?.emit(this.channelEventName, {
            event: e,
            eventInfo: t
        });
    }
    prepareThis({ channel: e, environment: t }) {
        this.channel = e, this.environment = t, this.debug("prepared", {
            channel: e,
            environment: t
        }), this.channel.on(this.channelEventName, this.handleChannelEvents), this.actor.type === T.ActorType.LEADER ? this.emitToChannel({
            type: T.InternalEventType.LEADER_CREATED
        }, {
            actor: this.actor
        }) : (this.emitToChannel({
            type: T.InternalEventType.FOLLOWER_CREATED
        }, {
            actor: this.actor
        }), this.emitToChannel({
            type: T.InternalEventType.EXISTING_STATE_REQUEST
        }, {
            actor: this.actor
        }), setTimeout(()=>{
            this.syncing.reject(new TypeError(`No existing state found for follower with id: '${this.id}'. Make sure a leader with the same id exists before creating a follower\
.`));
        }, 1e3));
    }
    emitToListeners(e, t) {
        let o = this.listeners.get(e.type), n = this.listeners.get("*");
        this.debug("emitToListeners", {
            event: e,
            eventInfo: t,
            eventTypeListeners: o,
            everythingListeners: n
        }), [
            ...o ?? [],
            ...n ?? []
        ].forEach((i)=>i(e, t));
    }
    handleChannelEvents(e) {
        let { event: t, eventInfo: o } = e;
        if ([
            o.actor.id,
            o.forwardingActor?.id
        ].includes(this.actor.id)) {
            this.debug("handleChannelEvents: Ignoring event from self", {
                channelEvent: e
            });
            return;
        } else if (this.syncing?.state === q.PENDING && t.type !== T.InternalEventType.EXISTING_STATE_RESPONSE) {
            this.debug("handleChannelEvents: Ignoring event while syncing", {
                channelEvent: e
            });
            return;
        }
        if (this.debug("handleChannelEvents", {
            channelEvent: e
        }), this.actor.type === T.ActorType.LEADER) {
            let n = !0;
            switch(t.type){
                case T.InternalEventType.EXISTING_STATE_REQUEST:
                    n = !1;
                    let i = {
                        type: T.InternalEventType.EXISTING_STATE_RESPONSE,
                        payload: this.state
                    };
                    this.debug("handleChannelEvents: responding to existing state request", {
                        responseEvent: i
                    }), this.emitToChannel(i, {
                        actor: this.actor
                    });
                    break;
                case T.InternalEventType.LEADER_CREATED:
                    n = !1, this.syncing.state = q.REJECTED, this.debug("handleChannelEvents: erroring due to second leader being created", {
                        event: t
                    }), console.error(P`Detected multiple UniversalStore leaders created with the same id "${this.id}".
            Only one leader can exists at a time, your stores are now in an invalid state.
            Leaders detected:
            this: ${JSON.stringify(this.actor, null, 2)}
            other: ${JSON.stringify(o.actor, null, 2)}`);
                    break;
            }
            n && (this.debug("handleChannelEvents: forwarding event", {
                channelEvent: e
            }), this.emitToChannel(t, {
                actor: o.actor,
                forwardingActor: this.actor
            }));
        }
        if (this.actor.type === T.ActorType.FOLLOWER) switch(t.type){
            case T.InternalEventType.EXISTING_STATE_RESPONSE:
                if (this.debug("handleChannelEvents: Setting state from leader's existing state response", {
                    event: t
                }), this.syncing?.state !== q.PENDING) break;
                this.syncing.resolve?.();
                let n = {
                    type: T.InternalEventType.SET_STATE,
                    payload: {
                        state: t.payload,
                        previousState: this.state
                    }
                };
                this.state = t.payload, this.emitToListeners(n, o);
                break;
        }
        switch(t.type){
            case T.InternalEventType.SET_STATE:
                this.debug("handleChannelEvents: Setting state", {
                    event: t
                }), this.state = t.payload.state;
                break;
        }
        this.emitToListeners(t, {
            actor: o.actor
        });
    }
    debug(e, t) {
        this.debugging && console.debug(P`[UniversalStore::${this.id}::${this.environment ?? T.Environment.UNKNOWN}]
        ${e}`, JSON.stringify({
            data: t,
            actor: this.actor,
            state: this.state,
            status: this.status
        }, null, 2));
    }
    /**
   * Used to reset the static fields of the UniversalStore class when cleaning up tests
   *
   * @internal
   */ static __reset() {
        T.preparation.reject(new Error("reset")), T.setupPreparationPromise(), T.isInternalConstructing = !1;
    }
};
s(T, "UniversalStore"), /**
 * Defines the possible actor types in the store system
 *
 * @readonly
 */ T.ActorType = {
    LEADER: "LEADER",
    FOLLOWER: "FOLLOWER"
}, /**
 * Defines the possible environments the store can run in
 *
 * @readonly
 */ T.Environment = {
    SERVER: "SERVER",
    MANAGER: "MANAGER",
    PREVIEW: "PREVIEW",
    UNKNOWN: "UNKNOWN",
    MOCK: "MOCK"
}, /**
 * Internal event types used for store synchronization
 *
 * @readonly
 */ T.InternalEventType = {
    EXISTING_STATE_REQUEST: "__EXISTING_STATE_REQUEST",
    EXISTING_STATE_RESPONSE: "__EXISTING_STATE_RESPONSE",
    SET_STATE: "__SET_STATE",
    LEADER_CREATED: "__LEADER_CREATED",
    FOLLOWER_CREATED: "__FOLLOWER_CREATED"
}, T.Status = {
    UNPREPARED: "UNPREPARED",
    SYNCING: "SYNCING",
    READY: "READY",
    ERROR: "ERROR"
}, T.isInternalConstructing = !1, T.setupPreparationPromise();
var J = T;
// ../node_modules/es-toolkit/dist/object/omitBy.mjs
function Ir(r, e) {
    let t = {}, o = Object.entries(r);
    for(let n = 0; n < o.length; n++){
        let [i, a] = o[n];
        e(a, i) || (t[i] = a);
    }
    return t;
}
s(Ir, "omitBy");
// ../node_modules/es-toolkit/dist/object/pick.mjs
function Or(r, e) {
    let t = {};
    for(let o = 0; o < e.length; o++){
        let n = e[o];
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
}
s(Or, "pick");
// ../node_modules/es-toolkit/dist/object/pickBy.mjs
function Dr(r, e) {
    let t = {}, o = Object.entries(r);
    for(let n = 0; n < o.length; n++){
        let [i, a] = o[n];
        e(a, i) && (t[i] = a);
    }
    return t;
}
s(Dr, "pickBy");
// ../node_modules/es-toolkit/dist/predicate/isPlainObject.mjs
function L(r) {
    if (typeof r != "object" || r == null) return !1;
    if (Object.getPrototypeOf(r) === null) return !0;
    if (r.toString() !== "[object Object]") return !1;
    let e = r;
    for(; Object.getPrototypeOf(e) !== null;)e = Object.getPrototypeOf(e);
    return Object.getPrototypeOf(r) === e;
}
s(L, "isPlainObject");
// ../node_modules/es-toolkit/dist/object/mapValues.mjs
function G(r, e) {
    let t = {}, o = Object.keys(r);
    for(let n = 0; n < o.length; n++){
        let i = o[n], a = r[i];
        t[i] = e(a, i, r);
    }
    return t;
}
s(G, "mapValues");
// ../node_modules/es-toolkit/dist/compat/_internal/tags.mjs
var Nt = "[object RegExp]", Mt = "[object String]", _t = "[object Number]", qt = "[object Boolean]", kr = "[object Arguments]", Ut = "[objec\
t Symbol]", Gt = "[object Date]", Bt = "[object Map]", zt = "[object Set]", Vt = "[object Array]", Ht = "[object Function]", Wt = "[object A\
rrayBuffer]", $e = "[object Object]", $t = "[object Error]", Yt = "[object DataView]", Kt = "[object Uint8Array]", Xt = "[object Uint8Clampe\
dArray]", Jt = "[object Uint16Array]", Qt = "[object Uint32Array]", Zt = "[object BigUint64Array]", eo = "[object Int8Array]", ro = "[object\
 Int16Array]", to = "[object Int32Array]", oo = "[object BigInt64Array]", no = "[object Float32Array]", so = "[object Float64Array]";
// ../node_modules/es-toolkit/dist/compat/_internal/getSymbols.mjs
function jr(r) {
    return Object.getOwnPropertySymbols(r).filter((e)=>Object.prototype.propertyIsEnumerable.call(r, e));
}
s(jr, "getSymbols");
// ../node_modules/es-toolkit/dist/compat/_internal/getTag.mjs
function Lr(r) {
    return r == null ? r === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(r);
}
s(Lr, "getTag");
// ../node_modules/es-toolkit/dist/predicate/isEqual.mjs
function De(r, e) {
    if (typeof r == typeof e) switch(typeof r){
        case "bigint":
        case "string":
        case "boolean":
        case "symbol":
        case "undefined":
            return r === e;
        case "number":
            return r === e || Object.is(r, e);
        case "function":
            return r === e;
        case "object":
            return Y(r, e);
    }
    return Y(r, e);
}
s(De, "isEqual");
function Y(r, e, t) {
    if (Object.is(r, e)) return !0;
    let o = Lr(r), n = Lr(e);
    if (o === kr && (o = $e), n === kr && (n = $e), o !== n) return !1;
    switch(o){
        case Mt:
            return r.toString() === e.toString();
        case _t:
            {
                let l = r.valueOf(), c = e.valueOf();
                return l === c || Number.isNaN(l) && Number.isNaN(c);
            }
        case qt:
        case Gt:
        case Ut:
            return Object.is(r.valueOf(), e.valueOf());
        case Nt:
            return r.source === e.source && r.flags === e.flags;
        case Ht:
            return r === e;
    }
    t = t ?? /* @__PURE__ */ new Map();
    let i = t.get(r), a = t.get(e);
    if (i != null && a != null) return i === e;
    t.set(r, e), t.set(e, r);
    try {
        switch(o){
            case Bt:
                if (r.size !== e.size) return !1;
                for (let [l, c] of r.entries())if (!e.has(l) || !Y(c, e.get(l), t)) return !1;
                return !0;
            case zt:
                {
                    if (r.size !== e.size) return !1;
                    let l = Array.from(r.values()), c = Array.from(e.values());
                    for(let d = 0; d < l.length; d++){
                        let p = l[d], u = c.findIndex((y)=>Y(p, y, t));
                        if (u === -1) return !1;
                        c.splice(u, 1);
                    }
                    return !0;
                }
            case Vt:
            case Kt:
            case Xt:
            case Jt:
            case Qt:
            case Zt:
            case eo:
            case ro:
            case to:
            case oo:
            case no:
            case so:
                if (typeof Buffer < "u" && Buffer.isBuffer(r) !== Buffer.isBuffer(e) || r.length !== e.length) return !1;
                for(let l = 0; l < r.length; l++)if (!Y(r[l], e[l], t)) return !1;
                return !0;
            case Wt:
                return r.byteLength !== e.byteLength ? !1 : Y(new Uint8Array(r), new Uint8Array(e), t);
            case Yt:
                return r.byteLength !== e.byteLength || r.byteOffset !== e.byteOffset ? !1 : Y(r.buffer, e.buffer, t);
            case $t:
                return r.name === e.name && r.message === e.message;
            case $e:
                {
                    if (!(Y(r.constructor, e.constructor, t) || L(r) && L(e))) return !1;
                    let c = [
                        ...Object.keys(r),
                        ...jr(r)
                    ], d = [
                        ...Object.keys(e),
                        ...jr(e)
                    ];
                    if (c.length !== d.length) return !1;
                    for(let p = 0; p < c.length; p++){
                        let u = c[p], y = r[u];
                        if (!Object.prototype.hasOwnProperty.call(e, u)) return !1;
                        let m = e[u];
                        if (!Y(y, m, t)) return !1;
                    }
                    return !0;
                }
            default:
                return !1;
        }
    } finally{
        t.delete(r), t.delete(e);
    }
}
s(Y, "areObjectsEqual");
// src/shared/universal-store/use-universal-store-preview.ts
var Ss = /* @__PURE__ */ s((r, e)=>{
    let [t, o] = (0, _previewApi.useState)(e ? e(r.getState()) : r.getState());
    return (0, _previewApi.useEffect)(()=>r.onStateChange((n, i)=>{
            if (!e) {
                o(n);
                return;
            }
            let a = e(n), l = e(i);
            !De(a, l) && o(a);
        }), [
        r,
        o,
        e
    ]), [
        t,
        r.setState
    ];
}, "useUniversalStore");
var Ye = class Ye extends J {
    constructor(e, t){
        J.isInternalConstructing = !0, super({
            ...e,
            leader: !0
        }, {
            channel: new (0, _channels.Channel)({}),
            environment: J.Environment.MOCK
        }), J.isInternalConstructing = !1, typeof t?.fn == "function" && (this.testUtils = t, this.getState = t.fn(this.getState), this.setState = t.fn(this.setState), this.subscribe = t.fn(this.subscribe), this.onStateChange = t.fn(this.onStateChange), this.send = t.fn(this.send));
    }
    /** Create a mock universal store. This is just an alias for the constructor */ static create(e, t) {
        return new Ye(e, t);
    }
    unsubscribeAll() {
        if (!this.testUtils) throw new Error(Lt`Cannot call unsubscribeAll on a store that does not have testUtils.
        Please provide testUtils as the second argument when creating the store.`);
        let e = /* @__PURE__ */ s((t)=>{
            try {
                t.value();
            } catch  {}
        }, "callReturnedUnsubscribeFn");
        this.subscribe.mock?.results.forEach(e), this.onStateChange.mock?.results.forEach(e);
    }
};
s(Ye, "MockUniversalStore");
var Nr = Ye;
var tr = he(_r(), 1);
var me = Symbol("incompatible"), Ur = /* @__PURE__ */ s((r, e)=>{
    let t = e.type;
    if (r == null || !t || e.mapping) return r;
    switch(t.name){
        case "string":
            return String(r);
        case "enum":
            return r;
        case "number":
            return Number(r);
        case "boolean":
            return String(r) === "true";
        case "array":
            return !t.value || !Array.isArray(r) ? me : r.reduce((o, n, i)=>{
                let a = Ur(n, {
                    type: t.value
                });
                return a !== me && (o[i] = a), o;
            }, new Array(r.length));
        case "object":
            return typeof r == "string" || typeof r == "number" ? r : !t.value || typeof r != "object" ? me : Object.entries(r).reduce((o, [n, i])=>{
                let a = Ur(i, {
                    type: t.value[n]
                });
                return a === me ? o : Object.assign(o, {
                    [n]: a
                });
            }, {});
        default:
            return me;
    }
}, "map"), ao = /* @__PURE__ */ s((r, e)=>Object.entries(r).reduce((t, [o, n])=>{
        if (!e[o]) return t;
        let i = Ur(n, e[o]);
        return i === me ? t : Object.assign(t, {
            [o]: i
        });
    }, {}), "mapArgsToTypes"), ke = /* @__PURE__ */ s((r, e)=>Array.isArray(r) && Array.isArray(e) ? e.reduce((t, o, n)=>(t[n] = ke(r[n], e[n]), t), [
        ...r
    ]).filter((t)=>t !== void 0) : !L(r) || !L(e) ? e : Object.keys({
        ...r,
        ...e
    }).reduce((t, o)=>{
        if (o in e) {
            let n = ke(r[o], e[o]);
            n !== void 0 && (t[o] = n);
        } else t[o] = r[o];
        return t;
    }, {}), "combineArgs"), lo = /* @__PURE__ */ s((r, e)=>Object.entries(e).reduce((t, [o, { options: n }])=>{
        function i() {
            return o in r && (t[o] = r[o]), t;
        }
        if (s(i, "allowArg"), !n) return i();
        if (!Array.isArray(n)) return (0, _clientLogger.once).error(P`
        Invalid argType: '${o}.options' should be an array.

        More info: https://storybook.js.org/docs/api/arg-types
      `), i();
        if (n.some((u)=>u && [
                "object",
                "function"
            ].includes(typeof u))) return (0, _clientLogger.once).error(P`
        Invalid argType: '${o}.options' should only contain primitives. Use a 'mapping' for complex values.

        More info: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
      `), i();
        let a = Array.isArray(r[o]), l = a && r[o].findIndex((u)=>!n.includes(u)), c = a && l === -1;
        if (r[o] === void 0 || n.includes(r[o]) || c) return i();
        let d = a ? `${o}[${l}]` : o, p = n.map((u)=>typeof u == "string" ? `'${u}'` : String(u)).join(", ");
        return (0, _clientLogger.once).warn(`Received illegal value for '${d}'. Supported options: ${p}`), t;
    }, {}), "validateOptions"), ie = Symbol("Deeply equal"), ge = /* @__PURE__ */ s((r, e)=>{
    if (typeof r != typeof e) return e;
    if (De(r, e)) return ie;
    if (Array.isArray(r) && Array.isArray(e)) {
        let t = e.reduce((o, n, i)=>{
            let a = ge(r[i], n);
            return a !== ie && (o[i] = a), o;
        }, new Array(e.length));
        return e.length >= r.length ? t : t.concat(new Array(r.length - e.length).fill(void 0));
    }
    return L(r) && L(e) ? Object.keys({
        ...r,
        ...e
    }).reduce((t, o)=>{
        let n = ge(r?.[o], e?.[o]);
        return n === ie ? t : Object.assign(t, {
            [o]: n
        });
    }, {}) : e;
}, "deepDiff"), Gr = "UNTARGETED";
function co({ args: r, argTypes: e }) {
    let t = {};
    return Object.entries(r).forEach(([o, n])=>{
        let { target: i = Gr } = e[o] || {};
        t[i] = t[i] || {}, t[i][o] = n;
    }), t;
}
s(co, "groupArgsByTarget");
// src/preview-api/modules/store/ArgsStore.ts
function Ts(r) {
    return Object.keys(r).forEach((e)=>r[e] === void 0 && delete r[e]), r;
}
s(Ts, "deleteUndefined");
var Br = class Br {
    constructor(){
        this.initialArgsByStoryId = {};
        this.argsByStoryId = {};
    }
    get(e) {
        if (!(e in this.argsByStoryId)) throw new Error(`No args known for ${e} -- has it been rendered yet?`);
        return this.argsByStoryId[e];
    }
    setInitial(e) {
        if (!this.initialArgsByStoryId[e.id]) this.initialArgsByStoryId[e.id] = e.initialArgs, this.argsByStoryId[e.id] = e.initialArgs;
        else if (this.initialArgsByStoryId[e.id] !== e.initialArgs) {
            let t = ge(this.initialArgsByStoryId[e.id], this.argsByStoryId[e.id]);
            this.initialArgsByStoryId[e.id] = e.initialArgs, this.argsByStoryId[e.id] = e.initialArgs, t !== ie && this.updateFromDelta(e, t);
        }
    }
    updateFromDelta(e, t) {
        let o = lo(t, e.argTypes);
        this.argsByStoryId[e.id] = ke(this.argsByStoryId[e.id], o);
    }
    updateFromPersisted(e, t) {
        let o = ao(t, e.argTypes);
        return this.updateFromDelta(e, o);
    }
    update(e, t) {
        if (!(e in this.argsByStoryId)) throw new Error(`No args known for ${e} -- has it been rendered yet?`);
        this.argsByStoryId[e] = Ts({
            ...this.argsByStoryId[e],
            ...t
        });
    }
};
s(Br, "ArgsStore");
var Ke = Br;
// src/preview-api/modules/store/csf/getValuesFromArgTypes.ts
var Xe = /* @__PURE__ */ s((r = {})=>Object.entries(r).reduce((e, [t, { defaultValue: o }])=>(typeof o < "u" && (e[t] = o), e), {}), "ge\
tValuesFromArgTypes");
// src/preview-api/modules/store/GlobalsStore.ts
var zr = class zr {
    constructor({ globals: e = {}, globalTypes: t = {} }){
        this.set({
            globals: e,
            globalTypes: t
        });
    }
    set({ globals: e = {}, globalTypes: t = {} }) {
        let o = this.initialGlobals && ge(this.initialGlobals, this.globals);
        this.allowedGlobalNames = /* @__PURE__ */ new Set([
            ...Object.keys(e),
            ...Object.keys(t)
        ]);
        let n = Xe(t);
        this.initialGlobals = {
            ...n,
            ...e
        }, this.globals = this.initialGlobals, o && o !== ie && this.updateFromPersisted(o);
    }
    filterAllowedGlobals(e) {
        return Object.entries(e).reduce((t, [o, n])=>(this.allowedGlobalNames.has(o) ? t[o] = n : (0, _clientLogger.logger).warn(`Attempted to set a global (${o}) that is not defined in initial globals or globalTypes`), t), {});
    }
    updateFromPersisted(e) {
        let t = this.filterAllowedGlobals(e);
        this.globals = {
            ...this.globals,
            ...t
        };
    }
    get() {
        return this.globals;
    }
    update(e) {
        this.globals = {
            ...this.globals,
            ...this.filterAllowedGlobals(e)
        };
    }
};
s(zr, "GlobalsStore");
var Je = zr;
// src/preview-api/modules/store/StoryIndexStore.ts
var po = he(_r(), 1);
var xs = (0, po.default)(1)((r)=>Object.values(r).reduce((e, t)=>(e[t.importPath] = e[t.importPath] || t, e), {})), Vr = class Vr {
    constructor({ entries: e } = {
        v: 5,
        entries: {}
    }){
        this.entries = e;
    }
    entryFromSpecifier(e) {
        let t = Object.values(this.entries);
        if (e === "*") return t[0];
        if (typeof e == "string") return this.entries[e] ? this.entries[e] : t.find((i)=>i.id.startsWith(e));
        let { name: o, title: n } = e;
        return t.find((i)=>i.name === o && i.title === n);
    }
    storyIdToEntry(e) {
        let t = this.entries[e];
        if (!t) throw new (0, _previewErrors.MissingStoryAfterHmrError)({
            storyId: e
        });
        return t;
    }
    importPathToEntry(e) {
        return xs(this.entries)[e];
    }
};
s(Vr, "StoryIndexStore");
var Qe = Vr;
// src/preview-api/modules/store/csf/normalizeInputTypes.ts
var ws = /* @__PURE__ */ s((r)=>typeof r == "string" ? {
        name: r
    } : r, "normalizeType"), vs = /* @__PURE__ */ s((r)=>typeof r == "strin\
g" ? {
        type: r
    } : r, "normalizeControl"), As = /* @__PURE__ */ s((r, e)=>{
    let { type: t, control: o, ...n } = r, i = {
        name: e,
        ...n
    };
    return t && (i.type = ws(t)), o ? i.control = vs(o) : o === !1 && (i.control = {
        disable: !0
    }), i;
}, "normalizeInputType"), ae = /* @__PURE__ */ s((r)=>G(r, As), "normalizeInputTypes");
// src/preview-api/modules/store/csf/normalizeArrays.ts
var F = /* @__PURE__ */ s((r)=>Array.isArray(r) ? r : r ? [
        r
    ] : [], "normalizeArrays");
// src/preview-api/modules/store/csf/normalizeStory.ts
var Os = P`
CSF .story annotations deprecated; annotate story functions directly:
- StoryFn.story.name => StoryFn.storyName
- StoryFn.story.(parameters|decorators) => StoryFn.(parameters|decorators)
See https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#hoisted-csf-annotations for details and codemod.
`;
function Se(r, e, t) {
    let o = e, n = typeof e == "function" ? e : null, { story: i } = o;
    i && ((0, _clientLogger.logger).debug("deprecated story", i), (0, _clientLogger.deprecate)(Os));
    let a = (0, _csf.storyNameFromExport)(r), l = typeof o != "function" && o.name || o.storyName || i?.name || a, c = [
        ...F(o.decorators),
        ...F(i?.decorators)
    ], d = {
        ...i?.parameters,
        ...o.parameters
    }, p = {
        ...i?.args,
        ...o.args
    }, u = {
        ...i?.argTypes,
        ...o.argTypes
    }, y = [
        ...F(o.loaders),
        ...F(i?.loaders)
    ], m = [
        ...F(o.beforeEach),
        ...F(i?.beforeEach)
    ], g = [
        ...F(o.experimental_afterEach),
        ...F(i?.experimental_afterEach)
    ], { render: S, play: h, tags: E = [], globals: R = {} } = o, f = d.__id || (0, _csf.toId)(t.id, a);
    return {
        moduleExport: e,
        id: f,
        name: l,
        tags: E,
        decorators: c,
        parameters: d,
        args: p,
        argTypes: ae(u),
        loaders: y,
        beforeEach: m,
        experimental_afterEach: g,
        globals: R,
        ...S && {
            render: S
        },
        ...n && {
            userStoryFn: n
        },
        ...h && {
            play: h
        }
    };
}
s(Se, "normalizeStory");
function je(r, e = r.title, t) {
    let { id: o, argTypes: n } = r;
    return {
        id: (0, _csf.sanitize)(o || e),
        ...r,
        title: e,
        ...n && {
            argTypes: ae(n)
        },
        parameters: {
            fileName: t,
            ...r.parameters
        }
    };
}
s(je, "normalizeComponentAnnotations");
// src/preview-api/modules/store/csf/processCSFFile.ts
var js = /* @__PURE__ */ s((r)=>{
    let { globals: e, globalTypes: t } = r;
    (e || t) && (0, _clientLogger.logger).error("Global args/argTypes can only be set globally", JSON.stringify({
        globals: e,
        globalTypes: t
    }));
}, "checkGlobals"), Ls = /* @__PURE__ */ s((r)=>{
    let { options: e } = r;
    e?.storySort && (0, _clientLogger.logger).error("The storySort option parameter can only be set globally");
}, "checkStorySort"), Ze = /* @__PURE__ */ s((r)=>{
    r && (js(r), Ls(r));
}, "checkDisallowedParameters");
function yo(r, e, t) {
    let { default: o, __namedExportsOrder: n, ...i } = r, a = Object.values(i)[0];
    if ((0, _csf.isStory)(a)) {
        let d = je(a.meta.input, t, e);
        Ze(d.parameters);
        let p = {
            meta: d,
            stories: {},
            moduleExports: r
        };
        return Object.keys(i).forEach((u)=>{
            if ((0, _csf.isExportStory)(u, d)) {
                let y = Se(u, i[u].input, d);
                Ze(y.parameters), p.stories[y.id] = y;
            }
        }), p.projectAnnotations = a.meta.preview.composed, p;
    }
    let l = je(o, t, e);
    Ze(l.parameters);
    let c = {
        meta: l,
        stories: {},
        moduleExports: r
    };
    return Object.keys(i).forEach((d)=>{
        if ((0, _csf.isExportStory)(d, l)) {
            let p = Se(d, i[d], l);
            Ze(p.parameters), c.stories[p.id] = p;
        }
    }), c;
}
s(yo, "processCSFFile");
// src/preview-api/modules/preview-web/render/mount-utils.ts
function mo(r) {
    return r != null && Ns(r).includes("mount");
}
s(mo, "mountDestructured");
function Ns(r) {
    let e = r.toString().match(/[^(]*\(([^)]*)/);
    if (!e) return [];
    let t = ho(e[1]);
    if (!t.length) return [];
    let o = t[0];
    return o.startsWith("{") && o.endsWith("}") ? ho(o.slice(1, -1).replace(/\s/g, "")).map((i)=>i.replace(/:.*|=.*/g, "")) : [];
}
s(Ns, "getUsedProps");
function ho(r) {
    let e = [], t = [], o = 0;
    for(let i = 0; i < r.length; i++)if (r[i] === "{" || r[i] === "[") t.push(r[i] === "{" ? "}" : "]");
    else if (r[i] === t[t.length - 1]) t.pop();
    else if (!t.length && r[i] === ",") {
        let a = r.substring(o, i).trim();
        a && e.push(a), o = i + 1;
    }
    let n = r.substring(o).trim();
    return n && e.push(n), e;
}
s(ho, "splitByComma");
// src/preview-api/modules/store/decorators.ts
function go(r, e, t) {
    let o = t(r);
    return (n)=>e(o, n);
}
s(go, "decorateStory");
function So({ componentId: r, title: e, kind: t, id: o, name: n, story: i, parameters: a, initialArgs: l, argTypes: c, ...d } = {}) {
    return d;
}
s(So, "sanitizeStoryContextUpdate");
function Hr(r, e) {
    let t = {}, o = /* @__PURE__ */ s((i)=>(a)=>{
            if (!t.value) throw new Error("Decorated function called without init");
            return t.value = {
                ...t.value,
                ...So(a)
            }, i(t.value);
        }, "bindWithContext"), n = e.reduce((i, a)=>go(i, a, o), r);
    return (i)=>(t.value = i, n(i));
}
s(Hr, "defaultDecorateStory");
// src/preview-api/modules/store/parameters.ts
var M = /* @__PURE__ */ s((...r)=>{
    let e = {}, t = r.filter(Boolean), o = t.reduce((n, i)=>(Object.entries(i).forEach(([a, l])=>{
            let c = n[a];
            Array.isArray(l) || typeof c > "u" ? n[a] = l : L(l) && L(c) ? e[a] = !0 : typeof l < "u" && (n[a] = l);
        }), n), {});
    return Object.keys(e).forEach((n)=>{
        let i = t.filter(Boolean).map((a)=>a[n]).filter((a)=>typeof a < "u");
        i.every((a)=>L(a)) ? o[n] = M(...i) : o[n] = i[i.length - 1];
    }), o;
}, "combineParameters");
// src/preview-api/modules/store/csf/prepareStory.ts
function Le(r, e, t) {
    let { moduleExport: o, id: n, name: i } = r || {}, a = bo(r, e, t), l = /* @__PURE__ */ s(async (w)=>{
        let A = {};
        for (let O of [
            ..."__STORYBOOK_TEST_LOADERS__" in I && Array.isArray(I.__STORYBOOK_TEST_LOADERS__) ? [
                I.__STORYBOOK_TEST_LOADERS__
            ] : [],
            F(t.loaders),
            F(e.loaders),
            F(r.loaders)
        ]){
            if (w.abortSignal.aborted) return A;
            let N = await Promise.all(O.map((U)=>U(w)));
            Object.assign(A, ...N);
        }
        return A;
    }, "applyLoaders"), c = /* @__PURE__ */ s(async (w)=>{
        let A = new Array();
        for (let O of [
            ...F(t.beforeEach),
            ...F(e.beforeEach),
            ...F(r.beforeEach)
        ]){
            if (w.abortSignal.aborted) return A;
            let N = await O(w);
            N && A.push(N);
        }
        return A;
    }, "applyBeforeEach"), d = /* @__PURE__ */ s(async (w)=>{
        let A = [
            ...F(t.experimental_afterEach),
            ...F(e.experimental_afterEach),
            ...F(r.experimental_afterEach)
        ].reverse();
        for (let O of A){
            if (w.abortSignal.aborted) return;
            await O(w);
        }
    }, "applyAfterEach"), p = /* @__PURE__ */ s((w)=>w.originalStoryFn(w.args, w), "undecoratedStoryFn"), { applyDecorators: u = Hr, runStep: y } = t, m = [
        ...F(r?.decorators),
        ...F(e?.decorators),
        ...F(t?.decorators)
    ], g = r?.userStoryFn || r?.render || e.render || t.render, S = vr(u)(p, m), h = /* @__PURE__ */ s((w)=>S(w), "unboundStoryFn"), E = r?.play ?? e?.play, R = mo(E);
    if (!g && !R) throw new (0, _previewErrors.NoRenderFunctionError)({
        id: n
    });
    let f = /* @__PURE__ */ s((w)=>async ()=>(await w.renderToCanvas(), w.canvas), "defaultMount"), b = r.mount ?? e.mount ?? t.mount ?? f, x = t.testingLibraryRender;
    return {
        storyGlobals: {},
        ...a,
        moduleExport: o,
        id: n,
        name: i,
        story: i,
        originalStoryFn: g,
        undecoratedStoryFn: p,
        unboundStoryFn: h,
        applyLoaders: l,
        applyBeforeEach: c,
        applyAfterEach: d,
        playFunction: E,
        runStep: y,
        mount: b,
        testingLibraryRender: x,
        renderToCanvas: t.renderToCanvas,
        usesMount: R
    };
}
s(Le, "prepareStory");
function Wr(r, e, t) {
    return {
        ...bo(void 0, r, e),
        moduleExport: t
    };
}
s(Wr, "prepareMeta");
function bo(r, e, t) {
    let o = [
        "dev",
        "test"
    ], n = I.DOCS_OPTIONS?.autodocs === !0 ? [
        "autodocs"
    ] : [], i = (0, _csf.combineTags)(...o, ...n, ...t.tags ?? [], ...e.tags ?? [], ...r?.tags ?? []), a = M(t.parameters, e.parameters, r?.parameters), { argTypesEnhancers: l = [], argsEnhancers: c = [] } = t, d = M(t.argTypes, e.argTypes, r?.argTypes);
    if (r) {
        let E = r?.userStoryFn || r?.render || e.render || t.render;
        a.__isArgsStory = E && E.length > 0;
    }
    let p = {
        ...t.args,
        ...e.args,
        ...r?.args
    }, u = {
        ...e.globals,
        ...r?.globals
    }, y = {
        componentId: e.id,
        title: e.title,
        kind: e.title,
        // Back compat
        id: r?.id || e.id,
        // if there's no story name, we create a fake one since enhancers expect a name
        name: r?.name || "__meta",
        story: r?.name || "__meta",
        // Back compat
        component: e.component,
        subcomponents: e.subcomponents,
        tags: i,
        parameters: a,
        initialArgs: p,
        argTypes: d,
        storyGlobals: u
    };
    y.argTypes = l.reduce((E, R)=>R({
            ...y,
            argTypes: E
        }), y.argTypes);
    let m = {
        ...p
    };
    y.initialArgs = c.reduce((E, R)=>({
            ...E,
            ...R({
                ...y,
                initialArgs: E
            })
        }), m);
    let { name: g, story: S, ...h } = y;
    return h;
}
s(bo, "preparePartialAnnotations");
function er(r) {
    let { args: e } = r, t = {
        ...r,
        allArgs: void 0,
        argsByTarget: void 0
    };
    if (I.FEATURES?.argTypeTargetsV7) {
        let i = co(r);
        t = {
            ...r,
            allArgs: r.args,
            argsByTarget: i,
            args: i[Gr] || {}
        };
    }
    let o = Object.entries(t.args).reduce((i, [a, l])=>{
        if (!t.argTypes[a]?.mapping) return i[a] = l, i;
        let c = /* @__PURE__ */ s((d)=>{
            let p = t.argTypes[a].mapping;
            return p && d in p ? p[d] : d;
        }, "mappingFn");
        return i[a] = Array.isArray(l) ? l.map(c) : c(l), i;
    }, {}), n = Object.entries(o).reduce((i, [a, l])=>{
        let c = t.argTypes[a] || {};
        return (0, _csf.includeConditionalArg)(c, o, t.globals) && (i[a] = l), i;
    }, {});
    return {
        ...t,
        unmappedArgs: e,
        args: n
    };
}
s(er, "prepareContext");
var $r = /* @__PURE__ */ s((r, e, t)=>{
    let o = typeof r;
    switch(o){
        case "boolean":
        case "string":
        case "number":
        case "function":
        case "symbol":
            return {
                name: o
            };
        default:
            break;
    }
    return r ? t.has(r) ? ((0, _clientLogger.logger).warn(P`
        We've detected a cycle in arg '${e}'. Args should be JSON-serializable.

        Consider using the mapping feature or fully custom args:
        - Mapping: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
        - Custom args: https://storybook.js.org/docs/essentials/controls#fully-custom-args
      `), {
        name: "other",
        value: "cyclic object"
    }) : (t.add(r), Array.isArray(r) ? {
        name: "array",
        value: r.length > 0 ? $r(r[0], e, new Set(t)) : {
            name: "other",
            value: "unknown"
        }
    } : {
        name: "object",
        value: G(r, (i)=>$r(i, e, new Set(t)))
    }) : {
        name: "object",
        value: {}
    };
}, "inferType"), Yr = /* @__PURE__ */ s((r)=>{
    let { id: e, argTypes: t = {}, initialArgs: o = {} } = r, n = G(o, (a, l)=>({
            name: l,
            type: $r(a, `${e}.${l}`, /* @__PURE__ */ new Set())
        })), i = G(t, (a, l)=>({
            name: l
        }));
    return M(n, i, t);
}, "inferArgTypes");
Yr.secondPass = !0;
// src/preview-api/modules/store/filterArgTypes.ts
var To = /* @__PURE__ */ s((r, e)=>Array.isArray(e) ? e.includes(r) : r.match(e), "matches"), rr = /* @__PURE__ */ s((r, e, t)=>!e && !t ? r : r && Dr(r, (o, n)=>{
        let i = o.name || n.toString();
        return !!(!e || To(i, e)) && (!t || !To(i, t));
    }), "filterArgTypes");
// src/preview-api/modules/store/inferControls.ts
var Bs = /* @__PURE__ */ s((r, e, t)=>{
    let { type: o, options: n } = r;
    if (o) {
        if (t.color && t.color.test(e)) {
            let i = o.name;
            if (i === "string") return {
                control: {
                    type: "color"
                }
            };
            i !== "enum" && (0, _clientLogger.logger).warn(`Addon controls: Control of type color only supports string, received "${i}" instead`);
        }
        if (t.date && t.date.test(e)) return {
            control: {
                type: "date"
            }
        };
        switch(o.name){
            case "array":
                return {
                    control: {
                        type: "object"
                    }
                };
            case "boolean":
                return {
                    control: {
                        type: "boolean"
                    }
                };
            case "string":
                return {
                    control: {
                        type: "text"
                    }
                };
            case "number":
                return {
                    control: {
                        type: "number"
                    }
                };
            case "enum":
                {
                    let { value: i } = o;
                    return {
                        control: {
                            type: i?.length <= 5 ? "radio" : "select"
                        },
                        options: i
                    };
                }
            case "function":
            case "symbol":
                return null;
            default:
                return {
                    control: {
                        type: n ? "select" : "object"
                    }
                };
        }
    }
}, "inferControl"), Ne = /* @__PURE__ */ s((r)=>{
    let { argTypes: e, // eslint-disable-next-line @typescript-eslint/naming-convention
    parameters: { __isArgsStory: t, controls: { include: o = null, exclude: n = null, matchers: i = {} } = {} } } = r;
    if (!t) return e;
    let a = rr(e, o, n), l = G(a, (c, d)=>c?.type && Bs(c, d.toString(), i));
    return M(l, a);
}, "inferControls");
Ne.secondPass = !0;
// src/preview-api/modules/store/csf/normalizeProjectAnnotations.ts
function be({ argTypes: r, globalTypes: e, argTypesEnhancers: t, decorators: o, loaders: n, beforeEach: i, experimental_afterEach: a, globals: l, initialGlobals: c, ...d }) {
    return l && Object.keys(l).length > 0 && (0, _clientLogger.deprecate)(P`
      The preview.js 'globals' field is deprecated and will be removed in Storybook 9.0.
      Please use 'initialGlobals' instead. Learn more:

      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#previewjs-globals-renamed-to-initialglobals
    `), {
        ...r && {
            argTypes: ae(r)
        },
        ...e && {
            globalTypes: ae(e)
        },
        decorators: F(o),
        loaders: F(n),
        beforeEach: F(i),
        experimental_afterEach: F(a),
        argTypesEnhancers: [
            ...t || [],
            Yr,
            // inferControls technically should only run if the user is using the controls addon,
            // and so should be added by a preset there. However, as it seems some code relies on controls
            // annotations (in particular the angular implementation's `cleanArgsDecorator`), for backwards
            // compatibility reasons, we will leave this in the store until 7.0
            Ne
        ],
        initialGlobals: M(c, l),
        ...d
    };
}
s(be, "normalizeProjectAnnotations");
// src/preview-api/modules/store/csf/beforeAll.ts
var Eo = /* @__PURE__ */ s((r)=>async ()=>{
        let e = [];
        for (let t of r){
            let o = await t();
            o && e.unshift(o);
        }
        return async ()=>{
            for (let t of e)await t();
        };
    }, "composeBeforeAllHooks");
// src/preview-api/modules/store/csf/stepRunners.ts
function Kr(r) {
    return async (e, t, o)=>{
        await r.reduceRight((i, a)=>async ()=>a(e, i, o), async ()=>t(o))();
    };
}
s(Kr, "composeStepRunners");
// src/preview-api/modules/store/csf/composeConfigs.ts
function _e(r, e) {
    return r.map((t)=>t.default?.[e] ?? t[e]).filter(Boolean);
}
s(_e, "getField");
function Q(r, e, t = {}) {
    return _e(r, e).reduce((o, n)=>{
        let i = F(n);
        return t.reverseFileOrder ? [
            ...i,
            ...o
        ] : [
            ...o,
            ...i
        ];
    }, []);
}
s(Q, "getArrayField");
function Me(r, e) {
    return Object.assign({}, ..._e(r, e));
}
s(Me, "getObjectField");
function Te(r, e) {
    return _e(r, e).pop();
}
s(Te, "getSingletonField");
function Ee(r) {
    let e = Q(r, "argTypesEnhancers"), t = _e(r, "runStep"), o = Q(r, "beforeAll");
    return {
        parameters: M(..._e(r, "parameters")),
        decorators: Q(r, "decorators", {
            reverseFileOrder: !(I.FEATURES?.legacyDecoratorFileOrder ?? !1)
        }),
        args: Me(r, "args"),
        argsEnhancers: Q(r, "argsEnhancers"),
        argTypes: Me(r, "argTypes"),
        argTypesEnhancers: [
            ...e.filter((n)=>!n.secondPass),
            ...e.filter((n)=>n.secondPass)
        ],
        globals: Me(r, "globals"),
        initialGlobals: Me(r, "initialGlobals"),
        globalTypes: Me(r, "globalTypes"),
        loaders: Q(r, "loaders"),
        beforeAll: Eo(o),
        beforeEach: Q(r, "beforeEach"),
        experimental_afterEach: Q(r, "experimental_afterEach"),
        render: Te(r, "render"),
        renderToCanvas: Te(r, "renderToCanvas"),
        renderToDOM: Te(r, "renderToDOM"),
        // deprecated
        applyDecorators: Te(r, "applyDecorators"),
        runStep: Kr(t),
        tags: Q(r, "tags"),
        mount: Te(r, "mount"),
        testingLibraryRender: Te(r, "testingLibraryRender")
    };
}
s(Ee, "composeConfigs");
// src/preview-api/modules/store/reporter-api.ts
var Xr = class Xr {
    constructor(){
        this.reports = [];
    }
    async addReport(e) {
        this.reports.push(e);
    }
};
s(Xr, "ReporterAPI");
var le = Xr;
function Jr(r, e, t) {
    return (0, _csf.isStory)(r) ? {
        story: r.input,
        meta: r.meta.input,
        preview: r.meta.preview.composed
    } : {
        story: r,
        meta: e,
        preview: t
    };
}
s(Jr, "getCsfFactoryAnnotations");
// src/preview-api/modules/store/csf/portable-stories.ts
function $s(r) {
    globalThis.defaultProjectAnnotations = r;
}
s($s, "setDefaultProjectAnnotations");
var Ys = "ComposedStory", Ks = "Unnamed Story";
function Xs(r) {
    return r ? Ee([
        r
    ]) : {};
}
s(Xs, "extractAnnotation");
function Js(r) {
    let e = Array.isArray(r) ? r : [
        r
    ];
    return globalThis.globalProjectAnnotations = Ee([
        globalThis.defaultProjectAnnotations ?? {},
        Ee(e.map(Xs))
    ]), globalThis.globalProjectAnnotations ?? {};
}
s(Js, "setProjectAnnotations");
var Z = [];
function Ro(r, e, t, o, n) {
    if (r === void 0) throw new Error("Expected a story but received undefined.");
    e.title = e.title ?? Ys;
    let i = je(e), a = n || r.storyName || r.story?.name || r.name || Ks, l = Se(a, r, i), c = be(Ee([
        o ?? globalThis.globalProjectAnnotations ?? {},
        t ?? {}
    ])), d = Le(l, i, c), u = {
        // TODO: remove loading from globalTypes in 9.0
        ...Xe(c.globalTypes),
        ...c.initialGlobals,
        ...d.storyGlobals
    }, y = new le(), m = /* @__PURE__ */ s(()=>{
        let f = er({
            hooks: new se(),
            globals: u,
            args: {
                ...d.initialArgs
            },
            viewMode: "story",
            reporting: y,
            loaded: {},
            abortSignal: new AbortController().signal,
            step: /* @__PURE__ */ s((b, x)=>d.runStep(b, x, f), "step"),
            canvasElement: null,
            canvas: {},
            globalTypes: c.globalTypes,
            ...d,
            context: null,
            mount: null
        });
        return f.parameters.__isPortableStory = !0, f.context = f, d.renderToCanvas && (f.renderToCanvas = async ()=>{
            let b = await d.renderToCanvas?.({
                componentId: d.componentId,
                title: d.title,
                id: d.id,
                name: d.name,
                tags: d.tags,
                showMain: /* @__PURE__ */ s(()=>{}, "showMain"),
                showError: /* @__PURE__ */ s((x)=>{
                    throw new Error(`${x.title}
${x.description}`);
                }, "showError"),
                showException: /* @__PURE__ */ s((x)=>{
                    throw x;
                }, "showException"),
                forceRemount: !0,
                storyContext: f,
                storyFn: /* @__PURE__ */ s(()=>d.unboundStoryFn(f), "storyFn"),
                unboundStoryFn: d.unboundStoryFn
            }, f.canvasElement);
            b && Z.push(b);
        }), f.mount = d.mount(f), f;
    }, "initializeContext"), g, S = /* @__PURE__ */ s(async (f)=>{
        let b = m();
        return b.canvasElement ??= globalThis?.document?.body, g && (b.loaded = g.loaded), Object.assign(b, f), d.playFunction(b);
    }, "play"), h = /* @__PURE__ */ s((f)=>{
        let b = m();
        return Object.assign(b, f), ri(d, b);
    }, "run"), E = d.playFunction ? S : void 0;
    return Object.assign(/* @__PURE__ */ s(function(b) {
        let x = m();
        return g && (x.loaded = g.loaded), x.args = {
            ...x.initialArgs,
            ...b
        }, d.unboundStoryFn(x);
    }, "storyFn"), {
        id: d.id,
        storyName: a,
        load: /* @__PURE__ */ s(async ()=>{
            for (let b of [
                ...Z
            ].reverse())await b();
            Z.length = 0;
            let f = m();
            f.loaded = await d.applyLoaders(f), Z.push(...(await d.applyBeforeEach(f)).filter(Boolean)), g = f;
        }, "load"),
        globals: u,
        args: d.initialArgs,
        parameters: d.parameters,
        argTypes: d.argTypes,
        play: E,
        run: h,
        reporting: y,
        tags: d.tags
    });
}
s(Ro, "composeStory");
var Qs = /* @__PURE__ */ s((r, e, t, o)=>Ro(r, e, t, {}, o), "defaultComposeStory");
function Zs(r, e, t = Qs) {
    let { default: o, __esModule: n, __namedExportsOrder: i, ...a } = r, l = o;
    return Object.entries(a).reduce((d, [p, u])=>{
        let { story: y, meta: m } = Jr(u);
        return !l && m && (l = m), (0, _csf.isExportStory)(p, l) ? Object.assign(d, {
            [p]: t(y, l, e, p)
        }) : d;
    }, {});
}
s(Zs, "composeStories");
function ei(r) {
    return r.extend({
        mount: /* @__PURE__ */ s(async ({ mount: e, page: t }, o)=>{
            await o(async (n, ...i)=>{
                if (!("__pw_type" in n) || "__pw_type" in n && n.__pw_type !== "jsx") throw new Error(P`
              Portable stories in Playwright CT only work when referencing JSX elements.
              Please use JSX format for your components such as:

              instead of:
              await mount(MyComponent, { props: { foo: 'bar' } })

              do:
              await mount(<MyComponent foo="bar"/>)

              More info: https://storybook.js.org/docs/api/portable-stories-playwright
            `);
                await t.evaluate(async (l)=>{
                    let c = await globalThis.__pwUnwrapObject?.(l);
                    return ("__pw_type" in c ? c.type : c)?.load?.();
                }, n);
                let a = await e(n, ...i);
                return await t.evaluate(async (l)=>{
                    let c = await globalThis.__pwUnwrapObject?.(l), d = "__pw_type" in c ? c.type : c, p = document.querySelector("#root");
                    return d?.play?.({
                        canvasElement: p
                    });
                }, n), a;
            });
        }, "mount")
    });
}
s(ei, "createPlaywrightTest");
async function ri(r, e) {
    for (let n of [
        ...Z
    ].reverse())await n();
    if (Z.length = 0, !e.canvasElement) {
        let n = document.createElement("div");
        globalThis?.document?.body?.appendChild(n), e.canvasElement = n, Z.push(()=>{
            globalThis?.document?.body?.contains(n) && globalThis?.document?.body?.removeChild(n);
        });
    }
    if (e.loaded = await r.applyLoaders(e), e.abortSignal.aborted) return;
    Z.push(...(await r.applyBeforeEach(e)).filter(Boolean));
    let t = r.playFunction, o = r.usesMount;
    o || await e.mount(), !e.abortSignal.aborted && (t && (o || (e.mount = async ()=>{
        throw new (0, _previewErrors.MountMustBeDestructuredError)({
            playFunction: t.toString()
        });
    }), await t(e)), await r.applyAfterEach(e));
}
s(ri, "runStory");
// src/preview-api/modules/store/StoryStore.ts
function wo(r, e) {
    return Ir(Or(r, e), (t)=>t === void 0);
}
s(wo, "picky");
var vo = 1e3, ni = 1e4, Qr = class Qr {
    constructor(e, t, o){
        this.importFn = t;
        // TODO: Remove in 9.0
        // NOTE: this is legacy `stories.json` data for the `extract` script.
        // It is used to allow v7 Storybooks to be composed in v6 Storybooks, which expect a
        // `stories.json` file with legacy fields (`kind` etc).
        this.getStoriesJsonData = /* @__PURE__ */ s(()=>{
            let e = this.getSetStoriesPayload(), t = [
                "fileName",
                "docsOnly",
                "framework",
                "__id",
                "__isArgsStory"
            ];
            return {
                v: 3,
                stories: G(e.stories, (n)=>{
                    let { importPath: i } = this.storyIndex.entries[n.id];
                    return {
                        ...wo(n, [
                            "id",
                            "name",
                            "title"
                        ]),
                        importPath: i,
                        // These 3 fields were going to be dropped in v7, but instead we will keep them for the
                        // 7.x cycle so that v7 Storybooks can be composed successfully in v6 Storybook.
                        // In v8 we will (likely) completely drop support for `extract` and `getStoriesJsonData`
                        kind: n.title,
                        story: n.name,
                        parameters: {
                            ...wo(n.parameters, t),
                            fileName: i
                        }
                    };
                })
            };
        }, "getStoriesJsonData");
        this.storyIndex = new Qe(e), this.projectAnnotations = be(o);
        let { initialGlobals: n, globalTypes: i } = this.projectAnnotations;
        this.args = new Ke(), this.userGlobals = new Je({
            globals: n,
            globalTypes: i
        }), this.hooks = {}, this.cleanupCallbacks = {}, this.processCSFFileWithCache = (0, tr.default)(vo)(yo), this.prepareMetaWithCache = (0, tr.default)(vo)(Wr), this.prepareStoryWithCache = (0, tr.default)(ni)(Le);
    }
    setProjectAnnotations(e) {
        this.projectAnnotations = be(e);
        let { initialGlobals: t, globalTypes: o } = e;
        this.userGlobals.set({
            globals: t,
            globalTypes: o
        });
    }
    // This means that one of the CSF files has changed.
    // If the `importFn` has changed, we will invalidate both caches.
    // If the `storyIndex` data has changed, we may or may not invalidate the caches, depending
    // on whether we've loaded the relevant files yet.
    async onStoriesChanged({ importFn: e, storyIndex: t }) {
        e && (this.importFn = e), t && (this.storyIndex.entries = t.entries), this.cachedCSFFiles && await this.cacheAllCSFFiles();
    }
    // Get an entry from the index, waiting on initialization if necessary
    async storyIdToEntry(e) {
        return this.storyIndex.storyIdToEntry(e);
    }
    // To load a single CSF file to service a story we need to look up the importPath in the index
    async loadCSFFileByStoryId(e) {
        let { importPath: t, title: o } = this.storyIndex.storyIdToEntry(e), n = await this.importFn(t);
        return this.processCSFFileWithCache(n, t, o);
    }
    async loadAllCSFFiles() {
        let e = {};
        return Object.entries(this.storyIndex.entries).forEach(([o, { importPath: n }])=>{
            e[n] = o;
        }), (await Promise.all(Object.entries(e).map(async ([o, n])=>({
                importPath: o,
                csfFile: await this.loadCSFFileByStoryId(n)
            })))).reduce((o, { importPath: n, csfFile: i })=>(o[n] = i, o), {});
    }
    async cacheAllCSFFiles() {
        this.cachedCSFFiles = await this.loadAllCSFFiles();
    }
    preparedMetaFromCSFFile({ csfFile: e }) {
        let t = e.meta;
        return this.prepareMetaWithCache(t, this.projectAnnotations, e.moduleExports.default);
    }
    // Load the CSF file for a story and prepare the story from it and the project annotations.
    async loadStory({ storyId: e }) {
        let t = await this.loadCSFFileByStoryId(e);
        return this.storyFromCSFFile({
            storyId: e,
            csfFile: t
        });
    }
    // This function is synchronous for convenience -- often times if you have a CSF file already
    // it is easier not to have to await `loadStory`.
    storyFromCSFFile({ storyId: e, csfFile: t }) {
        let o = t.stories[e];
        if (!o) throw new (0, _previewErrors.MissingStoryFromCsfFileError)({
            storyId: e
        });
        let n = t.meta, i = this.prepareStoryWithCache(o, n, t.projectAnnotations ?? this.projectAnnotations);
        return this.args.setInitial(i), this.hooks[i.id] = this.hooks[i.id] || new se(), i;
    }
    // If we have a CSF file we can get all the stories from it synchronously
    componentStoriesFromCSFFile({ csfFile: e }) {
        return Object.keys(this.storyIndex.entries).filter((t)=>!!e.stories[t]).map((t)=>this.storyFromCSFFile({
                storyId: t,
                csfFile: e
            }));
    }
    async loadEntry(e) {
        let t = await this.storyIdToEntry(e), o = t.type === "docs" ? t.storiesImports : [], [n, ...i] = await Promise.all([
            this.importFn(t.importPath),
            ...o.map((a)=>{
                let l = this.storyIndex.importPathToEntry(a);
                return this.loadCSFFileByStoryId(l.id);
            })
        ]);
        return {
            entryExports: n,
            csfFiles: i
        };
    }
    // A prepared story does not include args, globals or hooks. These are stored in the story store
    // and updated separtely to the (immutable) story.
    getStoryContext(e, { forceInitialArgs: t = !1 } = {}) {
        let o = this.userGlobals.get(), { initialGlobals: n } = this.userGlobals, i = new le();
        return er({
            ...e,
            args: t ? e.initialArgs : this.args.get(e.id),
            initialGlobals: n,
            globalTypes: this.projectAnnotations.globalTypes,
            userGlobals: o,
            reporting: i,
            globals: {
                ...o,
                ...e.storyGlobals
            },
            hooks: this.hooks[e.id]
        });
    }
    addCleanupCallbacks(e, t) {
        this.cleanupCallbacks[e.id] = t;
    }
    async cleanupStory(e) {
        this.hooks[e.id].clean();
        let t = this.cleanupCallbacks[e.id];
        if (t) for (let o of [
            ...t
        ].reverse())await o();
        delete this.cleanupCallbacks[e.id];
    }
    extract(e = {
        includeDocsOnly: !1
    }) {
        let { cachedCSFFiles: t } = this;
        if (!t) throw new (0, _previewErrors.CalledExtractOnStoreError)();
        return Object.entries(this.storyIndex.entries).reduce((o, [n, { type: i, importPath: a }])=>{
            if (i === "docs") return o;
            let l = t[a], c = this.storyFromCSFFile({
                storyId: n,
                csfFile: l
            });
            return !e.includeDocsOnly && c.parameters.docsOnly || (o[n] = Object.entries(c).reduce((d, [p, u])=>p === "moduleExport" || typeof u == "function" ? d : Array.isArray(u) ? Object.assign(d, {
                    [p]: u.slice().sort()
                }) : Object.assign(d, {
                    [p]: u
                }), {
                //
                args: c.initialArgs,
                globals: {
                    ...this.userGlobals.initialGlobals,
                    ...this.userGlobals.globals,
                    ...c.storyGlobals
                }
            })), o;
        }, {});
    }
    // TODO: Remove in 9.0
    getSetStoriesPayload() {
        let e = this.extract({
            includeDocsOnly: !0
        }), t = Object.values(e).reduce((o, { title: n })=>(o[n] = {}, o), {});
        return {
            v: 2,
            globals: this.userGlobals.get(),
            globalParameters: {},
            kindParameters: t,
            stories: e
        };
    }
    raw() {
        return (0, _clientLogger.deprecate)("StoryStore.raw() is deprecated and will be removed in 9.0, please use extract() instead"), Object.values(this.extract()).map(({ id: e })=>this.fromId(e)).filter(Boolean);
    }
    fromId(e) {
        if ((0, _clientLogger.deprecate)("StoryStore.fromId() is deprecated and will be removed in 9.0, please use loadStory() instead"), !this.cachedCSFFiles) throw new Error("Cannot call fromId/raw() unless you call cacheAllCSFFiles() first.");
        let t;
        try {
            ({ importPath: t } = this.storyIndex.storyIdToEntry(e));
        } catch  {
            return null;
        }
        let o = this.cachedCSFFiles[t], n = this.storyFromCSFFile({
            storyId: e,
            csfFile: o
        });
        return {
            ...n,
            storyFn: /* @__PURE__ */ s((i)=>{
                let a = {
                    ...this.getStoryContext(n),
                    abortSignal: new AbortController().signal,
                    canvasElement: null,
                    loaded: {},
                    step: /* @__PURE__ */ s((l, c)=>n.runStep(l, c, a), "step"),
                    context: null,
                    mount: null,
                    canvas: {},
                    viewMode: "story"
                };
                return n.unboundStoryFn({
                    ...a,
                    ...i
                });
            }, "storyFn")
        };
    }
};
s(Qr, "StoryStore");
var Re = Qr;
// ../node_modules/slash/index.js
function Zr(r) {
    return r.startsWith("\\\\?\\") ? r : r.replace(/\\/g, "/");
}
s(Zr, "slash");
// src/preview-api/modules/store/autoTitle.ts
var ii = /* @__PURE__ */ s((r)=>{
    if (r.length === 0) return r;
    let e = r[r.length - 1], t = e?.replace(/(?:[.](?:story|stories))?([.][^.]+)$/i, "");
    if (r.length === 1) return [
        t
    ];
    let o = r[r.length - 2];
    return t && o && t.toLowerCase() === o.toLowerCase() ? [
        ...r.slice(0, -2),
        t
    ] : t && (/^(story|stories)([.][^.]+)$/i.test(e) || /^index$/i.test(t)) ? r.slice(0, -1) : [
        ...r.slice(0, -1),
        t
    ];
}, "sanitize");
function Ao(r) {
    return r.flatMap((e)=>e.split("/")).filter(Boolean).join("/");
}
s(Ao, "pathJoin");
var Co = /* @__PURE__ */ s((r, e, t)=>{
    let { directory: o, importPathMatcher: n, titlePrefix: i = "" } = e || {};
    typeof r == "number" && (0, _clientLogger.once).warn(P`
      CSF Auto-title received a numeric fileName. This typically happens when
      webpack is mis-configured in production mode. To force webpack to produce
      filenames, set optimization.moduleIds = "named" in your webpack config.
    `);
    let a = Zr(String(r));
    if (n.exec(a)) {
        if (!t) {
            let l = a.replace(o, ""), c = Ao([
                i,
                l
            ]).split("/");
            return c = ii(c), c.join("/");
        }
        return i ? Ao([
            i,
            t
        ]) : t;
    }
}, "userOrAutoTitleFromSpecifier"), ai = /* @__PURE__ */ s((r, e, t)=>{
    for(let o = 0; o < e.length; o += 1){
        let n = Co(r, e[o], t);
        if (n) return n;
    }
    return t || void 0;
}, "userOrAutoTitle");
// src/preview-api/modules/store/storySort.ts
var Po = /\s*\/\s*/, Fo = /* @__PURE__ */ s((r = {})=>(e, t)=>{
        if (e.title === t.title && !r.includeNames) return 0;
        let o = r.method || "configure", n = r.order || [], i = e.title.trim().split(Po), a = t.title.trim().split(Po);
        r.includeNames && (i.push(e.name), a.push(t.name));
        let l = 0;
        for(; i[l] || a[l];){
            if (!i[l]) return -1;
            if (!a[l]) return 1;
            let c = i[l], d = a[l];
            if (c !== d) {
                let u = n.indexOf(c), y = n.indexOf(d), m = n.indexOf("*");
                return u !== -1 || y !== -1 ? (u === -1 && (m !== -1 ? u = m : u = n.length), y === -1 && (m !== -1 ? y = m : y = n.length), u - y) : o === "configure" ? 0 : c.localeCompare(d, r.locales ? r.locales : void 0, {
                    numeric: !0,
                    sensitivity: "accent"
                });
            }
            let p = n.indexOf(c);
            p === -1 && (p = n.indexOf("*")), n = p !== -1 && Array.isArray(n[p + 1]) ? n[p + 1] : [], l += 1;
        }
        return 0;
    }, "storySort");
// src/preview-api/modules/store/sortStories.ts
var li = /* @__PURE__ */ s((r, e, t)=>{
    if (e) {
        let o;
        typeof e == "function" ? o = e : o = Fo(e), r.sort(o);
    } else r.sort((o, n)=>t.indexOf(o.importPath) - t.indexOf(n.importPath));
    return r;
}, "sortStoriesCommon"), ci = /* @__PURE__ */ s((r, e, t)=>{
    try {
        return li(r, e, t);
    } catch (o) {
        throw new Error(P`
    Error sorting stories with sort parameter ${e}:

    > ${o.message}
    
    Are you using a V6-style sort function in V7 mode?

    More info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#v7-style-story-sort
  `);
    }
}, "sortStoriesV7");
// src/preview-api/modules/preview-web/render/Render.ts
var ee = new Error("prepareAborted");
// src/preview-api/modules/preview-web/render/StoryRender.ts
var { AbortController: Do } = globalThis;
function ko(r) {
    try {
        let { name: e = "Error", message: t = String(r), stack: o } = r;
        return {
            name: e,
            message: t,
            stack: o
        };
    } catch  {
        return {
            name: "Error",
            message: String(r)
        };
    }
}
s(ko, "serializeError");
var et = class et {
    constructor(e, t, o, n, i, a, l = {
        autoplay: !0,
        forceInitialArgs: !1
    }, c){
        this.channel = e;
        this.store = t;
        this.renderToScreen = o;
        this.callbacks = n;
        this.id = i;
        this.viewMode = a;
        this.renderOptions = l;
        this.type = "story";
        this.notYetRendered = !0;
        this.rerenderEnqueued = !1;
        this.disableKeyListeners = !1;
        this.teardownRender = /* @__PURE__ */ s(()=>{}, "teardownRender");
        this.torndown = !1;
        this.abortController = new Do(), c && (this.story = c, this.phase = "preparing");
    }
    async runPhase(e, t, o) {
        this.phase = t, this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
            newPhase: this.phase,
            storyId: this.id
        }), o && (await o(), this.checkIfAborted(e));
    }
    checkIfAborted(e) {
        return e.aborted ? (this.phase = "aborted", this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
            newPhase: this.phase,
            storyId: this.id
        }), !0) : !1;
    }
    async prepare() {
        if (await this.runPhase(this.abortController.signal, "preparing", async ()=>{
            this.story = await this.store.loadStory({
                storyId: this.id
            });
        }), this.abortController.signal.aborted) throw await this.store.cleanupStory(this.story), ee;
    }
    // The two story "renders" are equal and have both loaded the same story
    isEqual(e) {
        return !!(this.id === e.id && this.story && this.story === e.story);
    }
    isPreparing() {
        return [
            "preparing"
        ].includes(this.phase);
    }
    isPending() {
        return [
            "loading",
            "beforeEach",
            "rendering",
            "playing",
            "afterEach"
        ].includes(this.phase);
    }
    async renderToElement(e) {
        return this.canvasElement = e, this.render({
            initial: !0,
            forceRemount: !0
        });
    }
    storyContext() {
        if (!this.story) throw new Error("Cannot call storyContext before preparing");
        let { forceInitialArgs: e } = this.renderOptions;
        return this.store.getStoryContext(this.story, {
            forceInitialArgs: e
        });
    }
    async render({ initial: e = !1, forceRemount: t = !1 } = {}) {
        let { canvasElement: o } = this;
        if (!this.story) throw new Error("cannot render when not prepared");
        let n = this.story;
        if (!o) throw new Error("cannot render when canvasElement is unset");
        let { id: i, componentId: a, title: l, name: c, tags: d, applyLoaders: p, applyBeforeEach: u, applyAfterEach: y, unboundStoryFn: m, playFunction: g, runStep: S } = n;
        t && !e && (this.cancelRender(), this.abortController = new Do());
        let h = this.abortController.signal, E = !1, R = n.usesMount;
        try {
            let f = {
                ...this.storyContext(),
                viewMode: this.viewMode,
                abortSignal: h,
                canvasElement: o,
                loaded: {},
                step: /* @__PURE__ */ s((C, z)=>S(C, z, f), "step"),
                context: null,
                canvas: {},
                renderToCanvas: /* @__PURE__ */ s(async ()=>{
                    let C = await this.renderToScreen(b, o);
                    this.teardownRender = C || (()=>{}), E = !0;
                }, "renderToCanvas"),
                // The story provides (set in a renderer) a mount function that is a higher order function
                // (context) => (...args) => Canvas
                //
                // Before assigning it to the context, we resolve the context dependency,
                // so that a user can just call it as await mount(...args) in their play function.
                mount: /* @__PURE__ */ s(async (...C)=>{
                    this.callbacks.showStoryDuringRender?.();
                    let z = null;
                    return await this.runPhase(h, "rendering", async ()=>{
                        z = await n.mount(f)(...C);
                    }), R && await this.runPhase(h, "playing"), z;
                }, "mount")
            };
            f.context = f;
            let b = {
                componentId: a,
                title: l,
                kind: l,
                id: i,
                name: c,
                story: c,
                tags: d,
                ...this.callbacks,
                showError: /* @__PURE__ */ s((C)=>(this.phase = "errored", this.callbacks.showError(C)), "showError"),
                showException: /* @__PURE__ */ s((C)=>(this.phase = "errored", this.callbacks.showException(C)), "showException"),
                forceRemount: t || this.notYetRendered,
                storyContext: f,
                storyFn: /* @__PURE__ */ s(()=>m(f), "storyFn"),
                unboundStoryFn: m
            };
            if (await this.runPhase(h, "loading", async ()=>{
                f.loaded = await p(f);
            }), h.aborted) return;
            let x = await u(f);
            if (this.store.addCleanupCallbacks(n, x), this.checkIfAborted(h) || (!E && !R && await f.mount(), this.notYetRendered = !1, h.aborted)) return;
            let w = this.story.parameters?.test?.dangerouslyIgnoreUnhandledErrors === !0, A = /* @__PURE__ */ new Set(), O = /* @__PURE__ */ s((C)=>A.add("error" in C ? C.error : C.reason), "onError");
            if (this.renderOptions.autoplay && t && g && this.phase !== "errored") {
                window.addEventListener("error", O), window.addEventListener("unhandledrejection", O), this.disableKeyListeners = !0;
                try {
                    if (R ? await g(f) : (f.mount = async ()=>{
                        throw new (0, _previewErrors.MountMustBeDestructuredError)({
                            playFunction: g.toString()
                        });
                    }, await this.runPhase(h, "playing", async ()=>g(f))), !E) throw new (0, _previewErrors.NoStoryMountedError)();
                    this.checkIfAborted(h), !w && A.size > 0 ? await this.runPhase(h, "errored") : await this.runPhase(h, "played");
                } catch (C) {
                    if (this.callbacks.showStoryDuringRender?.(), await this.runPhase(h, "errored", async ()=>{
                        this.channel.emit((0, _coreEvents.PLAY_FUNCTION_THREW_EXCEPTION), ko(C));
                    }), this.story.parameters.throwPlayFunctionExceptions !== !1) throw C;
                    console.error(C);
                }
                if (!w && A.size > 0 && this.channel.emit((0, _coreEvents.UNHANDLED_ERRORS_WHILE_PLAYING), Array.from(A).map(ko)), this.disableKeyListeners = !1, window.removeEventListener("unhandledrejection", O), window.removeEventListener("error", O), h.aborted) return;
            }
            await this.runPhase(h, "completed", async ()=>this.channel.emit((0, _coreEvents.STORY_RENDERED), i)), this.phase !== "errored" && await this.runPhase(h, "afterEach", async ()=>{
                await y(f);
            });
            let N = !w && A.size > 0, U = f.reporting.reports.some((C)=>C.status === "failed"), ye = N || U;
            await this.runPhase(h, "finished", async ()=>this.channel.emit((0, _coreEvents.STORY_FINISHED), {
                    storyId: i,
                    status: ye ? "error" : "success",
                    reporters: f.reporting.reports
                }));
        } catch (f) {
            this.phase = "errored", this.callbacks.showException(f), await this.runPhase(h, "finished", async ()=>this.channel.emit((0, _coreEvents.STORY_FINISHED), {
                    storyId: i,
                    status: "error",
                    reporters: []
                }));
        }
        this.rerenderEnqueued && (this.rerenderEnqueued = !1, this.render());
    }
    /**
   * Rerender the story. If the story is currently pending (loading/rendering), the rerender will be
   * enqueued, and will be executed after the current render is completed. Rerendering while playing
   * will not be enqueued, and will be executed immediately, to support rendering args changes while
   * playing.
   */ async rerender() {
        if (this.isPending() && this.phase !== "playing") this.rerenderEnqueued = !0;
        else return this.render();
    }
    async remount() {
        return await this.teardown(), this.render({
            forceRemount: !0
        });
    }
    // If the story is torn down (either a new story is rendered or the docs page removes it)
    // we need to consider the fact that the initial render may not be finished
    // (possibly the loaders or the play function are still running). We use the controller
    // as a method to abort them, ASAP, but this is not foolproof as we cannot control what
    // happens inside the user's code.
    cancelRender() {
        this.abortController?.abort();
    }
    async teardown() {
        this.torndown = !0, this.cancelRender(), this.story && await this.store.cleanupStory(this.story);
        for(let e = 0; e < 3; e += 1){
            if (!this.isPending()) {
                await this.teardownRender();
                return;
            }
            await new Promise((t)=>setTimeout(t, 0));
        }
        window.location.reload(), await new Promise(()=>{});
    }
};
s(et, "StoryRender");
var ce = et;
// src/preview-api/modules/preview-web/Preview.tsx
var { fetch: Fi } = I, Ii = "./index.json", rt = class rt {
    constructor(e, t, o = V.getChannel(), n = !0){
        this.importFn = e;
        this.getProjectAnnotations = t;
        this.channel = o;
        this.storyRenders = [];
        this.storeInitializationPromise = new Promise((i, a)=>{
            this.resolveStoreInitializationPromise = i, this.rejectStoreInitializationPromise = a;
        }), n && this.initialize();
    }
    // Create a proxy object for `__STORYBOOK_STORY_STORE__` and `__STORYBOOK_PREVIEW__.storyStore`
    // That proxies through to the store once ready, and errors beforehand. This means we can set
    // `__STORYBOOK_STORY_STORE__ = __STORYBOOK_PREVIEW__.storyStore` without having to wait, and
    // similarly integrators can access the `storyStore` on the preview at any time, although
    // it is considered deprecated and we will no longer allow access in 9.0
    get storyStore() {
        return new Proxy({}, {
            get: /* @__PURE__ */ s((e, t)=>{
                if (this.storyStoreValue) return (0, _clientLogger.deprecate)("Accessing the Story Store is deprecated and will be removed in 9.0"), this.storyStoreValue[t];
                throw new (0, _previewErrors.StoryStoreAccessedBeforeInitializationError)();
            }, "get")
        });
    }
    // INITIALIZATION
    async initialize() {
        this.setupListeners();
        try {
            let e = await this.getProjectAnnotationsOrRenderError();
            await this.runBeforeAllHook(e), await this.initializeWithProjectAnnotations(e);
        } catch (e) {
            this.rejectStoreInitializationPromise(e);
        }
    }
    ready() {
        return this.storeInitializationPromise;
    }
    setupListeners() {
        this.channel.on((0, _coreEvents.STORY_INDEX_INVALIDATED), this.onStoryIndexChanged.bind(this)), this.channel.on((0, _coreEvents.UPDATE_GLOBALS), this.onUpdateGlobals.bind(this)), this.channel.on((0, _coreEvents.UPDATE_STORY_ARGS), this.onUpdateArgs.bind(this)), this.channel.on((0, _coreEvents.ARGTYPES_INFO_REQUEST), this.onRequestArgTypesInfo.bind(this)), this.channel.on((0, _coreEvents.RESET_STORY_ARGS), this.onResetArgs.bind(this)), this.channel.on((0, _coreEvents.FORCE_RE_RENDER), this.onForceReRender.bind(this)), this.channel.on((0, _coreEvents.FORCE_REMOUNT), this.onForceRemount.bind(this));
    }
    async getProjectAnnotationsOrRenderError() {
        try {
            let e = await this.getProjectAnnotations();
            if (this.renderToCanvas = e.renderToCanvas, !this.renderToCanvas) throw new (0, _previewErrors.MissingRenderToCanvasError)();
            return e;
        } catch (e) {
            throw this.renderPreviewEntryError("Error reading preview.js:", e), e;
        }
    }
    // If initialization gets as far as project annotations, this function runs.
    async initializeWithProjectAnnotations(e) {
        this.projectAnnotationsBeforeInitialization = e;
        try {
            let t = await this.getStoryIndexFromServer();
            return this.initializeWithStoryIndex(t);
        } catch (t) {
            throw this.renderPreviewEntryError("Error loading story index:", t), t;
        }
    }
    async runBeforeAllHook(e) {
        try {
            await this.beforeAllCleanup?.(), this.beforeAllCleanup = await e.beforeAll?.();
        } catch (t) {
            throw this.renderPreviewEntryError("Error in beforeAll hook:", t), t;
        }
    }
    async getStoryIndexFromServer() {
        let e = await Fi(Ii);
        if (e.status === 200) return e.json();
        throw new (0, _previewErrors.StoryIndexFetchError)({
            text: await e.text()
        });
    }
    // If initialization gets as far as the story index, this function runs.
    initializeWithStoryIndex(e) {
        if (!this.projectAnnotationsBeforeInitialization) throw new Error("Cannot call initializeWithStoryIndex until project annotations resolve");
        this.storyStoreValue = new Re(e, this.importFn, this.projectAnnotationsBeforeInitialization), delete this.projectAnnotationsBeforeInitialization, this.setInitialGlobals(), this.resolveStoreInitializationPromise();
    }
    async setInitialGlobals() {
        this.emitGlobals();
    }
    emitGlobals() {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "emitGlobals"
        });
        let e = {
            globals: this.storyStoreValue.userGlobals.get() || {},
            globalTypes: this.storyStoreValue.projectAnnotations.globalTypes || {}
        };
        this.channel.emit((0, _coreEvents.SET_GLOBALS), e);
    }
    // EVENT HANDLERS
    // This happens when a config file gets reloaded
    async onGetProjectAnnotationsChanged({ getProjectAnnotations: e }) {
        delete this.previewEntryError, this.getProjectAnnotations = e;
        let t = await this.getProjectAnnotationsOrRenderError();
        if (await this.runBeforeAllHook(t), !this.storyStoreValue) {
            await this.initializeWithProjectAnnotations(t);
            return;
        }
        this.storyStoreValue.setProjectAnnotations(t), this.emitGlobals();
    }
    async onStoryIndexChanged() {
        if (delete this.previewEntryError, !(!this.storyStoreValue && !this.projectAnnotationsBeforeInitialization)) try {
            let e = await this.getStoryIndexFromServer();
            if (this.projectAnnotationsBeforeInitialization) {
                this.initializeWithStoryIndex(e);
                return;
            }
            await this.onStoriesChanged({
                storyIndex: e
            });
        } catch (e) {
            throw this.renderPreviewEntryError("Error loading story index:", e), e;
        }
    }
    // This happens when a glob gets HMR-ed
    async onStoriesChanged({ importFn: e, storyIndex: t }) {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "onStoriesChanged"
        });
        await this.storyStoreValue.onStoriesChanged({
            importFn: e,
            storyIndex: t
        });
    }
    async onUpdateGlobals({ globals: e, currentStory: t }) {
        if (this.storyStoreValue || await this.storeInitializationPromise, !this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "onUpdateGlobals"
        });
        if (this.storyStoreValue.userGlobals.update(e), t) {
            let { initialGlobals: o, storyGlobals: n, userGlobals: i, globals: a } = this.storyStoreValue.getStoryContext(t);
            this.channel.emit((0, _coreEvents.GLOBALS_UPDATED), {
                initialGlobals: o,
                userGlobals: i,
                storyGlobals: n,
                globals: a
            });
        } else {
            let { initialGlobals: o, globals: n } = this.storyStoreValue.userGlobals;
            this.channel.emit((0, _coreEvents.GLOBALS_UPDATED), {
                initialGlobals: o,
                userGlobals: n,
                storyGlobals: {},
                globals: n
            });
        }
        await Promise.all(this.storyRenders.map((o)=>o.rerender()));
    }
    async onUpdateArgs({ storyId: e, updatedArgs: t }) {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "onUpdateArgs"
        });
        this.storyStoreValue.args.update(e, t), await Promise.all(this.storyRenders.filter((o)=>o.id === e && !o.renderOptions.forceInitialArgs).map((o)=>// We only run the play function, with in a force remount.
            // But when mount is destructured, the rendering happens inside of the play function.
            o.story && o.story.usesMount ? o.remount() : o.rerender())), this.channel.emit((0, _coreEvents.STORY_ARGS_UPDATED), {
            storyId: e,
            args: this.storyStoreValue.args.get(e)
        });
    }
    async onRequestArgTypesInfo({ id: e, payload: t }) {
        try {
            await this.storeInitializationPromise;
            let o = await this.storyStoreValue?.loadStory(t);
            this.channel.emit((0, _coreEvents.ARGTYPES_INFO_RESPONSE), {
                id: e,
                success: !0,
                payload: {
                    argTypes: o?.argTypes || {}
                },
                error: null
            });
        } catch (o) {
            this.channel.emit((0, _coreEvents.ARGTYPES_INFO_RESPONSE), {
                id: e,
                success: !1,
                error: o?.message
            });
        }
    }
    async onResetArgs({ storyId: e, argNames: t }) {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "onResetArgs"
        });
        let n = this.storyRenders.find((l)=>l.id === e)?.story || await this.storyStoreValue.loadStory({
            storyId: e
        }), a = (t || [
            .../* @__PURE__ */ new Set([
                ...Object.keys(n.initialArgs),
                ...Object.keys(this.storyStoreValue.args.get(e))
            ])
        ]).reduce((l, c)=>(l[c] = n.initialArgs[c], l), {});
        await this.onUpdateArgs({
            storyId: e,
            updatedArgs: a
        });
    }
    // ForceReRender does not include a story id, so we simply must
    // re-render all stories in case they are relevant
    async onForceReRender() {
        await Promise.all(this.storyRenders.map((e)=>e.rerender()));
    }
    async onForceRemount({ storyId: e }) {
        await Promise.all(this.storyRenders.filter((t)=>t.id === e).map((t)=>t.remount()));
    }
    // Used by docs to render a story to a given element
    // Note this short-circuits the `prepare()` phase of the StoryRender,
    // main to be consistent with the previous behaviour. In the future,
    // we will change it to go ahead and load the story, which will end up being
    // "instant", although async.
    renderStoryToElement(e, t, o, n) {
        if (!this.renderToCanvas || !this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "renderStoryToElement"
        });
        let i = new ce(this.channel, this.storyStoreValue, this.renderToCanvas, o, e.id, "docs", n, e);
        return i.renderToElement(t), this.storyRenders.push(i), async ()=>{
            await this.teardownRender(i);
        };
    }
    async teardownRender(e, { viewModeChanged: t } = {}) {
        this.storyRenders = this.storyRenders.filter((o)=>o !== e), await e?.teardown?.({
            viewModeChanged: t
        });
    }
    // API
    async loadStory({ storyId: e }) {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "loadStory"
        });
        return this.storyStoreValue.loadStory({
            storyId: e
        });
    }
    getStoryContext(e, { forceInitialArgs: t = !1 } = {}) {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "getStoryContext"
        });
        return this.storyStoreValue.getStoryContext(e, {
            forceInitialArgs: t
        });
    }
    async extract(e) {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "extract"
        });
        if (this.previewEntryError) throw this.previewEntryError;
        return await this.storyStoreValue.cacheAllCSFFiles(), this.storyStoreValue.extract(e);
    }
    // UTILITIES
    renderPreviewEntryError(e, t) {
        this.previewEntryError = t, (0, _clientLogger.logger).error(e), (0, _clientLogger.logger).error(t), this.channel.emit((0, _coreEvents.CONFIG_ERROR), t);
    }
};
s(rt, "Preview");
var xe = rt;
// ../node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var Oi = !1, tt = "Invariant failed";
function or(r, e) {
    if (!r) {
        if (Oi) throw new Error(tt);
        var t = typeof e == "function" ? e() : e, o = t ? "".concat(tt, ": ").concat(t) : tt;
        throw new Error(o);
    }
}
s(or, "invariant");
var ot = class ot {
    constructor(e, t, o, n){
        this.channel = e;
        this.store = t;
        this.renderStoryToElement = o;
        this.storyIdByName = /* @__PURE__ */ s((e)=>{
            let t = this.nameToStoryId.get(e);
            if (t) return t;
            throw new Error(`No story found with that name: ${e}`);
        }, "storyIdByName");
        this.componentStories = /* @__PURE__ */ s(()=>this.componentStoriesValue, "componentStories");
        this.componentStoriesFromCSFFile = /* @__PURE__ */ s((e)=>this.store.componentStoriesFromCSFFile({
                csfFile: e
            }), "componentStoriesFro\
mCSFFile");
        this.storyById = /* @__PURE__ */ s((e)=>{
            if (!e) {
                if (!this.primaryStory) throw new Error("No primary story defined for docs entry. Did you forget to use `<Meta>`?");
                return this.primaryStory;
            }
            let t = this.storyIdToCSFFile.get(e);
            if (!t) throw new Error(`Called \`storyById\` for story that was never loaded: ${e}`);
            return this.store.storyFromCSFFile({
                storyId: e,
                csfFile: t
            });
        }, "storyById");
        this.getStoryContext = /* @__PURE__ */ s((e)=>({
                ...this.store.getStoryContext(e),
                loaded: {},
                viewMode: "docs"
            }), "getStoryContext");
        this.loadStory = /* @__PURE__ */ s((e)=>this.store.loadStory({
                storyId: e
            }), "loadStory");
        this.componentStoriesValue = [], this.storyIdToCSFFile = /* @__PURE__ */ new Map(), this.exportToStory = /* @__PURE__ */ new Map(), this.exportsToCSFFile = /* @__PURE__ */ new Map(), this.nameToStoryId = /* @__PURE__ */ new Map(), this.attachedCSFFiles = /* @__PURE__ */ new Set(), n.forEach((i, a)=>{
            this.referenceCSFFile(i);
        });
    }
    // This docs entry references this CSF file and can synchronously load the stories, as well
    // as reference them by module export. If the CSF is part of the "component" stories, they
    // can also be referenced by name and are in the componentStories list.
    referenceCSFFile(e) {
        this.exportsToCSFFile.set(e.moduleExports, e), this.exportsToCSFFile.set(e.moduleExports.default, e), this.store.componentStoriesFromCSFFile({
            csfFile: e
        }).forEach((o)=>{
            let n = e.stories[o.id];
            this.storyIdToCSFFile.set(n.id, e), this.exportToStory.set(n.moduleExport, o);
        });
    }
    attachCSFFile(e) {
        if (!this.exportsToCSFFile.has(e.moduleExports)) throw new Error("Cannot attach a CSF file that has not been referenced");
        if (this.attachedCSFFiles.has(e)) return;
        this.attachedCSFFiles.add(e), this.store.componentStoriesFromCSFFile({
            csfFile: e
        }).forEach((o)=>{
            this.nameToStoryId.set(o.name, o.id), this.componentStoriesValue.push(o), this.primaryStory || (this.primaryStory = o);
        });
    }
    referenceMeta(e, t) {
        let o = this.resolveModuleExport(e);
        if (o.type !== "meta") throw new Error("<Meta of={} /> must reference a CSF file module export or meta export. Did you mistakenly reference your component instead of your \
CSF file?");
        t && this.attachCSFFile(o.csfFile);
    }
    get projectAnnotations() {
        let { projectAnnotations: e } = this.store;
        if (!e) throw new Error("Can't get projectAnnotations from DocsContext before they are initialized");
        return e;
    }
    resolveAttachedModuleExportType(e) {
        if (e === "story") {
            if (!this.primaryStory) throw new Error("No primary story attached to this docs file, did you forget to use <Meta of={} />?");
            return {
                type: "story",
                story: this.primaryStory
            };
        }
        if (this.attachedCSFFiles.size === 0) throw new Error("No CSF file attached to this docs file, did you forget to use <Meta of={} />?");
        let t = Array.from(this.attachedCSFFiles)[0];
        if (e === "meta") return {
            type: "meta",
            csfFile: t
        };
        let { component: o } = t.meta;
        if (!o) throw new Error("Attached CSF file does not defined a component, did you forget to export one?");
        return {
            type: "component",
            component: o
        };
    }
    resolveModuleExport(e) {
        let t = this.exportsToCSFFile.get(e);
        if (t) return {
            type: "meta",
            csfFile: t
        };
        let o = this.exportToStory.get((0, _csf.isStory)(e) ? e.input : e);
        return o ? {
            type: "story",
            story: o
        } : {
            type: "component",
            component: e
        };
    }
    resolveOf(e, t = []) {
        let o;
        if ([
            "component",
            "meta",
            "story"
        ].includes(e)) {
            let n = e;
            o = this.resolveAttachedModuleExportType(n);
        } else o = this.resolveModuleExport(e);
        if (t.length && !t.includes(o.type)) {
            let n = o.type === "component" ? "component or unknown" : o.type;
            throw new Error(P`Invalid value passed to the 'of' prop. The value was resolved to a '${n}' type but the only types for this block are: ${t.join(", ")}.
        - Did you pass a component to the 'of' prop when the block only supports a story or a meta?
        - ... or vice versa?
        - Did you pass a story, CSF file or meta to the 'of' prop that is not indexed, ie. is not targeted by the 'stories' globs in the main configuration?`);
        }
        switch(o.type){
            case "component":
                return {
                    ...o,
                    projectAnnotations: this.projectAnnotations
                };
            case "meta":
                return {
                    ...o,
                    preparedMeta: this.store.preparedMetaFromCSFFile({
                        csfFile: o.csfFile
                    })
                };
            case "story":
            default:
                return o;
        }
    }
};
s(ot, "DocsContext");
var re = ot;
// src/preview-api/modules/preview-web/render/CsfDocsRender.ts
var nt = class nt {
    constructor(e, t, o, n){
        this.channel = e;
        this.store = t;
        this.entry = o;
        this.callbacks = n;
        this.type = "docs";
        this.subtype = "csf";
        this.torndown = !1;
        this.disableKeyListeners = !1;
        this.preparing = !1;
        this.id = o.id;
    }
    isPreparing() {
        return this.preparing;
    }
    async prepare() {
        this.preparing = !0;
        let { entryExports: e, csfFiles: t = [] } = await this.store.loadEntry(this.id);
        if (this.torndown) throw ee;
        let { importPath: o, title: n } = this.entry, i = this.store.processCSFFileWithCache(e, o, n), a = Object.keys(i.stories)[0];
        this.story = this.store.storyFromCSFFile({
            storyId: a,
            csfFile: i
        }), this.csfFiles = [
            i,
            ...t
        ], this.preparing = !1;
    }
    isEqual(e) {
        return !!(this.id === e.id && this.story && this.story === e.story);
    }
    docsContext(e) {
        if (!this.csfFiles) throw new Error("Cannot render docs before preparing");
        let t = new re(this.channel, this.store, e, this.csfFiles);
        return this.csfFiles.forEach((o)=>t.attachCSFFile(o)), t;
    }
    async renderToElement(e, t) {
        if (!this.story || !this.csfFiles) throw new Error("Cannot render docs before preparing");
        let o = this.docsContext(t), { docs: n } = this.story.parameters || {};
        if (!n) throw new Error("Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed");
        let i = await n.renderer(), { render: a } = i, l = /* @__PURE__ */ s(async ()=>{
            try {
                await a(o, n, e), this.channel.emit((0, _coreEvents.DOCS_RENDERED), this.id);
            } catch (c) {
                this.callbacks.showException(c);
            }
        }, "renderDocs");
        return this.rerender = async ()=>l(), this.teardownRender = async ({ viewModeChanged: c })=>{
            !c || !e || i.unmount(e);
        }, l();
    }
    async teardown({ viewModeChanged: e } = {}) {
        this.teardownRender?.({
            viewModeChanged: e
        }), this.torndown = !0;
    }
};
s(nt, "CsfDocsRender");
var qe = nt;
var st = class st {
    constructor(e, t, o, n){
        this.channel = e;
        this.store = t;
        this.entry = o;
        this.callbacks = n;
        this.type = "docs";
        this.subtype = "mdx";
        this.torndown = !1;
        this.disableKeyListeners = !1;
        this.preparing = !1;
        this.id = o.id;
    }
    isPreparing() {
        return this.preparing;
    }
    async prepare() {
        this.preparing = !0;
        let { entryExports: e, csfFiles: t = [] } = await this.store.loadEntry(this.id);
        if (this.torndown) throw ee;
        this.csfFiles = t, this.exports = e, this.preparing = !1;
    }
    isEqual(e) {
        return !!(this.id === e.id && this.exports && this.exports === e.exports);
    }
    docsContext(e) {
        if (!this.csfFiles) throw new Error("Cannot render docs before preparing");
        return new re(this.channel, this.store, e, this.csfFiles);
    }
    async renderToElement(e, t) {
        if (!this.exports || !this.csfFiles || !this.store.projectAnnotations) throw new Error("Cannot render docs before preparing");
        let o = this.docsContext(t), { docs: n } = this.store.projectAnnotations.parameters || {};
        if (!n) throw new Error("Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed");
        let i = {
            ...n,
            page: this.exports.default
        }, a = await n.renderer(), { render: l } = a, c = /* @__PURE__ */ s(async ()=>{
            try {
                await l(o, i, e), this.channel.emit((0, _coreEvents.DOCS_RENDERED), this.id);
            } catch (d) {
                this.callbacks.showException(d);
            }
        }, "renderDocs");
        return this.rerender = async ()=>c(), this.teardownRender = async ({ viewModeChanged: d } = {})=>{
            !d || !e || (a.unmount(e), this.torndown = !0);
        }, c();
    }
    async teardown({ viewModeChanged: e } = {}) {
        this.teardownRender?.({
            viewModeChanged: e
        }), this.torndown = !0;
    }
};
s(st, "MdxDocsRender");
var Ue = st;
// src/preview-api/modules/preview-web/PreviewWithSelection.tsx
var Ki = globalThis;
function Xi(r) {
    let e = r.composedPath && r.composedPath()[0] || r.target;
    return /input|textarea/i.test(e.tagName) || e.getAttribute("contenteditable") !== null;
}
s(Xi, "focusInInput");
var Go = "attached-mdx", Ji = "unattached-mdx";
function Qi({ tags: r }) {
    return r?.includes(Ji) || r?.includes(Go);
}
s(Qi, "isMdxEntry");
function at(r) {
    return r.type === "story";
}
s(at, "isStoryRender");
function Zi(r) {
    return r.type === "docs";
}
s(Zi, "isDocsRender");
function ea(r) {
    return Zi(r) && r.subtype === "csf";
}
s(ea, "isCsfDocsRender");
var lt = class lt extends xe {
    constructor(t, o, n, i){
        super(t, o, void 0, !1);
        this.importFn = t;
        this.getProjectAnnotations = o;
        this.selectionStore = n;
        this.view = i;
        this.initialize();
    }
    setupListeners() {
        super.setupListeners(), Ki.onkeydown = this.onKeydown.bind(this), this.channel.on((0, _coreEvents.SET_CURRENT_STORY), this.onSetCurrentStory.bind(this)), this.channel.on((0, _coreEvents.UPDATE_QUERY_PARAMS), this.onUpdateQueryParams.bind(this)), this.channel.on((0, _coreEvents.PRELOAD_ENTRIES), this.onPreloadStories.bind(this));
    }
    async setInitialGlobals() {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "setInitialGlobals"
        });
        let { globals: t } = this.selectionStore.selectionSpecifier || {};
        t && this.storyStoreValue.userGlobals.updateFromPersisted(t), this.emitGlobals();
    }
    // If initialization gets as far as the story index, this function runs.
    async initializeWithStoryIndex(t) {
        return await super.initializeWithStoryIndex(t), this.selectSpecifiedStory();
    }
    // Use the selection specifier to choose a story, then render it
    async selectSpecifiedStory() {
        if (!this.storyStoreValue) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "selectSpecifiedStory"
        });
        if (this.selectionStore.selection) {
            await this.renderSelection();
            return;
        }
        if (!this.selectionStore.selectionSpecifier) {
            this.renderMissingStory();
            return;
        }
        let { storySpecifier: t, args: o } = this.selectionStore.selectionSpecifier, n = this.storyStoreValue.storyIndex.entryFromSpecifier(t);
        if (!n) {
            t === "*" ? this.renderStoryLoadingException(t, new (0, _previewErrors.EmptyIndexError)()) : this.renderStoryLoadingException(t, new (0, _previewErrors.NoStoryMatchError)({
                storySpecifier: t.toString()
            }));
            return;
        }
        let { id: i, type: a } = n;
        this.selectionStore.setSelection({
            storyId: i,
            viewMode: a
        }), this.channel.emit((0, _coreEvents.STORY_SPECIFIED), this.selectionStore.selection), this.channel.emit((0, _coreEvents.CURRENT_STORY_WAS_SET), this.selectionStore.selection), await this.renderSelection({
            persistedArgs: o
        });
    }
    // EVENT HANDLERS
    // This happens when a config file gets reloaded
    async onGetProjectAnnotationsChanged({ getProjectAnnotations: t }) {
        await super.onGetProjectAnnotationsChanged({
            getProjectAnnotations: t
        }), this.selectionStore.selection && this.renderSelection();
    }
    // This happens when a glob gets HMR-ed
    async onStoriesChanged({ importFn: t, storyIndex: o }) {
        await super.onStoriesChanged({
            importFn: t,
            storyIndex: o
        }), this.selectionStore.selection ? await this.renderSelection() : await this.selectSpecifiedStory();
    }
    onKeydown(t) {
        if (!this.storyRenders.find((o)=>o.disableKeyListeners) && !Xi(t)) {
            let { altKey: o, ctrlKey: n, metaKey: i, shiftKey: a, key: l, code: c, keyCode: d } = t;
            this.channel.emit((0, _coreEvents.PREVIEW_KEYDOWN), {
                event: {
                    altKey: o,
                    ctrlKey: n,
                    metaKey: i,
                    shiftKey: a,
                    key: l,
                    code: c,
                    keyCode: d
                }
            });
        }
    }
    async onSetCurrentStory(t) {
        this.selectionStore.setSelection({
            viewMode: "story",
            ...t
        }), await this.storeInitializationPromise, this.channel.emit((0, _coreEvents.CURRENT_STORY_WAS_SET), this.selectionStore.selection), this.renderSelection();
    }
    onUpdateQueryParams(t) {
        this.selectionStore.setQueryParams(t);
    }
    async onUpdateGlobals({ globals: t }) {
        let o = this.currentRender instanceof ce && this.currentRender.story || void 0;
        super.onUpdateGlobals({
            globals: t,
            currentStory: o
        }), (this.currentRender instanceof Ue || this.currentRender instanceof qe) && await this.currentRender.rerender?.();
    }
    async onUpdateArgs({ storyId: t, updatedArgs: o }) {
        super.onUpdateArgs({
            storyId: t,
            updatedArgs: o
        });
    }
    async onPreloadStories({ ids: t }) {
        await this.storeInitializationPromise, this.storyStoreValue && await Promise.allSettled(t.map((o)=>this.storyStoreValue?.loadEntry(o)));
    }
    // RENDERING
    // We can either have:
    // - a story selected in "story" viewMode,
    //     in which case we render it to the root element, OR
    // - a story selected in "docs" viewMode,
    //     in which case we render the docsPage for that story
    async renderSelection({ persistedArgs: t } = {}) {
        let { renderToCanvas: o } = this;
        if (!this.storyStoreValue || !o) throw new (0, _previewErrors.CalledPreviewMethodBeforeInitializationError)({
            methodName: "renderSelection"
        });
        let { selection: n } = this.selectionStore;
        if (!n) throw new Error("Cannot call renderSelection as no selection was made");
        let { storyId: i } = n, a;
        try {
            a = await this.storyStoreValue.storyIdToEntry(i);
        } catch (m) {
            this.currentRender && await this.teardownRender(this.currentRender), this.renderStoryLoadingException(i, m);
            return;
        }
        let l = this.currentSelection?.storyId !== i, c = this.currentRender?.type !== a.type;
        a.type === "story" ? this.view.showPreparingStory({
            immediate: c
        }) : this.view.showPreparingDocs({
            immediate: c
        }), this.currentRender?.isPreparing() && await this.teardownRender(this.currentRender);
        let d;
        a.type === "story" ? d = new ce(this.channel, this.storyStoreValue, o, this.mainStoryCallbacks(i), i, "story") : Qi(a) ? d = new Ue(this.channel, this.storyStoreValue, a, this.mainStoryCallbacks(i)) : d = new qe(this.channel, this.storyStoreValue, a, this.mainStoryCallbacks(i));
        let p = this.currentSelection;
        this.currentSelection = n;
        let u = this.currentRender;
        this.currentRender = d;
        try {
            await d.prepare();
        } catch (m) {
            u && await this.teardownRender(u), m !== ee && this.renderStoryLoadingException(i, m);
            return;
        }
        let y = !l && u && !d.isEqual(u);
        if (t && at(d) && (or(!!d.story), this.storyStoreValue.args.updateFromPersisted(d.story, t)), u && !u.torndown && !l && !y && !c) {
            this.currentRender = u, this.channel.emit((0, _coreEvents.STORY_UNCHANGED), i), this.view.showMain();
            return;
        }
        if (u && await this.teardownRender(u, {
            viewModeChanged: c
        }), p && (l || c) && this.channel.emit((0, _coreEvents.STORY_CHANGED), i), at(d)) {
            or(!!d.story);
            let { parameters: m, initialArgs: g, argTypes: S, unmappedArgs: h, initialGlobals: E, userGlobals: R, storyGlobals: f, globals: b } = this.storyStoreValue.getStoryContext(d.story);
            this.channel.emit((0, _coreEvents.STORY_PREPARED), {
                id: i,
                parameters: m,
                initialArgs: g,
                argTypes: S,
                args: h
            }), this.channel.emit((0, _coreEvents.GLOBALS_UPDATED), {
                userGlobals: R,
                storyGlobals: f,
                globals: b,
                initialGlobals: E
            });
        } else {
            let { parameters: m } = this.storyStoreValue.projectAnnotations, { initialGlobals: g, globals: S } = this.storyStoreValue.userGlobals;
            if (this.channel.emit((0, _coreEvents.GLOBALS_UPDATED), {
                globals: S,
                initialGlobals: g,
                storyGlobals: {},
                userGlobals: S
            }), ea(d) || d.entry.tags?.includes(Go)) {
                if (!d.csfFiles) throw new (0, _previewErrors.MdxFileWithNoCsfReferencesError)({
                    storyId: i
                });
                ({ parameters: m } = this.storyStoreValue.preparedMetaFromCSFFile({
                    csfFile: d.csfFiles[0]
                }));
            }
            this.channel.emit((0, _coreEvents.DOCS_PREPARED), {
                id: i,
                parameters: m
            });
        }
        at(d) ? (or(!!d.story), this.storyRenders.push(d), this.currentRender.renderToElement(this.view.prepareForStory(d.story))) : this.currentRender.renderToElement(this.view.prepareForDocs(), // This argument is used for docs, which is currently only compatible with HTMLElements
        this.renderStoryToElement.bind(this));
    }
    async teardownRender(t, { viewModeChanged: o = !1 } = {}) {
        this.storyRenders = this.storyRenders.filter((n)=>n !== t), await t?.teardown?.({
            viewModeChanged: o
        });
    }
    // UTILITIES
    mainStoryCallbacks(t) {
        return {
            showStoryDuringRender: /* @__PURE__ */ s(()=>this.view.showStoryDuringRender(), "showStoryDuringRender"),
            showMain: /* @__PURE__ */ s(()=>this.view.showMain(), "showMain"),
            showError: /* @__PURE__ */ s((o)=>this.renderError(t, o), "showError"),
            showException: /* @__PURE__ */ s((o)=>this.renderException(t, o), "showException")
        };
    }
    renderPreviewEntryError(t, o) {
        super.renderPreviewEntryError(t, o), this.view.showErrorDisplay(o);
    }
    renderMissingStory() {
        this.view.showNoPreview(), this.channel.emit((0, _coreEvents.STORY_MISSING));
    }
    renderStoryLoadingException(t, o) {
        (0, _clientLogger.logger).error(o), this.view.showErrorDisplay(o), this.channel.emit((0, _coreEvents.STORY_MISSING), t);
    }
    // renderException is used if we fail to render the story and it is uncaught by the app layer
    renderException(t, o) {
        let { name: n = "Error", message: i = String(o), stack: a } = o;
        this.channel.emit((0, _coreEvents.STORY_THREW_EXCEPTION), {
            name: n,
            message: i,
            stack: a
        }), this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
            newPhase: "errored",
            storyId: t
        }), this.view.showErrorDisplay(o), (0, _clientLogger.logger).error(`Error rendering story '${t}':`), (0, _clientLogger.logger).error(o);
    }
    // renderError is used by the various app layers to inform the user they have done something
    // wrong -- for instance returned the wrong thing from a story
    renderError(t, { title: o, description: n }) {
        (0, _clientLogger.logger).error(`Error rendering story ${o}: ${n}`), this.channel.emit((0, _coreEvents.STORY_ERRORED), {
            title: o,
            description: n
        }), this.channel.emit((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), {
            newPhase: "er\
rored",
            storyId: t
        }), this.view.showErrorDisplay({
            message: o,
            stack: n
        });
    }
};
s(lt, "PreviewWithSelection");
var we = lt;
// src/preview-api/modules/preview-web/UrlStore.ts
var Be = he(cr(), 1);
var en = he(cr(), 1);
var Zo = /^[a-zA-Z0-9 _-]*$/, rn = /^-?[0-9]+(\.[0-9]+)?$/, Ca = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i, tn = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i, ht = /* @__PURE__ */ s((r = "", e)=>r === null || r === "" || !Zo.test(r) ? !1 : e == null || e instanceof Date || typeof e == "number" || typeof e == "boolean" ? !0 : typeof e == "string" ? Zo.test(e) || rn.test(e) || Ca.test(e) || tn.test(e) : Array.isArray(e) ? e.every((t)=>ht(r, t)) : L(e) ? Object.entries(e).every(([t, o])=>ht(t, o)) : !1, "validateArgs"), Pa = {
    delimiter: ";",
    // we're parsing a single query param
    nesting: !0,
    arrayRepeat: !0,
    arrayRepeatSyntax: "bracket",
    nestingSyntax: "js",
    // objects are encoded using dot notation
    valueDeserializer (r) {
        if (r.startsWith("!")) {
            if (r === "!undefined") return;
            if (r === "!null") return null;
            if (r === "!true") return !0;
            if (r === "!false") return !1;
            if (r.startsWith("!date(") && r.endsWith(")")) return new Date(r.replaceAll(" ", "+").slice(6, -1));
            if (r.startsWith("!hex(") && r.endsWith(")")) return `#${r.slice(5, -1)}`;
            let e = r.slice(1).match(tn);
            if (e) return r.startsWith("!rgba") || r.startsWith("!RGBA") ? `${e[1]}(${e[2]}, ${e[3]}, ${e[4]}, ${e[5]})` : r.startsWith("!hsla") || r.startsWith("!HSLA") ? `${e[1]}(${e[2]}, ${e[3]}%, ${e[4]}%, ${e[5]})` : r.startsWith("!rgb") || r.startsWith("!RGB") ? `${e[1]}(${e[2]}, ${e[3]}\
, ${e[4]})` : `${e[1]}(${e[2]}, ${e[3]}%, ${e[4]}%)`;
        }
        return rn.test(r) ? Number(r) : r;
    }
}, mt = /* @__PURE__ */ s((r)=>{
    let e = r.split(";").map((t)=>t.replace("=", "~").replace(":", "="));
    return Object.entries((0, en.parse)(e.join(";"), Pa)).reduce((t, [o, n])=>ht(o, n) ? Object.assign(t, {
            [o]: n
        }) : ((0, _clientLogger.once).warn(P`
      Omitted potentially unsafe URL args.

      More info: https://storybook.js.org/docs/writing-stories/args#setting-args-through-the-url
    `), t), {});
}, "parseArgsParam");
// src/preview-api/modules/preview-web/UrlStore.ts
var { history: on, document: te } = I;
function Fa(r) {
    let e = (r || "").match(/^\/story\/(.+)/);
    if (!e) throw new Error(`Invalid path '${r}',  must start with '/story/'`);
    return e[1];
}
s(Fa, "pathToId");
var nn = /* @__PURE__ */ s(({ selection: r, extraParams: e })=>{
    let t = te?.location.search.slice(1), { path: o, selectedKind: n, selectedStory: i, ...a } = (0, Be.parse)(t);
    return `?${(0, Be.stringify)({
        ...a,
        ...e,
        ...r && {
            id: r.storyId,
            viewMode: r.viewMode
        }
    })}`;
}, "getQueryString"), Ia = /* @__PURE__ */ s((r)=>{
    if (!r) return;
    let e = nn({
        selection: r
    }), { hash: t = "" } = te.location;
    te.title = r.storyId, on.replaceState({}, "", `${te.location.pathname}${e}${t}`);
}, "setPath"), Oa = /* @__PURE__ */ s((r)=>r != null && typeof r == "object" && Array.isArray(r) === !1, "isObject"), Ge = /* @__PURE__ */ s((r)=>{
    if (r !== void 0) {
        if (typeof r == "string") return r;
        if (Array.isArray(r)) return Ge(r[0]);
        if (Oa(r)) return Ge(Object.values(r).filter(Boolean));
    }
}, "getFirstString"), Da = /* @__PURE__ */ s(()=>{
    if (typeof te < "u") {
        let r = te.location.search.slice(1), e = (0, Be.parse)(r), t = typeof e.args == "string" ? mt(e.args) : void 0, o = typeof e.globals == "\
string" ? mt(e.globals) : void 0, n = Ge(e.viewMode);
        (typeof n != "string" || !n.match(/docs|story/)) && (n = "story");
        let i = Ge(e.path), a = i ? Fa(i) : Ge(e.id);
        if (a) return {
            storySpecifier: a,
            args: t,
            globals: o,
            viewMode: n
        };
    }
    return null;
}, "getSelectionSpecifierFromPath"), gt = class gt {
    constructor(){
        this.selectionSpecifier = Da();
    }
    setSelection(e) {
        this.selection = e, Ia(this.selection);
    }
    setQueryParams(e) {
        let t = nn({
            extraParams: e
        }), { hash: o = "" } = te.location;
        on.replaceState({}, "", `${te.location.pathname}${t}${o}`);
    }
};
s(gt, "UrlStore");
var ve = gt;
// src/preview-api/modules/preview-web/WebView.ts
var Mn = he(jn(), 1), _n = he(cr(), 1);
var { document: j } = I, Ln = 100, qn = /* @__PURE__ */ ((i)=>(i.MAIN = "MAIN", i.NOPREVIEW = "NOPREVIEW", i.PREPARING_STORY = "PREPARING_\
STORY", i.PREPARING_DOCS = "PREPARING_DOCS", i.ERROR = "ERROR", i))(qn || {}), wt = {
    PREPARING_STORY: "sb-show-preparing-story",
    PREPARING_DOCS: "sb-show-preparing-docs",
    MAIN: "sb-show-main",
    NOPREVIEW: "sb-show-nopreview",
    ERROR: "sb-show-errordisplay"
}, vt = {
    centered: "sb-main-centered",
    fullscreen: "sb-main-fullscreen",
    padded: "sb-main-padded"
}, Nn = new Mn.default({
    escapeXML: !0
}), At = class At {
    constructor(){
        this.testing = !1;
        if (typeof j < "u") {
            let { __SPECIAL_TEST_PARAMETER__: e } = (0, _n.parse)(j.location.search.slice(1));
            switch(e){
                case "preparing-story":
                    this.showPreparingStory(), this.testing = !0;
                    break;
                case "preparing-docs":
                    this.showPreparingDocs(), this.testing = !0;
                    break;
                default:
            }
        }
    }
    // Get ready to render a story, returning the element to render to
    prepareForStory(e) {
        return this.showStory(), this.applyLayout(e.parameters.layout), j.documentElement.scrollTop = 0, j.documentElement.scrollLeft = 0, this.storyRoot();
    }
    storyRoot() {
        return j.getElementById("storybook-root");
    }
    prepareForDocs() {
        return this.showMain(), this.showDocs(), this.applyLayout("fullscreen"), j.documentElement.scrollTop = 0, j.documentElement.scrollLeft = 0, this.docsRoot();
    }
    docsRoot() {
        return j.getElementById("storybook-docs");
    }
    applyLayout(e = "padded") {
        if (e === "none") {
            j.body.classList.remove(this.currentLayoutClass), this.currentLayoutClass = null;
            return;
        }
        this.checkIfLayoutExists(e);
        let t = vt[e];
        j.body.classList.remove(this.currentLayoutClass), j.body.classList.add(t), this.currentLayoutClass = t;
    }
    checkIfLayoutExists(e) {
        vt[e] || (0, _clientLogger.logger).warn(P`
          The desired layout: ${e} is not a valid option.
          The possible options are: ${Object.keys(vt).join(", ")}, none.
        `);
    }
    showMode(e) {
        clearTimeout(this.preparingTimeout), Object.keys(qn).forEach((t)=>{
            t === e ? j.body.classList.add(wt[t]) : j.body.classList.remove(wt[t]);
        });
    }
    showErrorDisplay({ message: e = "", stack: t = "" }) {
        let o = e, n = t, i = e.split(`
`);
        i.length > 1 && ([o] = i, n = i.slice(1).join(`
`).replace(/^\n/, "")), j.getElementById("error-message").innerHTML = Nn.toHtml(o), j.getElementById("error-stack").innerHTML = Nn.toHtml(n), this.showMode("ERROR");
    }
    showNoPreview() {
        this.testing || (this.showMode("NOPREVIEW"), this.storyRoot()?.setAttribute("hidden", "true"), this.docsRoot()?.setAttribute("hidden", "\
true"));
    }
    showPreparingStory({ immediate: e = !1 } = {}) {
        clearTimeout(this.preparingTimeout), e ? this.showMode("PREPARING_STORY") : this.preparingTimeout = setTimeout(()=>this.showMode("PREPARING_STORY"), Ln);
    }
    showPreparingDocs({ immediate: e = !1 } = {}) {
        clearTimeout(this.preparingTimeout), e ? this.showMode("PREPARING_DOCS") : this.preparingTimeout = setTimeout(()=>this.showMode("PREPA\
RING_DOCS"), Ln);
    }
    showMain() {
        this.showMode("MAIN");
    }
    showDocs() {
        this.storyRoot().setAttribute("hidden", "true"), this.docsRoot().removeAttribute("hidden");
    }
    showStory() {
        this.docsRoot().setAttribute("hidden", "true"), this.storyRoot().removeAttribute("hidden");
    }
    showStoryDuringRender() {
        j.body.classList.add(wt.MAIN);
    }
};
s(At, "WebView");
var Ae = At;
// src/preview-api/modules/preview-web/PreviewWeb.tsx
var Ct = class Ct extends we {
    constructor(t, o){
        super(t, o, new ve(), new Ae());
        this.importFn = t;
        this.getProjectAnnotations = o;
        I.__STORYBOOK_PREVIEW__ = this;
    }
};
s(Ct, "PreviewWeb");
var gr = Ct;
// src/preview-api/modules/preview-web/simulate-pageload.ts
var { document: fe } = I, yl = [
    "application/javascript",
    "application/ecmascript",
    "application/x-ecmascript",
    "application/x-javascript",
    "text/ecmascript",
    "text/javascript",
    "text/javascript1.0",
    "text/javascript1.1",
    "text/javascript1.2",
    "text/javascript1.3",
    "text/javascript1.4",
    "text/javascript1.5",
    "text/jscript",
    "text/livescript",
    "text/x-ecmascript",
    "text/x-javascript",
    // Support modern javascript
    "module"
], hl = "script", Un = "scripts-root";
function Sr() {
    let r = fe.createEvent("Event");
    r.initEvent("DOMContentLoaded", !0, !0), fe.dispatchEvent(r);
}
s(Sr, "simulateDOMContentLoaded");
function ml(r, e, t) {
    let o = fe.createElement("script");
    o.type = r.type === "module" ? "module" : "text/javascript", r.src ? (o.onload = e, o.onerror = e, o.src = r.src) : o.textContent = r.innerText, t ? t.appendChild(o) : fe.head.appendChild(o), r.parentNode.removeChild(r), r.src || e();
}
s(ml, "insertScript");
function Gn(r, e, t = 0) {
    r[t](()=>{
        t++, t === r.length ? e() : Gn(r, e, t);
    });
}
s(Gn, "insertScriptsSequentially");
function Bn(r) {
    let e = fe.getElementById(Un);
    e ? e.innerHTML = "" : (e = fe.createElement("div"), e.id = Un, fe.body.appendChild(e));
    let t = Array.from(r.querySelectorAll(hl));
    if (t.length) {
        let o = [];
        t.forEach((n)=>{
            let i = n.getAttribute("type");
            (!i || yl.includes(i)) && o.push((a)=>ml(n, a, e));
        }), o.length && Gn(o, Sr, void 0);
    } else Sr();
}
s(Bn, "simulatePageLoad");

},{"9a66d1ff730df16a":"2zU6h","@storybook/core/channels":"9x1cJ","@storybook/core/client-logger":"a4BZx","@storybook/core/core-events":"l8kjz","@storybook/core/preview-api":"fer43","@storybook/core/preview-errors":"aVzSh","@storybook/core/csf":"cm2lZ","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"aVzSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalledExtractOnStoreError", ()=>L);
parcelHelpers.export(exports, "CalledPreviewMethodBeforeInitializationError", ()=>Y);
parcelHelpers.export(exports, "Category", ()=>se);
parcelHelpers.export(exports, "EmptyIndexError", ()=>F);
parcelHelpers.export(exports, "ImplicitActionsDuringRendering", ()=>j);
parcelHelpers.export(exports, "MdxFileWithNoCsfReferencesError", ()=>H);
parcelHelpers.export(exports, "MissingRenderToCanvasError", ()=>G);
parcelHelpers.export(exports, "MissingStoryAfterHmrError", ()=>D);
parcelHelpers.export(exports, "MissingStoryFromCsfFileError", ()=>X);
parcelHelpers.export(exports, "MountMustBeDestructuredError", ()=>J);
parcelHelpers.export(exports, "NextJsSharpError", ()=>B);
parcelHelpers.export(exports, "NextjsRouterMocksNotAvailable", ()=>Q);
parcelHelpers.export(exports, "NoRenderFunctionError", ()=>q);
parcelHelpers.export(exports, "NoStoryMatchError", ()=>K);
parcelHelpers.export(exports, "NoStoryMountedError", ()=>z);
parcelHelpers.export(exports, "StoryIndexFetchError", ()=>M);
parcelHelpers.export(exports, "StoryStoreAccessedBeforeInitializationError", ()=>U);
parcelHelpers.export(exports, "UnknownArgTypesError", ()=>Z);
parcelHelpers.export(exports, "UnsupportedViewportDimensionError", ()=>ee);
var oe = Object.defineProperty;
var t = (u, n)=>oe(u, "name", {
        value: n,
        configurable: !0
    });
// ../node_modules/ts-dedent/esm/index.js
function r(u) {
    for(var n = [], e = 1; e < arguments.length; e++)n[e - 1] = arguments[e];
    var a = Array.from(typeof u == "string" ? [
        u
    ] : u);
    a[a.length - 1] = a[a.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var g = a.reduce(function(i, m) {
        var y = m.match(/\n([\t ]+|(?!\s).)/g);
        return y ? i.concat(y.map(function(E) {
            var l, d;
            return (d = (l = E.match(/[\t ]/g)) === null || l === void 0 ? void 0 : l.length) !== null && d !== void 0 ? d : 0;
        })) : i;
    }, []);
    if (g.length) {
        var h = new RegExp(`
[	 ]{` + Math.min.apply(Math, g) + "}", "g");
        a = a.map(function(i) {
            return i.replace(h, `
`);
        });
    }
    a[0] = a[0].replace(/^\r?\n/, "");
    var c = a[0];
    return n.forEach(function(i, m) {
        var y = c.match(/(?:^|\n)( *)$/), E = y ? y[1] : "", l = i;
        typeof i == "string" && i.includes(`
`) && (l = String(i).split(`
`).map(function(d, te) {
            return te === 0 ? d : "" + E + d;
        }).join(`
`)), c += l + a[m + 1];
    }), c;
}
t(r, "dedent");
// src/storybook-error.ts
function C({ code: u, category: n }) {
    let e = String(u).padStart(4, "0");
    return `SB_${n}_${e}`;
}
t(C, "parseErrorCode");
var p = class p extends Error {
    constructor(e){
        super(p.getFullMessage(e));
        /**
     * Data associated with the error. Used to provide additional information in the error message or
     * to be passed to telemetry.
     */ this.data = {};
        /** Flag used to easily determine if the error originates from Storybook. */ this.fromStorybook = !0;
        this.category = e.category, this.documentation = e.documentation ?? !1, this.code = e.code;
    }
    get fullErrorCode() {
        return C({
            code: this.code,
            category: this.category
        });
    }
    /** Overrides the default `Error.name` property in the format: SB_<CATEGORY>_<CODE>. */ get name() {
        let e = this.constructor.name;
        return `${this.fullErrorCode} (${e})`;
    }
    /** Generates the error message along with additional documentation link (if applicable). */ static getFullMessage({ documentation: e, code: a, category: g, message: h }) {
        let c;
        return e === !0 ? c = `https://storybook.js.org/error/${C({
            code: a,
            category: g
        })}` : typeof e == "string" ? c = e : Array.isArray(e) && (c = `
${e.map((i)=>`	- ${i}`).join(`
`)}`), `${h}${c != null ? `

More info: ${c}
` : ""}`;
    }
};
t(p, "StorybookError");
var o = p;
// src/preview-errors.ts
var se = /* @__PURE__ */ ((s)=>(s.BLOCKS = "BLOCKS", s.DOCS_TOOLS = "DOCS-TOOLS", s.PREVIEW_CLIENT_LOGGER = "PREVIEW_CLIENT-LOGGER", s.PREVIEW_CHANNELS = "PREVIEW_CHANNELS", s.PREVIEW_CORE_EVENTS = "PREVIEW_CORE-EVENTS", s.PREVIEW_INSTRUMENTER = "PREVIEW_INSTRUMENTER", s.PREVIEW_API = "PREVIEW\
_API", s.PREVIEW_REACT_DOM_SHIM = "PREVIEW_REACT-DOM-SHIM", s.PREVIEW_ROUTER = "PREVIEW_ROUTER", s.PREVIEW_THEMING = "PREVIEW_THEMING", s.RENDERER_HTML = "RENDERER_HTML", s.RENDERER_PREACT = "RENDERER_PREACT", s.RENDERER_REACT = "RENDERER_REACT", s.RENDERER_SERVER = "RENDERER_SERVER", s.RENDERER_SVELTE = "RENDERER_SVELTE", s.RENDERER_VUE = "RENDERER_VUE", s.RENDERER_VUE3 = "RENDERER_VUE3", s.RENDERER_WEB_COMPONENTS = "RENDERER_WEB-COMPONENTS", s.FRAMEWORK_NEXTJS = "FRAMEWORK_NEXTJS", s.ADDON_VITEST = "ADDON_VITEST", s))(se || {}), f = class f extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 1,
            message: r`
        Couldn't find story matching id '${e.storyId}' after HMR.
        - Did you just rename a story?
        - Did you remove it from your CSF file?
        - Are you sure a story with the id '${e.storyId}' exists?
        - Please check the values in the stories field of your main.js config and see if they would match your CSF File.
        - Also check the browser console and terminal for potential error messages.`
        });
        this.data = e;
    }
};
t(f, "MissingStoryAfterHmrError");
var D = f, R = class R extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 2,
            documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#using-implicit-actions-during-rendering-is-deprecated-\
for-example-in-the-play-function",
            message: r`
        We detected that you use an implicit action arg while ${e.phase} of your story.  
        ${e.deprecated ? `
This is deprecated and won't work in Storybook 8 anymore.
` : ""}
        Please provide an explicit spy to your args like this:
          import { fn } from '@storybook/test';
          ... 
          args: {
           ${e.name}: fn()
          }`
        });
        this.data = e;
    }
};
t(R, "ImplicitActionsDuringRendering");
var j = R, b = class b extends o {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 3,
            message: r`
        Cannot call \`storyStore.extract()\` without calling \`storyStore.cacheAllCsfFiles()\` first.

        You probably meant to call \`await preview.extract()\` which does the above for you.`
        });
    }
};
t(b, "CalledExtractOnStoreError");
var L = b, I = class I extends o {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 4,
            message: r`
        Expected your framework's preset to export a \`renderToCanvas\` field.

        Perhaps it needs to be upgraded for Storybook 7.0?`,
            documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#mainjs-framework-field"
        });
    }
};
t(I, "MissingRenderToCanvasError");
var G = I, P = class P extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 5,
            message: r`
        Called \`Preview.${e.methodName}()\` before initialization.
        
        The preview needs to load the story index before most methods can be called. If you want
        to call \`${e.methodName}\`, try \`await preview.initializationPromise;\` first.
        
        If you didn't call the above code, then likely it was called by an addon that needs to
        do the above.`
        });
        this.data = e;
    }
};
t(P, "CalledPreviewMethodBeforeInitializationError");
var Y = P, x = class x extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 6,
            message: r`
        Error fetching \`/index.json\`:
        
        ${e.text}

        If you are in development, this likely indicates a problem with your Storybook process,
        check the terminal for errors.

        If you are in a deployed Storybook, there may have been an issue deploying the full Storybook
        build.`
        });
        this.data = e;
    }
};
t(x, "StoryIndexFetchError");
var M = x, T = class T extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 7,
            message: r`
        Tried to render docs entry ${e.storyId} but it is a MDX file that has no CSF
        references, or autodocs for a CSF file that some doesn't refer to itself.
        
        This likely is an internal error in Storybook's indexing, or you've attached the
        \`attached-mdx\` tag to an MDX file that is not attached.`
        });
        this.data = e;
    }
};
t(T, "MdxFileWithNoCsfReferencesError");
var H = T, w = class w extends o {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 8,
            message: r`
        Couldn't find any stories in your Storybook.

        - Please check your stories field of your main.js config: does it match correctly?
        - Also check the browser console and terminal for error messages.`
        });
    }
};
t(w, "EmptyIndexError");
var F = w, k = class k extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 9,
            message: r`
        Couldn't find story matching '${e.storySpecifier}'.

        - Are you sure a story with that id exists?
        - Please check your stories field of your main.js config.
        - Also check the browser console and terminal for error messages.`
        });
        this.data = e;
    }
};
t(k, "NoStoryMatchError");
var K = k, S = class S extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 10,
            message: r`
        Couldn't find story matching id '${e.storyId}' after importing a CSF file.

        The file was indexed as if the story was there, but then after importing the file in the browser
        we didn't find the story. Possible reasons:
        - You are using a custom story indexer that is misbehaving.
        - You have a custom file loader that is removing or renaming exports.

        Please check your browser console and terminal for errors that may explain the issue.`
        });
        this.data = e;
    }
};
t(S, "MissingStoryFromCsfFileError");
var X = S, v = class v extends o {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 11,
            message: r`
        Cannot access the Story Store until the index is ready.

        It is not recommended to use methods directly on the Story Store anyway, in Storybook 9 we will
        remove access to the store entirely`
        });
    }
};
t(v, "StoryStoreAccessedBeforeInitializationError");
var U = v, _ = class _ extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 12,
            message: r`
      Incorrect use of mount in the play function.
      
      To use mount in the play function, you must satisfy the following two requirements: 
      
      1. You *must* destructure the mount property from the \`context\` (the argument passed to your play function). 
         This makes sure that Storybook does not start rendering the story before the play function begins.
      
      2. Your Storybook framework or builder must be configured to transpile to ES2017 or newer. 
         This is because destructuring statements and async/await usages are otherwise transpiled away, 
         which prevents Storybook from recognizing your usage of \`mount\`.
      
      Note that Angular is not supported. As async/await is transpiled to support the zone.js polyfill. 
      
      More info: https://storybook.js.org/docs/writing-tests/interaction-testing#run-code-before-the-component-gets-rendered
      
      Received the following play function:
      ${e.playFunction}`
        });
        this.data = e;
    }
};
t(_, "MountMustBeDestructuredError");
var J = _, V = class V extends o {
    constructor(e){
        super({
            category: "PREVIEW_API",
            code: 14,
            message: r`
        No render function available for storyId '${e.id}'
      `
        });
        this.data = e;
    }
};
t(V, "NoRenderFunctionError");
var q = V, N = class N extends o {
    constructor(){
        super({
            category: "PREVIEW_API",
            code: 15,
            message: r`
        No component is mounted in your story.
        
        This usually occurs when you destructure mount in the play function, but forget to call it.
        
        For example:

        async play({ mount, canvasElement }) {
          // 👈 mount should be called: await mount(); 
          const canvas = within(canvasElement);
          const button = await canvas.findByRole('button');
          await userEvent.click(button);
        };

        Make sure to either remove it or call mount in your play function.
      `
        });
    }
};
t(N, "NoStoryMountedError");
var z = N, A = class A extends o {
    constructor(){
        super({
            category: "FRAMEWORK_NEXTJS",
            code: 1,
            documentation: "https://storybook.js.org/docs/get-started/nextjs#faq",
            message: r`
      You are importing avif images, but you don't have sharp installed.

      You have to install sharp in order to use image optimization features in Next.js.
      `
        });
    }
};
t(A, "NextJsSharpError");
var B = A, W = class W extends o {
    constructor(e){
        super({
            category: "FRAMEWORK_NEXTJS",
            code: 2,
            message: r`
        Tried to access router mocks from "${e.importType}" but they were not created yet. You might be running code in an unsupported environment.
      `
        });
        this.data = e;
    }
};
t(W, "NextjsRouterMocksNotAvailable");
var Q = W, $ = class $ extends o {
    constructor(e){
        super({
            category: "DOCS-TOOLS",
            code: 1,
            documentation: "https://github.com/storybookjs/storybook/issues/26606",
            message: r`
        There was a failure when generating detailed ArgTypes in ${e.language} for:
        ${JSON.stringify(e.type, null, 2)} 
        
        Storybook will fall back to use a generic type description instead.

        This type is either not supported or it is a bug in the docgen generation in Storybook.
        If you think this is a bug, please detail it as much as possible in the Github issue.
      `
        });
        this.data = e;
    }
};
t($, "UnknownArgTypesError");
var Z = $, O = class O extends o {
    constructor(e){
        super({
            category: "ADDON_VITEST",
            code: 1,
            // TODO: Add documentation about viewports support
            // documentation: '',
            message: r`
        Encountered an unsupported value "${e.value}" when setting the viewport ${e.dimension} dimension.
        
        The Storybook plugin only supports values in the following units:
        - px, vh, vw, em, rem and %.
        
        You can either change the viewport for this story to use one of the supported units or skip the test by adding '!test' to the story's tags per https://storybook.js.org/docs/writing-stories/tags
      `
        });
        this.data = e;
    }
};
t(O, "UnsupportedViewportDimensionError");
var ee = O;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"cm2lZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__definePreview", ()=>L);
parcelHelpers.export(exports, "combineTags", ()=>oe);
parcelHelpers.export(exports, "includeConditionalArg", ()=>z);
parcelHelpers.export(exports, "isExportStory", ()=>te);
parcelHelpers.export(exports, "isMeta", ()=>H);
parcelHelpers.export(exports, "isPreview", ()=>W);
parcelHelpers.export(exports, "isStory", ()=>K);
parcelHelpers.export(exports, "parseKind", ()=>ne);
parcelHelpers.export(exports, "sanitize", ()=>D);
parcelHelpers.export(exports, "storyNameFromExport", ()=>re);
parcelHelpers.export(exports, "toId", ()=>ee);
// src/csf/csf-factories.ts
var _previewApi = require("@storybook/core/preview-api");
var b = Object.create;
var f = Object.defineProperty;
var v = Object.getOwnPropertyDescriptor;
var P = Object.getOwnPropertyNames;
var O = Object.getPrototypeOf, _ = Object.prototype.hasOwnProperty;
var s = (e, r)=>f(e, "name", {
        value: r,
        configurable: !0
    });
var $ = (e, r)=>()=>(r || e((r = {
            exports: {}
        }).exports, r), r.exports);
var j = (e, r, t, n)=>{
    if (r && typeof r == "object" || typeof r == "function") for (let a of P(r))!_.call(e, a) && a !== t && f(e, a, {
        get: ()=>r[a],
        enumerable: !(n = v(r, a)) || n.enumerable
    });
    return e;
};
var C = (e, r, t)=>(t = e != null ? b(O(e)) : {}, j(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    r || !e || !e.__esModule ? f(t, "default", {
        value: e,
        enumerable: !0
    }) : t, e));
// ../node_modules/@ngard/tiny-isequal/index.js
var T = $((g)=>{
    Object.defineProperty(g, "__esModule", {
        value: !0
    }), g.isEqual = /* @__PURE__ */ function() {
        var e = Object.prototype.toString, r = Object.getPrototypeOf, t = Object.getOwnPropertySymbols ? function(n) {
            return Object.keys(n).concat(Object.getOwnPropertySymbols(n));
        } : Object.keys;
        return function(n, a) {
            return /* @__PURE__ */ s(function d(o, i, p) {
                var c, u, l, m = e.call(o), h = e.call(i);
                if (o === i) return !0;
                if (o == null || i == null) return !1;
                if (p.indexOf(o) > -1 && p.indexOf(i) > -1) return !0;
                if (p.push(o, i), m != h || (c = t(o), u = t(i), c.length != u.length || c.some(function(A) {
                    return !d(o[A], i[A], p);
                }))) return !1;
                switch(m.slice(8, -1)){
                    case "Symbol":
                        return o.valueOf() == i.valueOf();
                    case "Date":
                    case "Number":
                        return +o == +i || +o != +o && +i != +i;
                    case "RegExp":
                    case "Function":
                    case "String":
                    case "Boolean":
                        return "" + o == "" + i;
                    case "Set":
                    case "Map":
                        c = o.entries(), u = i.entries();
                        do if (!d((l = c.next()).value, u.next().value, p)) return !1;
                        while (!l.done);
                        return !0;
                    case "ArrayBuffer":
                        o = new Uint8Array(o), i = new Uint8Array(i);
                    case "DataView":
                        o = new Uint8Array(o.buffer), i = new Uint8Array(i.buffer);
                    case "Float32Array":
                    case "Float64Array":
                    case "Int8Array":
                    case "Int16Array":
                    case "Int32Array":
                    case "Uint8Array":
                    case "Uint16Array":
                    case "Uint32Array":
                    case "Uint8ClampedArray":
                    case "Arguments":
                    case "Array":
                        if (o.length != i.length) return !1;
                        for(l = 0; l < o.length; l++)if ((l in o || l in i) && (l in o != l in i || !d(o[l], i[l], p))) return !1;
                        return !0;
                    case "Object":
                        return d(r(o), r(i), p);
                    default:
                        return !1;
                }
            }, "n")(n, a, []);
        };
    }();
});
// src/csf/toStartCaseStr.ts
function R(e) {
    return e.replace(/_/g, " ").replace(/-/g, " ").replace(/\./g, " ").replace(/([^\n])([A-Z])([a-z])/g, (r, t, n, a)=>`${t} ${n}${a}`).replace(/([a-z])([A-Z])/g, (r, t, n)=>`${t} ${n}`).replace(/([a-z])([0-9])/gi, (r, t, n)=>`${t} ${n}`).replace(/([0-9])([a-z])/gi, (r, t, n)=>`${t}\
 ${n}`).replace(/(\s|^)(\w)/g, (r, t, n)=>`${t}${n.toUpperCase()}`).replace(/ +/g, " ").trim();
}
s(R, "toStartCaseStr");
// src/csf/includeConditionalArg.ts
var y = C(T(), 1);
var x = /* @__PURE__ */ s((e)=>e.map((r)=>typeof r < "u").filter(Boolean).length, "count"), E = /* @__PURE__ */ s((e, r)=>{
    let { exists: t, eq: n, neq: a, truthy: d } = e;
    if (x([
        t,
        n,
        a,
        d
    ]) > 1) throw new Error(`Invalid conditional test ${JSON.stringify({
        exists: t,
        eq: n,
        neq: a
    })}`);
    if (typeof n < "u") return (0, y.isEqual)(r, n);
    if (typeof a < "u") return !(0, y.isEqual)(r, a);
    if (typeof t < "u") {
        let i = typeof r < "u";
        return t ? i : !i;
    }
    return (typeof d > "u" ? !0 : d) ? !!r : !r;
}, "testValue"), z = /* @__PURE__ */ s((e, r, t)=>{
    if (!e.if) return !0;
    let { arg: n, global: a } = e.if;
    if (x([
        n,
        a
    ]) !== 1) throw new Error(`Invalid conditional value ${JSON.stringify({
        arg: n,
        global: a
    })}`);
    let d = n ? r[n] : t[a];
    return E(e.if, d);
}, "includeConditionalArg");
function L(e) {
    let r, t = {
        _tag: "Preview",
        input: e,
        get composed () {
            if (r) return r;
            let { addons: n, ...a } = e;
            return r = (0, _previewApi.normalizeProjectAnnotations)((0, _previewApi.composeConfigs)([
                ...n ?? [],
                a
            ])), r;
        },
        meta (n) {
            return I(n, this);
        }
    };
    return globalThis.globalProjectAnnotations = t.composed, t;
}
s(L, "__definePreview");
function W(e) {
    return e != null && typeof e == "object" && "_tag" in e && e?._tag === "Preview";
}
s(W, "isPreview");
function H(e) {
    return e != null && typeof e == "object" && "_tag" in e && e?._tag === "Meta";
}
s(H, "isMeta");
function I(e, r) {
    return {
        _tag: "Meta",
        input: e,
        preview: r,
        get composed () {
            throw new Error("Not implemented");
        },
        story (t) {
            return U(t, this);
        }
    };
}
s(I, "defineMeta");
function U(e, r) {
    return {
        _tag: "Story",
        input: e,
        meta: r,
        get composed () {
            throw new Error("Not implemented");
        }
    };
}
s(U, "defineStory");
function K(e) {
    return e != null && typeof e == "object" && "_tag" in e && e?._tag === "Story";
}
s(K, "isStory");
// src/csf/index.ts
var D = /* @__PURE__ */ s((e)=>e.toLowerCase().replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(/-+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), "sanitize"), w = /* @__PURE__ */ s((e, r)=>{
    let t = D(e);
    if (t === "") throw new Error(`Invalid ${r} '${e}', must include alphanumeric characters`);
    return t;
}, "sanitizeSafe"), ee = /* @__PURE__ */ s((e, r)=>`${w(e, "kind")}${r ? `--${w(r, "name")}` : ""}`, "toId"), re = /* @__PURE__ */ s((e)=>R(e), "storyNameFromExport");
function S(e, r) {
    return Array.isArray(r) ? r.includes(e) : e.match(r);
}
s(S, "matches");
function te(e, { includeStories: r, excludeStories: t }) {
    return(// https://babeljs.io/docs/en/babel-plugin-transform-modules-commonjs
    e !== "__esModule" && (!r || S(e, r)) && (!t || !S(e, t)));
}
s(te, "isExportStory");
var ne = /* @__PURE__ */ s((e, { rootSeparator: r, groupSeparator: t })=>{
    let [n, a] = e.split(r, 2), d = (a || e).split(t).filter((o)=>!!o);
    return {
        root: a ? n : null,
        groups: d
    };
}, "parseKind"), oe = /* @__PURE__ */ s((...e)=>{
    let r = e.reduce((t, n)=>(n.startsWith("!") ? t.delete(n.slice(1)) : t.add(n), t), /* @__PURE__ */ new Set());
    return Array.from(r);
}, "combineTags");

},{"@storybook/core/preview-api":"fer43","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"5mm0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _csf = require("@storybook/core/csf");
parcelHelpers.exportAll(_csf, exports);

},{"@storybook/core/csf":"cm2lZ","@parcel/transformer-js/src/esmodule-helpers.js":"9qIL3"}],"gLGvH":[function(require,module,exports,__globalThis) {
module.exports = {
    "./.storybook-s2/docs/Illustrations.mdx": ()=>require("6fd4c1611e610586"),
    "./.storybook-s2/docs/Intro.mdx": ()=>require("672a168d60c3268c"),
    "./.storybook-s2/docs/Migrating.mdx": ()=>require("628ef28423b99f8e"),
    "./.storybook-s2/docs/Release Notes.mdx": ()=>require("a2564e0c6c3f5ff3"),
    "./.storybook-s2/docs/Style Macro.mdx": ()=>require("347b9750cb43a61d"),
    "./.storybook-s2/docs/Workflow Icons.mdx": ()=>require("dab699a26216f380")
};

},{"6fd4c1611e610586":"18kNC","672a168d60c3268c":"adgAx","628ef28423b99f8e":"2MAk6","a2564e0c6c3f5ff3":"izaGO","347b9750cb43a61d":"4r4lr","dab699a26216f380":"29fKF"}],"18kNC":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("1N7Yh"),
    import("eVFEQ"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("4kJA5"),
    import("dkGXP"),
    import("9GPwr"),
    import("fb6xm"),
    import("lsVUB"),
    import("6Bmr9"),
    import("eSmDe"),
    require("666edb92b794fd99")(import.meta.resolve("ez92l")),
    require("666edb92b794fd99")(import.meta.resolve("jy2eV")),
    import("1PqQ3"),
    import("U1YYk")
]).then(()=>module.bundle.root('cNzHU'));

},{"666edb92b794fd99":"3hgb7"}],"3hgb7":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"hPTAq"}],"hPTAq":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"adgAx":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ecAGW"),
    import("3yxaM"),
    require("4803d7876e75bec7")(import.meta.resolve("iZMZT")),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("eSmDe"),
    require("4803d7876e75bec7")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("1oUFE")
]).then(()=>module.bundle.root('cAPr7'));

},{"4803d7876e75bec7":"3hgb7"}],"2MAk6":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("a7857b84fef41b90")(import.meta.resolve("bw4WD")),
    import("46OkM"),
    import("aC5QK"),
    import("eSmDe"),
    require("a7857b84fef41b90")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("2vs7f")
]).then(()=>module.bundle.root('cWn61'));

},{"a7857b84fef41b90":"3hgb7"}],"izaGO":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("d7b7ebea4e7d45b8")(import.meta.resolve("hBntf")),
    import("46OkM"),
    import("aC5QK"),
    import("eSmDe"),
    require("d7b7ebea4e7d45b8")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("7lVLZ")
]).then(()=>module.bundle.root('hsCzK'));

},{"d7b7ebea4e7d45b8":"3hgb7"}],"4r4lr":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("4044a8ab6a6478dd")(import.meta.resolve("2aNW9")),
    import("42AF2"),
    import("extYs"),
    require("4044a8ab6a6478dd")(import.meta.resolve("9JJAv")),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("4044a8ab6a6478dd")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("6trK8")
]).then(()=>module.bundle.root('8e1Y0'));

},{"4044a8ab6a6478dd":"3hgb7"}],"29fKF":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("44851da66bae3884")(import.meta.resolve("g54L6")),
    require("44851da66bae3884")(import.meta.resolve("2aNW9")),
    import("42AF2"),
    import("extYs"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("44851da66bae3884")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("9v3rx")
]).then(()=>module.bundle.root('9UZaV'));

},{"44851da66bae3884":"3hgb7"}],"cW8jp":[function(require,module,exports,__globalThis) {
module.exports = {
    "./packages/@react-spectrum/s2/stories/Accordion.stories.tsx": ()=>require("3e3a191d9a233fc5"),
    "./packages/@react-spectrum/s2/stories/ActionBar.stories.tsx": ()=>require("858d32612e3ab996"),
    "./packages/@react-spectrum/s2/stories/ActionButton.stories.tsx": ()=>require("559fa0e4572f6827"),
    "./packages/@react-spectrum/s2/stories/ActionButtonGroup.stories.tsx": ()=>require("a26eada2604ceef3"),
    "./packages/@react-spectrum/s2/stories/ActionMenu.stories.tsx": ()=>require("d2c18ed58e52e3e6"),
    "./packages/@react-spectrum/s2/stories/AlertDialog.stories.tsx": ()=>require("8f9cc7a9ff4ef934"),
    "./packages/@react-spectrum/s2/stories/Avatar.stories.tsx": ()=>require("e6ed20a9f73f0ae6"),
    "./packages/@react-spectrum/s2/stories/AvatarGroup.stories.tsx": ()=>require("7daade50a96b36c4"),
    "./packages/@react-spectrum/s2/stories/Badge.stories.tsx": ()=>require("91569fb83153691a"),
    "./packages/@react-spectrum/s2/stories/Breadcrumbs.stories.tsx": ()=>require("b307980bf41ced8e"),
    "./packages/@react-spectrum/s2/stories/Button.stories.tsx": ()=>require("9eb91cc6b9642ffb"),
    "./packages/@react-spectrum/s2/stories/ButtonGroup.stories.tsx": ()=>require("e52c32fab1188579"),
    "./packages/@react-spectrum/s2/stories/Calendar.stories.tsx": ()=>require("73476a073bbddef8"),
    "./packages/@react-spectrum/s2/stories/Card.stories.tsx": ()=>require("a63228a5dd7dcc24"),
    "./packages/@react-spectrum/s2/stories/CardView.stories.tsx": ()=>require("9a814990f1d051dd"),
    "./packages/@react-spectrum/s2/stories/Checkbox.stories.tsx": ()=>require("5d5e03265df7b524"),
    "./packages/@react-spectrum/s2/stories/CheckboxGroup.stories.tsx": ()=>require("ee74e1fe02ab76a6"),
    "./packages/@react-spectrum/s2/stories/CoachMark.stories.tsx": ()=>require("ee9a22ccca54bbb"),
    "./packages/@react-spectrum/s2/stories/ColorArea.stories.tsx": ()=>require("8837141acf086cd3"),
    "./packages/@react-spectrum/s2/stories/ColorField.stories.tsx": ()=>require("cf0c4a797fcad87e"),
    "./packages/@react-spectrum/s2/stories/ColorSlider.stories.tsx": ()=>require("d04d32246b27c190"),
    "./packages/@react-spectrum/s2/stories/ColorSwatch.stories.tsx": ()=>require("3492cc2fc5d806dc"),
    "./packages/@react-spectrum/s2/stories/ColorSwatchPicker.stories.tsx": ()=>require("b48caca3bee3eda9"),
    "./packages/@react-spectrum/s2/stories/ColorWheel.stories.tsx": ()=>require("6fb190985a638060"),
    "./packages/@react-spectrum/s2/stories/ComboBox.stories.tsx": ()=>require("8ba0c0cb7ef9899a"),
    "./packages/@react-spectrum/s2/stories/ContextualHelp.stories.tsx": ()=>require("e060aa697fc1b262"),
    "./packages/@react-spectrum/s2/stories/CustomDialog.stories.tsx": ()=>require("5870fd69ae69039"),
    "./packages/@react-spectrum/s2/stories/DateField.stories.tsx": ()=>require("5533ca6612fb9527"),
    "./packages/@react-spectrum/s2/stories/DatePicker.stories.tsx": ()=>require("3f6af4df525436c6"),
    "./packages/@react-spectrum/s2/stories/DateRangePicker.stories.tsx": ()=>require("fbd4119e9a4852f7"),
    "./packages/@react-spectrum/s2/stories/Dialog.stories.tsx": ()=>require("440b4b61cdc65f5a"),
    "./packages/@react-spectrum/s2/stories/Disclosure.stories.tsx": ()=>require("dfc3373ee80d02c4"),
    "./packages/@react-spectrum/s2/stories/Divider.stories.tsx": ()=>require("18ade2f5e3581187"),
    "./packages/@react-spectrum/s2/stories/DropZone.stories.tsx": ()=>require("d8bafb64be754f55"),
    "./packages/@react-spectrum/s2/stories/Form.stories.tsx": ()=>require("120cb0bfddf26c54"),
    "./packages/@react-spectrum/s2/stories/FullscreenDialog.stories.tsx": ()=>require("2983eea2ed4ede53"),
    "./packages/@react-spectrum/s2/stories/Icon.stories.tsx": ()=>require("fb5c2aad85c44249"),
    "./packages/@react-spectrum/s2/stories/IllustratedMessage.stories.tsx": ()=>require("1f1eebec4c0182c6"),
    "./packages/@react-spectrum/s2/stories/InlineAlert.stories.tsx": ()=>require("648f5029d5875ca7"),
    "./packages/@react-spectrum/s2/stories/Link.stories.tsx": ()=>require("ed521170024f201f"),
    "./packages/@react-spectrum/s2/stories/LinkButton.stories.tsx": ()=>require("38d2fe241cdf9d7c"),
    "./packages/@react-spectrum/s2/stories/Menu.stories.tsx": ()=>require("ec7cef84e3eee0e7"),
    "./packages/@react-spectrum/s2/stories/Meter.stories.tsx": ()=>require("84399978f30be460"),
    "./packages/@react-spectrum/s2/stories/NotificationBadge.stories.tsx": ()=>require("861f49d6b237ea03"),
    "./packages/@react-spectrum/s2/stories/NumberField.stories.tsx": ()=>require("c4a625edb90456b1"),
    "./packages/@react-spectrum/s2/stories/Picker.stories.tsx": ()=>require("bb6f42457299587e"),
    "./packages/@react-spectrum/s2/stories/Popover.stories.tsx": ()=>require("3121ed262a50c2a2"),
    "./packages/@react-spectrum/s2/stories/ProgressBar.stories.tsx": ()=>require("6ac38fb9bb898ef4"),
    "./packages/@react-spectrum/s2/stories/ProgressCircle.stories.tsx": ()=>require("3ff4349a1ec43655"),
    "./packages/@react-spectrum/s2/stories/RadioGroup.stories.tsx": ()=>require("59ac2670ced9c498"),
    "./packages/@react-spectrum/s2/stories/RangeCalendar.stories.tsx": ()=>require("37fdc6d80d804d0a"),
    "./packages/@react-spectrum/s2/stories/RangeSlider.stories.tsx": ()=>require("4bdcbdc0eae57e39"),
    "./packages/@react-spectrum/s2/stories/SearchField.stories.tsx": ()=>require("29781da5e151ecbf"),
    "./packages/@react-spectrum/s2/stories/SegmentedControl.stories.tsx": ()=>require("1827c15c86cf9672"),
    "./packages/@react-spectrum/s2/stories/SelectBoxGroup.stories.tsx": ()=>require("83d1f5565d870e79"),
    "./packages/@react-spectrum/s2/stories/Slider.stories.tsx": ()=>require("77e2b20274045963"),
    "./packages/@react-spectrum/s2/stories/StatusLight.stories.tsx": ()=>require("73acfdad624815b2"),
    "./packages/@react-spectrum/s2/stories/StyleMacro.stories.tsx": ()=>require("993af8f932e426ab"),
    "./packages/@react-spectrum/s2/stories/Switch.stories.tsx": ()=>require("9efec468bd269a66"),
    "./packages/@react-spectrum/s2/stories/TableView.stories.tsx": ()=>require("d8ee70234329fa91"),
    "./packages/@react-spectrum/s2/stories/Tabs.stories.tsx": ()=>require("b395d3abda2d12d2"),
    "./packages/@react-spectrum/s2/stories/TagGroup.stories.tsx": ()=>require("a3c00b1181c00db1"),
    "./packages/@react-spectrum/s2/stories/TextField.stories.tsx": ()=>require("54e74616414b65e0"),
    "./packages/@react-spectrum/s2/stories/TimeField.stories.tsx": ()=>require("53e89863b15d517b"),
    "./packages/@react-spectrum/s2/stories/Toast.stories.tsx": ()=>require("f9580a80e7586bd0"),
    "./packages/@react-spectrum/s2/stories/ToggleButton.stories.tsx": ()=>require("415abed3c793a729"),
    "./packages/@react-spectrum/s2/stories/ToggleButtonGroup.stories.tsx": ()=>require("11226d70c419abef"),
    "./packages/@react-spectrum/s2/stories/Tooltip.stories.tsx": ()=>require("55a465f81f328324"),
    "./packages/@react-spectrum/s2/stories/TreeView.stories.tsx": ()=>require("13dd802b86f66b78")
};

},{"3e3a191d9a233fc5":"inD8y","858d32612e3ab996":"43nMm","559fa0e4572f6827":"2x1G6","a26eada2604ceef3":"cLRRT","d2c18ed58e52e3e6":"4EVOu","8f9cc7a9ff4ef934":"4bROp","e6ed20a9f73f0ae6":"d5Qtz","7daade50a96b36c4":"jlg9F","91569fb83153691a":"2LH5z","b307980bf41ced8e":"dxvJn","9eb91cc6b9642ffb":"azrEM","e52c32fab1188579":"4B40N","73476a073bbddef8":"b7nCK","a63228a5dd7dcc24":"6oEZ0","9a814990f1d051dd":"lfunw","5d5e03265df7b524":"fGHM2","ee74e1fe02ab76a6":"8xamF","ee9a22ccca54bbb":"7IqYN","8837141acf086cd3":"cT2dY","cf0c4a797fcad87e":"3uclL","d04d32246b27c190":"l6btZ","3492cc2fc5d806dc":"ghNh3","b48caca3bee3eda9":"eBJRw","6fb190985a638060":"k8UkT","8ba0c0cb7ef9899a":"1ONJ0","e060aa697fc1b262":"86SKh","5870fd69ae69039":"bopGm","5533ca6612fb9527":"5kegR","3f6af4df525436c6":"er9Nh","fbd4119e9a4852f7":"fdQzh","440b4b61cdc65f5a":"h2Jup","dfc3373ee80d02c4":"6n9Yz","18ade2f5e3581187":"8K2Dy","d8bafb64be754f55":"2xG5y","120cb0bfddf26c54":"4LtqY","2983eea2ed4ede53":"3PB1k","fb5c2aad85c44249":"4pHkW","1f1eebec4c0182c6":"aL4Ud","648f5029d5875ca7":"b18s1","ed521170024f201f":"aeybw","38d2fe241cdf9d7c":"8vQya","ec7cef84e3eee0e7":"4YmYB","84399978f30be460":"7AQ7m","861f49d6b237ea03":"5UFdm","c4a625edb90456b1":"bSjBy","bb6f42457299587e":"k7BH1","3121ed262a50c2a2":"eqTpC","6ac38fb9bb898ef4":"dYOgm","3ff4349a1ec43655":"bgY8L","59ac2670ced9c498":"9hZXz","37fdc6d80d804d0a":"jCbdi","4bdcbdc0eae57e39":"4YZU7","29781da5e151ecbf":"4W7wA","1827c15c86cf9672":"1tUuD","83d1f5565d870e79":"knLPK","77e2b20274045963":"7N48L","73acfdad624815b2":"b1Etd","993af8f932e426ab":"j6g32","9efec468bd269a66":"65u1a","d8ee70234329fa91":"fysfO","b395d3abda2d12d2":"c0LRK","a3c00b1181c00db1":"3511L","54e74616414b65e0":"2cDCS","53e89863b15d517b":"7Ejta","f9580a80e7586bd0":"jgvFL","415abed3c793a729":"g9w1s","11226d70c419abef":"3rPw5","55a465f81f328324":"fnJuQ","13dd802b86f66b78":"hWCJt"}],"inD8y":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("extYs"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("b87d1eb6087c4701")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("fFXTU")
]).then(()=>module.bundle.root('lak5A'));

},{"b87d1eb6087c4701":"3hgb7"}],"43nMm":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("j2oFu"),
    import("9pZ01"),
    import("l7MuT"),
    import("j8Q5i"),
    import("iWqx8"),
    import("jO9Lo"),
    import("2xEKR"),
    import("iNVTJ"),
    import("ecAGW"),
    import("3yxaM"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("9GPwr"),
    import("eSmDe"),
    require("804ad8934ce8e195")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("dKzaA"),
    import("fMMO3")
]).then(()=>module.bundle.root('114kb'));

},{"804ad8934ce8e195":"3hgb7"}],"2x1G6":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("818600bcc4b709ae")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("erWNU")
]).then(()=>module.bundle.root('iGs4S'));

},{"818600bcc4b709ae":"3hgb7"}],"cLRRT":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("b81b2245b9ce6354")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("5n8Hx")
]).then(()=>module.bundle.root('5oaoS'));

},{"b81b2245b9ce6354":"3hgb7"}],"4EVOu":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("1e4c85aa99d3be0a")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("6ZVPf")
]).then(()=>module.bundle.root('2o5pQ'));

},{"1e4c85aa99d3be0a":"3hgb7"}],"4bROp":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("b4e6f8d7fac5d40b")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("h75zw")
]).then(()=>module.bundle.root('cYgH9'));

},{"b4e6f8d7fac5d40b":"3hgb7"}],"d5Qtz":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("eSmDe"),
    require("6ddf862631261b57")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("h9EvT")
]).then(()=>module.bundle.root('OpwD2'));

},{"6ddf862631261b57":"3hgb7"}],"jlg9F":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("eSmDe"),
    require("49035e3eb8bb77f6")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("cq9xx")
]).then(()=>module.bundle.root('hu8qE'));

},{"49035e3eb8bb77f6":"3hgb7"}],"2LH5z":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("6IbSZ"),
    import("aC5QK"),
    import("eSmDe"),
    require("a4ff80236fa4a8ac")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("7yki9")
]).then(()=>module.bundle.root('i6M0b'));

},{"a4ff80236fa4a8ac":"3hgb7"}],"dxvJn":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ecAGW"),
    import("3yxaM"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("db6517c3dfe5ea3a")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("lVY7O")
]).then(()=>module.bundle.root('3XpA0'));

},{"db6517c3dfe5ea3a":"3hgb7"}],"azrEM":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("24ed4ca5784cb57b")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("9pwRl")
]).then(()=>module.bundle.root('9UAM7'));

},{"24ed4ca5784cb57b":"3hgb7"}],"4B40N":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("eSmDe"),
    require("4938daf2a8abe741")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("6jNe4")
]).then(()=>module.bundle.root('cwjrt'));

},{"4938daf2a8abe741":"3hgb7"}],"b7nCK":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("5UqfF"),
    import("PRvrs"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("4e124a52d7b84cdf")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("M4WpA")
]).then(()=>module.bundle.root('7febw'));

},{"4e124a52d7b84cdf":"3hgb7"}],"6oEZ0":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("iNVTJ"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("dkGXP"),
    import("eSmDe"),
    require("a977059ecb158865")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("2trf6")
]).then(()=>module.bundle.root('a9mxv'));

},{"a977059ecb158865":"3hgb7"}],"lfunw":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("l7MuT"),
    import("j8Q5i"),
    import("iWqx8"),
    import("jO9Lo"),
    import("2xEKR"),
    import("iNVTJ"),
    import("ecAGW"),
    import("3yxaM"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("9GPwr"),
    import("eSmDe"),
    require("8b6dffeae36b62ac")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("dKzaA")
]).then(()=>module.bundle.root('aBlAi'));

},{"8b6dffeae36b62ac":"3hgb7"}],"fGHM2":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("3yxaM"),
    import("46OkM"),
    import("aC5QK"),
    import("eSmDe"),
    require("caa5dc2615ded39b")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("9hUsJ")
]).then(()=>module.bundle.root('cnDMi'));

},{"caa5dc2615ded39b":"3hgb7"}],"8xamF":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("6b1c6c01171a3ab6")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("49UDj")
]).then(()=>module.bundle.root('59c8k'));

},{"6b1c6c01171a3ab6":"3hgb7"}],"7IqYN":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("iOJfP"),
    import("dZxUL"),
    import("iNVTJ"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("39799bbb1270e3de")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("8CRjm")
]).then(()=>module.bundle.root('4cvHj'));

},{"39799bbb1270e3de":"3hgb7"}],"cT2dY":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("egodP"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("ed121e9260d0cf4e")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("c8LOX")
]).then(()=>module.bundle.root('kQBfJ'));

},{"ed121e9260d0cf4e":"3hgb7"}],"3uclL":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("c0r2J"),
    import("6RwW7"),
    import("egodP"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("8b371d3cedd0b42c")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("lwQiK")
]).then(()=>module.bundle.root('jPhIJ'));

},{"8b371d3cedd0b42c":"3hgb7"}],"l6btZ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("egodP"),
    import("iOJfP"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("af8283b5882d7948")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("7wxdP")
]).then(()=>module.bundle.root('aLU4G'));

},{"af8283b5882d7948":"3hgb7"}],"ghNh3":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("40736c58585be793")(import.meta.resolve("ez92l")),
    import("egodP"),
    import("eSmDe"),
    import("1PqQ3"),
    import("5Kzel")
]).then(()=>module.bundle.root('gW57M'));

},{"40736c58585be793":"3hgb7"}],"eBJRw":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("45f029f3a60511bc")(import.meta.resolve("ez92l")),
    import("egodP"),
    import("iWqx8"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("aC5QK"),
    import("aV5Au"),
    import("eSmDe"),
    import("1PqQ3"),
    import("akSws")
]).then(()=>module.bundle.root('2c6GJ'));

},{"45f029f3a60511bc":"3hgb7"}],"k8UkT":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("egodP"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("6be00d94992ad1e2")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("i0Bmj")
]).then(()=>module.bundle.root('6Dthq'));

},{"6be00d94992ad1e2":"3hgb7"}],"1ONJ0":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("l7MuT"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("b919552428373d6f")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("949Zj")
]).then(()=>module.bundle.root('5hpch'));

},{"b919552428373d6f":"3hgb7"}],"86SKh":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("874ec6d6cd62e690")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("4YbUL")
]).then(()=>module.bundle.root('aVzXo'));

},{"874ec6d6cd62e690":"3hgb7"}],"bopGm":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("i8j3z"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("lsVUB"),
    import("eSmDe"),
    require("37561dda3eb860f7")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("c4McR")
]).then(()=>module.bundle.root('bKv9Z'));

},{"37561dda3eb860f7":"3hgb7"}],"5kegR":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("jQrAp"),
    import("c0r2J"),
    import("5UqfF"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("68e602b733dbb58")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("cEeSB")
]).then(()=>module.bundle.root('kzIvR'));

},{"68e602b733dbb58":"3hgb7"}],"er9Nh":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ifFUB"),
    import("jQrAp"),
    import("c0r2J"),
    import("5UqfF"),
    import("PRvrs"),
    import("ehqbF"),
    import("emlxp"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("ab28ceee3cf28bf3")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("jszyi")
]).then(()=>module.bundle.root('81iDM'));

},{"ab28ceee3cf28bf3":"3hgb7"}],"fdQzh":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ifFUB"),
    import("jQrAp"),
    import("c0r2J"),
    import("5UqfF"),
    import("PRvrs"),
    import("ehqbF"),
    import("emlxp"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("4c0d94d1847b7af8")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("c7wRk")
]).then(()=>module.bundle.root('aEsmX'));

},{"4c0d94d1847b7af8":"3hgb7"}],"h2Jup":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("3yxaM"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("eSmDe"),
    require("4540681f234c77d3")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("kj5ye")
]).then(()=>module.bundle.root('hYYVS'));

},{"4540681f234c77d3":"3hgb7"}],"6n9Yz":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("extYs"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("232031f253351b16")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("9ZiR3")
]).then(()=>module.bundle.root('5g2MO'));

},{"232031f253351b16":"3hgb7"}],"8K2Dy":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("5c2974e49425cd7d")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("eyv9Y")
]).then(()=>module.bundle.root('CRHqC'));

},{"5c2974e49425cd7d":"3hgb7"}],"2xG5y":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("i8j3z"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("fb6xm"),
    import("eSmDe"),
    require("9f8b8f1a52e06430")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("lBVQv")
]).then(()=>module.bundle.root('kgMFp'));

},{"9f8b8f1a52e06430":"3hgb7"}],"4LtqY":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("jCJHq"),
    import("jJKJ6"),
    import("6RwW7"),
    import("egodP"),
    import("iOJfP"),
    import("ehqbF"),
    import("emlxp"),
    import("j8Q5i"),
    import("iWqx8"),
    import("jO9Lo"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("eVFEQ"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    require("611e2739fe52a")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("j3VWg")
]).then(()=>module.bundle.root('aKw0V'));

},{"611e2739fe52a":"3hgb7"}],"3PB1k":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("eSmDe"),
    require("b05a99e2274832d5")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("8ztsD")
]).then(()=>module.bundle.root('iMd2W'));

},{"b05a99e2274832d5":"3hgb7"}],"4pHkW":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("eSmDe"),
    require("f00cbb7f96c313bd")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("eYutL")
]).then(()=>module.bundle.root('fQrfd'));

},{"f00cbb7f96c313bd":"3hgb7"}],"aL4Ud":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("4kJA5"),
    import("eSmDe"),
    require("ca433666c6216191")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("jhDVZ")
]).then(()=>module.bundle.root('huHd8'));

},{"ca433666c6216191":"3hgb7"}],"b18s1":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("eSmDe"),
    require("c0414a2f36e12368")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("8GB3r")
]).then(()=>module.bundle.root('cQUyk'));

},{"c0414a2f36e12368":"3hgb7"}],"aeybw":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("bbfff95fed50c04b")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("1ZiHO")
]).then(()=>module.bundle.root('lwdbu'));

},{"bbfff95fed50c04b":"3hgb7"}],"8vQya":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("a386591f259016e2")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("9YXKl")
]).then(()=>module.bundle.root('bzyNl'));

},{"a386591f259016e2":"3hgb7"}],"4YmYB":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("271f206d70184a95")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("57RGp")
]).then(()=>module.bundle.root('4U383'));

},{"271f206d70184a95":"3hgb7"}],"7AQ7m":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("b7bc78198704419a")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("8qMlw")
]).then(()=>module.bundle.root('jIIcV'));

},{"b7bc78198704419a":"3hgb7"}],"5UFdm":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("b2d6ea7f80c1e571")(import.meta.resolve("ez92l")),
    import("8AwGi"),
    import("eSmDe"),
    import("1PqQ3"),
    import("6Rwkz")
]).then(()=>module.bundle.root('1dajx'));

},{"b2d6ea7f80c1e571":"3hgb7"}],"bSjBy":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("jJKJ6"),
    import("c0r2J"),
    import("6RwW7"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("de6b06078a900714")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("l2Qc6")
]).then(()=>module.bundle.root('4p8N0'));

},{"de6b06078a900714":"3hgb7"}],"k7BH1":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("l7MuT"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("15509d60d67b2502")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("3MPro")
]).then(()=>module.bundle.root('71gn5'));

},{"15509d60d67b2502":"3hgb7"}],"eqTpC":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("5y4kx"),
    import("2NqpY"),
    import("ehqbF"),
    import("iWqx8"),
    import("iNVTJ"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("f866a517b18cb77d")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("cCSkN")
]).then(()=>module.bundle.root('1OuLp'));

},{"f866a517b18cb77d":"3hgb7"}],"dYOgm":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("3c09523cc32c52dc")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("aTgyH")
]).then(()=>module.bundle.root('f4OI5'));

},{"3c09523cc32c52dc":"3hgb7"}],"bgY8L":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("899d53fb1199120b")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("2QbMR")
]).then(()=>module.bundle.root('5YGJy'));

},{"899d53fb1199120b":"3hgb7"}],"9hZXz":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("1N7Yh"),
    import("eVFEQ"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("81e7b216e278eaac")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("2dRF1")
]).then(()=>module.bundle.root('C8EWf'));

},{"81e7b216e278eaac":"3hgb7"}],"jCbdi":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("5UqfF"),
    import("PRvrs"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("16588aa9cb6352bc")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("lT7Ru")
]).then(()=>module.bundle.root('fM3Q8'));

},{"16588aa9cb6352bc":"3hgb7"}],"4YZU7":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("iOJfP"),
    import("dZxUL"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("d416cd3b3e1d8f0a")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("cByBv")
]).then(()=>module.bundle.root('e5jJ9'));

},{"d416cd3b3e1d8f0a":"3hgb7"}],"4W7wA":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("2NqpY"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("ae45edbe1a48875c")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("ep6MS")
]).then(()=>module.bundle.root('4AH6n'));

},{"ae45edbe1a48875c":"3hgb7"}],"1tUuD":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("j8Q5i"),
    import("6IbSZ"),
    import("46OkM"),
    import("aC5QK"),
    import("aV5Au"),
    import("eSmDe"),
    require("69d03097bf82a9ed")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("kprIR")
]).then(()=>module.bundle.root('1iUrt'));

},{"69d03097bf82a9ed":"3hgb7"}],"knLPK":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("iWqx8"),
    import("3yxaM"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("aC5QK"),
    import("aV5Au"),
    import("6Bmr9"),
    import("eSmDe"),
    require("866e2aa7f62c8666")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("5l06Y")
]).then(()=>module.bundle.root('cDjzq'));

},{"866e2aa7f62c8666":"3hgb7"}],"7N48L":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("iOJfP"),
    import("dZxUL"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("2e4b4eb9817eee38")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("6VQeS")
]).then(()=>module.bundle.root('5BOFA'));

},{"2e4b4eb9817eee38":"3hgb7"}],"b1Etd":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("6IbSZ"),
    import("aC5QK"),
    import("eSmDe"),
    require("29608612f69e8b38")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("9ptf9")
]).then(()=>module.bundle.root('eK8CY'));

},{"29608612f69e8b38":"3hgb7"}],"j6g32":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("46OkM"),
    import("aC5QK"),
    import("eSmDe"),
    require("dad054bceb0fe86")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("6hVHh")
]).then(()=>module.bundle.root('2pS6K'));

},{"dad054bceb0fe86":"3hgb7"}],"65u1a":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("46OkM"),
    import("aC5QK"),
    import("eSmDe"),
    require("607e0ee063485ae2")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("3LdmV")
]).then(()=>module.bundle.root('7aLsF'));

},{"607e0ee063485ae2":"3hgb7"}],"fysfO":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("9pZ01"),
    import("l7MuT"),
    import("j8Q5i"),
    import("iWqx8"),
    import("jO9Lo"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("9a9e264e195a6ec9")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("kQNKi")
]).then(()=>module.bundle.root('OD7ct'));

},{"9a9e264e195a6ec9":"3hgb7"}],"c0LRK":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("5y4kx"),
    import("ehqbF"),
    import("j8Q5i"),
    import("iWqx8"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("f3c8da3ed7a52f6e")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("ho3dA")
]).then(()=>module.bundle.root('4gD5Z'));

},{"f3c8da3ed7a52f6e":"3hgb7"}],"3511L":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("jCJHq"),
    import("iWqx8"),
    import("jO9Lo"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("99f6f6e55f62101f")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("iTBUv")
]).then(()=>module.bundle.root('egZ7u'));

},{"99f6f6e55f62101f":"3hgb7"}],"2cDCS":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("d20b16c574f58470")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("8Lz78")
]).then(()=>module.bundle.root('a3cP0'));

},{"d20b16c574f58470":"3hgb7"}],"7Ejta":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("jQrAp"),
    import("c0r2J"),
    import("5UqfF"),
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("e1082da986e75549")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("gj30Q")
]).then(()=>module.bundle.root('jszt3'));

},{"e1082da986e75549":"3hgb7"}],"jgvFL":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("9ff7bb603f535b82")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("8reCP")
]).then(()=>module.bundle.root('ifVGP'));

},{"9ff7bb603f535b82":"3hgb7"}],"g9w1s":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("70b040b4ced9dc2e")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("h1Gzt")
]).then(()=>module.bundle.root('aJAGS'));

},{"70b040b4ced9dc2e":"3hgb7"}],"3rPw5":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("j8Q5i"),
    import("iWqx8"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("8c405b57faad9485")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("cUbJa")
]).then(()=>module.bundle.root('03xGc'));

},{"8c405b57faad9485":"3hgb7"}],"fnJuQ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("37e4475cfbfbd7f0")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("7et3K")
]).then(()=>module.bundle.root('32LdD'));

},{"37e4475cfbfbd7f0":"3hgb7"}],"hWCJt":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("ehqbF"),
    import("emlxp"),
    import("j2oFu"),
    import("l7MuT"),
    import("j8Q5i"),
    import("iWqx8"),
    import("jO9Lo"),
    import("2xEKR"),
    import("ecAGW"),
    import("3yxaM"),
    import("1N7Yh"),
    import("8AwGi"),
    import("6IbSZ"),
    import("ehl6p"),
    import("46OkM"),
    import("28QzP"),
    import("aC5QK"),
    import("aV5Au"),
    import("f8892"),
    import("eSmDe"),
    require("23be3d0269dbc4c0")(import.meta.resolve("ez92l")),
    import("1PqQ3"),
    import("goK7f")
]).then(()=>module.bundle.root('gkOix'));

},{"23be3d0269dbc4c0":"3hgb7"}],"huTYo":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("llEdR"),
    import("1PqQ3"),
    import("dzsQs")
]).then(()=>module.bundle.root('g36Vt'));

},{}],"KUiYy":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("lNuXv"),
    import("kMTAi"),
    import("1PqQ3"),
    import("a7yaz")
]).then(()=>module.bundle.root('314xD'));

},{}],"61OqM":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("lNuXv"),
    import("kMTAi"),
    import("llEdR"),
    import("1PqQ3"),
    import("aXDfy")
]).then(()=>module.bundle.root('1RKxb'));

},{}],"9aIyJ":[function(require,module,exports,__globalThis) {
module.exports = import("iRXJ5").then(()=>module.bundle.root('dHdzT'));

},{}],"ck8Ne":[function(require,module,exports,__globalThis) {
module.exports = import("2ZmKp").then(()=>module.bundle.root('8kYF2'));

},{}],"dIBwg":[function(require,module,exports,__globalThis) {
module.exports = import("dlukc").then(()=>module.bundle.root('ltr1F'));

},{}],"5lIdo":[function(require,module,exports,__globalThis) {
module.exports = import("eIZv3").then(()=>module.bundle.root('kIRpy'));

},{}],"3HXbo":[function(require,module,exports,__globalThis) {
module.exports = import("knubS").then(()=>module.bundle.root('lPPaU'));

},{}],"c5EQp":[function(require,module,exports,__globalThis) {
module.exports = import("4uJzW").then(()=>module.bundle.root('1iYi9'));

},{}],"8dzD6":[function(require,module,exports,__globalThis) {
module.exports = import("ajrHW").then(()=>module.bundle.root('j0wO2'));

},{}],"c33w7":[function(require,module,exports,__globalThis) {
module.exports = import("ie0vM").then(()=>module.bundle.root('bZNmH'));

},{}],"64zdn":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("j8Q5i"),
    import("c6y2m")
]).then(()=>module.bundle.root('9kNmu'));

},{}],"lC5bg":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("j8Q5i"),
    import("kn9uF")
]).then(()=>module.bundle.root('4NunP'));

},{}],"ddhQC":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("9c0a690d61940c0f")(import.meta.resolve("9i9rx")),
    import("41BF2"),
    import("lNuXv"),
    require("9c0a690d61940c0f")(import.meta.resolve("ez92l")),
    import("a8NYe"),
    import("1PqQ3"),
    import("1eHvX")
]).then(()=>module.bundle.root('5Kytb'));

},{"9c0a690d61940c0f":"3hgb7"}]},["bNIxh"], "bNIxh", "parcelRequire7f0c", {})

//# sourceMappingURL=iframe.c067e760.js.map
